webpackJsonp([0],{

/***/ "+Un9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"projectList":"projectList__3A_lw","loadWrapper":"loadWrapper__DoJXj","hideButtons":"hideButtons__3dx6e","buttons":"buttons__IHbr5","containerClass":"containerClass__30VLP","headerContainerClass":"headerContainerClass__3yq60","tableBodyClass":"tableBodyClass__2EznD","toolBarStyle":"toolBarStyle__39WCN","row":"row__3QJXn","toolBar":"toolBar__2V0dp","searchWrapper":"searchWrapper__1tKXo","insertBtnWrapper":"insertBtnWrapper__33Aqn","priceColumn":"priceColumn__1nJsg","poId":"poId__3XNLT","vendor":"vendor__3Brre","description":"description__1C0Ug","date":"date__1ic4L","amount":"amount__3rDWg","preloaderWrapper":"preloaderWrapper__7_7iI","tableOuterWrapper":"tableOuterWrapper__245Yg","cardListOuterWrapper":"cardListOuterWrapper__1YxLl","viewDetailsIcon":"viewDetailsIcon__G32x0","purchaseOrderDescCards":"purchaseOrderDescCards__2z7o-","projectId":"projectId__3J9KE","vendorWrapper":"vendorWrapper__22mvL","docCategorylabel":"docCategorylabel__3aRAK","docCategorytext":"docCategorytext__3doSl","purchaseOrderDescription":"purchaseOrderDescription__3DCsS","amountDateWrapper":"amountDateWrapper__WPQ8E"};

/***/ }),

/***/ "/NpY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"projectTablesection":"projectTablesection__2rzh6","projectList":"projectList__2nXv6","headerContainerClass":"headerContainerClass__1tuTj","tableBodyClass":"tableBodyClass__3hUQ0","viewDetail":"viewDetail__3GO4L","exapnadlbleRow":"exapnadlbleRow__OQc1l","themeBtn":"themeBtn__5daL3","themeBtn1":"themeBtn1__1zSB0","selectedRow":"selectedRow__3Wz2g","view_results":"view_results__2dLlc","preloaderWrapper":"preloaderWrapper__3V35j","tableOuterWrapper":"tableOuterWrapper__3mh7Z","cardListOuterWrapper":"cardListOuterWrapper__2UG02","idClass":"idClass__3gsA3"};

/***/ }),

/***/ "/jkn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VerticalFlagList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("Ninc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'span',
	null,
	'Our Approach'
);

var VerticalFlagList = function (_Component) {
	_inherits(VerticalFlagList, _Component);

	function VerticalFlagList(props, context) {
		_classCallCheck(this, VerticalFlagList);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.tooltipOut = function (data) {
			_this.setState({ showtooltip: false });
		};

		_this.state = {
			showtooltip: '',
			tooltipData: '',
			country_name: '',
			tooltipPosition: [0, 0]
		};
		return _this;
	}

	VerticalFlagList.prototype.componentWillMount = function componentWillMount() {};

	VerticalFlagList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {};

	VerticalFlagList.prototype.showTooltip = function showTooltip(e, data) {
		this.setState({ showtooltip: true, country_name: data, tooltipPosition: [e.clientX, e.clientY] });
	};

	VerticalFlagList.prototype.render = function render(props) {
		var _this2 = this;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.top_container },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.header },
				_ref
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.tableWrapper },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'ul',
					{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.list },
					props.data.map(function (item, index) {
						return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'li',
							{ 'class': index === props.data.length - 1 ? '' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.lastLi : '' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.li },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'span',
								{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.legend_item },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': item.type === 1 ? '' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.knowledge_legend_block : item.type === 3 ? '' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.partnership_legend_block : '' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.capacity_legend_block }),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'span',
									{ 'class': '' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.legend_text },
									item.title
								)
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'span',
								{ style: item.description.toLocaleLowerCase().trim() === item.title.toLocaleLowerCase().trim() ? 'display:none' : 'display:block', 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.desc },
								item.description
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'ul',
								{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.flagList },
								item.countries.map(function (country, inde) {
									return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'li',
										{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.flagli },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { onMouseOver: function onMouseOver(e) {
												return _this2.showTooltip(e, country.country_name);
											},
											onMouseOut: function onMouseOut() {
												return _this2.tooltipOut(_this2.props.data);
											},
											onError: function onError(e) {
												e.target.src = '/static/assets/images/Empty.svg';
											},
											'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.flagImg, src: country.country_iso3 ? _this2.props.apiBase + '/static/assets/flag_icons/' + country.country_iso3 + '.svg' : '/static/assets/images/Empty.svg' })
									);
								})
							)
						);
					})
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				{ 'class': this.state.showtooltip ? __WEBPACK_IMPORTED_MODULE_1__style___default.a.tooltipDonors + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.otherTooltip : __WEBPACK_IMPORTED_MODULE_1__style___default.a.tooltipDisplay,
					style: { top: this.state.tooltipPosition[1] + 'px', left: this.state.tooltipPosition[0] + 'px' }
				},
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'span',
					null,
					this.state.country_name
				)
			)
		);
	};

	return VerticalFlagList;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "/lS5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sdgLegend":"sdgLegend__2PgM0","rightSDG":"rightSDG__3_9kW","sdgImage":"sdgImage__2Ay3q","leftSDG":"leftSDG__26aKL","sdgItem":"sdgItem__2Cf3H","sdgPercent":"sdgPercent__1t9Cd","imageItem":"imageItem__3mvY5","othersItem":"othersItem__1jHa_","sdgName":"sdgName__xImdG","sdgTooltip":"sdgTooltip__1qWI5"};

/***/ }),

/***/ "1DIU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1NngS","imageWrapper":"imageWrapper__G4Ctc","sdg_image":"sdg_image__2WCSb","list":"list__Z7ewr","value":"value__15I8_","label":"label__2os_t","mapContainer":"mapContainer__2BVg5","disclaimer":"disclaimer__1Cf_9","chartWrapper":"chartWrapper__mAQzS","recipient_themes_wrapper":"recipient_themes_wrapper__27qGX","budget_percent":"budget_percent__2z37i","top_budget_sources_wrapper":"top_budget_sources_wrapper__27xFy","outcome_chart_wrapper":"outcome_chart_wrapper__JKpwY","outcome_wrapper_styles":"outcome_wrapper_styles__2LeTl","textWrapperStyle":"textWrapperStyle__Oytyz","textFieldStyle":"textFieldStyle__30q31","our_focus_legend_styles":"our_focus_legend_styles__1_fRX","legend_styles":"legend_styles__2ORr9","donut_styles":"donut_styles__2ivyB","svgIe":"svgIe__2Y9s3","legendLabel":"legendLabel__2pljX","theme_slider_wrapper":"theme_slider_wrapper__1kTwQ","theme_donut_wrapper":"theme_donut_wrapper__1nBKN","theme_slider_title":"theme_slider_title__1VAQV","chartHead":"chartHead__2zJfR","infoWrapper":"infoWrapper__Ng7RJ","tableWrapper":"tableWrapper__3GTkl","titleWrapper":"titleWrapper__eKw8n","filterText":"filterText__1DwQR","filterTitle":"filterTitle__1OmI5","filterTextWrapper":"filterTextWrapper__3TZ2s"};

/***/ }),

/***/ "2cq4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"legend_container":"legend_container__3-oBe","legend_item":"legend_item__i-Csa","capacity_legend_block":"capacity_legend_block__2Z9wk","knowledge_legend_block":"knowledge_legend_block__3Eu1R","partnership_legend_block":"partnership_legend_block__2E8dK","legend_text":"legend_text__3DxIq","partnership_text":"partnership_text__13r__","knowledge_text":"knowledge_text__1c8bx","capacity_text":"capacity_text__113Jw"};

/***/ }),

/***/ "31tI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_image_gallery__ = __webpack_require__("uq96");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_image_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_image_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__("CeE8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PictureGallery = function (_Component) {
  _inherits(PictureGallery, _Component);

  function PictureGallery() {
    _classCallCheck(this, PictureGallery);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  PictureGallery.prototype.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_react_image_gallery___default.a, {
      showFullscreenButton: false,
      showPlayButton: false,
      showBullets: true,
      width: 300,
      height: 300,
      originalClass: __WEBPACK_IMPORTED_MODULE_3__style___default.a.image_sizewrapper,
      items: this.props.pictureList.data
    });
  };

  return PictureGallery;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "4PZ+":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = debounce;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "4VU6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bodyContainerClass":"bodyContainerClass__3xHiB","tableBodyClass":"tableBodyClass__3HNyC","headerContainerClass":"headerContainerClass__3Sw0X","headerImage":"headerImage__2lmY3","cellElement":"cellElement__35_XK","policyMarker":"policyMarker__1N2mu","budgetUtiWrapper":"budgetUtiWrapper__2LgFL","budgetInnerWrapper":"budgetInnerWrapper__Je75m","countryColumn":"countryColumn__Tp42J","yearColumn":"yearColumn__3VyUD","regularColumn":"regularColumn__3PqwC","othersColumn":"othersColumn__ow3aA","parent":"parent__1rp1Q","container":"container__2vXMZ","gender_equality":"gender_equality__2OfI1","gender_equality_item":"gender_equality_item__2El3l","marker_container":"marker_container__1wLbN","item_title":"item_title__1einc","textCenter":"textCenter__gZU-1","budgetBackground":"budgetBackground__1fEp-","child":"child__1gI4Y","markerSection":"markerSection__1-Hqe","parentMarkers":"parentMarkers__1YjYQ","level":"level__2mulP","imageSection":"imageSection__IZlhK","textSection":"textSection__3k1L7","sub_header":"sub_header__w2Wgy","marker_header":"marker_header__10fxU","sub_level":"sub_level__3Vl-7","track_vertical":"track_vertical__2ti1k","thumb_vertical":"thumb_vertical__85Y7k","thumb_horizontal":"thumb_horizontal__3-Rf4","sub_section_container":"sub_section_container__1Md1V","sub_section":"sub_section__2BtYw","bullet":"bullet__2TO8s","parent_container":"parent_container__2hxxz","table_container":"table_container__2IPg-","child_container":"child_container__LH3Ko","subTables":"subTables__2yt7R","item_budget":"item_budget__nA8jN","budget_list":"budget_list__3IKV3","alignment":"alignment__1mc19","alignment_right":"alignment_right__mTUpK","budget_container":"budget_container__wX1mx","card_container":"card_container__3Yy0-","child_item":"child_item__1EHLw","modal":"modal__1az3C","modalWrapper":"modalWrapper__1VbKM","outerContainer":"outerContainer__mne0Y","modalContainer":"modalContainer__3pvDe","modalContent":"modalContent__3LDpk","mobile":"mobile__2UBiX","yearWrapper":"yearWrapper__1GOwx","desktop":"desktop__1Fd9a","headerWrapper":"headerWrapper__2sRAj","closeBtn":"closeBtn__1SVcM","resultsHeader":"resultsHeader__NlVwX","detailWrapper":"detailWrapper__3AEiW","detailsSection":"detailsSection__1EzWe","sideNumber":"sideNumber__1LJL7","yearBtn":"yearBtn__Y3oLD","activeYear":"activeYear__e1wIt","footerContainer":"footerContainer__ankFc","footerDataWrapper":"footerDataWrapper__RL7xO","priceColumn":"priceColumn__tF87K","results_container":"results_container__1GYvB","results_item":"results_item__1oNx_","results_container_wrapper":"results_container_wrapper__1E-Lh"};

/***/ }),

/***/ "5PBJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chartLegendContainer":"chartLegendContainer__237oF","tooltip":"tooltip__2u6nr","hidden":"hidden__1LZXq","yAxisLabel":"yAxisLabel__2niI3","xAxisLabel":"xAxisLabel__2VvdS","hStackedBar_chart":"hStackedBar_chart__3iRhS","toolTip":"toolTip__1eVLW","svgIe":"svgIe__33KBl","axis":"axis__WxsFu"};

/***/ }),

/***/ "5a/9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"legend_container":"legend_container__1i6qk"};

/***/ }),

/***/ "5iAr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"themeSlider":"themeSlider__1fyiG","closeSlider":"closeSlider__3FmcD","headingWrapper":"headingWrapper__20q-Z","year":"year__389MQ","countryName":"countryName__3EIN6","scrollSection":"scrollSection__1onOX","theme_slider_wrapper":"theme_slider_wrapper__1GxNP","theme_slider_title":"theme_slider_title__29eoz","grouped_bar_chart":"grouped_bar_chart__3i_aH","per_bar_chart":"per_bar_chart__SPeML","summarySection":"summarySection__2x0RN","summaryDetails":"summaryDetails__1x8fB","summaryHeading":"summaryHeading__3rPGU","imageWrapper":"imageWrapper__2J5LB","sdg_image":"sdg_image__2X-iu"};

/***/ }),

/***/ "6xcH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__ = __webpack_require__("7N8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component__);

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(21).then((function (require) {
				cb( __webpack_require__("yFKW") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_cli_async_component___default()(load));
	

/***/ }),

/***/ "7QFR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3TJDF","row":"row__1xrMO","rowWrapper":"rowWrapper__2BkVZ","rowWrapperItem":"rowWrapperItem__1DG1M","rowText":"rowText__3TWfC","country_percentage":"country_percentage__2fyVH","countryWrapper":"countryWrapper__WJygE","allDonorWrapper":"allDonorWrapper__3An4p","tooltipDonors":"tooltipDonors__2hnvC","tooltipDisplay":"tooltipDisplay__3qV8B","targetTitle":"targetTitle__XuMsc"};

/***/ }),

/***/ "9YiL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chartWrapper":"chartWrapper__teAFj","recipient_themes_wrapper":"recipient_themes_wrapper__2QD1p","budget_percent":"budget_percent__1EM1O","top_budget_sources_wrapper":"top_budget_sources_wrapper__Qvgb1","mapWrapper":"mapWrapper__exIy3","titleWrapper":"titleWrapper__RFtsY","chartHead":"chartHead__fKCa6","budget_sources_wrapper":"budget_sources_wrapper__J7orM","tableHeader":"tableHeader__1ywKe","projectListWrapper":"projectListWrapper__2RcPP","table":"table__1149I","tableHeaderSection":"tableHeaderSection__1hPbW","tableHeaderData":"tableHeaderData__2GiyG","row":"row__38Gky","cell":"cell__2JahI","track_vertical":"track_vertical__20xwn","thumb_vertical":"thumb_vertical__2ewok","thumb_horizontal":"thumb_horizontal__1knoF","dataTitle":"dataTitle__2yswO","bullet":"bullet__r0_oM","titleText":"titleText__3_yA6","dataDetails":"dataDetails__1-JOa","scroll":"scroll__POi9m","data":"data__csJDC","dataTitle2":"dataTitle2__OLibX","textTitle2":"textTitle2__-hI8r","scroll2":"scroll2__3YcSx","listSection":"listSection__87DSg","bullet2":"bullet2__2-WSI"};

/***/ }),

/***/ "CCOa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"theme_container":"theme_container__5Dv9k","themedonor_container":"themedonor_container__2jWp2","searchContainer":"searchContainer__3CDDM","searchLabel":"searchLabel__39GJO","donorSearch":"donorSearch__2tkwB","searchItems":"searchItems__1LxMc","searchField":"searchField__3YLEC","searchIcon":"searchIcon__1stkD","searchIconSearch":"searchIconSearch__2Zv4S","searchIconClose":"searchIconClose__1denC","track-horizontal":"track-horizontal__1YSxb","sliderDonor":"sliderDonor__2waLZ","sliderVisible":"sliderVisible__2HCwY","showSlider":"showSlider__1ArQi","noResults":"noResults__1Tx8b"};

/***/ }),

/***/ "CamH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export projectDetailDocData */
var projectDetailDocData = [{
    date: "Nov 10, 2017",
    document: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    dateCategory: 'Project document'
}, {
    date: "Nov 11, 2017",
    document: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    dateCategory: 'Budget'
}, {
    date: "Nov 12, 2017",
    document: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    dateCategory: 'Project Reports'
}, {
    date: "Nov 13, 2017",
    document: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    dateCategory: 'Evalulation Reports'
}];

/***/ }),

/***/ "DgIW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/filter/index.js
var filter = __webpack_require__("DEwm");

// EXTERNAL MODULE: ./components/profilePage/components/style.scss
var style = __webpack_require__("NyMt");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/d3/d3.js
var d3 = __webpack_require__("tokj");
var d3_default = /*#__PURE__*/__webpack_require__.n(d3);

// EXTERNAL MODULE: ./components/windRoseChart/style.scss
var windRoseChart_style = __webpack_require__("cMmm");
var windRoseChart_style_default = /*#__PURE__*/__webpack_require__.n(windRoseChart_style);

// EXTERNAL MODULE: ./components/no-data-template/index.js
var no_data_template = __webpack_require__("wdDn");

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// EXTERNAL MODULE: ./static/assets/images/closeCard.png
var closeCard = __webpack_require__("ShPv");
var closeCard_default = /*#__PURE__*/__webpack_require__.n(closeCard);

// CONCATENATED MODULE: ./components/windRoseChart/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _ref2 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var windRoseChart_WindRoseChart = function (_Component) {
    _inherits(WindRoseChart, _Component);

    function WindRoseChart(props) {
        _classCallCheck(this, WindRoseChart);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.modifyText = function (string, limit) {

            return string.slice(0, limit) + "...";
        };

        _this.calcXpos = function (xpos) {
            if (xpos - 220 < 0) {
                return 220;
            } else if (xpos + 220 > window.outerWidth) {
                return window.outerWidth - 220;
            } else {
                return xpos;
            }
        };

        _this.drawWindRose = function (chartData, sectorColor) {
            var data = _this.processData(chartData);
            var that = _this;
            var width = Math.min(window.outerWidth, 1200);
            var height = 700;
            var radius = 200,
                labelr = radius + 50;

            var color = d3_default.a.scale.ordinal().range(["#98abc5", "#ffffff", "#8a89a6", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00"]);
            var arc = void 0;
            var arcColor = sectorColor;

            var pie = d3_default.a.layout.pie().sort(null).value(function (d) {
                return 1;
            });

            if (!d3_default.a.select("#windRoseChart").empty()) {
                d3_default.a.select("#windRoseChart svg").remove();
            }

            var svg = d3_default.a.select("#windRoseChart").append("svg").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", "0 0 " + width + " " + height).classed('' + windRoseChart_style_default.a.svgIe, true).append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

            var g = svg.selectAll(".arc").data(pie(data)).enter().append("g").attr("class", "arc");

            var outerArc = d3_default.a.svg.arc().outerRadius(radius).innerRadius(radius - 90);
            var innerArc = d3_default.a.svg.arc().outerRadius(radius - 90).innerRadius(0);

            g.append("path").attr("d", outerArc).style("fill", 'white').style("stroke", "#d4d4d4").style("stroke-width", 2);

            g.append("path").attr("d", innerArc).style("fill", 'white').style("stroke", "#d4d4d4").style("stroke-width", 2);

            var sector = data.length;
            var diff = 2 * Math.PI / (sector * 3);
            var startAngle = diff;

            data.forEach(function (item, index) {
                var arcRadius = item.percent * radius / 100;
                if (arcRadius > radius) arcRadius = radius + 30;
                var labelradius = arcRadius + 10;
                var themeArc = svg.append('g').attr("class", "themes");
                arc = d3_default.a.svg.arc().innerRadius(0).outerRadius(arcRadius).startAngle(startAngle).endAngle(startAngle + diff);

                startAngle = startAngle + 3 * diff;
                themeArc.append("path").attr("class", "arc").attr("d", arc).on("mouseover", function (d) {
                    d3_default.a.select('#budget_expense').html('<div id="budget_expense_innerData" class=' + windRoseChart_style_default.a.actualDescriptionWrapper + '>\n                                 <div class=' + windRoseChart_style_default.a.actual + '>Actual: ' + Object(numberFormatter["c" /* numberToCommaFormatter */])(item.actual) + '</div>\n                                 <div class=' + windRoseChart_style_default.a.target + '>Milestone: ' + Object(numberFormatter["c" /* numberToCommaFormatter */])(item.target) + '</div>\n                    <div>').style("left", d3_default.a.event.pageX + "px").style("top", d3_default.a.event.pageY + "px").style("opacity", 1);
                }).on("mouseout", function (d) {
                    d3_default.a.select('#budget_expense').html(null).style("opacity", 0);
                }).style("fill", '#' + arcColor).style("stroke", "#FFFFFF").style("stroke-width", 2);

                themeArc.append('text').attr("transform", function () {
                    var xTransformValue = void 0,
                        yTransformValue = void 0;
                    var c = arc.centroid(),
                        x = c[0],
                        y = c[1],
                        h = Math.sqrt(x * x + y * y);
                    if (x / h * labelradius <= 0) xTransformValue = x / h * labelradius - 10;else xTransformValue = x / h * labelradius + 10;
                    if (y / h * labelradius <= 0) yTransformValue = y / h * labelradius + 5;else yTransformValue = y / h * labelradius + 10;
                    return "translate(" + xTransformValue + ',' + yTransformValue + ")";
                }).attr("font-size", "14px").attr("font-weight", 'bold').attr("fill", 'black').attr("text-anchor", "middle").text(function () {
                    return item.percent != 0 ? item.percent + '%' : null;
                });
            });
            svg.append('g').append('text').attr("font-size", "14px").attr("fill", 'black').attr("transform", "translate(-5, 3)").text('0%');

            svg.append('g').append('text').attr("font-size", "14px").attr("fill", 'black').attr("transform", "translate(-15," + -(radius + 10) + " )").text('100%');

            g.append("text").attr("transform", function (d) {
                var xTransformText, yTransformText;
                var c = outerArc.centroid(d),
                    x = c[0],
                    y = c[1],
                    h = Math.sqrt(x * x + y * y);
                if (x / h * labelr <= 0) xTransformText = x / h * labelr - 30;else xTransformText = x / h * labelr + 30;
                if (y / h * labelr >= 0) yTransformText = y / h * labelr - 25;else yTransformText = y / h * labelr - 15;
                return "translate(" + xTransformText + ',' + yTransformText + ")";
            }).attr("font-size", "14px").attr("fill", '#3a3a3a').attr("width", 100).attr("text-anchor", function (d) {
                return (d.endAngle + d.startAngle) / 2 > Math.PI ? "end" : "start";
            }).text(function (d) {
                return d.data.country_result.description;
            }).attr("class", windRoseChart_style_default.a.textDescription).call(wrap, 200).attr("cursor", "pointer").on("mouseover", function (d, i) {
                d3_default.a.select("#display_label .tooltip").style('border', '1px solid #d4d4d4');
                that.setState({
                    description: _extends({}, that.state.description, {
                        text: d.data.country_result.description,
                        x: that.calcXpos(d3_default.a.event.pageX),
                        y: d3_default.a.event.pageY + 30,
                        display: true
                    })
                });
            }).on("mouseout", function (d) {
                d3_default.a.select("#display_label .tooltip").style("border", "none");
                that.setState({
                    description: _extends({}, that.state.description, {
                        display: false
                    })
                });
            });

            var div = d3_default.a.select("#display_label").attr("class", windRoseChart_style_default.a.tooltip).style("opacity", 0);

            function wrap(text, width) {

                text.each(function () {
                    var text = d3_default.a.select(this),
                        words = text.text().split(/\s+/).reverse(),
                        word = void 0,
                        line = [],
                        lineNumber = 0,
                        lineHeight = 0.1,
                        // ems
                    y = text.attr("y"),
                        dy = 1,
                        tspan = text.text(null).append("tspan").attr("class", windRoseChart_style_default.a.tspan).attr("x", 0).attr("y", y).attr("dy", dy + "em");

                    while (word = words.pop()) {
                        if (lineNumber < 2) {
                            line.push(word);
                            if (line.join(" ").length < 45) {

                                tspan.text(line.join(" "));
                            } else {
                                line.pop();
                                tspan.text(line.join(" "));
                                if (lineNumber !== 1) {
                                    line = [word];
                                    ++lineNumber;
                                    tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em").text(word);
                                }
                            }
                        }
                    }
                });
            }
        };

        _this.handleCloseDescription = function () {
            _this.setState({
                description: _extends({}, _this.state.description, {
                    display: false
                })
            });
        };

        _this.handleCloseBudget = function () {
            _this.setState({
                budgetExpense: _extends({}, _this.state.budgetExpense, {
                    display: false
                })
            });
        };

        _this.state = {
            description: {
                text: '',
                x: '',
                y: '',
                display: false
            },
            budgetExpense: {
                actual: '',
                target: '',
                x: '',
                y: '',
                display: false
            },
            showDisplay: false
        };
        return _this;
    }

    WindRoseChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.data != this.props.data && nextProps.data.length > 0) {
            this.drawWindRose(nextProps.data, nextProps.sectorColor);
        } else if (!nextProps.data.length) {
            d3_default.a.select("#windRoseChart svg").remove();
        }
    };

    WindRoseChart.prototype.componentDidMount = function componentDidMount() {
        this.props.data.length > 0 && this.drawWindRose(this.props.data, this.props.sectorColor);
        d3_default.a.select('#budget_expense').html(null).style("opacity", 0);
    };

    WindRoseChart.prototype.processData = function processData(chartData) {
        var list = chartData;
        var newList = list.map(function (item, index) {
            item.percent = item.target == 0 ? 0 : Math.floor(item.actual / item.target * 100);
            return item;
        });
        return newList;
    };

    WindRoseChart.prototype.render = function render(props, _ref) {
        var _this2 = this;

        var description = _ref.description,
            budgetExpense = _ref.budgetExpense;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])('div', { id: 'windRoseChart',
                'class': windRoseChart_style_default.a.windRoseChart,
                ref: function ref(node) {
                    return _this2.container = node;
                } }),
            this.props.data.length ? description.display ? Object(preact_min["h"])(
                'div',
                { id: 'display_label', 'class': windRoseChart_style_default.a.tooltip, style: { left: description.x - 200, top: description.y, padding: 10 } },
                Object(preact_min["h"])(
                    'span',
                    { 'class': windRoseChart_style_default.a.textDescription },
                    description.text
                )
            ) : null : _ref2,
            Object(preact_min["h"])('div', { id: 'budget_expense', 'class': windRoseChart_style_default.a.tooltip })
        );
    };

    return WindRoseChart;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/grouped-bar-chart/index.js
var grouped_bar_chart = __webpack_require__("2On6");

// EXTERNAL MODULE: ./components/preLoader/index.js
var preLoader = __webpack_require__("ufjx");

// EXTERNAL MODULE: ./components/budget-expense-legend/index.js
var budget_expense_legend = __webpack_require__("COsE");

// EXTERNAL MODULE: ./components/donutBarChart/index.js + 2 modules
var donutBarChart = __webpack_require__("pwGw");

// CONCATENATED MODULE: ./components/profilePage/components/generateRecipientCharts.js










var generateRecipientCharts__ref2 = Object(preact_min["h"])('div', null);

var _ref3 = Object(preact_min["h"])('div', null);

var _ref4 = Object(preact_min["h"])(
	'span',
	null,
	'Top 10 Donors'
);

var _ref5 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var _ref6 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref7 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var generateRecipientCharts_generateRecipientCharts = function generateRecipientCharts(_ref) {
	var countryDetails = _ref.countryDetails,
	    unitType = _ref.unitType,
	    themeList = _ref.themeList,
	    themeBudget = _ref.themeBudget,
	    topBudgetSources = _ref.topBudgetSources,
	    setSector = _ref.setSector,
	    budgetVsExpense = _ref.budgetVsExpense,
	    windRose = _ref.windRose,
	    yearList = _ref.yearList,
	    currentYear = _ref.currentYear,
	    updateBarChartOnArcHover = _ref.updateBarChartOnArcHover,
	    budgetVsExpenseSdg = _ref.budgetVsExpenseSdg,
	    recepientSdg = _ref.recepientSdg,
	    displaybudgetPercThemes = _ref.displaybudgetPercThemes,
	    displaybudgetPercSdg = _ref.displaybudgetPercSdg,
	    displaybudgetSources = _ref.displaybudgetSources,
	    embed = _ref.embed;

	return (
		// Recipient Profile  start
		Object(preact_min["h"])(
			'section',
			null,
			Object(preact_min["h"])(
				'div',
				{ 'class': style_default.a.wrapper + ' ' + style_default.a.chartWrapper },
				!displaybudgetPercThemes || displaybudgetPercThemes && displaybudgetPercThemes === 'true' ? Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.recipient_themes_wrapper },
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.chartWapper },
						Object(preact_min["h"])(
							'span',
							{ 'class': style_default.a.chartHeadsdg + ' ' + style_default.a.chartHead_themes },
							Object(preact_min["h"])(
								'span',
								{ 'class': style_default.a.budget_percent },
								'Programme Areas'
							),
							Object(preact_min["h"])('span', { 'class': style_default.a.budgetExpense })
						),
						Object(preact_min["h"])(donutBarChart["a" /* default */], {
							donutData: themeBudget,
							barChartData: budgetVsExpense,
							donutChartId: 'country_contribution',
							recipientProfile: 'true'
						})
					),
					generateRecipientCharts__ref2
				) : null,
				!displaybudgetPercSdg || displaybudgetPercSdg && displaybudgetPercSdg === 'true' ? Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.recipient_themes_wrapper + ' ' + style_default.a.recipient_sdg_wrapper },
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.chartWapper, style: { borderBottom: 'none' } },
						Object(preact_min["h"])(
							'span',
							{ 'class': style_default.a.chartHeadsdg + ' ' + style_default.a.chartHead_themes },
							Object(preact_min["h"])(
								'span',
								{ 'class': style_default.a.budget_percent },
								'SDG'
							),
							Object(preact_min["h"])('span', { 'class': style_default.a.budgetExpense }),
							Object(preact_min["h"])(
								'span',
								{ 'class': style_default.a.sdgDisclaimer },
								Object(preact_min["h"])(
									'span',
									{ 'class': style_default.a.sdgbuttons },
									'About SDG Data'
								),
								Object(preact_min["h"])(
									'span',
									{ 'class': style_default.a.sdgDisclaimerText },
									Object(preact_min["h"])(
										'span',
										{ 'class': style_default.a.textsdg },
										'SDG budget data indicated is based on the percentage estimate of the project contribution to the Sustainable Development Goals.'
									)
								)
							)
						),
						Object(preact_min["h"])(donutBarChart["a" /* default */], {
							donutData: recepientSdg,
							donutChartId: 'sdg_country_contribution',
							barChartData: budgetVsExpenseSdg,
							sdg: 'true',
							recipientProfile: 'true'
						})
					),
					_ref3
				) : null
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': style_default.a.wrapper },
				!displaybudgetSources || displaybudgetSources && displaybudgetSources === 'true' ? Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.wrapper + ' ' + style_default.a.chartWrapper },
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.top_budget_sources_wrapper },
						Object(preact_min["h"])(
							'span',
							{ 'class': style_default.a.chartHead },
							_ref4,
							_ref5
						),
						topBudgetSources.loading ? Object(preact_min["h"])(
							'div',
							{ style: { position: 'relative', height: 344 } },
							_ref6
						) : Object(preact_min["h"])(
							'div',
							null,
							topBudgetSources.length > 0 ? Object(preact_min["h"])(
								'div',
								{ 'class': style_default.a.budget_sources_wrapper },
								Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
									chart_id: 'budget_sources',
									width: 1250,
									height: 500,
									min_height: 540,
									data: topBudgetSources,
									label: 'type_level_3',
									tspanSize: '12px',
									textSize: '12px',
									color: '#191818'
								})
							) : _ref7
						)
					)
				) : null
			)
		)
		// Recipient Profile  end

	);
};
/* harmony default export */ var components_generateRecipientCharts = __webpack_exports__["a"] = (generateRecipientCharts_generateRecipientCharts);

/***/ }),

/***/ "EY8H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ../node_modules/d3/d3.js
var d3 = __webpack_require__("tokj");
var d3_default = /*#__PURE__*/__webpack_require__.n(d3);

// EXTERNAL MODULE: ./components/no-data-template/index.js
var no_data_template = __webpack_require__("wdDn");

// EXTERNAL MODULE: ./components/sankeyChart/d3.chart.sankey.js
var d3_chart_sankey = __webpack_require__("dqug");
var d3_chart_sankey_default = /*#__PURE__*/__webpack_require__.n(d3_chart_sankey);

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// EXTERNAL MODULE: ./components/sankeyChart/style.scss
var style = __webpack_require__("Vq5U");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// CONCATENATED MODULE: ./components/sankeyChart/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*********************** Preact *******************************/



/******************* Third party plugins **********************/

__webpack_require__("OBrC");
__webpack_require__("rP0b");

/********************** Custom components *********************/



/*********************** Util Actions *************************/


/*********************** Style Files **************************/


/**************************************************************/

var sankeyChart__ref = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sankeyChart_SankeyChart = function (_Component) {
	_inherits(SankeyChart, _Component);

	function SankeyChart(props) {
		_classCallCheck(this, SankeyChart);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			sankeyData: _this.props.data,
			currentYearSelected: _this.props.currentYearSelected
		};
		return _this;
	}

	SankeyChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.data != this.props.data) {
			// Check if there is data change
			this.setState({
				sankeyData: nextProps.data
			});
			this.drawSankey(); // Draws Sankey Chart only on data change
		}
	};

	SankeyChart.prototype.componentDidMount = function componentDidMount() {
		if (this.state.sankeyData.nodes.length && this.state.sankeyData.links.length) // Check if nodes and lengths of sankey data non empty
			this.drawSankey();
	};

	SankeyChart.prototype.drawSankey = function drawSankey() {
		var chart, tooltip;
		if (!d3_default.a.select('#sankey svg').empty()) {
			// Removes existing svg and tooltip from DOM
			d3_default.a.select('#sankey' + ' svg').remove();
			d3_default.a.select('#sankey' + ' .tooltip').remove();
		}
		chart = d3_default.a.select('#sankey') // Appends svg to the div with id = sankey
		.append('svg').chart('Sankey.Path'); // Chart Type = Sankey.Path

		tooltip = d3_default.a.select('#sankey') // Create span element for tooltip and append it to div with id = sankey
		.append('span').attr('class', 'tooltip');
		// .style('opacity', 0);

		chart.name(label) // function to add node label
		.colorNodes( // color for nodes
		function (name, node) {
			if (node.color) return '#' + node.color;else return '#013B69';
		}).colorLinks( // color for labels
		function (link) {
			return '#' + link.source.color;
		}).nodeWidth(15) // width of node
		.nodePadding(30) // vertical space between nodes
		.spread(true) // whether to spread nodes vertically after layout
		.draw(this.state.sankeyData);

		d3_default.a.selectAll('.link') // Set all link opacities to .05 initially
		.style('fill', 'none').style('stroke-opacity', '.05');

		d3_default.a.select('span.tooltip') // Customize tooltip
		.style('text-align', 'center').style('padding', '10px').style('font', '12px').style('color', '#000').style('background', '#fff').style('border', '1px solid #ccc').style('border-radius', '8px').style('pointer-events', 'none').style('position', 'absolute');

		d3_default.a.selectAll('.node rect') // Node Customization
		.style('fill-opacity', '1').style(' shape-rendering', 'crispEdges').style('stroke-width', '0').on('mouseover', function (d) {
			// Mouse over function
			d3_default.a.select(this).style('cursor', 'pointer') // Set cursor to pointer
			.style('stroke-width', '1'); // Increase stroke width
			d3_default.a.selectAll('.link').style('stroke-opacity', '0.8') // Increase stroke opacity
			.append;
			tooltip.transition().duration(500).style('opacity', 0);
			d3_default.a.select(this).style('stroke-opacity', '.05');
		}).on('mouseout', function () {
			// Mouse out function
			d3_default.a.select(this).style('cursor', 'none') // Set cursor to none
			.style('stroke-width', '0'); // Reset stroke width
			d3_default.a.selectAll('.link').style('stroke-opacity', '.05'); // Reset stroke opacity
		});

		d3_default.a.selectAll('.node text').text(function (d) {
			return d.short_name ? d.short_name : d.name;
		}) // Add Text shadow to node text
		.style('text-shadow', '0 1px 0 #fff').call(wrap);

		function label(node) {
			// Add node label
			return node.name.replace(/\s*\(.*?\)$/, '');
		}

		function wrap(text) {
			text.each(function () {
				var text = d3_default.a.select(this),
				    words = text.text().split(/\s+/).reverse(),
				    word,
				    width = 200,
				    line = [],
				    lineNumber = 0,
				    lineHeight = 0.9,
				    // ems
				y = text.attr("y"),
				    xx = text.attr("x"),
				    dy = parseFloat(text.attr("dy")),
				    tspan = text.text(null).append("tspan").attr("x", xx).attr("y", y).attr("dy", dy + "em");
				while (word = words.pop()) {
					line.push(word);
					tspan.text(line.join(" "));
					if (tspan.node().getComputedTextLength() > width) {
						line.pop();
						tspan.text(line.join(" "));
						line = [word];
						tspan = text.append("tspan").attr("x", xx).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
					}
				}
			});
		}

		d3_default.a.selectAll('.link') // Link Customization
		.on('click', function (link) {
			tooltip.transition().duration(200).style('opacity', .9);
			tooltip.html(link.source_name + ' - ' + link.target_name + ': ' + '<strong>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(link.value, 2) + '</strong>').style('left', d3_default.a.event.pageX - 28 + 'px').style('top', d3_default.a.event.pageY - 28 + 'px');
			d3_default.a.select(this).style('stroke-opacity', '0.8').style('cursor', 'pointer').append;
		}).on('mouseover', function (link) {
			tooltip.transition().duration(200).style('opacity', .9);
			tooltip.html(link.source_name + ' - ' + link.target_name + ': ' + '<strong>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(link.value, 2) + '</strong>').style('left', d3_default.a.event.pageX - 28 + 'px').style('top', d3_default.a.event.pageY - 28 + 'px').style('text-align', 'center').style('padding', '10px').style('font', '12px').style('color', '#000').style('background', '#fff').style('border', '1px solid #ccc').style('border-radius', '8px').style('pointer-events', 'none').style('position', 'absolute');

			d3_default.a.select(this).style('stroke-opacity', '0.8').style('cursor', 'pointer').append;
		}).on('mouseout', function () {
			tooltip.transition().duration(500);
			// .style('opacity', 0);
			d3_default.a.select(this).style('stroke-opacity', '.05');
		});
	};

	SankeyChart.prototype.render = function render() {
		var isNonEmpty = this.state.sankeyData.links.length > 0 && this.state.sankeyData.links.length > 0;
		return Object(preact_min["h"])(
			'div',
			null,
			isNonEmpty ? Object(preact_min["h"])(
				'section',
				{ 'class': style_default.a.sankey_container },
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.legend_container },
					Object(preact_min["h"])(
						'span',
						{ 'class': '' + style_default.a.legend_row },
						Object(preact_min["h"])(
							'span',
							{ 'class': style_default.a.legend_row_title },
							'Budget Sources'
						),
						Object(preact_min["h"])(
							'span',
							{ 'class': style_default.a.legend_row_detail },
							'Where our resources come from'
						)
					),
					Object(preact_min["h"])(
						'span',
						{ 'class': style_default.a.legend_row + ' ' + (this.props.sankeyYear >= constants["a" /* default */].SIGNATURE_SOLUTION_YEAR ? style_default.a.child2 : '') },
						Object(preact_min["h"])(
							'span',
							{ 'class': style_default.a.legend_row_title },
							'Recipient Region'
						),
						Object(preact_min["h"])(
							'span',
							{ 'class': style_default.a.legend_row_detail },
							'Where our resources go'
						)
					),
					Object(preact_min["h"])(
						'span',
						{ 'class': style_default.a.legend_row + ' ' + (this.props.sankeyYear >= constants["a" /* default */].SIGNATURE_SOLUTION_YEAR ? style_default.a.child3 : '') },
						Object(preact_min["h"])(
							'span',
							{ 'class': style_default.a.legend_row_title },
							'Programme Areas'
						),
						Object(preact_min["h"])(
							'span',
							{ 'class': style_default.a.legend_row_detail },
							'What our resources are spent on'
						)
					),
					this.props.sankeyYear >= constants["a" /* default */].SIGNATURE_SOLUTION_YEAR ? Object(preact_min["h"])(
						'span',
						{ 'class': style_default.a.legend_row + ' ' + (this.props.sankeyYear >= constants["a" /* default */].SIGNATURE_SOLUTION_YEAR ? style_default.a.child4 : '') },
						Object(preact_min["h"])(
							'span',
							{ 'class': style_default.a.legend_row_title },
							'SDG'
						),
						Object(preact_min["h"])(
							'span',
							{ 'class': style_default.a.legend_row_detail },
							'How our resources contribute to SDGs'
						)
					) : null
				),
				Object(preact_min["h"])('div', { 'class': style_default.a.sankey, id: 'sankey' })
			) : sankeyChart__ref
		);
	};

	return SankeyChart;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/preLoader/index.js
var preLoader = __webpack_require__("ufjx");

// EXTERNAL MODULE: ./components/sankey/component/style.scss
var component_style = __webpack_require__("fuiZ");
var component_style_default = /*#__PURE__*/__webpack_require__.n(component_style);

// CONCATENATED MODULE: ./components/sankey/component/index.js
var _class, _temp;



function component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function component__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function component__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*********************** Preact *******************************/



/********************** Custom components *********************/



/************************* Style Files ************************/

/**************************************************************/

var _ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref3 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var component_Sankey = (_temp = _class = function (_Component) {
  component__inherits(Sankey, _Component);

  function Sankey(props) {
    component__classCallCheck(this, Sankey);

    var _this = component__possibleConstructorReturn(this, _Component.call(this, props));

    _this.onBudgetChanged = function () {
      // Financial Flow type selector = budget
      _this.setState({ firstChecked: true }, function () {
        _this.props.getBugetType && _this.props.getBugetType(_this.state.firstChecked);
      });

      if (_this.state.year) {
        _this.props.fetchBudgetFinancialFlow(_this.state.year);
      }
    };

    _this.onExpenseChanged = function () {
      // Financial Flow type selector = expense
      _this.setState({ firstChecked: false }, function () {
        _this.props.getBugetType && _this.props.getBugetType(_this.state.firstChecked);
      });
      if (_this.state.year) {
        _this.props.fetchExpenseFinancialFlow(_this.state.year);
      }
    };

    _this.handleClickOutside = function (e) {
      // Close drop down on outside click
      if (_this.node.contains(e.target)) {
        return;
      }
      if (_this.state.modalState && !_this.dropDown.contains(e.target)) {
        _this.switchModalState();
      }
    };

    _this.generateYearList = function () {
      // Financial Flow Year Generator
      return _this.props.timeLine.map(function (data, index) {
        return Object(preact_min["h"])(
          'li',
          { tabIndex: '0',
            onClick: function onClick() {
              _this.props.getSankeyYear && _this.props.getSankeyYear(data);
              _this.handleYearSelection(data);
            } },
          Object(preact_min["h"])(
            'span',
            null,
            data
          )
        );
      });
    };

    _this.switchModalState = function () {
      // Drop Down List state Management
      _this.setState(function (prevState) {
        return {
          modalState: !prevState.modalState // Drop down hide/ show
        };
      });
    };

    _this.handleYearSelection = function (year) {
      // Financial Year Selection
      _this.setState({ year: year, modalState: false }, function () {
        _this.state.firstChecked ? _this.props.fetchBudgetFinancialFlow(_this.state.year) : // Financial Flow type selector = budget
        _this.props.fetchExpenseFinancialFlow(_this.state.year); // Financial Flow type selector = expense
      });
    };

    _this.state = {
      firstChecked: true, // Financial Flow type selector
      year: _this.props.year, // Financial Flow year selector
      modalState: false // Financial Flow year selector drop down state
    };
    return _this;
  }

  Sankey.prototype.componentWillMount = function componentWillMount() {

    if (this.props.embed) {
      var _props = this.props,
          financialFlowType = _props.financialFlowType,
          financialFlowYear = _props.financialFlowYear;

      financialFlowType === 'budget' ? this.props.fetchBudgetFinancialFlow(financialFlowYear) : this.props.fetchExpenseFinancialFlow(financialFlowYear);
    } else {
      if (this.state.year) {
        // Fetch Budget Financial Flow if year available
        this.props.fetchBudgetFinancialFlow(this.state.year);
      }
    }
  };

  Sankey.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    // Fetch Budget Financial Flow only if year is changed
    if (this.props.year != nextProps.year) {
      this.setState({
        year: nextProps.year
      }, function () {
        _this2.state.firstChecked ? _this2.props.fetchBudgetFinancialFlow(nextProps.year) : // Financial Flow type selector = budget
        _this2.props.fetchExpenseFinancialFlow(nextProps.year); // Financial Flow type selector = expense
      });
    }
  };

  Sankey.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener("mousedown", this.handleClickOutside);
    window.addEventListener("touchstart", this.handleClickOutside);
  };

  Sankey.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("mousedown", this.handleClickOutside);
    window.removeEventListener("touchstart", this.handleClickOutside);
  };

  Sankey.prototype.render = function render(props, _ref) {
    var _this3 = this;

    var firstChecked = _ref.firstChecked,
        year = _ref.year,
        modalState = _ref.modalState;

    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(
        'div',
        { 'class': component_style_default.a.financialTab },
        !this.props.embed || this.props.embed === undefined ? Object(preact_min["h"])(
          'div',
          { 'class': component_style_default.a.switch },
          Object(preact_min["h"])('input', { type: 'radio',
            'class': component_style_default.a.switchInput,
            onclick: function onclick() {
              return _this3.onBudgetChanged();
            },
            name: 'financial_flow_type',
            value: 'budget',
            id: 'budget',
            checked: firstChecked }),
          Object(preact_min["h"])(
            'label',
            { 'for': 'budget',
              'class': component_style_default.a.switchLabel + ' ' + component_style_default.a.switchLabeloff },
            'Budget'
          ),
          Object(preact_min["h"])('input', { type: 'radio',
            'class': component_style_default.a.switchInput,
            onclick: function onclick() {
              return _this3.onExpenseChanged();
            },
            name: 'financial_flow_type',
            value: 'expense',
            id: 'expense',
            checked: !firstChecked }),
          Object(preact_min["h"])(
            'label',
            { 'for': 'expense',
              'class': component_style_default.a.switchLabel + ' ' + component_style_default.a.switchLabelon },
            'Expenditure'
          ),
          Object(preact_min["h"])('span', { 'class': component_style_default.a.switchSelection })
        ) : null,
        !this.props.embed || this.props.embed === undefined ? Object(preact_min["h"])(
          'div',
          { 'class': component_style_default.a.buttonsWrapper },
          Object(preact_min["h"])(
            'div',
            { 'class': component_style_default.a.yearWrapper,
              ref: function ref(node) {
                _this3.node = node;
              } },
            Object(preact_min["h"])(
              'div',
              { className: component_style_default.a.dropDownWrapper, onClick: this.switchModalState },
              Object(preact_min["h"])(
                'span',
                { id: component_style_default.a.pageSize },
                year
              )
            ),
            modalState ? Object(preact_min["h"])(
              'div',
              { className: component_style_default.a.pageSizeModal, ref: function ref(node) {
                  return _this3.dropDown = node;
                } },
              Object(preact_min["h"])(
                'ul',
                null,
                this.generateYearList()
              )
            ) : null
          )
        ) : null
      ),
      props.loading ? Object(preact_min["h"])(
        'div',
        { 'class': component_style_default.a.loaderWrapper },
        _ref2
      ) : this.props.items.nodes && this.props.items.links ? Object(preact_min["h"])(sankeyChart_SankeyChart, {
        sankeyYear: year,
        data: this.props.items,
        currentYearSelected: this.props.currentYearSelected }) : _ref3
    );
  };

  return Sankey;
}(preact_min["Component"]), _class.defaultProps = { // Default Props
  firstChecked: true, // Financial Flow type selector - Default selection - Budget
  year: '', // Financial Flow year selector - Default selection - Current Year
  modalState: false // Financial Flow year selector drop down state - Default selection - Dropdown close
}, _temp);

var mapStateToProps = function mapStateToProps(state) {
  var yearList = state.yearList,
      timeLine = state.projectTimeline.year;
  return {
    yearList: yearList,
    timeLine: timeLine
  };
};

/* harmony default export */ var component = (Object(preact_redux_esm["a" /* connect */])(mapStateToProps)(component_Sankey));
// EXTERNAL MODULE: ./components/sankey/actions/budgetFinancialFlowActions.js
var budgetFinancialFlowActions = __webpack_require__("j+nI");

// EXTERNAL MODULE: ./components/sankey/actions/expenseFinancialFlowActions.js
var expenseFinancialFlowActions = __webpack_require__("Jf5u");

// CONCATENATED MODULE: ./components/sankey/index.js
/*********************** Preact *******************************/

/******************** Custom Components ***********************/

/************************* Actions ****************************/


/**************************************************************/

var sankey_mapStateToProps = function mapStateToProps(state) {
    var _state$sankeyData = state.sankeyData,
        loading = _state$sankeyData.loading,
        error = _state$sankeyData.error,
        items = _state$sankeyData.items,
        year = state.yearSummary.data.year;

    return { loading: loading, error: error, items: items, year: year };
};
var sankey_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchBudgetFinancialFlow: function fetchBudgetFinancialFlow(year) {
            return dispatch(Object(budgetFinancialFlowActions["a" /* fetchBudgetFinancialFlow */])(year));
        },
        fetchExpenseFinancialFlow: function fetchExpenseFinancialFlow(year) {
            return dispatch(Object(expenseFinancialFlowActions["a" /* fetchExpenseFinancialFlow */])(year));
        }
    };
};
/* harmony default export */ var sankey = __webpack_exports__["a"] = (Object(preact_redux_esm["a" /* connect */])(sankey_mapStateToProps, sankey_mapDispatchToProps)(component));

/***/ }),

/***/ "FNy/":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = throttle;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "FY1Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getRecipientBasicDetails__ = __webpack_require__("4SAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRecipientTheme__ = __webpack_require__("gaAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getRecipientDocuments__ = __webpack_require__("14MA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRecipientTopBugetSources__ = __webpack_require__("0Z3F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRecipientWindRoseDetails__ = __webpack_require__("8YPz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getRecepientBudgetVsExpense__ = __webpack_require__("EMSi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getRecepientbudgetVsExpenseSdg__ = __webpack_require__("X5/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getRecepientSdg__ = __webpack_require__("wD7O");









var recipientProfile = function recipientProfile(dispatch, code, year, sector, category) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__getRecipientBasicDetails__["b" /* loadRecipientBasic */])(code, year));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__getRecipientTheme__["c" /* loadRecipientTheme */])(code, year));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__getRecepientSdg__["c" /* fetchRecipientSdg */])(code, year));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__getRecipientDocuments__["b" /* fetchRecipientDocuments */])(code, year, category));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__getRecipientTopBugetSources__["b" /* fetchRecipientTopBudgetSources */])(code, year));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__getRecipientWindRoseDetails__["b" /* fetchRecipientWindRose */])(code, year, sector));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__getRecepientBudgetVsExpense__["b" /* fetchRecepientBudgetVsExpense */])(code, year));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__getRecepientbudgetVsExpenseSdg__["b" /* fetchRecepientBudgetVsExpenseSdg */])(code, year));
};

/* harmony default export */ __webpack_exports__["a"] = (recipientProfile);

/***/ }),

/***/ "G9P3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BudgetSource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("zgDO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_utils_numberFormatter__ = __webpack_require__("Au7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_utils_commonMethods__ = __webpack_require__("Cdrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__no_data_template__ = __webpack_require__("wdDn");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__no_data_template__["a" /* default */], null);

var BudgetSource = function (_Component) {
	_inherits(BudgetSource, _Component);

	function BudgetSource(props) {
		_classCallCheck(this, BudgetSource);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			budget_source: []
		};

		_this.dataSorting = function () {
			/**Sorting - Start*/
			if (_this.state.budget_source.length !== 0) {
				var data = _this.state.budget_source.slice();
				data.sort(function (a, b) {
					return a.budget - b.budget;
				});

				/**Sorting - End*/

				var id = 0;
				var result = data.map(function (el) {
					var o = _extends({}, el);
					o.id = id++;
					return o;
				});

				_this.setState({
					budget_source: result
				}, function () {
					_this.setFontSize();
				});
			}
		};

		_this.setFontSize = function () {
			var budget_source = _this.state.budget_source;

			var widthOfDevice = window.outerWidth;
			var division = budget_source[budget_source.length - 1].budget / 15;
			if (widthOfDevice <= 480) {
				budget_source[0].fontSize = 16;
				budget_source[budget_source.length - 1].fontSize = budget_source[budget_source.length - 1].budget > 0 ? 30 : 16;
			} else {
				budget_source[0].fontSize = 14;
				budget_source[budget_source.length - 1].fontSize = budget_source[budget_source.length - 1].budget > 0 ? 30 : 14;
			}

			budget_source.map(function (el, index) {
				if (index != 0 && index != budget_source.length - 1) {
					var priceDiff = division > 0 ? el.budget / division : 0;

					if (widthOfDevice <= 480) {
						budget_source[index].fontSize = 16 + parseInt(priceDiff, 10);
					} else {
						budget_source[index].fontSize = 16 + parseInt(priceDiff, 10);
					}
				}
			});
			_this.setState(_extends({}, _this.state, {
				budget_source: budget_source
			}));
		};

		_this.getStyles = function (id) {
			var currentEl = {};
			_this.state.budget_source.length > 0 && _this.state.budget_source.map(function (el) {
				if (el.id === id) {
					currentEl = el;
				}
			});
			var styles = {

				fontSize: currentEl.fontSize + 'px'
			};
			return styles;
		};

		_this.getBudgetStyles = function (id) {
			var currentEl = {};
			_this.state.budget_source.length > 0 && _this.state.budget_source.map(function (el) {
				if (el.id === id) {
					currentEl = el;
				}
			});
			var styles = {
				fontSize: currentEl.fontSize < 18 ? currentEl.fontSize * 0.90 + 'px' : currentEl.fontSize * 0.75 + 'px'
			};
			return styles;
		};

		_this.onSelectBudgetSource = function (budget_source) {
			if (_this.props.embed) {
				Object(__WEBPACK_IMPORTED_MODULE_4__src_utils_commonMethods__["g" /* openInNewTab */])('/profile/' + budget_source.organisation + '/donorprofile', function () {});
			} else {
				Object(__WEBPACK_IMPORTED_MODULE_2_preact_router__["route"])('/profile/' + budget_source.organisation + '/donorprofile');
			}
		};

		_this.state = {
			budget_source: _this.props.data ? _this.props.data : []
		};
		return _this;
	}

	/*To dynamically calculate the font-size of each names in Tag Cloud = Start**/


	BudgetSource.prototype.componentWillMount = function componentWillMount() {
		this.dataSorting();
	};

	BudgetSource.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		var _this2 = this;

		if (nextProps.data !== this.props.data) this.setState({
			budget_source: nextProps.data
		}, function () {
			_this2.dataSorting();
		});
	};

	BudgetSource.prototype.render = function render() {
		var _this3 = this;

		var isBudgetSourceNonEmpty = this.props.data.length > 0;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.budgetComponentWrapper },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.budgetWrapper },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'p',
					{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.budgetHeading },
					'Donors (',
					this.state.budget_source.length,
					')'
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.projectWrapper },
					this.state.budget_source.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						null,
						this.state.budget_source.map(function (el, index) {
							return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'span',
								{ key: index, 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.project, onClick: function onClick() {
										_this3.onSelectBudgetSource(el);
									} },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'span',
									{ style: _this3.getBudgetStyles(el.id),
										className: __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.projectPrice },
									Object(__WEBPACK_IMPORTED_MODULE_3__src_utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(el.budget, 2)
								),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'p',
									{ style: _this3.getStyles(el.id) },
									el.organisation_name,
									' ',
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'strong',
										null,
										'(',
										el.iucn_member ? ' IUCN Member' : ' IUCN Non-member',
										')'
									)
								)
							);
						})
					) : _ref
				)
			)
		);
	};

	return BudgetSource;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "Gnd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/index.js
var projectDetailActions = __webpack_require__("csCp");

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// EXTERNAL MODULE: ./components/projectDonutBarChart/donutBarChart/style.scss
var style = __webpack_require__("gxLQ");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./components/projectDonutBarChart/donutChart/style.scss
var donutChart_style = __webpack_require__("ykHf");
var donutChart_style_default = /*#__PURE__*/__webpack_require__.n(donutChart_style);

// EXTERNAL MODULE: ../node_modules/d3/d3.js
var d3 = __webpack_require__("tokj");
var d3_default = /*#__PURE__*/__webpack_require__.n(d3);

// EXTERNAL MODULE: ./components/donut-chart-legend/index.js
var donut_chart_legend = __webpack_require__("kwbv");

// EXTERNAL MODULE: ./utils/commonActionUtils.js
var commonActionUtils = __webpack_require__("I9r4");

// CONCATENATED MODULE: ./components/projectDonutBarChart/donutChart/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var donutChart_DonutChart = function (_Component) {
    _inherits(DonutChart, _Component);

    function DonutChart(props) {
        _classCallCheck(this, DonutChart);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.drawDonut = function () {
            var EDGE = window.navigator.userAgent.indexOf("Edge") > -1,
                IE = false || !!document.documentMode,
                EDGE_IE = EDGE || IE;

            var that = _this;

            var data = _this.state.data;
            var width = _this.props.chartWidth ? _this.props.chartWidth : 400,
                height = _this.props.chartHeight ? _this.props.chartHeight : 400,
                radius = Math.min(width, height) / 2,
                labelr = radius + 40,
                outerRadius = _this.props.outerRadius || radius - 10,
                innerRadius = _this.props.innerRadius || radius - 70;

            var arc = d3_default.a.svg.arc().outerRadius(outerRadius).innerRadius(innerRadius);

            var pie = d3_default.a.layout.pie().sort(null).value(function (d) {
                return d.percentage;
            }).padAngle(0);

            var onHover = function onHover(d) {
                _this.setState({
                    label: d.data.fund_stream || d.data.fund_type || d.data.sector_name || d.data.sdg_name,
                    index: d.data && d.data.sdg_name && _this.props.sdgIndex ? _this.props.sdgIndex.find(function (sdg) {
                        return sdg.name === d.data.sdg_name;
                    }).code : null,
                    percentage: d.data.percentage,
                    sdg_code: d.data.sdg_code,
                    total_contribution: !isNaN(d.data.total_contribution) ? d.data.total_contribution : d.data.budget ? d.data.budget : d.data.theme_budget
                }, function () {});
            };

            if (!d3_default.a.select('#' + _this.props.chart_id).empty()) {
                d3_default.a.select('#' + _this.props.chart_id + ' svg').remove();
            }

            var svg = d3_default.a.select('#' + _this.props.chart_id).append("svg").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", "0 0 " + width + " " + height).classed(donutChart_style_default.a.svgIe + ' ' + _this.props.svgIe, true).append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ") scale(0.7, 0.7)");

            var g = svg.selectAll(".arc").data(pie(data)).enter().append("g").attr("class", "arc");

            var newArcs = g.append("path").attr("d", arc).style("fill", function (d) {
                return "#" + (d.data.color || d.data.sector_color || d.data.sdg_color);
            });

            var _newArcs$ = newArcs[0],
                firstArc = _newArcs$[0],
                lastArc = _newArcs$.slice(1);

            firstArc.style.opacity = 1;
            firstArc.setAttribute("transform", 'scale(1.025,1.025)');
            firstArc.style.stroke = "#eee";
            firstArc.style.strokeWidth = "1px";
            lastArc.forEach(function (item) {
                item.style.transform = 'scale(1, 1)';
                item.style.stroke = "#eee";
                item.style.strokeWidth = "1px";
            });
            !_this.props.exportLegend && newArcs.on("mouseover", function (d, i) {

                if (EDGE_IE) {
                    var newArray = [];
                    d3_default.a.select('#' + that.props.chart_id).selectAll(".arc")[0].forEach(function (item) {

                        for (var i = 0, len = item.childNodes.length; i < 1; ++i) {
                            var child = item.childNodes[i];
                            newArray.push(child);
                            if (child.nodeType !== 1 /*Node.ELEMENT_NODE*/) continue;
                            // Now, do whatever you want with the child element.
                        }
                    });
                    var all = [].concat(newArray);

                    all.forEach(function (item) {
                        item.style.opacity = 1;
                        item.setAttribute("transform", 'scale(1,1)');
                    });

                    var current = d3_default.a.event.target;
                    current.setAttribute("transform", 'scale(1.025,1.025)');
                    current.style.stroke = "#eee";
                    current.style.strokeWidth = "1px";
                    onHover(d);
                } else {
                    var all = d3_default.a.select('#' + that.props.chart_id).selectAll(".arc")[0].filter(function (item) {
                        return item.children && item.children[0] !== d3_default.a.event.target;
                    });
                    d3_default.a.selectAll(all).selectAll("path").style('transform', 'scale(1,1)').style('opacity', 1);

                    var _current = d3_default.a.event.target;
                    _current.style.transform = 'scale(1.025,1.025)';
                    _current.style.stroke = "#eee";
                    _current.style.strokeWidth = "1px";
                    onHover(d);
                }
            });
        };

        _this.state = {
            data: _this.props.data ? _this.props.data : [],
            label: _this.props.data[0] && (_this.props.data[0].fund_stream || _this.props.data[0].fund_type || _this.props.data[0].sector_name || _this.props.data[0].sdg_name) ? _this.props.data[0].fund_stream || _this.props.data[0].fund_type || _this.props.data[0].sector_name || _this.props.data[0].sdg_name : "",
            index: _this.props.data && _this.props.data[0].sdg_name && _this.props.sdgIndex ? _this.props.sdgIndex.find(function (sdg) {
                return sdg.name === _this.props.data[0].sdg_name;
            }).code : null,
            sdg_code: _this.props.data[0] && _this.props.data[0].sdg_code ? _this.props.data[0].sdg_code : "",
            percentage: _this.props.data[0] && _this.props.data[0].percentage ? _this.props.data[0].percentage : 0,
            total_contribution: _this.props.data[0] ? !isNaN(_this.props.data[0].total_contribution) ? _this.props.data[0].total_contribution : _this.props.data[0].budget ? _this.props.data[0].budget : _this.props.data[0].theme_budget : 0
        };
        return _this;
    }

    DonutChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        this.setState({
            data: nextProps.data,
            label: nextProps.data[0] && (nextProps.data[0].fund_stream || nextProps.data[0].fund_type || nextProps.data[0].sector_name || this.props.data[0].sdg_name) ? nextProps.data[0].fund_stream || nextProps.data[0].fund_type || nextProps.data[0].sector_name || this.props.data[0].sdg_name : "",
            index: this.props.data && this.props.data[0].sdg_name && this.props.sdgIndex ? this.props.sdgIndex.find(function (sdg) {
                return sdg.name === _this2.props.data[0].sdg_name;
            }).code : null,
            sdg_code: nextProps.data[0] && nextProps.data[0].sdg_code ? nextProps.data[0].sdg_code : "",
            percentage: nextProps.data[0] && nextProps.data[0].percentage ? nextProps.data[0].percentage : 0,
            total_contribution: nextProps.data[0] ? !isNaN(nextProps.data[0].total_contribution) ? nextProps.data[0].total_contribution : nextProps.data[0].budget ? nextProps.data[0].budget : nextProps.data[0].theme_budget : 0
        }, function () {
            if (nextProps.data.length !== 0) {
                _this2.drawDonut();
            }
        });
    };

    DonutChart.prototype.componentDidMount = function componentDidMount() {
        if (this.props.data.length !== 0 && this.props.chart_id) {
            this.drawDonut();
        }
    };

    DonutChart.prototype.calculateTotalContribution = function calculateTotalContribution(dataset) {
        var total_contribution = 0;
        dataset.forEach(function (item, index) {
            total_contribution += item.theme_budget;
        });
        return Object(numberFormatter["d" /* numberToCurrencyFormatter */])(parseFloat(total_contribution), 2);
    };

    DonutChart.prototype.render = function render(props, _ref) {
        var label = _ref.label,
            percentage = _ref.percentage,
            total_contribution = _ref.total_contribution,
            sdg_code = _ref.sdg_code,
            index = _ref.index;

        var sdg_src = sdg_code && Object(commonActionUtils["c" /* getSDGImageFromCode */])(sdg_code);

        return Object(preact_min["h"])(
            'div',
            { 'class': donutChart_style_default.a.donut_wrapper + ' ' + this.props.donor_wrapper_styles, style: { marginTop: 14 } },
            Object(preact_min["h"])(
                'div',
                { 'class': donutChart_style_default.a.donut + ' ' + this.props.donut_styles, id: this.props.chart_id },
                !this.props.exportLegend && (percentage != 0 || percentage != "") ? Object(preact_min["h"])(
                    'div',
                    { 'class': this.props.percDiv },
                    Object(preact_min["h"])(
                        'section',
                        { 'class': donutChart_style_default.a.textLabel + ' ' + this.props.textWrapperStyle },
                        sdg_code ? Object(preact_min["h"])(
                            'span',
                            { 'class': donutChart_style_default.a.imageWrapper },
                            Object(preact_min["h"])('img', { 'class': donutChart_style_default.a.sdg_image, src: '../../../static/assets/icons/' + sdg_src, alt: 'sdg image' })
                        ) : null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': donutChart_style_default.a.perc + ' ' + this.props.donutCenterText },
                            percentage == parseInt(percentage) ? parseFloat(percentage).toFixed(1) + '%' : percentage >= 1 ? parseFloat(percentage).toFixed(1) + '%' : '< 1%'
                        ),
                        total_contribution ? Object(preact_min["h"])(
                            'span',
                            { 'class': donutChart_style_default.a.dollor + ' ' + this.props.dollor },
                            Object(numberFormatter["d" /* numberToCurrencyFormatter */])(total_contribution, 2)
                        ) : Object(preact_min["h"])(
                            'span',
                            { 'class': donutChart_style_default.a.perc + ' ' + donutChart_style_default.a.contributionText + ' ' + this.props.donutCenterText },
                            Object(numberFormatter["d" /* numberToCurrencyFormatter */])(percentage)
                        )
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': donutChart_style_default.a.textField + ' ' + this.props.textFieldStyle },
                        index,
                        '. ',
                        label
                    )
                ) : null,
                this.props.exportLegend && Object(preact_min["h"])(
                    'section',
                    { 'class': donutChart_style_default.a.textLabel + ' ' + this.props.textWrapperStyle },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': donutChart_style_default.a.dollor },
                        this.calculateTotalContribution(props.data)
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': donutChart_style_default.a.textField + ' ' + this.props.textFieldStyle },
                        'Total Contribution'
                    )
                )
            ),
            this.props.displayLegend && this.props.displayLegend == 'false' ? null : Object(preact_min["h"])(
                'div',
                { 'class': donutChart_style_default.a.legend + ' ' + this.props.legend_styles + ' ' + this.props.ourFocusLegendStyles },
                Object(preact_min["h"])(donut_chart_legend["a" /* default */], { legendLabel: this.props.legendLabel, legendData: this.props.legendData })
            ),
            this.props.exportLegend ? Object(preact_min["h"])(
                'div',
                { 'class': donutChart_style_default.a.exportLegend + ' ' + this.props.legend_styles },
                Object(preact_min["h"])(
                    'ul',
                    { 'class': donutChart_style_default.a.legendWrapper },
                    this.props.data.map(function (item, index) {
                        return Object(preact_min["h"])(
                            'li',
                            { 'class': donutChart_style_default.a.legendItem },
                            Object(preact_min["h"])('span', { 'class': donutChart_style_default.a.legendColor, style: { backgroundColor: '#' + item.color } }),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': donutChart_style_default.a.legendDescription },
                                item.fund_stream
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': donutChart_style_default.a.legendPercentage },
                                Object(numberFormatter["f" /* roundTo */])(item.percentage, 2),
                                '%'
                            )
                        );
                    })
                )
            ) : null
        );
    };

    return DonutChart;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/listView/index.js + 1 modules
var listView = __webpack_require__("lo/D");

// EXTERNAL MODULE: ./components/projectDonutBarChart/donutBarChart/components/barChartItem/style.scss
var barChartItem_style = __webpack_require__("ygBH");
var barChartItem_style_default = /*#__PURE__*/__webpack_require__.n(barChartItem_style);

// CONCATENATED MODULE: ./components/projectDonutBarChart/donutBarChart/components/barChartItem/index.js


function barChartItem__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function barChartItem__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function barChartItem__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var barChartItem_ChartItem = function (_Component) {
  barChartItem__inherits(ChartItem, _Component);

  function ChartItem(props, context) {
    barChartItem__classCallCheck(this, ChartItem);

    var _this = barChartItem__possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.state = {
      styles: {
        allDonorWrapper: {
          width: _this.props.data.budgetPercentage + "%",
          height: 25,
          backgroundColor: '#42689b',
          borderLeftWidth: 1,
          borderColor: '#42689b',
          verticalAlign: "middle"
        },
        countryWrapper: {
          width: _this.props.data.expensePercentage + "%",
          height: 25,
          backgroundColor: "#cae1f7",
          verticalAlign: "middle"
        }
      }
    };
    return _this;
  }

  ChartItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      styles: {
        allDonorWrapper: {
          height: 25,
          verticalAlign: "middle",
          width: nextProps.data.budgetPercentage + "%",
          backgroundColor: '#42689b',
          borderLeftWidth: 1,
          borderColor: '#42689b'
        },
        countryWrapper: {
          width: nextProps.data.expensePercentage + "%",
          height: 25,
          backgroundColor: "#cae1f7",
          verticalAlign: "middle"
        }
      }
    });
  };

  ChartItem.prototype.render = function render() {
    var _this2 = this;

    var sdg_src = this.props.data.sdg_code && Object(commonActionUtils["c" /* getSDGImageFromCode */])(this.props.data.sdg_code);
    return Object(preact_min["h"])(
      "section",
      { "class": barChartItem_style_default.a.wrapper + " " + barChartItem_style_default.a.wrapperSdg },
      Object(preact_min["h"])(
        "div",
        { "class": barChartItem_style_default.a.rowLegend },
        this.props.data.sdg_code ? Object(preact_min["h"])(
          "span",
          { "class": barChartItem_style_default.a.imageWrapper },
          Object(preact_min["h"])("img", { "class": barChartItem_style_default.a.sdg_image, src: "../../../static/assets/icons/" + sdg_src, alt: "sdg image" })
        ) : Object(preact_min["h"])("div", { "class": barChartItem_style_default.a.innerLegend, style: { backgroundColor: '#' + this.props.data.sdg_color } })
      ),
      Object(preact_min["h"])(
        "div",
        { "class": barChartItem_style_default.a.row },
        Object(preact_min["h"])(
          "span",
          { "class": barChartItem_style_default.a.barType },
          this.props.data.sector_name ? this.props.data.sector_name : this.props.sdgIndex ? this.props.sdgIndex.find(function (sdg) {
            return sdg.name === _this2.props.data.sdg_name;
          }).code + '. ' + this.props.data.sdg_name : this.props.data.sdg_name
        )
      ),
      Object(preact_min["h"])(
        "div",
        { "class": barChartItem_style_default.a.row, style: { marginTop: 'auto', marginBottom: 'auto' } },
        Object(preact_min["h"])(
          "div",
          { "class": barChartItem_style_default.a.rowWrapper },
          Object(preact_min["h"])("div", {
            "class": barChartItem_style_default.a.allDonorWrapper + " " + barChartItem_style_default.a.rowWrapperItem,
            style: this.state.styles.allDonorWrapper
          }),
          Object(preact_min["h"])(
            "div",
            { "class": barChartItem_style_default.a.text, style: { left: this.state.styles.allDonorWrapper.width, width: 'max-content' } },
            Object(preact_min["h"])(
              "span",
              { "class": barChartItem_style_default.a.barValue },
              Object(numberFormatter["d" /* numberToCurrencyFormatter */])(this.props.data.sdg_budget, 2)
            )
          )
        ),
        Object(preact_min["h"])(
          "div",
          { "class": barChartItem_style_default.a.rowWrapper },
          Object(preact_min["h"])("div", {
            "class": barChartItem_style_default.a.countryWrapper + " " + barChartItem_style_default.a.rowWrapperItem,
            style: this.state.styles.countryWrapper
          }),
          Object(preact_min["h"])(
            "div",
            { "class": barChartItem_style_default.a.text, style: { left: this.state.styles.allDonorWrapper.width, width: 'max-content' } },
            Object(preact_min["h"])(
              "span",
              { "class": barChartItem_style_default.a.barValue },
              Object(numberFormatter["d" /* numberToCurrencyFormatter */])(this.props.data.sdg_expense, 2)
            )
          )
        )
      )
    );
  };

  return ChartItem;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/projectDonutBarChart/donutBarChart/components/groupedBarChart/style.scss
var groupedBarChart_style = __webpack_require__("ai+R");
var groupedBarChart_style_default = /*#__PURE__*/__webpack_require__.n(groupedBarChart_style);

// CONCATENATED MODULE: ./components/projectDonutBarChart/donutBarChart/components/groupedBarChart/index.js


function groupedBarChart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function groupedBarChart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function groupedBarChart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var groupedBarChart_GroupedBarChart = function (_Component) {
	groupedBarChart__inherits(GroupedBarChart, _Component);

	function GroupedBarChart(props, context) {
		groupedBarChart__classCallCheck(this, GroupedBarChart);

		var _this = groupedBarChart__possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.renderRow = function (item, index) {
			return Object(preact_min["h"])(barChartItem_ChartItem, {
				label1: _this.props.label1,
				label2: _this.props.label2,
				data: item.item,
				sdgIndex: _this.props.sdgIndex,
				index: index
			});
		};

		return _this;
	}

	GroupedBarChart.prototype.render = function render() {

		return Object(preact_min["h"])(
			'div',
			{ 'class': groupedBarChart_style_default.a.wrapper },
			Object(preact_min["h"])(
				'div',
				{ style: { border: '1px solid #ccc', borderRadius: '7px', padding: 25 }, 'class': groupedBarChart_style_default.a.list_wrapper },
				this.props.data && this.props.data.length ? Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						'div',
						{ 'class': groupedBarChart_style_default.a.legendOuterWrapper },
						Object(preact_min["h"])('div', { 'class': groupedBarChart_style_default.a.legendInnerWrapper })
					),
					Object(preact_min["h"])(listView["a" /* default */], {
						data: this.props.data,
						renderItem: this.renderRow
					})
				) : Object(preact_min["h"])(
					'span',
					{ 'class': groupedBarChart_style_default.a.noResults },
					'No Results'
				)
			)
		);
	};

	return GroupedBarChart;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/no-data-template/index.js
var no_data_template = __webpack_require__("wdDn");

// EXTERNAL MODULE: ./components/preLoader/index.js
var preLoader = __webpack_require__("ufjx");

// EXTERNAL MODULE: ./components/budget-expense-legend/index.js
var budget_expense_legend = __webpack_require__("COsE");

// CONCATENATED MODULE: ./components/projectDonutBarChart/donutBarChart/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function donutBarChart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function donutBarChart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function donutBarChart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var donutBarChart__ref = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref2 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref4 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var _ref5 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var donutBarChart_DonutBarCharts = function (_Component) {
    donutBarChart__inherits(DonutBarCharts, _Component);

    function DonutBarCharts() {
        donutBarChart__classCallCheck(this, DonutBarCharts);

        return donutBarChart__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DonutBarCharts.prototype.render = function render() {

        if (this.props.barChartData.data) {
            if (this.props.barChartData.data.length > 0) {
                if (this.props.barChartData.data[0].sdg_code) {
                    this.props.barChartData.data = this.props.barChartData.data.map(function (element) {
                        var data = _extends({}, element, {
                            total_budgetNumber: parseFloat(element.total_budget)
                        });
                        return data;
                    });
                    var others = _.remove(this.props.barChartData.data, function (element) {
                        return element.sdg_code === "0";
                    });
                    var sortedArray = this.props.barChartData.data.sort(function (item1, item2) {
                        return item1.total_budgetNumber < item2.total_budgetNumber ? 1 : item2.total_budgetNumber < item1.total_budgetNumber ? -1 : 0;
                    });
                    others.length > 0 ? sortedArray.push(others[0]) : null;
                    this.props.barChartData.data = sortedArray;
                    ;
                }
            }
        }
        this.props.donutData.data;
        var donutDataArray = Array.isArray(this.props.donutData.data) ? this.props.donutData.data : [];

        this.props.sdg === 'true' && this.props.donutData.data ? this.props.donutData.data = donutDataArray.map(function (element) {
            return _extends({}, element, {
                budget: element.sdg_budget || element.budget_percentage
            });
        }) : this.props.donutData.data = donutDataArray.map(function (element) {
            return _extends({}, element, {
                budget: element.budget_percentage
            });
        });

        return Object(preact_min["h"])(
            'div',
            { 'class': style_default.a.wrapper },
            this.props.donutData.loading ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.preLoaderWrapper },
                donutBarChart__ref
            ) : this.props.donutData.data.length !== 0 ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.donutChartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': style_default.a.headerWrapper },
                    '% of Budget'
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': style_default.a.donuttopWrapper },
                    Object(preact_min["h"])(donutChart_DonutChart, {
                        sdg: this.props.sdg,
                        data: this.props.donutData.data,
                        legendData: [{}, {}],
                        chartWidth: 456,
                        chartHeight: 456,
                        chart_id: this.props.donutChartId,
                        sdgIndex: this.props.sdgIndex,
                        textFieldStyle: this.props.recipientProfile === 'true' ? style_default.a.recipientProfileChartHeaderInfo : this.props.textFieldSDGStyle ? this.props.textFieldSDGStyle : style_default.a.textFieldStyle,
                        textWrapperStyle: style_default.a.textWrapperStyle,
                        donor_wrapper_styles: style_default.a.donorWrapperStyle,
                        displayLegend: 'false',
                        displayRegularLegend: 'false'
                    })
                )
            ) : Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.noDataTemplateWrapper },
                _ref2
            ),
            this.props.barChartData.loading ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.preLoaderWrapper },
                _ref3
            ) : this.props.barChartData.data.length !== 0 ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.barChartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': style_default.a.headerWrapper },
                    'Budget - Expenditure',
                    _ref4
                ),
                Object(preact_min["h"])(groupedBarChart_GroupedBarChart, {
                    label1: 'Budget',
                    label2: 'Expenditure',
                    sdgIndex: this.props.sdgIndex,
                    data: this.props.barChartData.data
                })
            ) : Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.noDataTemplateWrapper },
                _ref5
            )
        );
    };

    return DonutBarCharts;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/preact-helmet/lib/Helmet.js
var Helmet = __webpack_require__("FJnM");
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./components/projectDescription/style.scss
var projectDescription_style = __webpack_require__("JNi8");
var projectDescription_style_default = /*#__PURE__*/__webpack_require__.n(projectDescription_style);

// CONCATENATED MODULE: ./components/projectDonutBarChart/index.js


function projectDonutBarChart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function projectDonutBarChart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function projectDonutBarChart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/************************* Preact Files ************************/



/************************* Custom Component Files ************************/


/************************* Third Party  Files ************************/


/************************* Style Files ************************/



var projectDonutBarChart__ref = Object(preact_min["h"])(preLoader["a" /* default */], null);

var projectDonutBarChart_ProjectDonut = function (_Component) {
	projectDonutBarChart__inherits(ProjectDonut, _Component);

	function ProjectDonut(props) {
		projectDonutBarChart__classCallCheck(this, ProjectDonut);

		var _this = projectDonutBarChart__possibleConstructorReturn(this, _Component.call(this, props));

		_this.componentDidMount = function () {

			_this.props.fetchProjectProgramAreas(_this.props.projectId, _this.props.year);
		};

		_this.handleOnClick = function (e) {
			if (e.size && e.size != 1) {}
		};

		_this.onTargetClick = function (e) {

			if (e.name) {
				var targetIds = e.name.replace('Target', '').trim().split('.');
				window.location = '/programme-area/targets/' + targetIds[0] + '/' + targetIds[1];
			}
		};

		_this.onSDGClick = function (e) {
			return;
			if (e.parent.name.includes('PA')) {
				window.location = '/programme-area/' + e.parent.code + '/' + e.parent.fullName;
			}
		};

		return _this;
	}

	ProjectDonut.prototype.piechartData = function piechartData(resp) {
		resp.sdg.map(function (obj) {
			obj.fullName = obj.name;
			obj.name = 'Programme Area ' + obj.code;
			obj.image = '/static/assets/icons/sdg/PA-' + obj.code + '.svg';
		});
		var tempData = { name: '', size: 1 };
		tempData.children = resp.sdg;
		resp = tempData;
		return resp;
	};

	ProjectDonut.prototype.render = function render(props) {
		return Object(preact_min["h"])(
			'div',
			{ style: { margin: 'auto', maxWidth: '1200px' } },
			Object(preact_min["h"])(
				'div',
				{ style: { borderBottom: '1px solid rgb(204, 204, 204)', marginBottom: '70px' } },
				Object(preact_min["h"])(
					'span',
					{ style: { margin: '0' }, 'class': projectDescription_style_default.a.theme_slider_title },
					'Programme Areas'
				),
				this.props.projectDetail && this.props.projectDetail.programAreaBudget && this.props.projectDetail.programAreaBudget.data && this.props.projectDetail.programAreaBudget.data ? Object(preact_min["h"])(donutBarChart_DonutBarCharts, {
					donutData: this.props.projectDetail.programAreaBudget,
					donutChartId: 'budget_area',
					barChartData: this.props.projectDetail.programAreaBudget,
					sdg: 'true',
					recipientProfile: 'true'
				}) : Object(preact_min["h"])(
					'div',
					{ style: { position: 'relative', height: 344 } },
					projectDonutBarChart__ref
				)
			),
			Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'span',
					{ style: { marginLeft: '0' }, 'class': projectDescription_style_default.a.theme_slider_title },
					'SDG'
				),
				Object(preact_min["h"])(donutBarChart_DonutBarCharts, {
					donutData: this.props.projectDetail.projectSDGBudget,
					donutChartId: 'project_sdg_budget_area',
					barChartData: this.props.projectDetail.projectSDGBudget,
					sdg: 'true',
					recipientProfile: 'true',
					sdgIndex: this.props.sdgIndex
				})
			)
		);
	};

	return ProjectDonut;
}(preact_min["Component"]);

var mapStateToProps = function mapStateToProps(state) {
	var projectDetailMapData = state.mapData.projectDetailMapData;

	var mapCountryData = state.mapData;
	var sdg = state.sdgData;
	return {
		projectDetail: state.projectDetail,
		projectDetailMapData: projectDetailMapData,
		mapCountryData: mapCountryData,
		sdgIndex: sdg.data
	};
};

var projectDonutBarChart_mapDispatch = function mapDispatch(dispatch) {
	return {
		fetchProjectProgramAreas: function fetchProjectProgramAreas(id, year) {
			return dispatch(Object(projectDetailActions["c" /* fetchProjectProgramAreas */])(id, year));
		},
		fetchProjectDetailsOnSelection: function fetchProjectDetailsOnSelection(id) {
			return dispatch(Object(projectDetailActions["b" /* fetchProjectDetailsOnSelection */])(id));
		}
	};
};

/* harmony default export */ var projectDonutBarChart = __webpack_exports__["a"] = (Object(preact_redux_esm["a" /* connect */])(mapStateToProps, projectDonutBarChart_mapDispatch)(projectDonutBarChart_ProjectDonut));

/***/ }),

/***/ "HX72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("zKRB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ProgressBar = function (_Component) {
  _inherits(ProgressBar, _Component);

  function ProgressBar(props, context) {
    _classCallCheck(this, ProgressBar);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.state = {
      styles: {
        progressWrapper: {
          width: _this.props.percentage + '%',
          backgroundColor: _this.props.color
        },
        progressPercent: {
          color: _this.props.color,
          fontFamily: 'Bebas',
          left: _this.props.percentage + '%'
        }
      }
    };
    return _this;
  }

  ProgressBar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      styles: {
        progressWrapper: {
          width: nextProps.percentage + '%',
          backgroundColor: nextProps.color
        },
        progressPercent: {
          color: nextProps.color,
          fontFamily: 'Bebas',
          left: nextProps.percentage + '%'
        }
      }
    });
  };

  ProgressBar.prototype.render = function render() {
    var percentage =
    // this.props.tabSelected === "sdg" ? Math.ceil(this.props.percentage) :
    parseFloat(this.props.percentage).toFixed(1);
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.progressOuterWrapper },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.progressWrapper, style: this.state.styles.progressWrapper }),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.progressPercent, style: this.state.styles.progressPercent },
          !parseInt(percentage) ? '<1' : percentage,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'span',
            { style: this.state.styles.progressPercentage },
            '%'
          )
        )
      )
    );
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "Ho0Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ./components/paSunburstChart/style.scss
var style = __webpack_require__("iN9L");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/d3/d3.js
var d3 = __webpack_require__("tokj");
var d3_default = /*#__PURE__*/__webpack_require__.n(d3);

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// EXTERNAL MODULE: ./utils/commonActionUtils.js
var commonActionUtils = __webpack_require__("I9r4");

// EXTERNAL MODULE: ./utils/commonMethods.js
var commonMethods = __webpack_require__("Cdrj");

// EXTERNAL MODULE: ./components/paSunburstChart/components/sdgLegend/style.scss
var sdgLegend_style = __webpack_require__("jUQA");
var sdgLegend_style_default = /*#__PURE__*/__webpack_require__.n(sdgLegend_style);

// CONCATENATED MODULE: ./components/paSunburstChart/constants.js


var TOOLTIP_LABEL = 'rightSDGTooltip';
var SDG_OTHERS = "0";

function TOOLTIP_HTML(sdg) {
    return '<span><b>' + sdg.name + ': </b></span><span>' + sdg.fullName + '</span><br><span"><b>Budget: </b></span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(sdg.size.budget, 0) + '</span><br><span"><b> Expenditure: </b></span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(sdg.size.expense, 0) + '</span>';
}
// CONCATENATED MODULE: ./components/paSunburstChart/components/sdgLegend/index.js




var getItemPercentage = function getItemPercentage(data, code) {
	var total = data.map(function (row) {
		return row.children.reduce(function (total, item) {
			return total + item.size.budget;
		}, 0);
	}).reduce(function (total, item) {
		return total + item;
	}, 0);
	var element = data.find(function (item) {
		return item.code === code;
	}).children.reduce(function (total, item) {
		return total + item.size.budget;
	}, 0);
	return (100 * element / total).toFixed(1);
};

var getData = function getData(data, side) {
	return side === "right" ? data.slice(0, Math.ceil(data.length / 2)) : data.slice(Math.ceil(data.length / 2), data.length);
};

var getItemLink = function getItemLink(item) {
	var cleaned = item.name.replace("Target ", "");
	var firstPart = cleaned.substring(0, cleaned.indexOf("."));
	var secondPart = cleaned.substring(cleaned.indexOf(".") + 1);
	return '/programme-area/targets/' + firstPart + '/' + secondPart;
};

var sdgLegend_SDGLegend = function SDGLegend(props) {
	return Object(preact_min["h"])(
		'div',
		{ 'class': sdgLegend_style_default.a.sdgLegend },
		props.data && getData(props.data, props.side).map(function (itemMain) {
			return Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'div',
					{ style: { marginTop: '20px' }, 'class': (props.side === "right" ? sdgLegend_style_default.a.sdgItem : sdgLegend_style_default.a.sdgItemRight) + ' ' + (props.sdgTooltip === TOOLTIP_LABEL ? sdgLegend_style_default.a.rightSDG : sdgLegend_style_default.a.leftSDG) },
					Object(preact_min["h"])(
						'span',
						{ style: itemMain.code !== SDG_OTHERS ? { backgroundColor: '#' + itemMain.color } : null, 'class': sdgLegend_style_default.a.sdgImageTop
						},
						Object(preact_min["h"])('img', { 'class': itemMain.code !== SDG_OTHERS ? sdgLegend_style_default.a.imageItem : sdgLegend_style_default.a.othersItem,
							src: props.baseURL + ('' + itemMain.image)
						})
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': sdgLegend_style_default.a.sdgName },
						Object(preact_min["h"])(
							'a',
							{
								href: '/programme-area/' + itemMain.code + '/' + itemMain.fullName,
								target: props.embed ? '_blank' : '_self'
							},
							Object(preact_min["h"])(
								'span',
								{ 'class': sdgLegend_style_default.a.sdgName },
								itemMain.fullName
							)
						)
					),
					props.side === "right" ? Object(preact_min["h"])(
						'div',
						{ className: sdgLegend_style_default.a.mainPercentageWrapper },
						Object(preact_min["h"])('div', { style: { backgroundColor: '#' + itemMain.color } }),
						Object(preact_min["h"])(
							'span',
							null,
							getItemPercentage(props.data, itemMain.code),
							'%'
						)
					) : Object(preact_min["h"])(
						'div',
						{ className: sdgLegend_style_default.a.mainPercentageWrapper },
						Object(preact_min["h"])(
							'span',
							null,
							getItemPercentage(props.data, itemMain.code),
							'%'
						),
						Object(preact_min["h"])('div', { style: { backgroundColor: '#' + itemMain.color } })
					)
				),
				itemMain.children.map(function (item, index) {
					return Object(preact_min["h"])(
						'div',
						{ 'class': sdgLegend_style_default.a.sdgItem + ' ' + (props.sdgTooltip === TOOLTIP_LABEL ? sdgLegend_style_default.a.rightSDG : sdgLegend_style_default.a.leftSDG), key: index },
						Object(preact_min["h"])(
							'span',
							{ style: { 'width': '10%', 'marginRight': '20px' } },
							Number(item.size.percentage).toFixed(1),
							'%'
						),
						Object(preact_min["h"])('span', { 'class': sdgLegend_style_default.a.sdgImage,
							style: item.code !== SDG_OTHERS ? { backgroundColor: '#' + itemMain.color } : null
						}),
						item.code === SDG_OTHERS ? Object(preact_min["h"])(
							'span',
							{ id: props.sdgTooltip + '-' + index, 'class': sdgLegend_style_default.a.sdgName },
							' ',
							item.name,
							' '
						) : Object(preact_min["h"])(
							'a',
							{
								style: { 'padding': '0 10px' }, id: props.sdgTooltip + '-' + index,
								href: getItemLink(item),
								target: props.embed ? '_blank' : '_self'
							},
							Object(preact_min["h"])(
								'span',
								{ 'class': sdgLegend_style_default.a.sdgName },
								item.name
							)
						)
					);
				})
			);
		}),
		Object(preact_min["h"])('div', { id: props.sdgTooltip, 'class': sdgLegend_style_default.a.sdgTooltip })
	);
};

/* harmony default export */ var sdgLegend = (sdgLegend_SDGLegend);
// EXTERNAL MODULE: ./routes/sdgLanding/action/index.js
var action = __webpack_require__("24AF");

// CONCATENATED MODULE: ./components/paSunburstChart/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**************************** Preact files ******************************/



/**************************** Style files******************************/


/**************************** Components ******************************/







var paSunburstChart_SunburstChart = function (_Component) {
    _inherits(SunburstChart, _Component);

    function SunburstChart(props) {
        _classCallCheck(this, SunburstChart);

        var _this2 = _possibleConstructorReturn(this, _Component.call(this, props));

        _this2.isIE = false;
        _this2.mainArr = _this2.props.data;
        _this2.firstNewArr = _this2.props.data && _this2.props.data.children && _this2.props.data.children[5];
        _this2.state = {
            init: 'false',
            data: _this2.props.data
        };

        return _this2;
    }

    SunburstChart.prototype.componentDidMount = function componentDidMount() {

        //this.setState({...this.state,data:this.props.data})
        this._onSunburstBarChart(this);
    };

    SunburstChart.prototype._onSunburstBarChart = function _onSunburstBarChart(sunburstChart) {
        var finalArr = [].concat(this.mainArr.children);
        var firstData = this.firstNewArr;
        var remainingNode = { children: finalArr };
        if (Object(commonActionUtils["b" /* getBrowserInformation */])() && Object(commonActionUtils["b" /* getBrowserInformation */])().toString().indexOf('IE') !== -1) this.isIE = true;

        var userAgentString = window.navigator.userAgent.toLocaleLowerCase(),
            isSafari = userAgentString.indexOf("safari") && (userAgentString.indexOf("iphone") > -1 || userAgentString.indexOf("ipad") > -1);

        var margins = {
            top: 40,
            right: 40,
            bottom: 45,
            left: 40
        },
            translateIndex = this.isIE ? -70 : 30;
        ;
        var width = this.props.width ? this.props.width : 400,
            height = this.props.height ? this.props.height - margins.bottom : 300,
            radius = Math.min(this.props.width, this.props.height) / 2,
            lastSelectedNode,
            _this = this;

        var x = d3_default.a.scale.linear().range([0, 2 * Math.PI]);

        var y = d3_default.a.scale.linear().range([0, radius]);

        var partition = d3_default.a.layout.partition().sort(function (a, b) {
            return d3_default.a.ascending(Number(a.code), Number(b.code));
        }).value(function (d) {
            return d.size ? d.size.budget : 1;
        });
        if (!d3_default.a.select('#' + this.props.chart_id).empty()) {
            d3_default.a.select('#' + this.props.chart_id + ' svg').remove();
        }
        var svg = d3_default.a.select('#' + this.props.chart_id).append("svg").attr("id", "multi_level_svg").attr("preserveAspectRatio", "xMidYMid meet").attr("viewBox", "0 0 " + width + " " + (height + margins.bottom + margins.top)).classed("svg-content", true).classed(this.isIE ? '' + style_default.a.svgIe : '', true).append("g").attr("transform", "translate(" + width / 2 + "," + (height / 2 + translateIndex) + ")");

        var tooltip = d3_default.a.select("body").append("div").attr("class", style_default.a.toolTip);
        var isLevelOne = true;
        d3_default.a.select("g").append("foreignObject").html(function (d) {
            return '<div ><p style="font-weight:900;margin-left:50px;font-size: 24px;color: gray;">IUCN </p> <p style="font-weight:900;margin-left:22px;font-size: 24px;color: gray;">Programme </p><p style="font-weight:900;margin-left:56px;font-size: 24px;color: gray;">Areas </p> </div>';
        }).attr("x", -80).attr("y", -80).attr("width", 300).attr("height", 200);

        var startAngle = 0;
        var endAngle = 0;
        var arc = d3_default.a.svg.arc().startAngle(function (d) {
            startAngle = Math.max(0, Math.min(2 * Math.PI, x(d.x)));
            return Math.max(0, Math.min(2 * Math.PI, x(d.x)));
        }).endAngle(function (d) {
            endAngle = Math.max(0, Math.min(2 * Math.PI, x(d.x + d.dx)));
            // return (endAngle - startAngle ) < 0.17? d.depth === 2?  0.17 : endAngle :endAngle ;
            return endAngle;
        }).innerRadius(function (d) {
            return isLevelOne ? 80 : Math.max(0, y(d.y));
        }).outerRadius(function (d) {
            return 307;
        });

        var g = svg.selectAll("path").data(partition.nodes(remainingNode)).enter().append("g");

        var path = g.append("path").attr("d", arc).style("fill", function (d) {
            return '#' + d.color;
        }).style("stroke", "#ffffff").style("stroke-width", function (d) {
            return d.image ? '0px' : '1px';
        }).attr("opacity", function (d) {
            return d.name === '' || d.code !== "0" && !d.children ? 0 : 1;
        }).style("display", function (d) {
            return d.name === '' || d.code !== "0" && !d.children ? 'none' : 'block';
        }).attr('class', style_default.a.rect + ' IMGDID').on("click", click);
        if (!isSafari) {
            path.on("mousemove", function (d) {
                if (d.name) {
                    tooltip.style("left", d3_default.a.event.pageX + 50 + "px").style("top", d3_default.a.event.pageY - 70 + "px").style("display", "inline-block").style("z-index", 2).html(d.code !== "0" && !d.children ? '<span class="' + style_default.a.head + '">' + d.name + ': </span><span>' + d.description + '</span><br><span class="' + style_default.a.head + '">Budget: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.budget, 0) + '</span><br><span class="' + style_default.a.head + '"> Expenditure: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.expense, 0) + '</span>' : '<span class="' + style_default.a.head + '">' + d.name + ': </span><span>' + d.fullName + '</span><br><span class="' + style_default.a.head + '">Budget: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.budget, 0) + '</span><br><span class="' + style_default.a.head + '"> Expenditure: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.expense, 0) + '</span>');
                }
            }).on("mouseout", function (d) {
                tooltip.style("display", "none");
            });
        }

        var text = g.append("text").filter(filter_min_arc_size_text).attr("transform", function (d) {
            return "translate(" + arc.centroid(d) + ")rotate(" + computeTextRotation(d) + ")";
        }).attr("text-anchor", "middle").attr("dx", "0") // margin
        .attr("dy", ".35em") // vertical-align

        .style("font-size", "15px").style("display", function (d) {
            return d.name === '' || d.code !== "0" && !d.children ? 'none' : 'block';
        }).style("fill", "#ffffff").on("click", click).style("cursor", "pointer").on("mousemove", function (d) {
            if (d.name) {
                tooltip.style("left", d3_default.a.event.pageX + 50 + "px").style("top", d3_default.a.event.pageY - 70 + "px").style("display", "inline-block").html(d.code !== "0" && !d.children ? '<span class="' + style_default.a.head + '">' + d.name + ': </span><span>' + d.description + '</span>' : '<span class="' + style_default.a.head + '">' + d.name + ': </span><span>' + d.fullName + '</span><br><span class="' + style_default.a.head + '">Budget: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.budget, 0) + '</span><br><span class="' + style_default.a.head + '"> Expenditure: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.expense, 0) + '</span>');
            }
        }).on("mouseout", function (d) {
            tooltip.style("display", "none");
        });

        g.append("svg:image").attr("transform", function (d) {
            return "translate(" + arc.centroid(d) + ")rotate(" + computeImageRotation(d) + ")";
        }).attr("text-anchor", "middle").attr('width', 105).attr('height', 110).attr('opacity', 1).attr("x", function (d) {
            return -53;
        }).attr("y", function (d) {
            return -90;
        }).attr('class', style_default.a.rect + ' IMGDID').on("click", imageClick).attr("xlink:href", function (d) {
            if (d.size && d.size.percentage > 6) {
                return d.image ? d.image : '';
            } else {
                return '';
            }
        });

        function filter_min_arc_size_text(d, i) {
            var compare = void 0;
            if (d.depth > 1) {
                compare = 0.1;
                if (d.parent.name === 'PA 3') {
                    compare = 0.25;
                }
                if (d.parent.name === 'PA 16') {
                    compare = 0.3;
                }
            } else {
                compare = 1;
            }
            return d.dx * d.depth * radius / 2 > compare;
        };

        function click(d) {
            var isImgClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var goBack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (d.code !== "0") {
                isLevelOne = goBack;
                tooltip.style("display", "none");
                // d.code ? sunburstChart.props.updateSDG(parseInt(d.code)) : sunburstChart.props.updateSDG('');
                var glowCircle = d3_default.a.select('#glowCircle');
                glowCircle ? glowCircle.remove() : null;
                if (!isLevelOne) {
                    setTimeout(function () {
                        var path2 = d3_default.a.select("g").append("circle").attr("cx", 0).attr("cy", 0).attr("r", 158).attr('class', '' + style_default.a.sdgCircle).attr("id", 'glowCircle').style("fill", function (d) {
                            return 'transparent';
                        }).style("stroke", "#fdfdfd").style("stroke-width", '3px').style("stroke-linejoin", "round").style("stroke-linecap", "round");
                    }, 1000);
                }
                if (isImgClick === 0) return;

                if (!d.children) {
                    _this.props.onTargetClick(d);
                    return;
                }

                text.transition().attr("opacity", 0);
                path.transition().duration(750).attrTween("d", arcTween(d)).each("end", function (e, i) {
                    var arcTextAll = d3_default.a.select(this.parentNode).select("text");
                    arcTextAll.transition().duration(750).style("display", 'none');
                    // check if the animated element's data e lies within the visible angle span given in d
                    if (e.x >= d.x && e.x < d.x + d.dx) {
                        // get a selection of the associated text element
                        if (!isLevelOne) {
                            document.querySelectorAll('[class^="IMGDID"],[class*="IMGDID"]').forEach(function (el) {
                                return el.style.display = "none";
                            });
                            document.getElementById("sdgBackButton").style.display = "inline-block";
                            document.getElementById('sdgBackButton').onclick = function goBack() {

                                if (lastSelectedNode) {
                                    click(lastSelectedNode.parent, true, true);
                                }
                            };
                            var arcText = d3_default.a.select(this.parentNode).select("text");
                            // fade in the text element and recalculate positions
                            arcText.filter(filter_min_arc_size_text).attr("transform", function (d) {
                                return "translate(" + arc.centroid(d) + ")rotate(" + computeTextRotation(d) + ")";
                            }).attr("text-anchor", "middle").attr("dx", "0") // margin
                            .attr("dy", ".35em") // vertical-align
                            .text(function (d, i) {
                                return d.name;
                            }).style("font-size", "15px").style("pointer-events", "none").style("display", function (d) {
                                return d.name === '' || d.code !== "0" && !d.children ? 'none' : 'block';
                            }).style("fill", "#ffffff").on("click", click).style("cursor", "pointer").on("mousemove", function (d) {
                                if (d.name) {
                                    tooltip.style("left", d3_default.a.event.pageX + 50 + "px").style("top", d3_default.a.event.pageY - 70 + "px").style("display", "inline-block").html(d.code !== "0" && !d.children ? '<span class="' + style_default.a.head + '">' + d.name + ': </span><span>' + d.description + '</span>' : '<span class="' + style_default.a.head + '">' + d.name + ': </span><span>' + d.fullName + '</span><br><span class="' + style_default.a.head + '">Budget: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.budget, 0) + '</span><br><span class="' + style_default.a.head + '"> Expenditure: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.expense, 0) + '</span>');
                                }
                            }).on("mouseout", function (d) {
                                tooltip.style("display", "none");
                            }).transition().duration(750).attr("opacity", function (d) {
                                return d.image ? isImgClick === true ? 1 : 0 : 1;
                            }).attr("transform", function (d) {
                                return "translate(" + arc.centroid(d) + ")rotate(" + computeTextRotation(d) + ")";
                            }).style("display", function (d) {
                                return getPathOpacity(d, isImgClick) === 1 ? 'block' : 'none';
                            }).attr("text-anchor", "middle");
                        } else {
                            document.querySelectorAll('[class^="IMGDID"],[class*="IMGDID"]').forEach(function (el) {
                                return el.style.display = "block";
                            });
                            document.getElementById("sdgBackButton").style.display = "none";
                            _this._onSunburstBarChart(_this);
                            // _this.componentDidMount()
                            // _this.setState({
                            //     init: 'true'
                            // })
                        }

                        var arcImage = d3_default.a.select(this.parentNode).select("image");
                        arcImage.transition().duration(750).attr("opacity", d.image ? 1 : 0).style("display", d.image ? 'block' : 'none').attr("transform", function (d) {
                            return "translate(" + -70 + ", -80)rotate(" + computeImageRotation(d) + ")";
                        }).attr("text-anchor", "middle");

                        var pathItem = d3_default.a.select(this.parentNode).select("path");
                        pathItem.transition().duration(750).attr("opacity", function (d) {
                            return getPathOpacity(d, isImgClick);
                        }).style("display", function (d) {
                            return getPathOpacity(d, isImgClick) === 1 ? 'block' : 'none';
                        });
                    }
                });

                lastSelectedNode = d;
                _this.props.handleOnClick(lastSelectedNode);
            }
        }

        function imageClick(d) {
            click(d.parent, 1, 0);
        }
        function getPathOpacity(d, isImgClick) {
            var opacityVal = 0;
            if (isImgClick === true) {
                opacityVal = d.name ? d.code === "0" || d.children ? 1 : 0 : 0;
            } else opacityVal = d.name ? 1 : 0;

            return opacityVal;
        }
        function arcTween(d) {
            var xd = d3_default.a.interpolate(x.domain(), [d.x, d.x + d.dx]),
                yd = d3_default.a.interpolate(y.domain(), [d.y, 1]),
                yr = d3_default.a.interpolate(y.range(), [d.y ? 20 : 0, radius]);
            return function (d, i) {
                return i ? function (t) {
                    return arc(d);
                } : function (t) {
                    x.domain(xd(t));
                    y.domain(yd(t)).range(yr(t));
                    return arc(d);
                };
            };
        }

        function computeTextRotation(d) {
            var ang = (x(d.x + d.dx / 2) - Math.PI / 2) / Math.PI * 180;
            return ang > 90 ? 180 + ang : ang;
        }
        function computeImageRotation(d) {
            return 0;
        }
    };

    SunburstChart.prototype.render = function render() {
        var SdgLegendId = document.querySelectorAll('[class^="SdgLegendId"],[class*="SdgLegendId"]');
        var windowWidth = window.innerWidth;
        return Object(preact_min["h"])(
            'div',
            { 'class': style_default.a.sdgWrapper },
            Object(preact_min["h"])(
                'span',
                { style: {
                        display: 'inline-block',
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        zIndex: 1
                    },
                    'class': this.props.embed ? style_default.a.rightArray + ' ' + style_default.a.embedArray : style_default.a.rightArray
                },
                Object(preact_min["h"])(sdgLegend, {
                    data: this.props.data.children,
                    side: 'left',
                    embed: this.props.embed,
                    sdgTooltip: 'rightSDGTooltip',
                    baseURL: Object(commonMethods["d" /* getAPIBaseUrRl */])()
                })
            ),
            Object(preact_min["h"])('div', { style: {
                    height: 'auto', position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0
                },
                'class': style_default.a.hStackedBar_chart,
                id: this.props.chart_id }),
            Object(preact_min["h"])(
                'span',
                { style: {
                        display: 'inline-block', position: 'absolute',
                        top: 0,
                        left: 0
                    },
                    'class': this.props.embed ? style_default.a.leftArray + ' ' + style_default.a.embedArray : style_default.a.leftArray },
                Object(preact_min["h"])(sdgLegend, {
                    data: this.props.data.children,
                    side: 'right',
                    sdgTooltip: 'leftSDGTooltip',
                    embed: this.props.embed,
                    baseURL: Object(commonMethods["d" /* getAPIBaseUrRl */])()
                })
            ),
            Object(preact_min["h"])(
                'section',
                { 'class': style_default.a.backButtonContainer + ' ' + this.props.backButtonTop },
                Object(preact_min["h"])(
                    'button',
                    { id: 'sdgBackButton', 'class': style_default.a.backButton },
                    windowWidth >= 650 ? Object(preact_min["h"])('img', { src: Object(commonMethods["d" /* getAPIBaseUrRl */])() + '/static/assets/icons/backButtonImg.png', 'class': style_default.a.backImg }) : null,
                    'Back'
                )
            )
        );
    };

    return SunburstChart;
}(preact_min["Component"]);

var mapStateToProps = function mapStateToProps(state) {
    var sdgSelected = state.sdgSelected;

    return {
        sdgSelected: sdgSelected
    };
};

var paSunburstChart_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        updateSDG: function updateSDG(sdg) {
            return dispatch(Object(action["b" /* updateSDG */])(sdg));
        }
    };
};

/* harmony default export */ var paSunburstChart = __webpack_exports__["a"] = (Object(preact_redux_esm["a" /* connect */])(mapStateToProps, paSunburstChart_mapDispatchToProps)(paSunburstChart_SunburstChart));

/***/ }),

/***/ "JNi8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2ChvU","descriptionSection":"descriptionSection__2bhUb","description":"description__3dtic","mapArea":"mapArea__qjRGI","timelineNew":"timelineNew__2icBA","heading":"heading__YLXD5","source":"source__1w4Qs","mapOptions":"mapOptions__pWIIx","mapMenu":"mapMenu__18qMN","mapbuttons":"mapbuttons__3MF8q","selected":"selected__1pvrx","expandButton":"expandButton__1W7Hq","theme_slider_title":"theme_slider_title__1qsrU","projectStatus":"projectStatus__3c0BB","hide":"hide__2HtCo","expanded":"expanded__1XCXM","projectMap":"projectMap__2l2vw","satellite":"satellite__ZSJDd","disclaimer":"disclaimer__1Br-b","arealChart":"arealChart__3N4bJ","areaHeaderWrapper":"areaHeaderWrapper__3_jzG","titleWrapper":"titleWrapper__18Opn","legendWrapper":"legendWrapper__1clp7","legendItemOuterWrapper":"legendItemOuterWrapper__SAhx2","legendItemInnerWrapper":"legendItemInnerWrapper__3FfdE","itemAlignmentWrapper":"itemAlignmentWrapper__1uT-o","legend":"legend__12-Gc","budgetLegend":"budgetLegend__1lDSb","revenueLegend":"revenueLegend__16o4P","info":"info__3wKex","info_popup":"info_popup__lfafR","projectTopoIconsLegend":"projectTopoIconsLegend__3O5XD","accordion__arrow__left":"accordion__arrow__left__1GY5z","accordion__arrow__right":"accordion__arrow__right__23E1P","locationText":"locationText__3afVw","satellite_btn_container":"satellite_btn_container__sWzwY","rightBtn":"rightBtn__3Lmnb","leftBtn":"leftBtn__386-N","centerBtn":"centerBtn__3BLJv","satelliteWrapper":"satelliteWrapper__1XBoA","buttonMode":"buttonMode__k7Whe","cssCircle":"cssCircle__rNdac","cssCirclePartner":"cssCirclePartner__w6Wyo","minusSign":"minusSign__28dEc","plusSign":"plusSign__1pY9G","sunburstParent":"sunburstParent__u019t","sunburstChartContainer":"sunburstChartContainer__1afU2"};

/***/ }),

/***/ "JTUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SELECT_SSC_COUNTRY */
/* harmony export (immutable) */ __webpack_exports__["a"] = selectSSCCountry;
var SELECT_SSC_COUNTRY = 'SELECT_SSC_COUNTRY';

function selectSSCCountry(data) {
    if (typeof data === typeof {}) {
        return {
            type: SELECT_SSC_COUNTRY,
            data: data
        };
    }

    return {
        type: SELECT_SSC_COUNTRY,
        data: {}
    };
}

/***/ }),

/***/ "Jf5u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export expenseFlowFetchStart */
/* unused harmony export expenseFlowFetchEnd */
/* unused harmony export expenseFlowClear */
/* unused harmony export expenseFlowFetchSuccess */
/* unused harmony export expenseFlowFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchExpenseFinancialFlow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("dzhT");



var expenseFlowFetchStart = function expenseFlowFetchStart() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* FINANCIAL_FLOW */].start
    };
};

var expenseFlowFetchEnd = function expenseFlowFetchEnd() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* FINANCIAL_FLOW */].end
    };
};
var expenseFlowClear = function expenseFlowClear() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* FINANCIAL_FLOW */].clear
    };
};

var expenseFlowFetchSuccess = function expenseFlowFetchSuccess(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* FINANCIAL_FLOW */].success,
        data: data
    };
};

var expenseFlowFetchFailed = function expenseFlowFetchFailed(error) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* FINANCIAL_FLOW */].failed,
        error: error
    };
};

var fetchExpenseFinancialFlow = function fetchExpenseFinancialFlow(year) {
    return function (dispatch) {
        dispatch(expenseFlowFetchStart());
        if (year != '') {
            return __WEBPACK_IMPORTED_MODULE_0__lib_api__["c" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["c" /* default */].API_EXPENSE_FINANCIAL_FLOW(year)).then(function (resp) {
                if (resp.success && resp.data) {
                    dispatch(expenseFlowFetchEnd());
                    dispatch(expenseFlowFetchSuccess(resp.data));
                } else {
                    dispatch(expenseFlowFetchFailed());
                }
            }).catch(function (exception) {
                dispatch(expenseFlowFetchEnd());
                dispatch(expenseFlowFetchFailed(exception));
            });
        } else {
            dispatch(expenseFlowClear());
            dispatch(expenseFlowFetchFailed());
        }
    };
};

/***/ }),

/***/ "KAlA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SELECT_L2_COUNTRY */
/* harmony export (immutable) */ __webpack_exports__["a"] = selectL2Country;
var SELECT_L2_COUNTRY = 'SELECT_L2_COUNTRY';

function selectL2Country(data) {
    if (typeof data === typeof {}) {
        return {
            type: SELECT_L2_COUNTRY,
            data: data
        };
    }

    return {
        type: SELECT_L2_COUNTRY,
        data: {}
    };
}

/***/ }),

/***/ "LBG8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"percentageFill":"percentageFill__3rPnn","progressWrapper":"progressWrapper__3D2bN","container":"container__1LuTv","isInActive":"isInActive__q1woD","row":"row__2g7xH","columnLeft":"columnLeft__1apsS","theme_wrapper":"theme_wrapper__ucxAu","theme_name":"theme_name__37i0D","isActive":"isActive__1sVep","rowMiddle":"rowMiddle__jJAJW","rowBottom":"rowBottom__2CVuZ","theme_point":"theme_point__Wj39a","all_theme_content":"all_theme_content__3o0ZZ","content_key":"content_key__3yJdL","content_value":"content_value__1oSX1","columnRight":"columnRight__13WYg","theme_more":"theme_more__Czk6_","theme_next":"theme_next__2Of4n","percentText":"percentText__3Cc4a","theme_content":"theme_content__2IhWu"};

/***/ }),

/***/ "Lztf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2Opog","barChart":"barChart__3ja-9","tooltipDonors":"tooltipDonors__2sMKq","tooltipDisplay":"tooltipDisplay__M2Z2E","displayTextWrapper":"displayTextWrapper__18A3F","title":"title__3_fvR","donorName":"donorName__1EYWa","contribution":"contribution__3_5LE","innerChartWrapper":"innerChartWrapper__1XvfE","regular":"regular__3V0KP","other":"other__1KbQa","mobile_responsive":"mobile_responsive__2kQeN","donorFlag":"donorFlag__3pPvc","donorLegendMobile":"donorLegendMobile__1aCZD","donorLegend":"donorLegend__3-k1Q","desktop_responsive":"desktop_responsive__20_Wr"};

/***/ }),

/***/ "N4Ow":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mapContainer":"mapContainer__E0w11","disclaimer":"disclaimer__2iB_P","subtitleWrapper":"subtitleWrapper__1ONEO","titleWrapper":"titleWrapper__27YxA","sidebarWrapper":"sidebarWrapper__3je7c","filterTextWrapper":"filterTextWrapper__10vZ-","filterHighlight":"filterHighlight__LqhZC","filterText":"filterText__KCu6N"};

/***/ }),

/***/ "Ninc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"top_container":"top_container__1PIJb","header":"header__3MoVY","tableWrapper":"tableWrapper__1wNbw","legend_item":"legend_item__1b949","capacity_legend_block":"capacity_legend_block__2F7Ix","knowledge_legend_block":"knowledge_legend_block__3-UHT","partnership_legend_block":"partnership_legend_block__1cron","legend_text":"legend_text__3xV_U","list":"list__2cbSL","lastLi":"lastLi__2_uC8","li":"li__25C2q","desc":"desc__1UZ5g","flagList":"flagList__1FxHm","flagli":"flagli__3i-RP","flagImg":"flagImg__3Rhvb","tooltipDonors":"tooltipDonors__3F_rO","tooltipDisplay":"tooltipDisplay__2c0UQ","targetTitle":"targetTitle__1nUTK"};

/***/ }),

/***/ "NyMt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"donor_wrapper_styles":"donor_wrapper_styles__Eb-5u","profile_page_container":"profile_page_container__2LFr-","mapWrapper":"mapWrapper__3KP4G","mapSwitchContainer":"mapSwitchContainer__3PvRI","mapProjectSwitch":"mapProjectSwitch__3i172","mapProjectList":"mapProjectList__3VyY5","mapProjectButton":"mapProjectButton__1S0Ea","mapProjectItem":"mapProjectItem__3rxKy","mapSwitch":"mapSwitch__BBWoO","mapBtn":"mapBtn__2G8QY","listSelected":"listSelected__1XrS0","mapSelected":"mapSelected__11JzZ","mapRight":"mapRight__1ZyRX","wrapper":"wrapper__2I-_a","hidingBorder":"hidingBorder__jawqj","marginClass":"marginClass__3eYNF","btnListWrapper":"btnListWrapper__3P1rD","btnList":"btnList__3hs_n","active":"active__2eUFd","accessibility":"accessibility__1xEtV","list":"list__2OPPd","value":"value__kkWrP","label":"label__3Q3fJ","flagIcon":"flagIcon__1GU0e","ulWithFlag":"ulWithFlag__1ErNy","listPofile":"listPofile__3_3Gf","flagIconProfile":"flagIconProfile__mpUFo","ulWithFlagProfile":"ulWithFlagProfile__1Q_Xk","mapContainer":"mapContainer__22jTB","filterWrapper":"filterWrapper__3aa2G","legend_styles":"legend_styles__2xffI","donut_styles":"donut_styles__-eEi4","sdgDisclaimer":"sdgDisclaimer__BpF3Q","textsdg":"textsdg__3o7Jn","sdgDisclaimerText":"sdgDisclaimerText__1bEs8","chartWrapper":"chartWrapper__2eZ4E","recipient_themes_wrapper":"recipient_themes_wrapper___rfLG","budget_percent":"budget_percent__3yY8S","budgetExpense":"budgetExpense__2t69Z","windroseWrapper":"windroseWrapper__1L0u2","chartSmall":"chartSmall__3BI4K","disclaimer":"disclaimer__1nqPV","disclaimer2":"disclaimer2__1oSAg","chartDonorHead":"chartDonorHead__1KEX9","chartWapper":"chartWapper__2Zgdl","chartHead":"chartHead__25GfP","chartHead_themes":"chartHead_themes__2pRHH","chartHeadsdg":"chartHeadsdg__2Smm8","chartSubHeading":"chartSubHeading__3XJUe","progress":"progress__3c1Ji","contribution_wrapper":"contribution_wrapper__1aPIA","textWrapperStyle":"textWrapperStyle__2q1rF","groupedBarChart2Wrapper":"groupedBarChart2Wrapper__3yDwm","recipient_charts_wrapper":"recipient_charts_wrapper__3iun4","wind_rose_wrapper":"wind_rose_wrapper__3F6D7","top_budget_sources_wrapper":"top_budget_sources_wrapper__3hVTz","budget_sources_wrapper":"budget_sources_wrapper__3xIjc","contribution_other_resource_wrapper":"contribution_other_resource_wrapper__15nNq","recipientDocumentWrapper":"recipientDocumentWrapper__29fFB","dropDownWrapper":"dropDownWrapper__kk1Ia","disclaimerText":"disclaimerText__1N53e","no_box_shadow":"no_box_shadow__udiPK","textFieldSDGStyle":"textFieldSDGStyle__14IXC","textFieldStyle":"textFieldStyle__1d1kB","sdgbuttons":"sdgbuttons__2gigy","SDGdisclaimer":"SDGdisclaimer__wOCsS","perc":"perc__dfL1y","dollor":"dollor__1FmRB","boxWrapper":"boxWrapper__3Gg5S","mapButtonsWrapper":"mapButtonsWrapper__2GjKe","selected":"selected__1zdQ2","sunburstParent":"sunburstParent__mjvwG","sunburstChartContainer":"sunburstChartContainer__yilzx"};

/***/ }),

/***/ "O8Wv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
var detectPassiveEvents = {
  update: function update() {
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      var passive = false;
      var options = Object.defineProperty({}, 'passive', {
        get: function get() {
          passive = true;
        }
      });
      // note: have to set and remove a no-op listener instead of null
      // (which was used previously), becasue Edge v15 throws an error
      // when providing a null callback.
      // https://github.com/rafrex/detect-passive-events/pull/3
      var noop = function noop() {};
      window.addEventListener('testPassiveEventSupport', noop, options);
      window.removeEventListener('testPassiveEventSupport', noop, options);
      detectPassiveEvents.hasSupport = passive;
    }
  }
};

detectPassiveEvents.update();
exports.default = detectPassiveEvents;

/***/ }),

/***/ "OBrC":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * d3.chart - v0.3.0
 * License: MIT
 * Date: 2016-01-23
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if (true) module.exports = factory(__webpack_require__("tokj"));else if (typeof define === 'function' && define.amd) define("d3.chart", ["d3"], factory);else if (typeof exports === 'object') exports["d3.chart"] = factory(require("d3"));else root["d3.chart"] = factory(root["d3"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_1__) {
	return (/******/function (modules) {
			// webpackBootstrap
			/******/ // The module cache
			/******/var installedModules = {};

			/******/ // The require function
			/******/function __webpack_require__(moduleId) {

				/******/ // Check if module is in cache
				/******/if (installedModules[moduleId])
					/******/return installedModules[moduleId].exports;

				/******/ // Create a new module (and put it into the cache)
				/******/var module = installedModules[moduleId] = {
					/******/exports: {},
					/******/id: moduleId,
					/******/loaded: false
					/******/ };

				/******/ // Execute the module function
				/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

				/******/ // Flag the module as loaded
				/******/module.loaded = true;

				/******/ // Return the exports of the module
				/******/return module.exports;
				/******/
			}

			/******/ // expose the modules object (__webpack_modules__)
			/******/__webpack_require__.m = modules;

			/******/ // expose the module cache
			/******/__webpack_require__.c = installedModules;

			/******/ // __webpack_public_path__
			/******/__webpack_require__.p = "";

			/******/ // Load entry module and return exports
			/******/return __webpack_require__(0);
			/******/
		}(
		/************************************************************************/
		/******/[
		/* 0 */
		/***/function (module, exports, __webpack_require__) {

			var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
				"use strict";

				var d3 = __webpack_require__(1);

				var Chart = __webpack_require__(2);
				var assert = __webpack_require__(3);

				assert(/^3\./.test(d3.version), "d3.js version 3 is required");

				__webpack_require__(4);

				/**
     * A namespace defined by [the D3.js library](http://d3js.org/). The d3.chart
     * API is defined within this namespace.
     * @namespace d3
     */

				/**
     * A constructor function defined by [the D3.js library](http://d3js.org/).
     * @constructor d3.selection
     * @memberof d3
     */

				/**
     * Create a new chart constructor or return a previously-created chart
     * constructor.
     *
     * @static
     * @memberof d3
     * @externalExample {runnable} chart
     *
     * @param {String} name If no other arguments are specified, return the
     *        previously-created chart with this name.
     * @param {Object} protoProps If specified, this value will be forwarded to
     *        {@link Chart.extend} and used to create a new chart.
     * @param {Object} staticProps If specified, this value will be forwarded to
     *        {@link Chart.extend} and used to create a new chart.
     */
				d3.chart = function (name) {
					if (arguments.length === 0) {
						return Chart;
					} else if (arguments.length === 1) {
						return Chart[name];
					}

					return Chart.extend.apply(Chart, arguments);
				};

				/**
     * Instantiate a chart or return the chart that the current selection belongs
     * to.
     *
     * @externalExample {runnable} selection-chart
     *
     * @param {String} [chartName] The name of the chart to instantiate. If the
     *        name is unspecified, this method will return the chart that the
     *        current selection belongs to.
     * @param {mixed} options The options to use when instantiated the new chart.
     *        See {@link Chart} for more information.
     */
				d3.selection.prototype.chart = function (chartName, options) {
					// Without an argument, attempt to resolve the current selection's
					// containing d3.chart.
					if (arguments.length === 0) {
						return this._chart;
					}
					var ChartCtor = Chart[chartName];
					assert(ChartCtor, "No chart registered with name '" + chartName + "'");

					return new ChartCtor(this, options);
				};

				// Implement the zero-argument signature of `d3.selection.prototype.chart`
				// for all selection types.
				d3.selection.enter.prototype.chart = function () {
					return this._chart;
				};
				d3.transition.prototype.chart = d3.selection.enter.prototype.chart;

				module.exports = d3.chart;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

			/***/
		},
		/* 1 */
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

			/***/
		},
		/* 2 */
		/***/function (module, exports, __webpack_require__) {

			var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
				"use strict";

				var assert = __webpack_require__(3);
				var hasOwnProp = Object.hasOwnProperty;

				// extend
				// Borrowed from Underscore.js
				function extend(object) {
					var argsIndex, argsLength, iteratee, key;
					if (!object) {
						return object;
					}
					argsLength = arguments.length;
					for (argsIndex = 1; argsIndex < argsLength; argsIndex++) {
						iteratee = arguments[argsIndex];
						if (iteratee) {
							for (key in iteratee) {
								object[key] = iteratee[key];
							}
						}
					}
					return object;
				}

				/**
     * Call the {@Chart#initialize} method up the inheritance chain, starting with
     * the base class and continuing "downward".
     *
     * @private
     */
				var initCascade = function initCascade(instance, args) {
					var ctor = this.constructor;
					var sup = ctor.__super__;
					if (sup) {
						initCascade.call(sup, instance, args);
					}

					// Do not invoke the `initialize` method on classes further up the
					// prototype chain (again).
					if (hasOwnProp.call(ctor.prototype, "initialize")) {
						this.initialize.apply(instance, args);
					}
				};

				/**
     * Call the `transform` method down the inheritance chain, starting with the
     * instance and continuing "upward". The result of each transformation should
     * be supplied as input to the next.
     *
     * @private
     */
				var transformCascade = function transformCascade(instance, data) {
					var ctor = this.constructor;
					var sup = ctor.__super__;

					// Unlike `initialize`, the `transform` method has significance when
					// attached directly to a chart instance. Ensure that this transform takes
					// first but is not invoked on later recursions.
					if (this === instance && hasOwnProp.call(this, "transform")) {
						data = this.transform(data);
					}

					// Do not invoke the `transform` method on classes further up the prototype
					// chain (yet).
					if (hasOwnProp.call(ctor.prototype, "transform")) {
						data = ctor.prototype.transform.call(instance, data);
					}

					if (sup) {
						data = transformCascade.call(sup, instance, data);
					}

					return data;
				};

				/**
     * Create a d3.chart
     *
     * @constructor
     * @externalExample {runnable} chart
     *
     * @param {d3.selection} selection The chart's "base" DOM node. This should
     *        contain any nodes that the chart generates.
     * @param {mixed} chartOptions A value for controlling how the chart should be
     *        created. This value will be forwarded to {@link Chart#initialize}, so
     *        charts may define additional properties for consumers to modify their
     *        behavior during initialization. The following attributes will be
     *        copied onto the chart instance (if present):
     * @param {Function} [chartOptions.transform] - A data transformation function
     *        unique to the Chart instance being created. If specified, this
     *        function will be invoked after all inherited implementations as part
     *        of the `Chart#draw` operation.
     * @param {Function} [chartOptions.demux] - A data filtering function for
     *        attachment charts. If specified, this function will be invoked with
     *        every {@link Chart#draw|draw} operation and provided with two
     *        arguments: the attachment name (see {@link Chart#attach}) and the
     *        data.
     *
     * @constructor
     */
				var Chart = function Chart(selection, chartOptions) {
					this.base = selection;
					this._layers = {};
					this._attached = {};
					this._events = {};

					if (chartOptions && chartOptions.transform) {
						this.transform = chartOptions.transform;
					}

					initCascade.call(this, this, [chartOptions]);
				};

				/**
     * Set up a chart instance. This method is intended to be overridden by Charts
     * authored with this library. It will be invoked with a single argument: the
     * `options` value supplied to the {@link Chart|constructor}.
     *
     * For charts that are defined as extensions of other charts using
     * `Chart.extend`, each chart's `initilize` method will be invoked starting
     * with the "oldest" ancestor (see the private {@link initCascade} function for
     * more details).
     */
				Chart.prototype.initialize = function () {};

				/**
     * Remove a layer from the chart.
     *
     * @externalExample chart-unlayer
     *
     * @param {String} name The name of the layer to remove.
     *
     * @returns {Layer} The layer removed by this operation.
     */
				Chart.prototype.unlayer = function (name) {
					var layer = this.layer(name);

					delete this._layers[name];
					delete layer._chart;

					return layer;
				};

				/**
     * Interact with the chart's {@link Layer|layers}.
     *
     * If only a `name` is provided, simply return the layer registered to that
     * name (if any).
     *
     * If a `name` and `selection` are provided, treat the `selection` as a
     * previously-created layer and attach it to the chart with the specified
     * `name`.
     *
     * If all three arguments are specified, initialize a new {@link Layer} using
     * the specified `selection` as a base passing along the specified `options`.
     *
     * The {@link Layer.draw} method of attached layers will be invoked
     * whenever this chart's {@link Chart#draw} is invoked and will receive the
     * data (optionally modified by the chart's {@link Chart#transform} method.
     *
     * @externalExample chart-layer
     *
     * @param {String} name Name of the layer to attach or retrieve.
     * @param {d3.selection|Layer} [selection] The layer's base or a
     *        previously-created {@link Layer}.
     * @param {Object} [options] Options to be forwarded to {@link Layer|the Layer
     *        constructor}
     *
     * @returns {Layer}
     */
				Chart.prototype.layer = function (name, selection, options) {
					var layer;

					if (arguments.length === 1) {
						return this._layers[name];
					}

					// we are reattaching a previous layer, which the
					// selection argument is now set to.
					if (arguments.length === 2) {

						if (typeof selection.draw === "function") {
							selection._chart = this;
							this._layers[name] = selection;
							return this._layers[name];
						} else {
							assert(false, "When reattaching a layer, the second argument " + "must be a d3.chart layer");
						}
					}

					layer = selection.layer(options);

					this._layers[name] = layer;

					selection._chart = this;

					return layer;
				};

				/**
     * Register or retrieve an "attachment" Chart. The "attachment" chart's `draw`
     * method will be invoked whenever the containing chart's `draw` method is
     * invoked.
     *
     * @externalExample chart-attach
     *
     * @param {String} attachmentName Name of the attachment
     * @param {Chart} [chart] d3.chart to register as a mix in of this chart. When
     *        unspecified, this method will return the attachment previously
     *        registered with the specified `attachmentName` (if any).
     *
     * @returns {Chart} Reference to this chart (chainable).
     */
				Chart.prototype.attach = function (attachmentName, chart) {
					if (arguments.length === 1) {
						return this._attached[attachmentName];
					}

					this._attached[attachmentName] = chart;
					return chart;
				};

				/**
     * A "hook" method that you may define to modify input data before it is used
     * to draw the chart's layers and attachments. This method will be used by all
     * sub-classes (see {@link transformCascade} for details).
     *
     * Note you will most likely never call this method directly, but rather
     * include it as part of a chart definition, and then rely on d3.chart to
     * invoke it when you draw the chart with {@link Chart#draw}.
     *
     * @externalExample {runnable} chart-transform
     *
     * @param {Array} data Input data provided to @link Chart#draw}.
     *
     * @returns {mixed} Data to be used in drawing the chart's layers and
     *                  attachments.
     */
				Chart.prototype.transform = function (data) {
					return data;
				};

				/**
     * Update the chart's representation in the DOM, drawing all of its layers and
     * any "attachment" charts (as attached via {@link Chart#attach}).
     *
     * @externalExample chart-draw
     *
     * @param {Object} data Data to pass to the {@link Layer#draw|draw method} of
     *        this cart's {@link Layer|layers} (if any) and the {@link
     *        Chart#draw|draw method} of this chart's attachments (if any).
     */
				Chart.prototype.draw = function (data) {

					var layerName, attachmentName, attachmentData;

					data = transformCascade.call(this, this, data);

					for (layerName in this._layers) {
						this._layers[layerName].draw(data);
					}

					for (attachmentName in this._attached) {
						if (this.demux) {
							attachmentData = this.demux(attachmentName, data);
						} else {
							attachmentData = data;
						}
						this._attached[attachmentName].draw(attachmentData);
					}
				};

				/**
     * Function invoked with the context specified when the handler was bound (via
     * {@link Chart#on} {@link Chart#once}).
     *
     * @callback ChartEventHandler
     * @param {...*} arguments Invoked with the arguments passed to {@link
     *         Chart#trigger}
     */

				/**
     * Subscribe a callback function to an event triggered on the chart. See {@link
     * Chart#once} to subscribe a callback function to an event for one occurence.
     *
     * @externalExample {runnable} chart-on
     *
     * @param {String} name Name of the event
     * @param {ChartEventHandler} callback Function to be invoked when the event
     *        occurs
     * @param {Object} [context] Value to set as `this` when invoking the
     *        `callback`. Defaults to the chart instance.
     *
     * @returns {Chart} A reference to this chart (chainable).
     */
				Chart.prototype.on = function (name, callback, context) {
					var events = this._events[name] || (this._events[name] = []);
					events.push({
						callback: callback,
						context: context || this,
						_chart: this
					});
					return this;
				};

				/**
     * Subscribe a callback function to an event triggered on the chart. This
     * function will be invoked at the next occurance of the event and immediately
     * unsubscribed. See {@link Chart#on} to subscribe a callback function to an
     * event indefinitely.
     *
     * @externalExample {runnable} chart-once
     *
     * @param {String} name Name of the event
     * @param {ChartEventHandler} callback Function to be invoked when the event
     *        occurs
     * @param {Object} [context] Value to set as `this` when invoking the
     *        `callback`. Defaults to the chart instance
     *
     * @returns {Chart} A reference to this chart (chainable)
     */
				Chart.prototype.once = function (name, callback, context) {
					var self = this;
					var once = function once() {
						self.off(name, once);
						callback.apply(this, arguments);
					};
					return this.on(name, once, context);
				};

				/**
     * Unsubscribe one or more callback functions from an event triggered on the
     * chart. When no arguments are specified, *all* handlers will be unsubscribed.
     * When only a `name` is specified, all handlers subscribed to that event will
     * be unsubscribed. When a `name` and `callback` are specified, only that
     * function will be unsubscribed from that event. When a `name` and `context`
     * are specified (but `callback` is omitted), all events bound to the given
     * event with the given context will be unsubscribed.
     *
     * @externalExample {runnable} chart-off
     *
     * @param {String} [name] Name of the event to be unsubscribed
     * @param {ChartEventHandler} [callback] Function to be unsubscribed
     * @param {Object} [context] Contexts to be unsubscribe
     *
     * @returns {Chart} A reference to this chart (chainable).
     */
				Chart.prototype.off = function (name, callback, context) {
					var names, n, events, event, i, j;

					// remove all events
					if (arguments.length === 0) {
						for (name in this._events) {
							this._events[name].length = 0;
						}
						return this;
					}

					// remove all events for a specific name
					if (arguments.length === 1) {
						events = this._events[name];
						if (events) {
							events.length = 0;
						}
						return this;
					}

					// remove all events that match whatever combination of name, context
					// and callback.
					names = name ? [name] : Object.keys(this._events);
					for (i = 0; i < names.length; i++) {
						n = names[i];
						events = this._events[n];
						j = events.length;
						while (j--) {
							event = events[j];
							if (callback && callback === event.callback || context && context === event.context) {
								events.splice(j, 1);
							}
						}
					}

					return this;
				};

				/**
     * Publish an event on this chart with the given `name`.
     *
     * @externalExample {runnable} chart-trigger
     *
     * @param {String} name Name of the event to publish
     * @param {...*} arguments Values with which to invoke the registered
     *        callbacks.
     *
     * @returns {Chart} A reference to this chart (chainable).
     */
				Chart.prototype.trigger = function (name) {
					var args = Array.prototype.slice.call(arguments, 1);
					var events = this._events[name];
					var i, ev;

					if (events !== undefined) {
						for (i = 0; i < events.length; i++) {
							ev = events[i];
							ev.callback.apply(ev.context, args);
						}
					}

					return this;
				};

				/**
     * Create a new {@link Chart} constructor with the provided options acting as
     * "overrides" for the default chart instance methods. Allows for basic
     * inheritance so that new chart constructors may be defined in terms of
     * existing chart constructors. Based on the `extend` function defined by
     * [Backbone.js](http://backbonejs.org/).
     *
     * @static
     * @externalExample {runnable} chart-extend
     *
     * @param {String} name Identifier for the new Chart constructor.
     * @param {Object} protoProps Properties to set on the new chart's prototype.
     * @param {Object} staticProps Properties to set on the chart constructor
     *        itself.
     *
     * @returns {Function} A new Chart constructor
     */
				Chart.extend = function (name, protoProps, staticProps) {
					var parent = this;
					var child;

					// The constructor function for the new subclass is either defined by
					// you (the "constructor" property in your `extend` definition), or
					// defaulted by us to simply call the parent's constructor.
					if (protoProps && hasOwnProp.call(protoProps, "constructor")) {
						child = protoProps.constructor;
					} else {
						child = function child() {
							return parent.apply(this, arguments);
						};
					}

					// Add static properties to the constructor function, if supplied.
					extend(child, parent, staticProps);

					// Set the prototype chain to inherit from `parent`, without calling
					// `parent`'s constructor function.
					var Surrogate = function Surrogate() {
						this.constructor = child;
					};
					Surrogate.prototype = parent.prototype;
					child.prototype = new Surrogate();

					// Add prototype properties (instance properties) to the subclass, if
					// supplied.
					if (protoProps) {
						extend(child.prototype, protoProps);
					}

					// Set a convenience property in case the parent's prototype is needed
					// later.
					child.__super__ = parent.prototype;

					Chart[name] = child;
					return child;
				};

				module.exports = Chart;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

			/***/
		},
		/* 3 */
		/***/function (module, exports, __webpack_require__) {

			var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
				"use strict";

				module.exports = function (test, message) {
					if (test) {
						return;
					}
					throw new Error("[d3.chart] " + message);
				};
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

			/***/
		},
		/* 4 */
		/***/function (module, exports, __webpack_require__) {

			var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
				"use strict";

				var d3 = __webpack_require__(1);

				var Layer = __webpack_require__(5);

				/**
     * Create a new layer on the d3 selection from which it is called.
     *
     * @static
     *
     * @param {Object} [options] Options to be forwarded to {@link Layer|the Layer
     *        constructor}
     * @returns {d3.selection}
     */
				d3.selection.prototype.layer = function (options) {
					var layer = new Layer(this);
					var eventName;

					// Set layer methods (required)
					layer.dataBind = options.dataBind;
					layer.insert = options.insert;

					// Bind events (optional)
					if ("events" in options) {
						for (eventName in options.events) {
							layer.on(eventName, options.events[eventName]);
						}
					}

					// Mix the public methods into the D3.js selection (bound appropriately)
					this.on = function () {
						return layer.on.apply(layer, arguments);
					};
					this.off = function () {
						return layer.off.apply(layer, arguments);
					};
					this.draw = function () {
						return layer.draw.apply(layer, arguments);
					};

					return this;
				};
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

			/***/
		},
		/* 5 */
		/***/function (module, exports, __webpack_require__) {

			var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
				"use strict";

				var d3 = __webpack_require__(1);

				var assert = __webpack_require__(3);

				var lifecycleRe = /^(enter|update|merge|exit)(:transition)?$/;

				/**
     * Create a layer using the provided `base`. The layer instance is *not*
     * exposed to d3.chart users. Instead, its instance methods are mixed in to the
     * `base` selection it describes; users interact with the instance via these
     * bound methods.
     *
     * @private
     * @constructor
     * @externalExample {runnable} layer
     *
     * @param {d3.selection} base The containing DOM node for the layer.
     */
				var Layer = function Layer(base) {
					assert(base, "Layers must be initialized with a base.");
					this._base = base;
					this._handlers = {};
				};

				/**
     * Invoked by {@link Layer#draw} to join data with this layer's DOM nodes. This
     * implementation is "virtual"--it *must* be overridden by Layer instances.
     *
     * @param {Array} data Value passed to {@link Layer#draw}
     */
				Layer.prototype.dataBind = function () {
					assert(false, "Layers must specify a `dataBind` method.");
				};

				/**
     * Invoked by {@link Layer#draw} in order to insert new DOM nodes into this
     * layer's `base`. This implementation is "virtual"--it *must* be overridden by
     * Layer instances.
     */
				Layer.prototype.insert = function () {
					assert(false, "Layers must specify an `insert` method.");
				};

				/**
     * Subscribe a handler to a "lifecycle event". These events (and only these
     * events) are triggered when {@link Layer#draw} is invoked--see that method
     * for more details on lifecycle events.
     *
     * @externalExample {runnable} layer-on
     *
     * @param {String} eventName Identifier for the lifecycle event for which to
     *        subscribe.
     * @param {Function} handler Callback function
     *
     * @returns {d3.selection} Reference to the layer's base.
     */
				Layer.prototype.on = function (eventName, handler, options) {
					options = options || {};

					assert(lifecycleRe.test(eventName), "Unrecognized lifecycle event name specified to `Layer#on`: '" + eventName + "'.");

					if (!(eventName in this._handlers)) {
						this._handlers[eventName] = [];
					}
					this._handlers[eventName].push({
						callback: handler,
						chart: options.chart || null
					});
					return this._base;
				};

				/**
     * Unsubscribe the specified handler from the specified event. If no handler is
     * supplied, remove *all* handlers from the event.
     *
     * @externalExample {runnable} layer-off
     *
     * @param {String} eventName Identifier for event from which to remove
     *        unsubscribe
     * @param {Function} handler Callback to remove from the specified event
     *
     * @returns {d3.selection} Reference to the layer's base.
     */
				Layer.prototype.off = function (eventName, handler) {

					var handlers = this._handlers[eventName];
					var idx;

					assert(lifecycleRe.test(eventName), "Unrecognized lifecycle event name specified to `Layer#off`: '" + eventName + "'.");

					if (!handlers) {
						return this._base;
					}

					if (arguments.length === 1) {
						handlers.length = 0;
						return this._base;
					}

					for (idx = handlers.length - 1; idx > -1; --idx) {
						if (handlers[idx].callback === handler) {
							handlers.splice(idx, 1);
						}
					}
					return this._base;
				};

				/**
     * Render the layer according to the input data: Bind the data to the layer
     * (according to {@link Layer#dataBind}, insert new elements (according to
     * {@link Layer#insert}, make lifecycle selections, and invoke all relevant
     * handlers (as attached via {@link Layer#on}) with the lifecycle selections.
     *
     * - update
     * - update:transition
     * - enter
     * - enter:transition
     * - exit
     * - exit:transition
     *
     * @externalExample {runnable} layer-draw
     *
     * @param {Array} data Data to drive the rendering.
     */
				Layer.prototype.draw = function (data) {
					var bound, entering, events, selection, method, handlers, eventName, idx, len;

					bound = this.dataBind.call(this._base, data);

					// Although `bound instanceof d3.selection` is more explicit, it fails
					// in IE8, so we use duck typing to maintain compatability.
					assert(bound && bound.call === d3.selection.prototype.call, "Invalid selection defined by `Layer#dataBind` method.");
					assert(bound.enter, "Layer selection not properly bound.");

					entering = bound.enter();
					entering._chart = this._base._chart;

					events = [{
						name: "update",
						selection: bound
					}, {
						name: "enter",
						selection: entering,
						method: this.insert
					}, {
						name: "merge",
						// Although the `merge` lifecycle event shares its selection object
						// with the `update` lifecycle event, the object's contents will be
						// modified when d3.chart invokes the user-supplied `insert` method
						// when triggering the `enter` event.
						selection: bound
					}, {
						name: "exit",
						// Although the `exit` lifecycle event shares its selection object
						// with the `update` and `merge` lifecycle events, the object's
						// contents will be modified when d3.chart invokes
						// `d3.selection.exit`.
						selection: bound,
						method: bound.exit
					}];

					for (var i = 0, l = events.length; i < l; ++i) {
						eventName = events[i].name;
						selection = events[i].selection;
						method = events[i].method;

						// Some lifecycle selections modify shared state, so they must be
						// deferred until just prior to handler invocation.
						if (typeof method === "function") {
							selection = method.call(selection);
						}

						if (selection.empty()) {
							continue;
						}

						// Although `selection instanceof d3.selection` is more explicit,
						// it fails in IE8, so we use duck typing to maintain
						// compatability.
						assert(selection && selection.call === d3.selection.prototype.call, "Invalid selection defined for '" + eventName + "' lifecycle event.");

						handlers = this._handlers[eventName];

						if (handlers) {
							for (idx = 0, len = handlers.length; idx < len; ++idx) {
								// Attach a reference to the parent chart so the selection"s
								// `chart` method will function correctly.
								selection._chart = handlers[idx].chart || this._base._chart;
								selection.call(handlers[idx].callback);
							}
						}

						handlers = this._handlers[eventName + ":transition"];

						if (handlers && handlers.length) {
							selection = selection.transition();
							for (idx = 0, len = handlers.length; idx < len; ++idx) {
								selection._chart = handlers[idx].chart || this._base._chart;
								selection.call(handlers[idx].callback);
							}
						}
					}
				};

				module.exports = Layer;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

			/***/
		}
		/******/])
	);
});
;

/***/ }),

/***/ "OP7B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"legend":"legend__3-mOA","textLabel":"textLabel__2Oftx","exportLegend":"exportLegend__1t9nN","legendWrapper":"legendWrapper__2RqEt","legendColor":"legendColor__2rZno","legendDescription":"legendDescription__3S9qZ","legendPercentage":"legendPercentage__1cSm1","perc":"perc__29QOt","textField":"textField__2Qb_A","dollor":"dollor__bVku_","donut":"donut__8TQt2","imageWrapper":"imageWrapper__V5Cd4","sdg_image":"sdg_image__1UGW8","svgIe":"svgIe__3MZcc","regularOtherLegend":"regularOtherLegend__3_IS2","legend_wrapper":"legend_wrapper__2Im90","legendText":"legendText__1jVSc"};

/***/ }),

/***/ "OXGr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectimeline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dateFormatter__ = __webpack_require__("GXBc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__("YZJ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var projectimeline = function (_Component) {
  _inherits(projectimeline, _Component);

  function projectimeline(props, context) {
    _classCallCheck(this, projectimeline);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.setPercentCompleted = function () {
      var perc = _this.calculatePerc() + "%";
      _this.setState({ perc: perc });
    };

    _this.calculatePerc = function () {
      if (_this.isProjectTimeLineNonEmpty) {
        var start = new Date(_this.state.data.start_date),
            end = new Date(_this.state.data.end_date),
            today = new Date(),
            p = Math.round((today - start) / (end - start) * 100);
        return p;
      }
    };

    _this.state = {
      data: _this.props.data ? _this.props.data : {},
      perc: 0
    }, _this.isProjectTimeLineNonEmpty = _this.props.data && Object.keys(_this.props.data).length > 0;
    return _this;
  }

  projectimeline.prototype.componentWillMount = function componentWillMount() {
    this.setPercentCompleted();
  };

  projectimeline.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (nextProps.data != this.props.data) {
      this.isProjectTimeLineNonEmpty = nextProps.data && Object.keys(nextProps.data).length > 0;
      this.setState({
        data: nextProps.data
      }, function () {
        return _this2.setPercentCompleted();
      });
    }
  };

  projectimeline.prototype.render = function render() {
    if (this.isProjectTimeLineNonEmpty) {
      var length = this.state.data.year_array.length,
          start_year = this.state.data.year_array[0],
          end_year = this.state.data.year_array[length - 1],
          divisions = end_year - start_year,
          width_factor = 100 / divisions,
          list = [];
      for (var i = start_year; i <= end_year; i++) {
        list.push(i);
      };
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'section',
      null,
      this.isProjectTimeLineNonEmpty && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'section',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'p',
          { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.headingTimeline },
          'Project Timeline'
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.timeLineWrapper },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.progressBar },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.progressBarChild, style: { width: this.state.perc } }),
            list.map(function (el, index) {
              var width_percentage = {
                left: index * width_factor + '%'
              };
              return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.bar_step, style: width_percentage },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'div',
                  { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.label_percent },
                  el
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.label_line })
              );
            })
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.dateWrapper },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'span',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_1__utils_dateFormatter__["a" /* getFormmattedDate */])(this.state.data.start_date)
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'span',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_1__utils_dateFormatter__["a" /* getFormmattedDate */])(this.state.data.end_date)
            )
          )
        )
      )
    );
  };

  return projectimeline;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "QFwC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectDetailOutputResult; });
var projectDetailOutputResult = [{
    id: '000954595',
    output: 'OutputName',
    theme: 'Democratice governance',
    outputDesc: 'Updated legislative policy and regulatory framework',
    viewDetails: 'View Results'

}, {
    id: '000954596',
    output: 'OutputName',
    theme: 'Responsive institution',
    outputDesc: 'Updated legislative policy and regulatory framework',
    viewDetails: 'View Results'

}, {
    id: '000954597',
    output: 'OutputName',
    theme: 'Democratice governance',
    outputDesc: 'Updated legislative policy and regulatory framework',
    viewDetails: 'View Results'

}, {
    id: '000954598',
    output: 'OutputName',
    theme: 'Responsive institution',
    outputDesc: 'Updated legislative policy and regulatory framework',
    viewDetails: 'View Results'

}];

/***/ }),

/***/ "RBXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ./routes/home/index.js
var home = __webpack_require__("E1C8");

// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/sdg-target-details/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(16).then((function (require) {
				cb( __webpack_require__("1zHQ") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var sdg_target_details = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/pa-target-details/index.js

		

		function pa_target_details_load(cb) {
			__webpack_require__.e/* require.ensure */(11).then((function (require) {
				cb( __webpack_require__("hNUn") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var pa_target_details = (async_default()(pa_target_details_load));
	
// CONCATENATED MODULE: ./routes/ourApproaches/index.js

		

		function ourApproaches_load(cb) {
			__webpack_require__.e/* require.ensure */(18).then((function (require) {
				cb( __webpack_require__("BH6c") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var ourApproaches = (async_default()(ourApproaches_load));
	
// EXTERNAL MODULE: ./routes/profile/index.js
var profile = __webpack_require__("gNuw");

// CONCATENATED MODULE: ./routes/themes/index.js

		

		function themes_load(cb) {
			__webpack_require__.e/* require.ensure */(8).then((function (require) {
				cb( __webpack_require__("fBPj") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var routes_themes = (async_default()(themes_load));
	
// CONCATENATED MODULE: ./routes/signature/index.js

		

		function signature_load(cb) {
			__webpack_require__.e/* require.ensure */(9).then((function (require) {
				cb( __webpack_require__("lpsX") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var signature = (async_default()(signature_load));
	
// EXTERNAL MODULE: ./routes/project/index.js
var project = __webpack_require__("chsG");

// EXTERNAL MODULE: ./routes/projectDetails/index.js
var projectDetails = __webpack_require__("l+xS");

// CONCATENATED MODULE: ./routes/searchResults/index.js

		

		function searchResults_load(cb) {
			__webpack_require__.e/* require.ensure */(6).then((function (require) {
				cb( __webpack_require__("nwmL") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var searchResults = (async_default()(searchResults_load));
	
// CONCATENATED MODULE: ./routes/donors/index.js

		

		function donors_load(cb) {
			__webpack_require__.e/* require.ensure */(13).then((function (require) {
				cb( __webpack_require__("PJto") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var donors = (async_default()(donors_load));
	
// CONCATENATED MODULE: ./routes/aboutUs/index.js

		

		function aboutUs_load(cb) {
			__webpack_require__.e/* require.ensure */(14).then((function (require) {
				cb( __webpack_require__("0Y4i") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var aboutUs = (async_default()(aboutUs_load));
	
// CONCATENATED MODULE: ./routes/sdg/index.js

		

		function sdg_load(cb) {
			__webpack_require__.e/* require.ensure */(15).then((function (require) {
				cb( __webpack_require__("TXrW") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var routes_sdg = (async_default()(sdg_load));
	
// CONCATENATED MODULE: ./routes/programArea/index.js

		

		function programArea_load(cb) {
			__webpack_require__.e/* require.ensure */(17).then((function (require) {
				cb( __webpack_require__("uDbe") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var programArea = (async_default()(programArea_load));
	
// EXTERNAL MODULE: ./components/bootstraptable/index.js + 2 modules
var bootstraptable = __webpack_require__("yNoq");

// EXTERNAL MODULE: ./components/map/index.js + 6 modules
var map = __webpack_require__("wvix");

// EXTERNAL MODULE: ./shared/actions/mapActions/projectListMapData.js
var mapActions_projectListMapData = __webpack_require__("ZIP0");

// EXTERNAL MODULE: ./shared/actions/getYearList.js
var getYearList = __webpack_require__("EIKz");

// EXTERNAL MODULE: ./routes/embedViews/project/style.scss
var style = __webpack_require__("dXTN");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./routes/embedViews/project/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// http://localhost:8080/embed/projects?title=false&summary=false&map=false&projectTable=false&country=&sources=&themes=&sdg=


//title=false&summary=false&map=false&projectTable=false&country=&countryLabel=&sources=&sourcesLabel=&themes=&themesLabel=&sdg=&sdgLabel=&year=2018'}width={300}></frame>


// Projects <Budget Source> contributed in <Recipient Country Office / Operating Unit> for <year> under <No Poverty>


var project_EmbedProjectView = function (_Component) {
    _inherits(EmbedProjectView, _Component);

    function EmbedProjectView(props) {
        _classCallCheck(this, EmbedProjectView);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleFilterChange = function (type, value) {
            if (_this.props.projectTable === 'true') {
                if (type === 'search') {
                    _this.setState({ keyword: value });
                }
            }
        };

        _this.generateFilteredList = function () {
            return _this.state.filterList.map(function (item) {
                if (item.label !== '') {
                    return Object(preact_min["h"])(
                        'span',
                        { 'class': style_default.a.filterLabels },
                        Object(preact_min["h"])(
                            'strong',
                            null,
                            item.displayLabel
                        ),
                        ': ',
                        item.label
                    );
                }
            });
        };

        _this.generateFilteredList = function () {
            return _this.state.filterList.map(function (item) {
                if (item.label !== '') {
                    return Object(preact_min["h"])(
                        'span',
                        { 'class': style_default.a.filterLabels },
                        Object(preact_min["h"])(
                            'strong',
                            null,
                            item.displayLabel
                        ),
                        ': ',
                        item.label
                    );
                }
            });
        };

        _this.state = {
            projectList: [],
            totalDataSize: 0,
            links: {},
            keyword: _this.props.search,
            filterList: [{
                displayLabel: 'Donors',
                label: _this.props.sourcesLabel,
                text: ''

            }, {
                displayLabel: 'Recipient Country / Region',
                label: _this.props.countryLabel,
                text: ''

            }, {
                displayLabel: 'Year',
                label: _this.props.year,
                text: ''
            }, {
                displayLabel: 'Programme Areas',
                label: _this.props.themesLabel,
                text: ''

            }, {
                displayLabel: 'Sdg',
                label: _this.props.sdgLabel,
                text: ''

            }, {
                displayLabel: 'Programme Areas',
                label: _this.props.signatureLabel,
                text: ''

            }]
        };
        return _this;
    }

    EmbedProjectView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.projectTable === 'true') {
            if (nextProps.projectList != this.props.projectList) {
                var data = nextProps.projectList.data;
                var parseData = function parseData(data) {
                    data.forEach(function (item) {
                        item.country_name = item.country;
                        item.probObj = {
                            title: item.title,
                            project_id: item.project_id
                        };
                        item.total_budget = item.budget == null ? 0 : item.budget;
                        item.total_expense = item.expense == null ? 0 : item.expense;
                    });
                    return data;
                };
                this.setState({ projectList: parseData(data), totalDataSize: nextProps.projectList.count, links: nextProps.projectList.links });
            }
        }
    };

    EmbedProjectView.prototype.componentWillMount = function componentWillMount() {

        this.props.setCurrentYear(this.props.year);

        if (this.props.map === 'true') {
            this.props.loadProjectListMapData(this.props.mapCurrentYear, this.props.themes, this.props.country, this.props.sources, this.props.sdg);
        }
    };

    EmbedProjectView.prototype.render = function render(_ref, _ref2) {
        var _this2 = this;

        var projectListMapData = _ref.projectListMapData;
        var links = _ref2.links,
            projectList = _ref2.projectList,
            totalDataSize = _ref2.totalDataSize;

        return Object(preact_min["h"])(
            'div',
            { 'class': style_default.a.container },
            this.props.title === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.titleWrapper },
                'Projects - ',
                this.props.year
            ) : null,
            this.props.summary === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.filterTextWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': style_default.a.filterText },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': style_default.a.filterHighlight },
                        this.props.sourcesLabel + ' '
                    ),
                    'contribution',
                    this.props.countryLabel != '' ? Object(preact_min["h"])(
                        'span',
                        null,
                        ' to ',
                        Object(preact_min["h"])(
                            'span',
                            { 'class': style_default.a.filterHighlight },
                            '' + this.props.countryLabel
                        )
                    ) : Object(preact_min["h"])(
                        'span',
                        { 'class': style_default.a.filterHighlight },
                        '' + this.props.countryLabel
                    ),
                    this.props.themesLabel !== '' ? Object(preact_min["h"])(
                        'span',
                        null,
                        ' for ',
                        Object(preact_min["h"])(
                            'span',
                            { 'class': style_default.a.filterHighlight },
                            '' + this.props.themesLabel
                        )
                    ) : ' ',
                    this.props.sdgLabel !== '' ? Object(preact_min["h"])(
                        'span',
                        null,
                        ' for ',
                        Object(preact_min["h"])(
                            'span',
                            { 'class': style_default.a.filterHighlight },
                            '' + this.props.sdgLabel
                        )
                    ) : '',
                    ' in ',
                    Object(preact_min["h"])(
                        'span',
                        { 'class': style_default.a.filterHighlight },
                        '' + this.props.year
                    )
                )
            ) : null,
            this.props.map === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.mapWrapper },
                Object(preact_min["h"])(map["a" /* default */], { sector: this.props.themes,
                    sdg: this.props.sdg,
                    source: this.props.sources,
                    mapData: this.props.projectListMapData,
                    enableTimeline: false,
                    embed: true
                }),
                Object(preact_min["h"])(
                    'div',
                    { 'class': style_default.a.disclaimer },
                    '* The boundaries and names shown and the designations used on this map do not imply official endorsement or acceptance by the United Nations'
                )
            ) : null,
            this.props.projectTable === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.projectListWrapper },
                Object(preact_min["h"])(bootstraptable["a" /* default */], { data: projectList,
                    loading: this.props.loading,
                    theme: this.props.themes,
                    unit: this.props.country,
                    keyword: this.state.keyword,
                    source: this.props.source,
                    count: totalDataSize,
                    sdg: this.props.sdg,
                    links: links,
                    embed: true,
                    handleFilterChange: function handleFilterChange(type, value) {
                        return _this2.handleFilterChange(type, value);
                    }
                })
            ) : null
        );
    };

    return EmbedProjectView;
}(preact_min["Component"]);

var mapStateToProps = function mapStateToProps(state) {
    var mapCurrentYear = state.mapData.yearTimeline.mapCurrentYear,
        projectListMapData = state.mapData.projectListMapData,
        _state$projectList = state.projectList,
        loading = _state$projectList.loading,
        error = _state$projectList.error,
        projectList = _state$projectList.projectList;


    return {
        router: state.router,
        mapCurrentYear: mapCurrentYear,
        projectListMapData: projectListMapData,
        projectList: projectList,
        loading: loading

    };
};

var project_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        // onChangeRoute: (url) => dispatch(onChangeRoute(url))
        loadProjectListMapData: function loadProjectListMapData(year, sector, unit, source, sdg) {
            return dispatch(Object(mapActions_projectListMapData["b" /* loadProjectListMapData */])(year, sector, unit, source, sdg));
        },
        setCurrentYear: function setCurrentYear(year) {
            return dispatch(Object(getYearList["b" /* setCurrentYear */])(year));
        }

    };
};

/* harmony default export */ var embedViews_project = (Object(preact_redux_esm["a" /* connect */])(mapStateToProps, project_mapDispatchToProps)(project_EmbedProjectView));
// CONCATENATED MODULE: ./static/assets/json/projectDetail.js
var projectDetail = {
    "data": [{
        "ID": "10000129",
        "Output": "Donec vestibulum iaculis ullamcorper.",
        "Theme": "Responsive Institution",
        "Output Description": "Country Name 5",
        "Link": "$123,456,789"
    }, {
        "ID": "10000130",
        "Output": "Donec vestibulum iaculis ullamcorper.",
        "Theme": "Democratic Governance",
        "Output Description": "Country Name 5",
        "Link": "$123,456,789"
    }, {
        "ID": "10000131",
        "Output": "Donec vestibulum iaculis ullamcorper.",
        "Theme": "Democratic Governance",
        "Output Description": "Country Name 1",
        "Link": "$123,456,789",
        "Expense": "$123,456,789"
    }, {
        "ID": "10000132",
        "Output": "Donec vestibulum iaculis ullamcorper.",
        "Theme": "Responsive Institution",
        "Output Description": "Country Name 2",
        "Link": "$123,456,789",
        "Expense": "$123,456,789"
    }, {
        "ID": "10000133",
        "Output": "Donec vestibulum iaculis ullamcorper.",
        "Theme": "Democratic Governance",
        "Output Description": "Country Name 3",
        "Link": "$123,456,789",
        "Expense": "$123,456,789"
    }, {
        "ID": "10000134",
        "Output": "Donec vestibulum iaculis ullamcorper.",
        "Theme": "Responsive Institution",
        "Output Description": "Country Name 4",
        "Link": "$123,456,789",
        "Expense": "$123,456,789"
    }, {
        "ID": "10000135",
        "Output": "Donec vestibulum iaculis ullamcorper.",
        "Theme": "Democratic Governance",
        "Output Description": "Country Name 5",
        "Link": "$123,456,789"
    }, {
        "ID": "10000136",
        "Output": "Donec vestibulum iaculis ullamcorper.",
        "Theme": "Responsive Institution",
        "Output Description": "Country Name 5",
        "Link": "$123,456,789"
    }, {
        "ID": "10000137",
        "Output": "Donec vestibulum iaculis ullamcorper.",
        "Theme": "Democratic Governance",
        "Output Description": "Country Name 5",
        "Link": "$123,456,789"
    }, {
        "ID": "10000138",
        "Output": "Donec vestibulum iaculis ullamcorper.",
        "Theme": "Responsive Institution",
        "Output Description": "Country Name 5",
        "Link": "$123,456,789"
    }]
};
// EXTERNAL MODULE: ./components/projectDescription/index.js
var projectDescription = __webpack_require__("Vhkl");

// EXTERNAL MODULE: ./components/budgetSource/index.js
var components_budgetSource = __webpack_require__("G9P3");

// EXTERNAL MODULE: ./components/projectDetailTable/index.js + 5 modules
var projectDetailTable = __webpack_require__("V1bQ");

// EXTERNAL MODULE: ./components/PictureGallery/index.js
var PictureGallery = __webpack_require__("31tI");

// EXTERNAL MODULE: ./components/preLoader/index.js
var preLoader = __webpack_require__("ufjx");

// EXTERNAL MODULE: ./components/no-data-template/index.js
var no_data_template = __webpack_require__("wdDn");

// EXTERNAL MODULE: ./components/projectDetailDocuTable/index.js
var projectDetailDocuTable = __webpack_require__("YTB6");

// EXTERNAL MODULE: ./components/purchaseOrderTable/index.js
var purchaseOrderTable = __webpack_require__("pqrH");

// EXTERNAL MODULE: ./static/assets/json/projectDetailOutPutResults.js
var projectDetailOutPutResults = __webpack_require__("QFwC");

// EXTERNAL MODULE: ./static/assets/json/projectDetailPurchaseOrderData.js
var projectDetailPurchaseOrderData = __webpack_require__("dIRi");

// EXTERNAL MODULE: ./static/assets/json/projectDetailDocuments.js
var projectDetailDocuments = __webpack_require__("CamH");

// EXTERNAL MODULE: ./components/EmbedSection/index.js + 1 modules
var EmbedSection = __webpack_require__("7aq3");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/index.js
var projectDetailActions = __webpack_require__("csCp");

// EXTERNAL MODULE: ./shared/actions/mapActions/fetchMapOutputs.js
var fetchMapOutputs = __webpack_require__("GbIW");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/documentListActions.js
var documentListActions = __webpack_require__("e0UL");

// EXTERNAL MODULE: ./components/urlBreadCrumb/data/actions.js
var actions = __webpack_require__("usUj");

// EXTERNAL MODULE: ./shared/actions/routerActions.js
var routerActions = __webpack_require__("Y9jh");

// EXTERNAL MODULE: ./utils/commonActionUtils.js
var commonActionUtils = __webpack_require__("I9r4");

// EXTERNAL MODULE: ./components/areaChart/index.js
var areaChart = __webpack_require__("VSTg");

// EXTERNAL MODULE: ./components/project-timeline/index.js
var project_timeline = __webpack_require__("OXGr");

// EXTERNAL MODULE: ./routes/embedViews/projectDetails/style.scss
var projectDetails_style = __webpack_require__("uq14");
var projectDetails_style_default = /*#__PURE__*/__webpack_require__.n(projectDetails_style);

// CONCATENATED MODULE: ./routes/embedViews/projectDetails/index.js


function projectDetails__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function projectDetails__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function projectDetails__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





























var projectDetails__ref = Object(preact_min["h"])(preLoader["a" /* default */], null);

var projectDetails__ref2 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref3 = Object(preact_min["h"])(
	'span',
	null,
	'Budget Utilisation'
);

var _ref4 = Object(preact_min["h"])(
	'span',
	null,
	'Budget'
);

var _ref5 = Object(preact_min["h"])(
	'span',
	null,
	'Expenditure'
);

var _ref6 = Object(preact_min["h"])(areaChart["a" /* default */], null);

var projectDetails_EmbedProjectDetailsView = function (_Component) {
	projectDetails__inherits(EmbedProjectDetailsView, _Component);

	function EmbedProjectDetailsView(props) {
		projectDetails__classCallCheck(this, EmbedProjectDetailsView);

		var _this = projectDetails__possibleConstructorReturn(this, _Component.call(this, props));

		_this.selectCategory = function (category) {
			category == '' ? _this.props.swapDocumentList() : _this.props.updateProjectDocumentList(_this.props.id, category);
		};

		_this.onInfoLegendToggle = function () {
			_this.setState({
				isInfo: !_this.state.isInfo
			});
		};

		_this.changeIframeSrc = function (type) {
			var source = '';
			switch (type) {
				case 'prev':
					if (_this.currentLocationIndex > 0) {
						_this.currentLocationIndex--;
						if (_this.props.projectDetail.project.storyMap[_this.currentLocationIndex - 1]) {
							_this.setState({ prevLocation: _this.props.projectDetail.project.storyMap[_this.currentLocationIndex - 1] });
							_this.showPrev = true;
						} else {
							_this.setState({ prevLocation: { location: '', source: '' } });
							_this.showPrev = false;
						}
						_this.setState({ currentLocation: _this.props.projectDetail.project.storyMap[_this.currentLocationIndex] });
						_this.setState({ nextLocation: _this.props.projectDetail.project.storyMap[_this.currentLocationIndex + 1] });
						source = _this.state.currentLocation.source;
					} else {
						_this.setState({ prevLocation: { location: '', source: '' } });
						_this.showPrev = false;
					}
					if (_this.state.nextLocation.source) _this.showNext = true;else _this.showNext = false;

					break;
				case 'next':
					if (_this.currentLocationIndex < _this.props.projectDetail.project.storyMap.length - 1) {
						_this.setState({ prevLocation: _this.props.projectDetail.project.storyMap[_this.currentLocationIndex] });
						_this.currentLocationIndex++;
						_this.setState({ currentLocation: _this.props.projectDetail.project.storyMap[_this.currentLocationIndex] });
						_this.setState({ nextLocation: _this.props.projectDetail.project.storyMap[_this.currentLocationIndex + 1] });
						source = _this.state.currentLocation.source;
						_this.showNext = true;
						if (_this.currentLocationIndex === _this.props.projectDetail.project.storyMap.length - 1) {
							_this.setState({ nextLocation: { location: '', source: '' } });
							_this.showNext = false;
						}
					} else {
						_this.setState({ nextLocation: { location: '', source: '' } });
						_this.showNext = false;
					}
					if (_this.state.prevLocation.source) _this.showPrev = true;else _this.showPrev = false;
					break;
			}
		};

		_this.state = {
			isInfo: false,
			prevLocation: { location: '', source: '' },
			currentLocation: { location: '', source: '' },
			nextLocation: { location: '', source: '' }
		};
		_this.currentLocationIndex = 0;
		_this.showNext = false;
		_this.showPrev = false;
		_this.isSetStoryMap = false;
		return _this;
	}

	EmbedProjectDetailsView.prototype.componentWillMount = function componentWillMount() {
		this.props.fetchProjectDetailsOnSelection(this.props.id);
		this.props.loadOutputsMapData(this.props.currentYear, '', '', '', this.props.id, '');
	};

	EmbedProjectDetailsView.prototype.changeSatelliteSrc = function changeSatelliteSrc(currentLocationIndex) {
		this.currentLocationIndex = currentLocationIndex;
		if (this.props.projectDetail.project.storyMap && this.props.projectDetail.project.storyMap.length) {
			if (this.currentLocationIndex === 0) {
				this.setState({ prevLocation: { location: '', source: '' } });
				this.showPrev = false;
			} else {
				this.setState({ prevLocation: this.props.projectDetail.project.storyMap[this.currentLocationIndex - 1] });
				this.showPrev = true;
			}
			this.setState({ currentLocation: this.props.projectDetail.project.storyMap[this.currentLocationIndex] });
			if (this.props.projectDetail.project.storyMap.length > 1 && this.currentLocationIndex !== this.props.projectDetail.project.storyMap.length - 1) {
				this.setState({ nextLocation: this.props.projectDetail.project.storyMap[this.currentLocationIndex + 1] });
				this.showNext = true;
			} else {
				this.showNext = false;
			}
		}
	};

	EmbedProjectDetailsView.prototype.render = function render() {
		var _this2 = this;

		var org_name = this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation.org_name ? this.props.projectDetail.project.organisation.org_name : '';
		var satelliteData = this.props.satellite === 'true' && this.props.projectDetail.project && this.props.projectDetail.project.storyMap ? this.props.projectDetail.project.storyMap : [];

		if (this.props.satellite === 'true' && satelliteData.length && !this.isSetStoryMap) {
			this.setState({ prevLocation: { location: '', source: '' } });
			this.setState({ currentLocation: this.props.projectDetail.project.storyMap[this.currentLocationIndex] });
			if (this.props.projectDetail.project.storyMap.length > 1) {
				this.setState({ nextLocation: this.props.projectDetail.project.storyMap[this.currentLocationIndex + 1] });
				this.showNext = true;
			} else {
				this.showNext = false;
			}
			this.isSetStoryMap = true;
		}

		return Object(preact_min["h"])(
			'div',
			{ 'class': projectDetails_style_default.a.container },
			this.props.title === 'true' ? Object(preact_min["h"])(
				'div',
				{ 'class': projectDetails_style_default.a.titleWrapper },
				this.props.projectDetail.project.title
			) : null,
			this.props.description === 'true' ? Object(preact_min["h"])(
				'div',
				{ 'class': projectDetails_style_default.a.filterTextWrapper },
				Object(preact_min["h"])(
					'div',
					{ 'class': projectDetails_style_default.a.filterText },
					this.props.projectDetail.project.description
				)
			) : null,
			this.props.map === 'true' ? Object(preact_min["h"])(
				'div',
				{ 'class': projectDetails_style_default.a.projectMap },
				Object(preact_min["h"])(map["a" /* default */], {
					clusterMode: true,
					projectId: this.props.id,
					mapData: this.props.projectDetailMapData,
					embed: true
				}),
				Object(preact_min["h"])(
					'div',
					{ 'class': projectDetails_style_default.a.disclaimer },
					'* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'
				)
			) : null,
			this.props.satellite === 'true' ? Object(preact_min["h"])(
				'div',
				{ 'class': projectDetails_style_default.a.satelliteWrapper },
				this.props.projectDetail.loading ? projectDetails__ref : satelliteData.length ? Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])('iframe', { id: 'satelliteIframe', src: this.state.currentLocation.source, 'class': projectDetails_style_default.a.satellite }),
					Object(preact_min["h"])(
						'div',
						{ 'class': projectDetails_style_default.a.satellite_btn_container },
						Object(preact_min["h"])(
							'span',
							{ style: !this.showPrev ? 'opacity:0' : '', 'class': projectDetails_style_default.a.locationText + ' ' + projectDetails_style_default.a.leftBtn },
							Object(preact_min["h"])('div', { onClick: function onClick() {
									return _this2.changeIframeSrc('prev');
								}, className: projectDetails_style_default.a.accordion__arrow__left }),
							Object(preact_min["h"])(
								'span',
								{ style: !this.showPrev ? 'display:none' : 'display:inline-block', 'class': projectDetails_style_default.a.buttonMode, onClick: function onClick() {
										return _this2.changeIframeSrc('prev');
									} },
								'Previous: ',
								this.state.prevLocation.location
							)
						),
						Object(preact_min["h"])(
							'span',
							{ 'class': projectDetails_style_default.a.locationText + ' ' + projectDetails_style_default.a.centerBtn },
							this.state.currentLocation.location
						),
						Object(preact_min["h"])(
							'span',
							{ style: !this.showNext ? 'opacity:0' : '', 'class': projectDetails_style_default.a.locationText + ' ' + projectDetails_style_default.a.rightBtn },
							Object(preact_min["h"])(
								'span',
								{ style: !this.showNext ? 'display:none' : 'display:inline-block', 'class': projectDetails_style_default.a.buttonMode, onClick: function onClick() {
										return _this2.changeIframeSrc('next');
									} },
								'Next: ',
								this.state.nextLocation.location
							)
						),
						Object(preact_min["h"])('div', { onClick: function onClick() {
								return _this2.changeIframeSrc('next');
							}, style: !this.showNext ? 'opacity:0' : '', className: projectDetails_style_default.a.accordion__arrow__right })
					)
				) : projectDetails__ref2
			) : null,
			this.props.projectinfo === 'true' ? Object(preact_min["h"])(
				'div',
				{ 'class': projectDetails_style_default.a.projectstatusWrapper },
				Object(preact_min["h"])(
					'div',
					{ 'class': projectDetails_style_default.a.heading },
					Object(preact_min["h"])(
						'p',
						{ 'class': projectDetails_style_default.a.source },
						'Implementing Organisation'
					),
					Object(preact_min["h"])(
						'p',
						null,
						org_name
					)
				),
				Object(preact_min["h"])(project_timeline["a" /* default */], { data: this.props.projectDetail.time_line }),
				Object(preact_min["h"])(
					'div',
					{ className: projectDetails_style_default.a.arealChart },
					Object(preact_min["h"])(
						'div',
						{ className: projectDetails_style_default.a.areaHeaderWrapper },
						Object(preact_min["h"])(
							'div',
							{ className: projectDetails_style_default.a.titleWrapper },
							_ref3
						),
						Object(preact_min["h"])(
							'div',
							{ className: projectDetails_style_default.a.legendWrapper },
							Object(preact_min["h"])(
								'div',
								{ className: projectDetails_style_default.a.legendItemOuterWrapper },
								Object(preact_min["h"])(
									'div',
									{ className: projectDetails_style_default.a.legendItemInnerWrapper },
									Object(preact_min["h"])(
										'div',
										{ className: projectDetails_style_default.a.itemAlignmentWrapper },
										Object(preact_min["h"])('span', { 'class': projectDetails_style_default.a.legend + ' ' + projectDetails_style_default.a.budgetLegend + ' ' }),
										_ref4
									)
								),
								Object(preact_min["h"])(
									'div',
									{ className: projectDetails_style_default.a.legendItemInnerWrapper },
									Object(preact_min["h"])(
										'div',
										{ className: projectDetails_style_default.a.itemAlignmentWrapper },
										Object(preact_min["h"])('span', { 'class': projectDetails_style_default.a.legend + ' ' + projectDetails_style_default.a.revenueLegend + ' ' }),
										_ref5
									)
								)
							)
						)
					),
					_ref6
				)
			) : null,
			this.props.budgetSources === 'true' ? Object(preact_min["h"])(
				'div',
				{ 'class': projectDetails_style_default.a.budgetSourceWrapper },
				Object(preact_min["h"])(components_budgetSource["a" /* default */], { data: this.props.projectDetail.budget_source, embed: true })
			) : null,
			this.props.outputTable === 'true' ? Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'div',
					{ 'class': projectDetails_style_default.a.table_title },
					'CONTRACTS'
				),
				Object(preact_min["h"])(projectDetailTable["a" /* default */], { data: projectDetailOutPutResults["a" /* projectDetailOutputResult */],
					loading: this.props.projectDetail.output_list.loading,
					embed: true
				})
			) : null,
			this.props.docTable === 'true' ? Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'div',
					{ 'class': projectDetails_style_default.a.table_title },
					'DOCUMENTS'
				),
				Object(preact_min["h"])(projectDetailDocuTable["a" /* default */], {
					loading: this.props.projectDetail.document_list_filtered.loading,
					embed: true,
					categorySelect: function categorySelect(value) {
						return _this2.selectCategory(value);
					},
					data: this.props.projectDetail && this.props.projectDetail.document_list_filtered && this.props.projectDetail.document_list_filtered.data ? this.props.projectDetail.document_list_filtered.data : [] })
			) : null,
			this.props.purchaseOrdrTable === 'true' ? Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'div',
					{ 'class': projectDetails_style_default.a.table_title },
					'PURCHASE ORDERS'
				),
				Object(preact_min["h"])(purchaseOrderTable["a" /* default */], {
					loading: this.props.projectDetail.purchase_orders.loading,
					data: this.props.projectDetail && this.props.projectDetail.purchase_orders && this.props.projectDetail.purchase_orders.data ? this.props.projectDetail.purchase_orders.data : [] }),
				' '
			) : null
		);
	};

	return EmbedProjectDetailsView;
}(preact_min["Component"]);

var projectDetails_mapStateToProps = function mapStateToProps(state) {
	var projectDetailMapData = state.mapData.projectDetailMapData,
	    currentYear = state.yearList.currentYear;


	return {
		router: state.router,
		projectDetail: state.projectDetail,
		projectDetailMapData: projectDetailMapData,
		currentYear: currentYear
	};
};

var projectDetails_mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		setPageHeader: function setPageHeader(data) {
			return dispatch(Object(actions["a" /* setPageHeader */])(data));
		},
		fetchProjectDetailsOnSelection: function fetchProjectDetailsOnSelection(id) {
			return dispatch(Object(projectDetailActions["b" /* fetchProjectDetailsOnSelection */])(id));
		},
		clearProjectDetails: function clearProjectDetails() {
			return dispatch(Object(projectDetailActions["a" /* clearProjectDetails */])());
		},
		updateProjectDocumentList: function updateProjectDocumentList(id, category) {
			return dispatch(Object(documentListActions["e" /* updateProjectDocumentList */])(id, category));
		},
		swapDocumentList: function swapDocumentList() {
			return dispatch(Object(documentListActions["d" /* swapDocumentList */])());
		},
		onChangeRoute: function onChangeRoute(title) {
			return dispatch(Object(routerActions["b" /* onChangeRoute */])(title));
		},
		loadOutputsMapData: function loadOutputsMapData(year, unit, sector, source, project_id, budget_type) {
			return dispatch(Object(fetchMapOutputs["d" /* loadOutputsMapData */])(year, unit, sector, source, project_id, budget_type));
		}
	};
};

/* harmony default export */ var embedViews_projectDetails = (Object(preact_redux_esm["a" /* connect */])(projectDetails_mapStateToProps, projectDetails_mapDispatchToProps)(projectDetails_EmbedProjectDetailsView));
// EXTERNAL MODULE: ./components/stackedBarChart2/index.js + 1 modules
var stackedBarChart2 = __webpack_require__("uO0A");

// EXTERNAL MODULE: ./components/donorsPage/actions/index.js
var donorsPage_actions = __webpack_require__("faXx");

// EXTERNAL MODULE: ./routes/embedViews/donors/style.scss
var donors_style = __webpack_require__("n5Fx");
var donors_style_default = /*#__PURE__*/__webpack_require__.n(donors_style);

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// CONCATENATED MODULE: ./routes/embedViews/donors/index.js


function donors__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function donors__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function donors__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var TAB_OTHER = "Project Agreements",
    TAB_REGULAR = "Institutional",
    TAB_TOTAL = "";

var donors__ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var donors__ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var donors__ref4 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var donors__ref5 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var donors__ref6 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref7 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref8 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref9 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var donors_EmbedDonorsView = function (_Component) {
    donors__inherits(EmbedDonorsView, _Component);

    function EmbedDonorsView(props) {
        donors__classCallCheck(this, EmbedDonorsView);

        var _this = donors__possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            filterObj: {
                year: _this.props.year,
                donorType: {
                    value: _this.props.donorType,
                    label: ''
                },
                fundType: null,
                fundStream: {
                    value: _this.props.fundStream,
                    label: ''
                }
            }
        };
        return _this;
    }

    EmbedDonorsView.prototype.componentWillMount = function componentWillMount() {
        this.props.donorFetchData(this.state.filterObj, TAB_TOTAL);

        if (this.props.regular === 'true') {
            this.props.donorFetchData(this.state.filterObj, TAB_REGULAR);
        }
        if (this.props.others === 'true') {
            this.props.donorFetchData(this.state.filterObj, TAB_OTHER);
        }
    };

    EmbedDonorsView.prototype.render = function render(_ref, state) {
        var donorData = _ref.donorData;
        var data = donorData.data,
            regularPercent = data && data.regular_percentage ? data.regular_percentage : 50,
            otherPercent = data && data.other_percentage ? data.other_percentage : 50,
            totalContributions = data && data.total_contributions ? data.total_contributions : 0,
            regularContribution = data && data.regular_contribution ? data.regular_contribution : 0,
            otherContributions = data && data.other_contributions ? data.other_contributions : 0,
            displayContryDetail = data && data.regular_percentage && data.other_percentage && data.regular_percentage != 0 && data.other_percentage != 0,
            totalData = donorData.totalData && donorData.totalData.data && donorData.totalData.data.country ? donorData.totalData.data.country : [],
            regularData = donorData.regularData && donorData.regularData.data && donorData.regularData.data.country ? donorData.regularData.data.country : [],
            otherData = donorData.otherData && donorData.otherData.data && donorData.otherData.data.country ? donorData.otherData.data.country : [],
            year = this.props.year,
            donorTypelabel = this.props.donorTypelabel === '' ? '' : 'of donor type ' + this.props.donorTypelabel,
            fundStreamlabel = this.props.fundStreamlabel === '' ? '' : 'of fund stream ' + this.props.fundStreamlabel;


        return Object(preact_min["h"])(
            'div',
            { 'class': donors_style_default.a.container },
            donorData.totalDataLoading && donors__ref2,
            Object(preact_min["h"])(
                'div',
                { style: displayContryDetail ? { display: 'block' } : { display: 'none' } },
                this.props.title === 'true' ? Object(preact_min["h"])(
                    'div',
                    { 'class': donors_style_default.a.titleWrapper },
                    'Donors'
                ) : null,
                this.props.summary === 'true' ? Object(preact_min["h"])(
                    'div',
                    { 'class': donors_style_default.a.filterTextWrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': donors_style_default.a.filterTitle },
                        'Donors for year ' + year + ' ' + donorTypelabel + ' ' + fundStreamlabel
                    ),
                    Object(preact_min["h"])('div', { 'class': donors_style_default.a.filterText })
                ) : null,
                this.props.stats === 'true' ? Object(preact_min["h"])(
                    'div',
                    { 'class': donors_style_default.a.detailViewWrapper },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': donors_style_default.a.detailView },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': donors_style_default.a.statsWrapper },
                            Object(preact_min["h"])(
                                'span',
                                { 'class': donors_style_default.a.stats },
                                'Total Contribution:',
                                Object(preact_min["h"])(
                                    'span',
                                    null,
                                    Object(numberFormatter["e" /* numberToDollarFormatter */])(totalContributions)
                                )
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': donors_style_default.a.contributionBarWrapper },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': donors_style_default.a.barTextWrapper },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': donors_style_default.a.barTextLeft + ' ' + donors_style_default.a.textLabel },
                                    ' Institutional'
                                ),
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': donors_style_default.a.barTextRight + ' ' + donors_style_default.a.textLabel },
                                    'Project Agreements'
                                )
                            ),
                            Object(preact_min["h"])('span', { 'class': donors_style_default.a.contributionBar, style: { width: regularPercent + '%', backgroundColor: '#16537d' } }),
                            Object(preact_min["h"])('span', { 'class': donors_style_default.a.contributionBar, style: { width: otherPercent + '%', backgroundColor: '#FFECB3' } }),
                            Object(preact_min["h"])(
                                'div',
                                { 'class': donors_style_default.a.barTextWrapper },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': donors_style_default.a.barTextLeft },
                                    Object(numberFormatter["d" /* numberToCurrencyFormatter */])(regularContribution, 2)
                                ),
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': donors_style_default.a.barTextRight },
                                    Object(numberFormatter["d" /* numberToCurrencyFormatter */])(otherContributions, 2)
                                )
                            ),
                            Object(preact_min["h"])(
                                'div',
                                { 'class': donors_style_default.a.barTextWrapper },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': donors_style_default.a.barTextLeft + ' ' + donors_style_default.a.textPerc },
                                    '(',
                                    regularPercent,
                                    '%)'
                                ),
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': donors_style_default.a.barTextRight + ' ' + donors_style_default.a.textPerc },
                                    '(',
                                    otherPercent,
                                    '%)'
                                )
                            )
                        )
                    )
                ) : null,
                this.props.total === 'true' ? Object(preact_min["h"])(
                    'div',
                    { 'class': donors_style_default.a.chartWrapper },
                    donorData.totalDataLoading ? Object(preact_min["h"])(
                        'div',
                        { 'class': donors_style_default.a.preLoaderWrapper },
                        donors__ref3
                    ) : donorData.totalData.data && donorData.totalData.data && donorData.totalData.data.country && donorData.totalData.data.country.length !== 0 ? Object(preact_min["h"])(
                        'div',
                        null,
                        Object(preact_min["h"])(
                            'p',
                            { 'class': donors_style_default.a.donorsourceTitle },
                            'total'
                        ),
                        Object(preact_min["h"])(stackedBarChart2["a" /* default */], { data: donorData.totalData.data.country })
                    ) : donors__ref4
                ) : null,
                this.props.regular === 'true' ? Object(preact_min["h"])(
                    'div',
                    { 'class': donors_style_default.a.chartWrapper },
                    donorData.regularDataLoading ? Object(preact_min["h"])(
                        'div',
                        { 'class': donors_style_default.a.preLoaderWrapper },
                        donors__ref5
                    ) : donorData.regularData.data && donorData.regularData.data && donorData.regularData.data.country && donorData.regularData.data.country.length !== 0 ? Object(preact_min["h"])(
                        'div',
                        null,
                        Object(preact_min["h"])(
                            'p',
                            { 'class': donors_style_default.a.donorsourceTitle },
                            'Institutional'
                        ),
                        Object(preact_min["h"])(stackedBarChart2["a" /* default */], { data: donorData.regularData.data.country })
                    ) : donors__ref6
                ) : null,
                this.props.others === 'true' ? Object(preact_min["h"])(
                    'div',
                    { 'class': donors_style_default.a.chartWrapper },
                    donorData.otherDataLoading ? Object(preact_min["h"])(
                        'div',
                        { 'class': donors_style_default.a.preLoaderWrapper },
                        _ref7
                    ) : donorData.otherData.data && donorData.otherData.data && donorData.otherData.data.country && donorData.otherData.data.country.length !== 0 ? Object(preact_min["h"])(
                        'div',
                        null,
                        Object(preact_min["h"])(
                            'p',
                            { 'class': donors_style_default.a.donorsourceTitle },
                            'Project Agreements'
                        ),
                        Object(preact_min["h"])(stackedBarChart2["a" /* default */], { data: donorData.otherData.data.country })
                    ) : _ref8
                ) : null
            ),
            Object(preact_min["h"])(
                'div',
                { style: displayContryDetail || donorData.totalDataLoading ? { display: 'none' } : { display: 'block' } },
                _ref9
            )
        );
    };

    return EmbedDonorsView;
}(preact_min["Component"]);

var donors_mapStateToProps = function mapStateToProps(state) {
    return {
        donorData: state.donorData,
        donorTypes: state.donorTypes,
        fundStreams: state.fundStreams

    };
};

var donors_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        donorFetchData: function donorFetchData(data, tabSelected) {
            return dispatch(Object(donorsPage_actions["m" /* donorFetchData */])(data, tabSelected));
        },
        onSwitchTab: function (_onSwitchTab) {
            function onSwitchTab(_x) {
                return _onSwitchTab.apply(this, arguments);
            }

            onSwitchTab.toString = function () {
                return _onSwitchTab.toString();
            };

            return onSwitchTab;
        }(function (data) {
            return dispatch(onSwitchTab(data));
        }),
        donorTypesFetchData: function donorTypesFetchData() {
            return dispatch(Object(donorsPage_actions["n" /* donorTypesFetchData */])());
        },
        fundStreamsFetchData: function fundStreamsFetchData() {
            return dispatch(Object(donorsPage_actions["o" /* fundStreamsFetchData */])());
        }
    };
};

/* harmony default export */ var embedViews_donors = (Object(preact_redux_esm["a" /* connect */])(donors_mapStateToProps, donors_mapDispatchToProps)(donors_EmbedDonorsView));
// EXTERNAL MODULE: ./routes/embedViews/profile/style.scss
var profile_style = __webpack_require__("cN8x");
var profile_style_default = /*#__PURE__*/__webpack_require__.n(profile_style);

// EXTERNAL MODULE: ./components/profilePage/components/generateRecipientCharts.js + 1 modules
var generateRecipientCharts = __webpack_require__("DgIW");

// EXTERNAL MODULE: ./components/profilePage/components/generateDonorCharts.js
var generateDonorCharts = __webpack_require__("UZkw");

// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/index.js
var recipientActions = __webpack_require__("FY1Z");

// EXTERNAL MODULE: ./components/profilePage/actions/donorActions/index.js
var donorActions = __webpack_require__("JMhk");

// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/getRecipientWindRoseDetails.js
var getRecipientWindRoseDetails = __webpack_require__("8YPz");

// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/getRecipientDocuments.js
var getRecipientDocuments = __webpack_require__("14MA");

// EXTERNAL MODULE: ./components/profilePage/actions/recipientActions/budgetVsExpenseCharts.js
var budgetVsExpenseCharts = __webpack_require__("E1kG");

// EXTERNAL MODULE: ./shared/actions/mapActions/recipientProfileMapData.js
var recipientProfileMapData = __webpack_require__("ve3m");

// EXTERNAL MODULE: ./shared/actions/mapActions/donorProfileMapData.js
var mapActions_donorProfileMapData = __webpack_require__("sVsK");

// EXTERNAL MODULE: ./components/profilePage/components/generateDonorSummary.js + 3 modules
var generateDonorSummary = __webpack_require__("h90+");

// CONCATENATED MODULE: ./routes/embedViews/profile/profilePage.js


function profilePage__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function profilePage__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function profilePage__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






























var profilePage__ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var profilePage__ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var profilePage_ProfilePage = function (_Component) {
    profilePage__inherits(ProfilePage, _Component);

    function ProfilePage(props) {
        profilePage__classCallCheck(this, ProfilePage);

        var _this = profilePage__possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            listSelected: false,
            totalDataSize: 0,
            currentYear: _this.props.year,
            budgetType: _this.props.budgetType,
            selectedCountry: {
                name: '',
                iso2: '',
                iso3: '',
                email: '',
                web: ''
            },
            projectList: []
        };
        _this.sectorSelected = '';
        _this.categorySelected = '';

        _this.mapTilte = {
            "donorprofile": "Donor Profile",
            "recipientprofile": "Recipient Profile"
        };
        _this.mapBudgeType = {
            direct: 'Direct Funded Projects',
            regular: 'IUCN Regular Resources'
        };

        return _this;
    }

    ProfilePage.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.projectList != this.props.projectList) {
            var data = nextProps.projectList.data;
            var parseData = function parseData(data) {
                data.forEach(function (item) {
                    item.country_name = item.country;
                    item.probObj = {
                        title: item.title,
                        project_id: item.project_id
                    };
                    item.total_budget = item.budget == null ? 0 : item.budget;
                    item.total_expense = item.expense == null ? 0 : item.expense;
                });
                return data;
            };
            this.setState({ projectList: parseData(data), totalDataSize: nextProps.projectList.count, links: nextProps.projectList.links });
        }
        // if (nextProps.selectedCountry != this.props.selectedCountry) {
        //     if (nextProps.profileType === 'donorprofile') {
        //         this.props.getDonorDetails(
        //             nextProps.selectedCountry.iso3,
        //             this.props.year);
        //         this.props.loadDonorProfileMapData(this.props.year,
        //             nextProps.selectedCountry.iso3,
        //             this.state.budgetType
        //         )
        //     }
        //     else {
        //         this.props.fetchDocuments(this.props.selectedCountry.iso3,
        //             this.props.year,
        //             this.props.docCategory)
        //         this.props.getRecipientDetails(
        //             nextProps.selectedCountry.iso3,
        //             this.props.year,
        //             this.sectorSelected,
        //             this.categorySelected);
        //         if (nextProps.unitType != 2) {
        //             this.props.loadRecipientProfileMapData(this.props.year, nextProps.selectedCountry.iso3)
        //         }
        //         else
        //             this.props.loadOutputsMapData(this.props.year, nextProps.selectedCountry.iso3)
        //     }

        // }
    };

    ProfilePage.prototype.componentWillMount = function componentWillMount() {
        var item = void 0;
        if (this.props.profileType === 'donorprofile') {
            this.props.getDonorDetails(this.props.selectedCountry.iso3, this.props.year);
            this.props.loadDonorProfileMapData(this.props.year, this.props.selectedCountry.iso3, this.state.budgetType);
        } else {
            this.props.fetchDocuments(this.props.selectedCountry.iso3, this.props.year, this.props.docCategory);
            this.props.getRecipientDetails(this.props.selectedCountry.iso3, this.props.year, this.sectorSelected);
            if (this.props.unitType != 2) this.props.loadRecipientProfileMapData(this.props.year, this.props.selectedCountry.iso3);else this.props.loadOutputsMapData(this.props.year, this.props.selectedCountry.iso3);
        }
        this.setState({ countryDetails: this.props.selectedCountry });
    };

    ProfilePage.prototype.render = function render(props, _ref) {
        var _this2 = this;

        var projectList = _ref.projectList,
            totalDataSize = _ref.totalDataSize,
            donutBudget = _ref.donutBudget,
            donutModality = _ref.donutModality,
            selectedCountry = _ref.selectedCountry;
        var recipientBasicDetails = props.recipientBasicDetails,
            themeBudget = props.themeBudget,
            recipientDocumentList = props.recipientDocumentList,
            topBudgetSources = props.topBudgetSources,
            windRose = props.windRose,
            donorBasicDetails = props.donorBasicDetails,
            topRecipientOffices = props.topRecipientOffices,
            recipientMapData = props.recipientMapData,
            donorProfileMapData = props.donorProfileMapData,
            regularAndOthers = props.regularAndOthers,
            contributionToRegular = props.contributionToRegular,
            fundModlaitySplitUp = props.fundModlaitySplitUp,
            otherResourcesContributions = props.otherResourcesContributions,
            budgetVsExpense = props.budgetVsExpense,
            budgetVsExpenseSdg = props.budgetVsExpenseSdg,
            recepientSdg = props.recepientSdg;


        return Object(preact_min["h"])(
            'div',
            null,
            this.props.title === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': profile_style_default.a.titleWrapper },
                '' + this.mapTilte[props.profileType] + (props.profileType === 'donorprofile' ? '- ' + this.mapBudgeType[this.props.budgetType] : '')
            ) : null,
            props.profileType !== "recipientprofile" && this.props.fundModality === 'true' ? Object(preact_min["h"])(generateDonorSummary["a" /* default */], {
                donorBasicDetails: donorBasicDetails,
                countryDetails: props.selectedCountry,
                donutBudget: regularAndOthers,
                donutModality: fundModlaitySplitUp,
                displayfundModality: this.props.fundModality,
                displayContributionSplit: this.props.fundModality,
                contributionToRegular: contributionToRegular,
                otherResourcesContributions: otherResourcesContributions,
                embed: true,
                listStyle: profile_style_default.a.list,
                labelStyle: profile_style_default.a.label,
                valueStyle: profile_style_default.a.value
            }) : null,
            Object(preact_min["h"])(
                'div',
                { 'class': profile_style_default.a.statsWrapper },
                this.props.stats === 'true' ? props.profileType == "recipientprofile" ? Object(preact_min["h"])(
                    'div',
                    null,
                    recipientBasicDetails.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: "relative", height: 83 } },
                        profilePage__ref2
                    ) : Object(preact_min["h"])(
                        'ul',
                        { 'class': profile_style_default.a.list },
                        Object(preact_min["h"])(
                            'li',
                            null,
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.value },
                                recipientBasicDetails.data.budget && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(recipientBasicDetails.data.budget, 2)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.label },
                                'Budget'
                            )
                        ),
                        Object(preact_min["h"])(
                            'li',
                            null,
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.value },
                                recipientBasicDetails.data.expense && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(recipientBasicDetails.data.expense, 2)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.label },
                                'Expenditure'
                            )
                        ),
                        Object(preact_min["h"])(
                            'li',
                            null,
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.value },
                                recipientBasicDetails.data.projects_count && Object(numberFormatter["c" /* numberToCommaFormatter */])(recipientBasicDetails.data.projects_count)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.label },
                                'Projects'
                            )
                        ),
                        Object(preact_min["h"])(
                            'li',
                            null,
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.value },
                                recipientBasicDetails.data.budget_sources && Object(numberFormatter["c" /* numberToCommaFormatter */])(recipientBasicDetails.data.budget_sources)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.label },
                                'Donors'
                            )
                        )
                    )
                ) : Object(preact_min["h"])(
                    'div',
                    null,
                    donorBasicDetails.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: "relative", height: 83 } },
                        profilePage__ref3
                    ) : Object(preact_min["h"])(
                        'ul',
                        { 'class': profile_style_default.a.list },
                        Object(preact_min["h"])(
                            'li',
                            null,
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.value },
                                donorBasicDetails.data.budget ? Object(numberFormatter["d" /* numberToCurrencyFormatter */])(donorBasicDetails.data.budget, 2) : Object(numberFormatter["d" /* numberToCurrencyFormatter */])(0)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.label },
                                ' Budget'
                            )
                        ),
                        Object(preact_min["h"])(
                            'li',
                            null,
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.value },
                                donorBasicDetails.data.expense ? Object(numberFormatter["d" /* numberToCurrencyFormatter */])(donorBasicDetails.data.expense, 2) : Object(numberFormatter["d" /* numberToCurrencyFormatter */])(0)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.label },
                                ' Expenditure'
                            )
                        ),
                        Object(preact_min["h"])(
                            'li',
                            null,
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.value },
                                donorBasicDetails.data.direct_funded_projects ? Object(numberFormatter["c" /* numberToCommaFormatter */])(donorBasicDetails.data.direct_funded_projects) : Object(numberFormatter["c" /* numberToCommaFormatter */])(0)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.label },
                                '  Direct Funded Projects'
                            )
                        ),
                        donorBasicDetails.data.show_regular_resources > 0 && Object(preact_min["h"])(
                            'li',
                            null,
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.value },
                                donorBasicDetails.data.regular_resources ? Object(numberFormatter["c" /* numberToCommaFormatter */])(donorBasicDetails.data.regular_resources) : Object(numberFormatter["c" /* numberToCommaFormatter */])(0)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': profile_style_default.a.label },
                                '  IUCN Regular Resources'
                            )
                        )
                    )
                ) : null
            ),
            this.props.map === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': profile_style_default.a.mapContainer, style: { position: 'relative', display: 'block' } },
                Object(preact_min["h"])(map["a" /* default */], {
                    embed: true,
                    clusterMode: this.props.unitType == 2 && props.profileType == "recipientprofile" ? true : false,
                    source: props.profileType == "donorprofile" && this.props.selectedCountry.iso3,
                    budgetType: props.profileType == "donorprofile" && this.state.budgetType,
                    mapData: this.props.unitType == 1 ? props.profileType == "donorprofile" ? donorProfileMapData : recipientMapData : donorProfileMapData }),
                Object(preact_min["h"])(
                    'div',
                    { 'class': profile_style_default.a.disclaimer },
                    '* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'
                )
            ) : null,
            this.props.projectTable === 'true' ? Object(preact_min["h"])(
                'div',
                { style: { paddingTop: '9px', display: 'block' } },
                Object(preact_min["h"])(
                    'div',
                    { 'class': profile_style_default.a.sectionTitle },
                    'Projects'
                ),
                Object(preact_min["h"])(bootstraptable["a" /* default */], { count: totalDataSize,
                    loading: this.props.loading,
                    budgetType: props.profileType == "donorprofile" && this.state.budgetType,
                    source: props.profileType == "donorprofile" ? props.selectedCountry.iso3 : '',
                    unit: props.profileType == "recipientprofile" && props.selectedCountry.iso3,
                    data: projectList,
                    embed: true,
                    year: this.props.year
                })
            ) : null,
            props.profileType == "recipientprofile" ? Object(preact_min["h"])(
                'section',
                { 'class': profile_style_default.a.outerChartWrapper },
                Object(preact_min["h"])(generateRecipientCharts["a" /* default */], {
                    displaybudgetPercThemes: this.props.budgetPercThemes,
                    displaybudgetPercSdg: this.props.budgetPercSdg,
                    displaybudgetSources: this.props.budgetSources,
                    themeList: props.themeList,
                    themeBudget: themeBudget,
                    unitType: props.unitType,
                    setSector: function setSector(sector) {
                        return _this2.selectSector(sector);
                    },
                    topBudgetSources: topBudgetSources,
                    countryDetails: props.selectedCountry,
                    windRose: windRose,
                    budgetVsExpense: budgetVsExpense,
                    yearList: this.props.yearList,
                    currentYear: this.props.year,
                    updateBarChartOnArcHover: this.props.updateBarChartOnArcHover,
                    budgetVsExpenseSdg: budgetVsExpenseSdg,
                    recepientSdg: recepientSdg,
                    embed: true
                }),
                this.props.docTable === 'true' ? Object(preact_min["h"])(
                    'div',
                    { 'class': profile_style_default.a.recipientDocumentWrapper },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': profile_style_default.a.sectionTitle },
                        'Documents'
                    ),
                    Object(preact_min["h"])(projectDetailDocuTable["a" /* default */], {
                        loading: this.props.documentListLoading,
                        clearFilter: function clearFilter() {
                            return _this2.clearCategoryFilter();
                        },
                        categorySelect: function categorySelect(value) {
                            return _this2.selectCategory(value);
                        },
                        data: recipientDocumentList,
                        all: 'false',
                        embed: true
                    })
                ) : null
            ) : Object(preact_min["h"])(generateDonorCharts["a" /* default */], {
                topRecipientOffices: topRecipientOffices,
                countryDetails: props.selectedCountry,
                donutBudget: regularAndOthers,
                donutModality: fundModlaitySplitUp,
                contributionToRegular: contributionToRegular,
                otherResourcesContributions: otherResourcesContributions,
                displayRecepientOffices: this.props.recepientOffices,
                displayfundModality: this.props.fundModality,
                displayContributionSplit: this.props.contributionSplit,
                embed: true })
        );
    };

    return ProfilePage;
}(preact_min["Component"]);

var profilePage_mapStateToProps = function mapStateToProps(state) {
    // Donor Profile
    var donorBasicDetails = state.donorProfile.basicDetails ? state.donorProfile.basicDetails : [],
        topRecipientOffices = state.donorProfile.topRecipientOffices.data ? state.donorProfile.topRecipientOffices.data : [],
        regularAndOthers = state.donorProfile.regularAndOthers.data.country ? state.donorProfile.regularAndOthers.data.country : [],
        contributionToRegular = state.donorProfile.regularAndOthers.data.country ? state.donorProfile.regularAndOthers.data.country : [],
        fundModlaitySplitUp = state.donorProfile.resourcesModalityContribution.data.country ? state.donorProfile.resourcesModalityContribution.data.country : [],
        otherResourcesContributions = state.donorProfile.resourcesModalityContribution.data.total ? state.donorProfile.resourcesModalityContribution.data.total : [],
        recipientBasicDetails = state.recipientProfile.basicDetails,
        documentListLoading = state.recipientProfile.documentList.loading,
        recipientDocumentList = state.recipientProfile.documentList.data.data ? state.recipientProfile.documentList.data.data : [],
        topBudgetSources = state.recipientProfile.topBudgetSources.data ? state.recipientProfile.topBudgetSources.data : [],
        themeBudget = state.recipientProfile.themeBudget,
        recepientSdg = state.recipientProfile.recepientSdg,
        windRose = state.recipientProfile.windRose,
        _state$projectList = state.projectList,
        loading = _state$projectList.loading,
        error = _state$projectList.error,
        projectList = _state$projectList.projectList,
        currentYear = state.yearList.currentYear,
        budgetVsExpense = state.recipientProfile.budgetVsExpense ? state.recipientProfile.budgetVsExpense : [],
        budgetVsExpenseSdg = state.recipientProfile.budgetVsExpenseSdg,
        yearList = state.yearList;
    var _state$mapData = state.mapData,
        recipientMapData = _state$mapData.recipientMapData,
        donorProfileMapData = _state$mapData.donorProfileMapData;


    return {
        // Donor Profile
        donorBasicDetails: donorBasicDetails, // Get Donor's basic Details
        topRecipientOffices: topRecipientOffices, // Get Donor's top Recipient countries
        regularAndOthers: regularAndOthers, // Get Donor's Contribution to Regular and Other Resources
        contributionToRegular: contributionToRegular, // Get Donor's Contribution to IUCN Regular Resources
        fundModlaitySplitUp: fundModlaitySplitUp, // Get Donor's Contribution to Other Resources by Fund Category
        otherResourcesContributions: otherResourcesContributions, // Other Resources Modality Contributions - All Donors vs Algeria
        // Recipient Profile
        recipientBasicDetails: recipientBasicDetails, // Get Recipient's basic Details
        recipientDocumentList: recipientDocumentList, // Get Recipient's Document List
        documentListLoading: documentListLoading,
        topBudgetSources: topBudgetSources, // Get Recipient's top Budget Sources
        themeBudget: themeBudget, // Get Recipient's Themes (% of Budget)
        recepientSdg: recepientSdg, // Get Recipient's Sdg (% of Budget)
        windRose: windRose, // Get Recipient's IUCN Strategic Plan IRRF Indicators
        // Others
        recipientMapData: recipientMapData,
        donorProfileMapData: donorProfileMapData,
        loading: loading,
        error: error,
        projectList: projectList,
        themeList: state.themeList,
        currentYear: currentYear,
        budgetVsExpense: budgetVsExpense,
        budgetVsExpenseSdg: budgetVsExpenseSdg,
        yearList: yearList

    };
};
var profilePage_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        getRecipientDetails: function getRecipientDetails(code, year, theme) {
            return Object(recipientActions["a" /* default */])(dispatch, code, year, theme);
        },
        getDonorDetails: function getDonorDetails(code, year) {
            return Object(donorActions["a" /* default */])(dispatch, code, year);
        },
        fetchWindRose: function fetchWindRose(code, year, theme) {
            return dispatch(Object(getRecipientWindRoseDetails["b" /* fetchRecipientWindRose */])(code, year, theme));
        },
        fetchDocuments: function fetchDocuments(code, year, category) {
            return dispatch(Object(getRecipientDocuments["b" /* fetchRecipientDocuments */])(code, year, category));
        },
        loadRecipientProfileMapData: function loadRecipientProfileMapData(year, unit) {
            return dispatch(Object(recipientProfileMapData["b" /* loadRecipientProfileMapData */])(year, unit));
        },
        loadDonorProfileMapData: function loadDonorProfileMapData(year, source, budget_type) {
            return dispatch(Object(mapActions_donorProfileMapData["b" /* loadDonorProfileMapData */])(year, source, budget_type));
        },
        updateBarChartOnArcHover: function updateBarChartOnArcHover(data) {
            return dispatch(Object(budgetVsExpenseCharts["b" /* updateBarChartOnArcHover */])(data));
        },
        loadOutputsMapData: function loadOutputsMapData(year, unit, sector, source, project_id, budget_type) {
            return dispatch(Object(fetchMapOutputs["d" /* loadOutputsMapData */])(year, unit, sector, source, project_id, budget_type));
        }
    };
};

/* harmony default export */ var profilePage = (Object(preact_redux_esm["a" /* connect */])(profilePage_mapStateToProps, profilePage_mapDispatchToProps)(profilePage_ProfilePage));
// CONCATENATED MODULE: ./routes/embedViews/profile/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function profile__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function profile__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function profile__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var profile_EmbedProfileView = function (_Component) {
	profile__inherits(EmbedProfileView, _Component);

	function EmbedProfileView(props) {
		profile__classCallCheck(this, EmbedProfileView);

		var _this = profile__possibleConstructorReturn(this, _Component.call(this, props));

		_this.componentWillReceiveProps = function (nextProps) {
			if (nextProps.type !== _this.props.type || nextProps.code != _this.props.code) {
				nextProps.type === 'recipientprofile' ? _this.profileType = 'Recipient Profile' : _this.profileType = 'Donor Profile';
				_this.setState({ profileFound: false });
				_this.profileFound = false;
			}
			if (!_this.profileFound && nextProps.countryList.countries.length) {
				nextProps.countryList.countries.forEach(function (item, index) {
					if (item.iso2 == nextProps.code || item.iso3 == nextProps.code) {
						_this.profileFound = true;
						_this.setState({ unitType: 2, selectedCountry: item, profileFound: true }); // Only Both Profiles
						_this.profileName = item.name;
					}
				});
			}

			if (!_this.profileFound && nextProps.masterDonorList.data != undefined && !_this.profileFound) {
				nextProps.masterDonorList.data.donors.forEach(function (item, index) {
					if (item.code == _this.props.code) {
						item.iso3 = item.code;
						_this.profileFound = true;
						_this.setState({ unitType: 3, selectedCountry: item, profileFound: true }); // Only Donor Profile
						_this.profileName = item.name;
					}
				});
			}
			if (!_this.profileFound && nextProps.masterDonorList.data != undefined && !_this.profileFound) {
				nextProps.masterDonorList.data.donors.forEach(function (donor, index) {
					donor.organisations.forEach(function (item, index) {
						if (item.code == _this.props.code) {
							item.iso3 = item.code;
							_this.profileFound = true;
							_this.setState({ unitType: 3, selectedCountry: item, profileFound: true }); // Only Donor Profile
							_this.profileName = item.name;
						}
					});
				});
			}
			if (!_this.profileFound && _this.props.searchResult != nextProps.searchResult) {
				nextProps.searchResult.forEach(function (item, index) {
					if (item.code == _this.props.code) {
						item.iso3 = item.code;
						_this.profileFound = true;
						_this.setState({ unitType: 1, selectedCountry: item, profileFound: true });
						_this.profileName = item.name;
					}
				});
			}
			if (!_this.profileFound && nextProps.masterDonorList.data != undefined && !_this.profileFound) {
				nextProps.masterDonorList.data.donors.forEach(function (donor, index) {
					donor.organisations.forEach(function (item, index) {
						if (item.code == _this.props.code) {
							item.iso3 = item.code;
							_this.profileFound = true;
							_this.setState({ unitType: 3, selectedCountry: item, profileFound: true }); // Only Donor Profile
							_this.profileName = item.name;
						}
					});
				});
			}
		};

		_this.state = {
			projectList: [],
			unitType: "",
			selectedCountry: {
				name: '',
				iso2: '',
				iso3: '',
				email: '',
				web: ''
			},
			profileFound: false
		};

		_this.profileFound = false;
		_this.profileName = "";
		_this.profileType = "Donor Profile";

		return _this;
	}

	EmbedProfileView.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		window.scrollTo(0, 0);
		this.props.countryList.countries.forEach(function (item, index) {
			if (item.iso2 == _this2.props.code || item.iso3 == _this2.props.code) {
				_this2.profileFound = true;
				_this2.setState({ unitType: 2, selectedCountry: item, profileFound: true });
				_this2.profileName = item.name;
			}
		});
		if (!this.profileFound) {
			this.props.searchResult.forEach(function (item, index) {
				if (item.code == _this2.props.code) {
					item.iso3 = item.code;
					_this2.profileFound = true;
					_this2.setState({ unitType: 1, selectedCountry: item, profileFound: true });
					_this2.profileName = item.name;
				}
			});
		}
		if (this.props.type == 'recipientprofile') this.profileType = 'Recipient Profile';
	};

	EmbedProfileView.prototype.render = function render() {
		return this.state.profileFound ? Object(preact_min["h"])(profilePage, _extends({
			countries: this.state.unitType == 1 ? this.props.searchResult : this.props.countryList.countries,
			countryCode: this.props.code,
			selectedCountry: this.state.selectedCountry,
			unitType: this.state.unitType,
			profileType: this.props.type
		}, this.props)) : null;
	};

	return EmbedProfileView;
}(preact_min["Component"]);

var profile_mapStateToProps = function mapStateToProps(state) {
	var searchResult = state.countryRegionSearch.list;

	return {
		router: state.router,
		countryList: state.countryList,
		masterDonorList: state.masterDonorList,
		searchResult: searchResult
	};
};

var profile_mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		searchCountryRegionsListData: function (_searchCountryRegionsListData) {
			function searchCountryRegionsListData() {
				return _searchCountryRegionsListData.apply(this, arguments);
			}

			searchCountryRegionsListData.toString = function () {
				return _searchCountryRegionsListData.toString();
			};

			return searchCountryRegionsListData;
		}(function () {
			return dispatch(searchCountryRegionsListData());
		})
	};
};

/* harmony default export */ var embedViews_profile = (Object(preact_redux_esm["a" /* connect */])(profile_mapStateToProps, profile_mapDispatchToProps)(profile_EmbedProfileView));
// EXTERNAL MODULE: ./components/sankey/index.js + 2 modules
var sankey = __webpack_require__("EY8H");

// EXTERNAL MODULE: ./components/sankey/actions/budgetFinancialFlowActions.js
var budgetFinancialFlowActions = __webpack_require__("j+nI");

// EXTERNAL MODULE: ./components/sankey/actions/expenseFinancialFlowActions.js
var expenseFinancialFlowActions = __webpack_require__("Jf5u");

// EXTERNAL MODULE: ./shared/actions/mapActions/globalMapData.js
var mapActions_globalMapData = __webpack_require__("9KE5");

// EXTERNAL MODULE: ./shared/actions/countryData.js
var actions_countryData = __webpack_require__("xgQa");

// EXTERNAL MODULE: ./routes/embedViews/home/recipientCountry/_style.scss
var _style = __webpack_require__("xQgv");
var _style_default = /*#__PURE__*/__webpack_require__.n(_style);

// CONCATENATED MODULE: ./routes/embedViews/home/recipientCountry/index.js


function recipientCountry__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function recipientCountry__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function recipientCountry__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var recipientCountry__ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var recipientCountry_EmbedHomeRecipientCountry = function (_Component) {
    recipientCountry__inherits(EmbedHomeRecipientCountry, _Component);

    function EmbedHomeRecipientCountry(props) {
        recipientCountry__classCallCheck(this, EmbedHomeRecipientCountry);

        var _this = recipientCountry__possibleConstructorReturn(this, _Component.call(this, props));

        _this.mapData = function () {
            var array = _this.props.globalMapData && _this.props.globalMapData.data ? _this.props.globalMapData.data : [];
            if (array.length) {
                return array[0];
            } else {
                return {};
            }
        };

        _this.mapFinancialType = {
            budget: 'Budget',
            expense: 'Expenditure'
        };

        return _this;
    }

    EmbedHomeRecipientCountry.prototype.componentWillMount = function componentWillMount() {
        var _props = this.props,
            year = _props.year,
            financialFlowYear = _props.financialFlowYear,
            financialFlowType = _props.financialFlowType,
            country = _props.country,
            countryLabel = _props.countryLabel;

        if (this.props.country === '') {
            this.props.fetchGlobalData(year);
        }
        this.props.loadGlobalMapData(year, country);
        financialFlowType === 'budget' ? this.props.fetchBudgetFinancialFlow(financialFlowYear) : this.props.fetchExpenseFinancialFlow(financialFlowYear);
    };

    EmbedHomeRecipientCountry.prototype.render = function render(_ref, state) {
        var year = _ref.year,
            financialFlowYear = _ref.financialFlowYear,
            financialFlowType = _ref.financialFlowType,
            country = _ref.country,
            countryData = _ref.countryData,
            countryLabel = _ref.countryLabel;

        var tempData = country === '' ? this.props.countryData.data ? this.props.countryData.data : {} : this.mapData();

        return Object(preact_min["h"])(
            'div',
            null,
            this.props.title === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': _style_default.a.titleWrapper },
                'Recipient Country / Region'
            ) : null,
            this.props.summary === 'true' ? Object(preact_min["h"])(
                'div',
                null,
                Object(preact_min["h"])(
                    'div',
                    { 'class': _style_default.a.filterTextWrapper },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': _style_default.a.filterText },
                        'Contribution',
                        this.props.countryLabel != '' ? Object(preact_min["h"])(
                            'span',
                            null,
                            ' to ',
                            Object(preact_min["h"])(
                                'span',
                                { 'class': _style_default.a.filterHighlight },
                                '' + this.props.countryLabel
                            )
                        ) : Object(preact_min["h"])(
                            'span',
                            { 'class': _style_default.a.filterHighlight },
                            '' + this.props.countryLabel
                        ),
                        ' in ',
                        Object(preact_min["h"])(
                            'span',
                            { 'class': _style_default.a.filterHighlight },
                            '' + this.props.year
                        )
                    )
                )
            ) : null,
            this.props.stats === 'true' ? this.props.globalMapData.loading || this.props.countryData.loading ? Object(preact_min["h"])(
                'div',
                { 'class': _style_default.a.loaderWrapper },
                recipientCountry__ref2
            ) : Object(preact_min["h"])(
                'div',
                { 'class': _style_default.a.wrapper },
                Object(preact_min["h"])(
                    'ul',
                    { 'class': _style_default.a.list },
                    Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': _style_default.a.value },
                            tempData.total_budget && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(tempData.total_budget, 2)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': _style_default.a.label },
                            'Budget'
                        )
                    ),
                    Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': _style_default.a.value },
                            tempData.total_expense && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(tempData.total_expense, 2)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': _style_default.a.label },
                            'Expenditure'
                        )
                    ),
                    Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': _style_default.a.value },
                            tempData.project_count && Object(numberFormatter["c" /* numberToCommaFormatter */])(tempData.project_count)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': _style_default.a.label },
                            'Projects'
                        )
                    ),
                    Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': _style_default.a.value },
                            tempData.donor_count && Object(numberFormatter["c" /* numberToCommaFormatter */])(tempData.donor_count)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': _style_default.a.label },
                            'Donors'
                        )
                    )
                )
            ) : null,
            this.props.map === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': _style_default.a.mapContainer },
                Object(preact_min["h"])(map["a" /* default */], { mapData: this.props.globalMapData,
                    code: country,
                    yearSelected: year,
                    embedCountryRegion: true,
                    embed: true
                }),
                Object(preact_min["h"])(
                    'div',
                    { 'class': _style_default.a.disclaimer },
                    '* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'
                )
            ) : null,
            this.props.financialFlow === 'true' ? Object(preact_min["h"])(
                'div',
                null,
                Object(preact_min["h"])(
                    'span',
                    { 'class': _style_default.a.subtitleWrapper },
                    'Financial Flow - ' + this.mapFinancialType[financialFlowType] + ' - ' + financialFlowYear
                ),
                Object(preact_min["h"])(sankey["a" /* default */], {
                    embed: true,
                    financialFlowYear: financialFlowYear,
                    financialFlowType: financialFlowType
                })
            ) : null
        );
    };

    return EmbedHomeRecipientCountry;
}(preact_min["Component"]);

var recipientCountry_mapStateToProps = function mapStateToProps(state) {
    var mapCurrentYear = state.mapData.yearTimeline.mapCurrentYear,
        projectListMapData = state.mapData.projectListMapData,
        _state$projectList = state.projectList,
        loading = _state$projectList.loading,
        error = _state$projectList.error,
        projectList = _state$projectList.projectList;
    var _state$mapData = state.mapData,
        globalMapData = _state$mapData.globalMapData,
        themesMapData = _state$mapData.themesMapData,
        donorsMapData = _state$mapData.donorsMapData,
        sdgMapData = _state$mapData.sdgMapData,
        countryData = state.countryData;


    return {
        router: state.router,
        mapCurrentYear: mapCurrentYear,
        projectListMapData: projectListMapData,
        projectList: projectList,
        loading: loading,
        globalMapData: globalMapData,
        countryData: countryData

    };
};

var recipientCountry_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        loadProjectListMapData: function loadProjectListMapData(year, sector, unit, source, sdg) {
            return dispatch(Object(mapActions_projectListMapData["b" /* loadProjectListMapData */])(year, sector, unit, source, sdg));
        },
        setCurrentYear: function setCurrentYear(year) {
            return dispatch(Object(getYearList["b" /* setCurrentYear */])(year));
        },
        fetchBudgetFinancialFlow: function fetchBudgetFinancialFlow(year) {
            return dispatch(Object(budgetFinancialFlowActions["a" /* fetchBudgetFinancialFlow */])(year));
        },
        fetchExpenseFinancialFlow: function fetchExpenseFinancialFlow(year) {
            return dispatch(Object(expenseFinancialFlowActions["a" /* fetchExpenseFinancialFlow */])(year));
        },
        loadGlobalMapData: function loadGlobalMapData(year, unit) {
            return dispatch(Object(mapActions_globalMapData["b" /* loadGlobalMapData */])(year, unit));
        },
        fetchGlobalData: function fetchGlobalData(year) {
            return dispatch(Object(actions_countryData["c" /* fetchGlobalData */])(year));
        }
    };
};

/* harmony default export */ var recipientCountry = (Object(preact_redux_esm["a" /* connect */])(recipientCountry_mapStateToProps, recipientCountry_mapDispatchToProps)(recipientCountry_EmbedHomeRecipientCountry));
// EXTERNAL MODULE: ./components/themeSlider/actions/index.js
var themeSlider_actions = __webpack_require__("yuQp");

// EXTERNAL MODULE: ./shared/actions/mapActions/themesMapData.js
var mapActions_themesMapData = __webpack_require__("t4UN");

// EXTERNAL MODULE: ./shared/actions/getProjectList.js
var getProjectList = __webpack_require__("STnb");

// EXTERNAL MODULE: ./components/budget-expense-legend/index.js
var budget_expense_legend = __webpack_require__("COsE");

// EXTERNAL MODULE: ./components/grouped-bar-chart/index.js
var grouped_bar_chart = __webpack_require__("2On6");

// EXTERNAL MODULE: ./components/themeSlider/actions/signatureOutcome.js
var signatureOutcome = __webpack_require__("A1ba");

// EXTERNAL MODULE: ./routes/embedViews/themes/style.scss
var themes_style = __webpack_require__("1DIU");
var themes_style_default = /*#__PURE__*/__webpack_require__.n(themes_style);

// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// EXTERNAL MODULE: ./components/donutChart/index.js
var donutChart = __webpack_require__("nZhv");

// CONCATENATED MODULE: ./routes/embedViews/themes/index.js


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function themes__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function themes__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function themes__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










 // Themes Top Budget Sources, Top Recipient countries








var themes__ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var themes__ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var themes__ref4 = Object(preact_min["h"])(
    'span',
    null,
    'Signature Solutions'
);

var themes__ref5 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var themes__ref6 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var themes__ref7 = Object(preact_min["h"])(
    'span',
    null,
    'Top 10 Donors'
);

var themes__ref8 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var themes__ref9 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref10 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref11 = Object(preact_min["h"])(
    'span',
    null,
    'Top 10 Recipient Countries'
);

var _ref12 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var _ref13 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref14 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var themes_EmbedThemesView = function (_Component) {
    themes__inherits(EmbedThemesView, _Component);

    function EmbedThemesView(props) {
        themes__classCallCheck(this, EmbedThemesView);

        var _this = themes__possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            projectListArr: [],
            totalDataSize: 0,
            links: {},
            themeSliderData: {}, // Theme Slider Data object
            themesMapData: {}, // Theme Map Data object
            projectList: {}
        };
        return _this;
    }

    EmbedThemesView.prototype.componentWillMount = function componentWillMount() {
        this.props.fetchDonorSliderData(this.props.year, this.props.themes);
        this.props.loadThemesMapData(this.props.year, this.props.themes);
        if (this.props.signatureSolutions === 'true' && Number(this.props.year) >= constants["a" /* default */].SIGNATURE_SOLUTION_YEAR) this.props.fetchSignatureSolutionChartData(this.props.themes, this.props.year);
    };

    EmbedThemesView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {

        if (Object.keys(nextProps.themeSliderData.data).length) {
            this.setState({
                themeSliderData: nextProps.themeSliderData
            });
        }
        if (Object.keys(nextProps.themesMapData.data).length) {
            this.setState({
                themesMapData: nextProps.themesMapData
            });
        }
        if (Object.keys(nextProps.projectList.projectList.data).length) {
            this.setState({
                projectList: nextProps.projectList
            });
        }

        if (nextProps.projectList.projectList != this.props.projectList.projectList) {
            var data = nextProps.projectList.projectList.data;
            var parseData = function parseData(data) {
                data.forEach(function (item) {
                    item.country_name = item.country;
                    item.probObj = {
                        title: item.title,
                        project_id: item.project_id
                    };
                    item.total_budget = item.budget == null ? 0 : item.budget;
                    item.total_expense = item.expense == null ? 0 : item.expense;
                });
                return data;
            };
            this.setState({
                projectListArr: parseData(data),
                totalDataSize: nextProps.projectList.projectList.count,
                links: nextProps.projectList.projectList.links
            });
        }
    };

    EmbedThemesView.prototype.render = function render(props, _ref) {
        var _h;

        var projectListArr = _ref.projectListArr,
            totalDataSize = _ref.totalDataSize,
            links = _ref.links,
            projectList = _ref.projectList,
            themesMapData = _ref.themesMapData,
            themeSliderData = _ref.themeSliderData;

        _objectDestructuringEmpty(props);

        var isNonEmpty = Object.keys(this.state.themeSliderData).length,
            isMapDataNonEmpty = Object.keys(this.state.themesMapData).length,
            isProjectListNonEmpty = this.state.projectList && this.state.projectList.projectList ? Object.keys(this.state.projectList.projectList).length : 0,
            aggregate = isNonEmpty ? themeSliderData.data && themeSliderData.data.aggregate : {},
            budgetSources = isNonEmpty ? themeSliderData.data && themeSliderData.data.budget_sources : {},
            recepientOffices = isNonEmpty ? themeSliderData.data && themeSliderData.data.top_recipient_offices : {},
            mapData = isMapDataNonEmpty ? themesMapData && themesMapData.data && themesMapData : {};
        return Object(preact_min["h"])(
            'div',
            null,
            this.props.title === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': themes_style_default.a.titleWrapper },
                this.props.themesLabel
            ) : null,
            Object(preact_min["h"])(
                'div',
                { 'class': themes_style_default.a.wrapper },
                this.props.themeSliderData.loading ? Object(preact_min["h"])(
                    'div',
                    { style: { position: "relative", height: 83 } },
                    themes__ref2
                ) : this.props.stats === 'true' ? Object(preact_min["h"])(
                    'ul',
                    { 'class': themes_style_default.a.list },
                    Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': themes_style_default.a.value },
                            aggregate.budget_amount && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(aggregate.budget_amount, 2)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': themes_style_default.a.label },
                            'Budget'
                        )
                    ),
                    Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': themes_style_default.a.value },
                            aggregate.expense_amount && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(aggregate.expense_amount, 2)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': themes_style_default.a.label },
                            'Expenditure'
                        )
                    ),
                    Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': themes_style_default.a.value },
                            aggregate.projects && Object(numberFormatter["c" /* numberToCommaFormatter */])(aggregate.projects)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': themes_style_default.a.label },
                            'Projects'
                        )
                    ),
                    Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': themes_style_default.a.value },
                            aggregate.budget_sources && Object(numberFormatter["c" /* numberToCommaFormatter */])(aggregate.budget_sources)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': themes_style_default.a.label },
                            'Donors'
                        )
                    )
                ) : null
            ),
            this.props.map === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': themes_style_default.a.mapContainer, style: { position: 'relative', display: 'block' } },
                isMapDataNonEmpty ? Object(preact_min["h"])(map["a" /* default */], {
                    themes: this.props.themes,
                    mapData: mapData
                }) : themes__ref3,
                isMapDataNonEmpty ? Object(preact_min["h"])(
                    'div',
                    { 'class': themes_style_default.a.disclaimer },
                    '* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'
                ) : null
            ) : null,
            this.props.projectTable === 'true' ? Object(preact_min["h"])(bootstraptable["a" /* default */], (_h = { count: totalDataSize,
                loading: this.props.projectList.loading,
                currentYear: this.props.year,
                theme: this.props.themes,
                keyword: '',
                unit: '',
                source: ''
            }, _h['currentYear'] = this.props.year, _h.sdg = '', _h.data = projectListArr, _h.links = links, _h.embed = true, _h)) : null,
            Number(this.props.year) >= constants["a" /* default */].SIGNATURE_SOLUTION_YEAR && this.props.signatureSolutions === 'true' ? !this.props.donutChartData.resourcesModalityContribution.loading ? Object(preact_min["h"])(
                'div',
                { 'class': themes_style_default.a.wrapper + ' ' + themes_style_default.a.chartWrapper },
                this.props.donutChartData.resourcesModalityContribution.data.country[0] ? Object(preact_min["h"])(
                    'section',
                    { 'class': themes_style_default.a.theme_slider_wrapper },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': themes_style_default.a.theme_slider_title },
                        themes__ref4
                    ),
                    Object(preact_min["h"])(
                        'div',
                        null,
                        this.props.donutChartData.resourcesModalityContribution.data.country[0] ? Object(preact_min["h"])(
                            'div',
                            { 'class': themes_style_default.a.outcome_chart_wrapper },
                            Object(preact_min["h"])(donutChart["a" /* default */], {
                                donor_wrapper_styles: themes_style_default.a.outcome_wrapper_styles,
                                donut_styles: themes_style_default.a.donut_styles,
                                legend_styles: themes_style_default.a.legend_styles,
                                textWrapperStyle: themes_style_default.a.textWrapperStyle,
                                textFieldStyle: themes_style_default.a.textFieldStyle,
                                ourFocusLegendStyles: themes_style_default.a.our_focus_legend_styles,
                                legendLabel: themes_style_default.a.legendLabel,
                                data: this.props.donutChartData.resourcesModalityContribution.data.country,
                                legendData: this.props.donutChartData.resourcesModalityContribution.data.total,
                                chartWidth: 560,
                                chartHeight: 400,
                                svgIe: themes_style_default.a.svgIe,
                                chart_id: 'signatureSolution_chart_embed' })
                        ) : themes__ref5
                    )
                ) : null
            ) : themes__ref6 : null,
            this.props.budgetSources === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': themes_style_default.a.wrapper + ' ' + themes_style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': themes_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': themes_style_default.a.chartHead },
                        themes__ref7,
                        themes__ref8
                    ),
                    themeSliderData.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: "relative", height: 344 } },
                        themes__ref9
                    ) : Object(preact_min["h"])(
                        'div',
                        null,
                        budgetSources.length > 0 ? Object(preact_min["h"])(
                            'div',
                            { 'class': themes_style_default.a.budget_sources_wrapper },
                            Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                chart_id: 'themes_embed_budget_sources',
                                width: 1250,
                                height: 500,
                                min_height: 540,
                                data: budgetSources,
                                label: 'short_name',
                                tspanSize: '12px',
                                textSize: '12px' })
                        ) : _ref10
                    )
                )
            ) : null,
            this.props.recepientOffices === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': themes_style_default.a.wrapper + ' ' + themes_style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': themes_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': themes_style_default.a.chartHead },
                        _ref11,
                        _ref12
                    ),
                    themeSliderData.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: "relative", height: 344 } },
                        _ref13
                    ) : Object(preact_min["h"])(
                        'div',
                        null,
                        recepientOffices.length > 0 ? Object(preact_min["h"])(
                            'div',
                            { 'class': themes_style_default.a.budget_sources_wrapper },
                            Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                chart_id: 'themes_embed_top_recipient_offices',
                                width: 1250,
                                height: 500,
                                min_height: 540,
                                data: recepientOffices,
                                label: 'iso3',
                                tspanSize: '12px',
                                textSize: '12px' })
                        ) : _ref14
                    )
                )
            ) : null
        );
    };

    return EmbedThemesView;
}(preact_min["Component"]);

var themes_mapStateToProps = function mapStateToProps(state) {
    var themeSliderData = state.themeSliderData,
        themesMapData = state.mapData.themesMapData,
        projectList = state.projectList,
        donutChartData = state.donorProfile;

    return {
        themeSliderData: themeSliderData,
        themesMapData: themesMapData,
        projectList: projectList,
        donutChartData: donutChartData
    };
};

var themes_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchDonorSliderData: function fetchDonorSliderData(year, sector) {
            return dispatch(Object(themeSlider_actions["b" /* fetchDonorSliderData */])(year, sector));
        },
        loadThemesMapData: function loadThemesMapData(year, sector) {
            return dispatch(Object(mapActions_themesMapData["b" /* loadThemesMapData */])(year, sector));
        },
        updateProjectList: function updateProjectList(year, unit, source, theme, keyword, limit, offset, budget_type) {
            return dispatch(Object(getProjectList["c" /* updateProjectList */])(year, unit, source, theme, keyword, limit, offset, budget_type));
        },
        fetchSignatureSolutionChartData: function fetchSignatureSolutionChartData(code, year) {
            return dispatch(Object(signatureOutcome["d" /* fetchSignatureSolutionChartData */])(code, year));
        }
    };
};

/* harmony default export */ var embedViews_themes = (Object(preact_redux_esm["a" /* connect */])(themes_mapStateToProps, themes_mapDispatchToProps)(themes_EmbedThemesView));
// EXTERNAL MODULE: ./components/topography-icons-legend/style.scss
var topography_icons_legend_style = __webpack_require__("5a/9");
var topography_icons_legend_style_default = /*#__PURE__*/__webpack_require__.n(topography_icons_legend_style);

// CONCATENATED MODULE: ./components/topography-icons-legend/index.js


function topography_icons_legend__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function topography_icons_legend__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function topography_icons_legend__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var topography_icons_legend__ref = Object(preact_min["h"])(
    'li',
    null,
    Object(preact_min["h"])('img', { src: '../../../static/assets/icons/Administrative_Region.svg', alt: 'info icon' }),
    Object(preact_min["h"])(
        'span',
        null,
        'Administrative Region'
    )
);

var topography_icons_legend__ref2 = Object(preact_min["h"])(
    'li',
    null,
    Object(preact_min["h"])('img', { src: '../../../static/assets/icons/Populated_Place.svg', alt: 'info icon' }),
    Object(preact_min["h"])(
        'span',
        null,
        'Populated Place'
    )
);

var topography_icons_legend__ref3 = Object(preact_min["h"])(
    'li',
    null,
    Object(preact_min["h"])('img', { src: '../../../static/assets/icons/Structure.svg', alt: 'info icon' }),
    Object(preact_min["h"])(
        'span',
        null,
        'Structure'
    )
);

var topography_icons_legend__ref4 = Object(preact_min["h"])(
    'li',
    null,
    Object(preact_min["h"])('img', { src: '../../../static/assets/icons/Other_Topographical.svg', alt: 'info icon' }),
    Object(preact_min["h"])(
        'span',
        null,
        'Other Topographical Feature'
    )
);

var topography_icons_legend_TopographyIconsLegend = function (_Component) {
    topography_icons_legend__inherits(TopographyIconsLegend, _Component);

    function TopographyIconsLegend() {
        topography_icons_legend__classCallCheck(this, TopographyIconsLegend);

        return topography_icons_legend__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    TopographyIconsLegend.prototype.render = function render() {
        var _this2 = this;

        return Object(preact_min["h"])(
            'div',
            { 'class': topography_icons_legend_style_default.a.legend_container + ' ' + this.props.containerStyle },
            Object(preact_min["h"])(
                'ul',
                { 'class': this.props.projectTopoIconsLegend + ' ' + topography_icons_legend_style_default.a.topoIconsLegend + ' ', ref: function ref(node) {
                        return _this2.topoLegend = node;
                    } },
                topography_icons_legend__ref,
                topography_icons_legend__ref2,
                topography_icons_legend__ref3,
                topography_icons_legend__ref4
            )
        );
    };

    return TopographyIconsLegend;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/sdgSlider/actions/targetAction.js
var targetAction = __webpack_require__("TVaU");

// EXTERNAL MODULE: ./components/sdgSlider/actions/index.js
var sdgSlider_actions = __webpack_require__("aYEV");

// EXTERNAL MODULE: ./shared/actions/mapActions/sdgMapData.js
var sdgMapData = __webpack_require__("H+FH");

// EXTERNAL MODULE: ./components/horizontalStackedBarChart/index.js + 1 modules
var horizontalStackedBarChart = __webpack_require__("eogv");

// EXTERNAL MODULE: ./routes/embedViews/sdg/style.scss
var sdg_style = __webpack_require__("ZuJw");
var sdg_style_default = /*#__PURE__*/__webpack_require__.n(sdg_style);

// CONCATENATED MODULE: ./routes/embedViews/sdg/index.js


function sdg__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sdg__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sdg__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




 // Themes Profile Projects Table



 // Themes Top Budget Sources, Top Recipient countries











var sdg__ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sdg__ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sdg__ref4 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var sdg__ref5 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sdg__ref6 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sdg__ref7 = Object(preact_min["h"])(
    'span',
    null,
    'Top 10 Donors'
);

var sdg__ref8 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var sdg__ref9 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sdg__ref10 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sdg__ref11 = Object(preact_min["h"])(
    'span',
    null,
    'Top 10 Recipient Countries'
);

var sdg__ref12 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var sdg__ref13 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sdg__ref14 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sdg_EmbedSdgView = function (_Component) {
    sdg__inherits(EmbedSdgView, _Component);

    function EmbedSdgView(props) {
        sdg__classCallCheck(this, EmbedSdgView);

        var _this = sdg__possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            themeSliderData: {}, // Theme Slider Data object
            themesMapData: {}, // Theme Map Data object
            projectList: {},
            listSelected: false,
            totalDataSize: 0,
            links: '',
            projectListArr: []
        };
        return _this;
    }

    EmbedSdgView.prototype.componentWillMount = function componentWillMount() {
        this.props.fetchSdgSliderData(this.props.year, this.props.sdg);
        this.props.fetchSdgSliderTargetData(this.props.year, this.props.sdg);
        this.props.loadSdgMapData(this.props.year, this.props.sdg, "", "", "sdg");
    };

    EmbedSdgView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {

        if (Object.keys(nextProps.sdgSliderData.data).length) {
            this.setState({
                themeSliderData: nextProps.sdgSliderData
            });
        }
        if (Object.keys(nextProps.sdgMapData.data).length) {
            this.setState({
                themesMapData: nextProps.sdgMapData
            });
        }
        if (Object.keys(nextProps.projectList.projectList.data).length) {
            this.setState({
                projectList: nextProps.projectList
            });
        }

        if (nextProps.projectList.projectList !== this.props.projectList.projectList) {
            var data = nextProps.projectList.projectList.data;

            var parseData = function parseData(data) {
                data.forEach(function (item) {
                    item.country_name = item.country;
                    item.probObj = {
                        title: item.title,
                        project_id: item.project_id
                    };
                    item.total_budget = item.budget === null ? 0 : item.budget;
                    item.total_expense = item.expense === null ? 0 : item.expense;
                });
                return data;
            };
            this.setState({
                projectListArr: parseData(data),
                totalDataSize: nextProps.projectList.projectList.count,
                links: nextProps.projectList.projectList.links
            });
        }
    };

    EmbedSdgView.prototype.render = function render(props, _ref) {
        var links = _ref.links,
            projectList = _ref.projectList,
            totalDataSize = _ref.totalDataSize,
            themesMapData = _ref.themesMapData,
            themeSliderData = _ref.themeSliderData,
            sdgSliderData = _ref.sdgSliderData,
            projectListArr = _ref.projectListArr;


        var isNonEmpty = Object.keys(this.state.themeSliderData).length,
            isMapDataNonEmpty = Object.keys(this.state.themesMapData).length,
            aggregate = isNonEmpty ? themeSliderData.data && themeSliderData.data.aggregate : {},
            budgetSources = isNonEmpty ? themeSliderData.data && themeSliderData.data.budget_sources : {},
            topRecipientOffices = isNonEmpty ? themeSliderData.data && themeSliderData.data.top_recipient_offices : {},
            mapData = isMapDataNonEmpty ? themesMapData && themesMapData.data && themesMapData : {};
        // sdgSrc = aggregate && aggregate.sdg && getSDGImageFromCode(aggregate.sdg);

        return Object(preact_min["h"])(
            'div',
            null,
            this.props.title === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sdg_style_default.a.titleWrapper },
                this.props.sdglabel
            ) : null,
            Object(preact_min["h"])(
                'div',
                { 'class': sdg_style_default.a.wrapper },
                this.props.sdgSliderData.loading ? Object(preact_min["h"])(
                    'div',
                    { style: { position: 'relative', height: 83 } },
                    sdg__ref2
                ) : this.props.stats === 'true' ? Object(preact_min["h"])(
                    'div',
                    { 'class': sdg_style_default.a.infoWrapper },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': sdg_style_default.a.tableWrapper },
                        Object(preact_min["h"])(
                            'ul',
                            { 'class': sdg_style_default.a.list },
                            Object(preact_min["h"])(
                                'li',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdg_style_default.a.value },
                                    aggregate.total_budget && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(aggregate.total_budget, 2)
                                ),
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdg_style_default.a.label },
                                    'Budget'
                                )
                            ),
                            Object(preact_min["h"])(
                                'li',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdg_style_default.a.value },
                                    aggregate.total_expense && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(aggregate.total_expense, 2)
                                ),
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdg_style_default.a.label },
                                    'Expenditure'
                                )
                            ),
                            Object(preact_min["h"])(
                                'li',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdg_style_default.a.value },
                                    aggregate.total_projects && Object(numberFormatter["c" /* numberToCommaFormatter */])(aggregate.total_projects)
                                ),
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdg_style_default.a.label },
                                    'Projects'
                                )
                            ),
                            Object(preact_min["h"])(
                                'li',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdg_style_default.a.value },
                                    aggregate.budget_sources && Object(numberFormatter["c" /* numberToCommaFormatter */])(aggregate.budget_sources)
                                ),
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdg_style_default.a.label },
                                    'Donors'
                                )
                            )
                        )
                    )
                ) : null
            ),
            this.props.map === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sdg_style_default.a.mapContainer, style: { position: 'relative', display: 'block' } },
                isMapDataNonEmpty ? Object(preact_min["h"])(map["a" /* default */], {
                    sdg: this.props.sdg,
                    mapData: mapData
                }) : sdg__ref3,
                isMapDataNonEmpty ? Object(preact_min["h"])(
                    'div',
                    { 'class': sdg_style_default.a.disclaimer },
                    '* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'
                ) : null
            ) : null,
            this.props.projectTable === 'true' ? Object(preact_min["h"])(bootstraptable["a" /* default */], { count: totalDataSize,
                loading: this.props.projectList.loading,
                keyword: '',
                theme: '',
                unit: '',
                source: '',
                currentYear: this.props.year,
                sdg: this.props.sdg,
                data: projectListArr,
                links: links,
                embed: true

            }) : null,
            this.props.outcomes === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sdg_style_default.a.wrapper + ' ' + sdg_style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': sdg_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdg_style_default.a.chartHead },
                        Object(preact_min["h"])(
                            'span',
                            null,
                            'SDG - ',
                            this.props.sdg,
                            ' Targets'
                        ),
                        sdg__ref4
                    ),
                    this.props.sdgTargetSliderData.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: 'relative', height: 344 } },
                        sdg__ref5
                    ) : Object(preact_min["h"])(
                        'div',
                        { 'class': sdg_style_default.a.targetChartWrapper },
                        this.props.sdgTargetSliderData.data.percentage && this.props.sdgTargetSliderData.data.percentage.length > 0 ? Object(preact_min["h"])(
                            'div',
                            { 'class': sdg_style_default.a.budget_sources_wrapper },
                            Object(preact_min["h"])(horizontalStackedBarChart["a" /* default */], {
                                chart_id: 'sdg_target_outcome_chart',
                                width: 1250,
                                height: this.props.sdgTargetSliderData.data.percentage.length * 50,
                                data: this.props.sdgTargetSliderData.data.percentage
                            })
                        ) : sdg__ref6
                    )
                )
            ) : null,
            this.props.topDonors === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sdg_style_default.a.wrapper + ' ' + sdg_style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': sdg_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdg_style_default.a.chartHead },
                        sdg__ref7,
                        sdg__ref8
                    ),
                    themeSliderData.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: 'relative', height: 344 } },
                        sdg__ref9
                    ) : Object(preact_min["h"])(
                        'div',
                        null,
                        budgetSources.length > 0 ? Object(preact_min["h"])(
                            'div',
                            { 'class': sdg_style_default.a.budget_sources_wrapper },
                            Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                chart_id: 'sdg_embed_budget_sources',
                                width: 1250,
                                height: 500,
                                min_height: 540,
                                data: budgetSources,
                                label: 'short_name',
                                tspanSize: '12px',
                                textSize: '12px'
                            })
                        ) : sdg__ref10
                    )
                )
            ) : null,
            this.props.receipOffices === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sdg_style_default.a.wrapper + ' ' + sdg_style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': sdg_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdg_style_default.a.chartHead },
                        sdg__ref11,
                        sdg__ref12
                    ),
                    themeSliderData.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: 'relative', height: 344 } },
                        sdg__ref13
                    ) : Object(preact_min["h"])(
                        'div',
                        null,
                        topRecipientOffices.length > 0 ? Object(preact_min["h"])(
                            'div',
                            { 'class': sdg_style_default.a.budget_sources_wrapper },
                            Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                chart_id: 'sdg_embed_top_recipient_offices',
                                width: 1250,
                                height: 500,
                                min_height: 540,
                                data: topRecipientOffices,
                                label: 'iso3',
                                tspanSize: '12px',
                                textSize: '12px'
                            })
                        ) : sdg__ref14
                    )
                )
            ) : null
        );
    };

    return EmbedSdgView;
}(preact_min["Component"]);

var sdg_mapStateToProps = function mapStateToProps(state) {
    var themeSliderData = state.themeSliderData,
        sdgSliderData = state.sdgSliderData,
        sdgTargetSliderData = state.sdgTargetSliderData,
        _state$mapData = state.mapData,
        themesMapData = _state$mapData.themesMapData,
        sdgMapData = _state$mapData.sdgMapData,
        projectList = state.projectList,
        currentYear = state.yearList.currentYear;

    return {
        themeSliderData: themeSliderData,
        themesMapData: themesMapData,
        projectList: projectList,
        currentYear: currentYear,
        sdgTargetSliderData: sdgTargetSliderData,
        sdgSliderData: sdgSliderData,
        sdgMapData: sdgMapData
    };
};
var sdg_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchDonorSliderData: function fetchDonorSliderData(year, sector) {
            return dispatch(Object(themeSlider_actions["b" /* fetchDonorSliderData */])(year, sector));
        },
        loadThemesMapData: function loadThemesMapData(year, sector) {
            return dispatch(Object(mapActions_themesMapData["b" /* loadThemesMapData */])(year, sector));
        },
        loadSdgMapData: function loadSdgMapData(year, sdg, unit, source, tab) {
            return dispatch(Object(sdgMapData["b" /* loadSdgMapData */])(year, sdg, unit, source, tab));
        },
        updateProjectList: function updateProjectList(year, unit, source, theme, keyword, limit, offset, budgetType, sdg) {
            return dispatch(Object(getProjectList["c" /* updateProjectList */])(year, unit, source, theme, keyword, limit, offset, budgetType, sdg));
        },
        fetchSdgSliderData: function fetchSdgSliderData(year, sdg) {
            return dispatch(Object(sdgSlider_actions["b" /* fetchSdgSliderData */])(year, sdg));
        },
        fetchSdgSliderTargetData: function fetchSdgSliderTargetData(year, sdg) {
            return dispatch(Object(targetAction["b" /* fetchSdgSliderTargetData */])(year, sdg));
        }
    };
};

/* harmony default export */ var embedViews_sdg = (Object(preact_redux_esm["a" /* connect */])(sdg_mapStateToProps, sdg_mapDispatchToProps)(sdg_EmbedSdgView));
// EXTERNAL MODULE: ./routes/embedViews/sdgTarget/style.scss
var sdgTarget_style = __webpack_require__("y4nW");
var sdgTarget_style_default = /*#__PURE__*/__webpack_require__.n(sdgTarget_style);

// CONCATENATED MODULE: ./routes/embedViews/sdgTarget/index.js


function sdgTarget__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sdgTarget__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sdgTarget__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




 // Themes Profile Projects Table



 // Themes Top Budget Sources, Top Recipient countries













var sdgTarget__ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sdgTarget__ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sdgTarget__ref4 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var sdgTarget__ref5 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sdgTarget__ref6 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sdgTarget__ref7 = Object(preact_min["h"])(
    'span',
    null,
    'Top 10 Donors'
);

var sdgTarget__ref8 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var sdgTarget__ref9 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sdgTarget__ref10 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sdgTarget__ref11 = Object(preact_min["h"])(
    'span',
    null,
    'Top 10 Recipient Countries'
);

var sdgTarget__ref12 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var sdgTarget__ref13 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sdgTarget__ref14 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sdgTarget_EmbedTargetSdgView = function (_Component) {
    sdgTarget__inherits(EmbedTargetSdgView, _Component);

    function EmbedTargetSdgView(props) {
        sdgTarget__classCallCheck(this, EmbedTargetSdgView);

        var _this = sdgTarget__possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            themeSliderData: {}, // Theme Slider Data object
            themesMapData: {}, // Theme Map Data object
            projectList: {},
            listSelected: false,
            totalDataSize: 0,
            links: '',
            projectListArr: []
        };
        return _this;
    }

    EmbedTargetSdgView.prototype.componentWillMount = function componentWillMount() {
        // this.props.updateProjectList(this.props.year,'','','','','',)
        this.props.fetchSdgTargetData(this.props.year, this.props.target);
        this.props.fetchSdgSliderTargetData(this.props.year, this.props.target);
        this.props.loadTargetMapData(this.props.year, this.props.target, "", "", "sdg_target");
    };

    EmbedTargetSdgView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {

        if (Object.keys(nextProps.sdgSliderData.data).length) {
            this.setState({
                themeSliderData: nextProps.sdgSliderData
            });
        }
        if (Object.keys(nextProps.sdgMapData.data).length) {
            this.setState({
                themesMapData: nextProps.sdgMapData
            });
        }
        if (Object.keys(nextProps.projectList.projectList.data).length) {
            this.setState({
                projectList: nextProps.projectList
            });
        }

        if (nextProps.projectList.projectList !== this.props.projectList.projectList) {
            var data = nextProps.projectList.projectList.data;

            var parseData = function parseData(data) {
                data.forEach(function (item) {
                    item.country_name = item.country;
                    item.probObj = {
                        title: item.title,
                        project_id: item.project_id
                    };
                    item.total_budget = item.budget === null ? 0 : item.budget;
                    item.total_expense = item.expense === null ? 0 : item.expense;
                });
                return data;
            };
            this.setState({
                projectListArr: parseData(data),
                totalDataSize: nextProps.projectList.projectList.count,
                links: nextProps.projectList.projectList.links
            });
        }
    };

    EmbedTargetSdgView.prototype.render = function render(props, _ref) {
        var links = _ref.links,
            projectList = _ref.projectList,
            totalDataSize = _ref.totalDataSize,
            themesMapData = _ref.themesMapData,
            themeSliderData = _ref.themeSliderData,
            sdgSliderData = _ref.sdgSliderData,
            projectListArr = _ref.projectListArr;


        var isNonEmpty = Object.keys(this.state.themeSliderData).length,
            isMapDataNonEmpty = Object.keys(this.state.themesMapData).length,
            aggregate = isNonEmpty ? themeSliderData.data && themeSliderData.data.aggregate : {},
            budgetSources = isNonEmpty ? themeSliderData.data && themeSliderData.data.budget_sources : {},
            topRecipientOffices = isNonEmpty ? themeSliderData.data && themeSliderData.data.top_recipient_offices : {},
            mapData = isMapDataNonEmpty ? themesMapData && themesMapData.data && themesMapData : {};
        // sdgSrc = aggregate && aggregate.sdg && getSDGImageFromCode(aggregate.sdg);

        return Object(preact_min["h"])(
            'div',
            null,
            this.props.title === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sdgTarget_style_default.a.titleWrapper },
                this.props.sdglabel
            ) : null,
            Object(preact_min["h"])(
                'div',
                { 'class': sdgTarget_style_default.a.wrapper },
                this.props.sdgSliderData.loading ? Object(preact_min["h"])(
                    'div',
                    { style: { position: 'relative', height: 83 } },
                    sdgTarget__ref2
                ) : this.props.stats === 'true' ? Object(preact_min["h"])(
                    'div',
                    { 'class': sdgTarget_style_default.a.infoWrapper },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': sdgTarget_style_default.a.tableWrapper },
                        Object(preact_min["h"])(
                            'ul',
                            { 'class': sdgTarget_style_default.a.list },
                            Object(preact_min["h"])(
                                'li',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdgTarget_style_default.a.value },
                                    aggregate.total_budget && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(aggregate.total_budget, 2)
                                ),
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdgTarget_style_default.a.label },
                                    'Budget'
                                )
                            ),
                            Object(preact_min["h"])(
                                'li',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdgTarget_style_default.a.value },
                                    aggregate.total_expense && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(aggregate.total_expense, 2)
                                ),
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdgTarget_style_default.a.label },
                                    'Expenditure'
                                )
                            ),
                            Object(preact_min["h"])(
                                'li',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdgTarget_style_default.a.value },
                                    aggregate.total_projects && Object(numberFormatter["c" /* numberToCommaFormatter */])(aggregate.total_projects)
                                ),
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdgTarget_style_default.a.label },
                                    'Projects'
                                )
                            ),
                            Object(preact_min["h"])(
                                'li',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdgTarget_style_default.a.value },
                                    aggregate.budget_sources && Object(numberFormatter["c" /* numberToCommaFormatter */])(aggregate.budget_sources)
                                ),
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': sdgTarget_style_default.a.label },
                                    'Donors'
                                )
                            )
                        )
                    )
                ) : null
            ),
            this.props.map === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sdgTarget_style_default.a.mapContainer, style: { position: 'relative', display: 'block' } },
                isMapDataNonEmpty ? Object(preact_min["h"])(map["a" /* default */], {
                    sdg: this.props.sdg,
                    mapData: mapData,
                    sdgTarget: this.props.target
                }) : sdgTarget__ref3,
                isMapDataNonEmpty ? Object(preact_min["h"])(
                    'div',
                    { 'class': sdgTarget_style_default.a.disclaimer },
                    '* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'
                ) : null
            ) : null,
            this.props.projectTable === 'true' ? Object(preact_min["h"])(bootstraptable["a" /* default */], { count: totalDataSize,
                loading: this.props.projectList.loading,
                keyword: '',
                theme: '',
                unit: '',
                source: '',
                yearSelected: this.props.year,
                sdg: this.props.sdg,
                data: projectListArr,
                sdg_targets: this.props.target,
                links: links,
                embed: true

            }) : null,
            this.props.outcomes === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sdgTarget_style_default.a.wrapper + ' ' + sdgTarget_style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': sdgTarget_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgTarget_style_default.a.chartHead },
                        Object(preact_min["h"])(
                            'span',
                            null,
                            'SDG- ',
                            this.props.sdg,
                            ' Targets'
                        ),
                        sdgTarget__ref4
                    ),
                    this.props.sdgTargetSliderData.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: 'relative', height: 344 } },
                        sdgTarget__ref5
                    ) : Object(preact_min["h"])(
                        'div',
                        { 'class': sdgTarget_style_default.a.targetChartWrapper },
                        this.props.sdgTargetSliderData.data.percentage && this.props.sdgTargetSliderData.data.percentage.length > 0 ? Object(preact_min["h"])(
                            'div',
                            { 'class': sdgTarget_style_default.a.budget_sources_wrapper },
                            Object(preact_min["h"])(horizontalStackedBarChart["a" /* default */], {
                                chart_id: 'sdg_target_outcome_chart',
                                width: 1250,
                                height: this.props.sdgTargetSliderData.data.percentage.length * 50,
                                data: this.props.sdgTargetSliderData.data.percentage
                            })
                        ) : sdgTarget__ref6
                    )
                )
            ) : null,
            this.props.topDonors === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sdgTarget_style_default.a.wrapper + ' ' + sdgTarget_style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': sdgTarget_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgTarget_style_default.a.chartHead },
                        sdgTarget__ref7,
                        sdgTarget__ref8
                    ),
                    themeSliderData.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: 'relative', height: 344 } },
                        sdgTarget__ref9
                    ) : Object(preact_min["h"])(
                        'div',
                        null,
                        budgetSources.length > 0 ? Object(preact_min["h"])(
                            'div',
                            { 'class': sdgTarget_style_default.a.budget_sources_wrapper },
                            Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                chart_id: 'sdg_embed_budget_sources',
                                width: 1250,
                                height: 500,
                                min_height: 540,
                                data: budgetSources,
                                label: 'short_name',
                                tspanSize: '12px',
                                textSize: '12px'
                            })
                        ) : sdgTarget__ref10
                    )
                )
            ) : null,
            this.props.receipOffices === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sdgTarget_style_default.a.wrapper + ' ' + sdgTarget_style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': sdgTarget_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgTarget_style_default.a.chartHead },
                        sdgTarget__ref11,
                        sdgTarget__ref12
                    ),
                    themeSliderData.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: 'relative', height: 344 } },
                        sdgTarget__ref13
                    ) : Object(preact_min["h"])(
                        'div',
                        null,
                        topRecipientOffices.length > 0 ? Object(preact_min["h"])(
                            'div',
                            { 'class': sdgTarget_style_default.a.budget_sources_wrapper },
                            Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                chart_id: 'sdg_embed_top_recipient_offices',
                                width: 1250,
                                height: 500,
                                min_height: 540,
                                data: topRecipientOffices,
                                label: 'iso3',
                                tspanSize: '12px',
                                textSize: '12px'
                            })
                        ) : sdgTarget__ref14
                    )
                )
            ) : null
        );
    };

    return EmbedTargetSdgView;
}(preact_min["Component"]);

var sdgTarget_mapStateToProps = function mapStateToProps(state) {
    var themeSliderData = state.themeSliderData,
        sdgSliderData = state.sdgSliderData,
        sdgTargetSliderData = state.sdgTargetSliderData,
        _state$mapData = state.mapData,
        themesMapData = _state$mapData.themesMapData,
        sdgMapData = _state$mapData.sdgMapData,
        projectList = state.projectList,
        currentYear = state.yearList.currentYear;

    return {
        themeSliderData: themeSliderData,
        themesMapData: themesMapData,
        projectList: projectList,
        currentYear: currentYear,
        sdgTargetSliderData: sdgTargetSliderData,
        sdgSliderData: sdgSliderData,
        sdgMapData: sdgMapData
    };
};
var sdgTarget_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchDonorSliderData: function fetchDonorSliderData(year, sector) {
            return dispatch(Object(themeSlider_actions["b" /* fetchDonorSliderData */])(year, sector));
        },
        loadThemesMapData: function loadThemesMapData(year, sector) {
            return dispatch(Object(mapActions_themesMapData["b" /* loadThemesMapData */])(year, sector));
        },
        loadSdgMapData: function loadSdgMapData(year, sdg, unit, source, tab) {
            return dispatch(Object(sdgMapData["b" /* loadSdgMapData */])(year, sdg, unit, source, tab));
        },
        fetchSdgSliderData: function fetchSdgSliderData(year, sdg) {
            return dispatch(Object(sdgSlider_actions["b" /* fetchSdgSliderData */])(year, sdg));
        },
        fetchSdgTargetData: function fetchSdgTargetData(year, target) {
            return dispatch(Object(sdgSlider_actions["c" /* fetchSdgTargetData */])(year, target));
        },
        loadTargetMapData: function loadTargetMapData(year, target, unit, source, tab) {
            return dispatch(Object(sdgMapData["c" /* loadTargetMapData */])(year, target, unit, source, tab));
        },
        fetchSdgSliderTargetData: function fetchSdgSliderTargetData(year, sdg) {
            return dispatch(Object(targetAction["b" /* fetchSdgSliderTargetData */])(year, sdg));
        }
    };
};

/* harmony default export */ var sdgTarget = (Object(preact_redux_esm["a" /* connect */])(sdgTarget_mapStateToProps, sdgTarget_mapDispatchToProps)(sdgTarget_EmbedTargetSdgView));
// EXTERNAL MODULE: ./routes/404Page/index.js
var _04Page = __webpack_require__("6xcH");

// EXTERNAL MODULE: ../node_modules/react-custom-scrollbars/lib/index.js
var lib = __webpack_require__("E5f5");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./shared/actions/sdgAggregate.js
var sdgAggregate = __webpack_require__("/Krw");

// EXTERNAL MODULE: ./shared/actions/getDonorFundAggrList.js
var getDonorFundAggrList = __webpack_require__("6ofl");

// EXTERNAL MODULE: ./components/sideBar/index.js + 6 modules
var sideBar = __webpack_require__("gEA8");

// EXTERNAL MODULE: ./components/TabSection/actions/index.js + 2 modules
var TabSection_actions = __webpack_require__("GXjV");

// EXTERNAL MODULE: ./components/listView/index.js + 1 modules
var listView = __webpack_require__("lo/D");

// EXTERNAL MODULE: ./components/sideBarItem/index.js
var sideBarItem = __webpack_require__("TC6b");

// EXTERNAL MODULE: ./components/sideBarItemDonors/index.js
var sideBarItemDonors = __webpack_require__("udqz");

// EXTERNAL MODULE: ./shared/actions/mapActions/signatureMapData.js
var mapActions_signatureMapData = __webpack_require__("N97i");

// EXTERNAL MODULE: ./shared/actions/mapActions/donorsMapData.js
var donorsMapData = __webpack_require__("SDqA");

// EXTERNAL MODULE: ./components/YearSummary/actions/index.js
var YearSummary_actions = __webpack_require__("vgLy");

// EXTERNAL MODULE: ./routes/embedViews/home/homeTabcommon/style.scss
var homeTabcommon_style = __webpack_require__("N4Ow");
var homeTabcommon_style_default = /*#__PURE__*/__webpack_require__.n(homeTabcommon_style);

// EXTERNAL MODULE: ./utils/commonMethods.js
var commonMethods = __webpack_require__("Cdrj");

// CONCATENATED MODULE: ./routes/embedViews/home/homeTabcommon/index.js
var homeTabcommon__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function homeTabcommon__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function homeTabcommon__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function homeTabcommon__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
































var homeTabcommon__ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var homeTabcommon__ref3 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var homeTabcommon_EmbedHomeTabs = function (_Component) {
  homeTabcommon__inherits(EmbedHomeTabs, _Component);

  function EmbedHomeTabs(props) {
    homeTabcommon__classCallCheck(this, EmbedHomeTabs);

    var _this = homeTabcommon__possibleConstructorReturn(this, _Component.call(this, props));

    _this.mapLabelToValue = function (value, list) {
      if (list.length) {
        var label = list.filter(function (item) {
          return item.value == value;
        });
        if (label.length) {
          return label[0].label;
        } else {
          return '';
        }
      } else {
        return '';
      }
    };

    _this.renderRow = function (item, index) {
      return _this.props.type === 'themes' || _this.props.type === 'signature' || _this.props.type === 'sdg' ? Object(preact_min["h"])(sideBarItem["a" /* default */], { data: item.item,
        tabSelected: _this.props.type,
        index: index,
        embed: true,
        apiBase: Object(commonMethods["d" /* getAPIBaseUrRl */])()
      }) : Object(preact_min["h"])(sideBarItemDonors["a" /* default */], { data: item.item,
        index: index,
        embed: true
      });
    };

    _this.renderMapdata = function () {
      var mapData = [];

      switch (_this.props.type) {
        case 'themes':
          mapData = _this.props.themesMapData;
          break;
        case 'donors':
          mapData = _this.props.donorsMapData;
          break;
        case 'sdg':
          mapData = _this.props.sdgMapData;
          break;
        case 'signature':
          mapData = _this.props.signatureMapData;
          break;

        default:
      }
      return mapData;
    };

    _this.getSignatureName = function (array) {
      var filterArray = [],
          signatureName = '';
      if (array.length) filterArray = _this.filterArray(array);

      if (filterArray.length) signatureName = filterArray[0].label;

      return signatureName;
    };

    _this.filterArray = function (array) {
      var keyMap = {
        themes: {
          key: 'sector',
          typeKey: 'themes'
        },
        donors: {
          key: 'level_3_code',
          typeKey: 'budgetSources'
        },
        sdg: {
          key: 'sdg_code',
          typeKey: 'sdg'
        }
      };

      var typKey = _this.props.type === 'signature' ? 'themes' : _this.props.type;
      if (_this.props[keyMap[typKey].typeKey] === '') {
        return array;
      } else {
        return array.filter(function (item) {
          if (item[keyMap[typKey].key] === _this.props[keyMap[typKey].typeKey]) {
            return true;
          }
        });
      }
    };

    _this.state = {};
    _this.mapTitle = {
      themes: "Programme Areas",
      sdg: "SDG",
      donors: "Donors",
      signature: "Programme Areas"
    };
    _this.mapFinancialType = {
      budget: 'Budget',
      expense: 'Expenditure'
    };
    return _this;
  }

  EmbedHomeTabs.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        year = _props.year,
        financialFlowYear = _props.financialFlowYear,
        financialFlowType = _props.financialFlowType,
        budgetSources = _props.budgetSources,
        operatingUnits = _props.operatingUnits,
        sdg = _props.sdg,
        themes = _props.themes;

    this.props.onTabSwitch(this.props.type);
    financialFlowType === 'budget' ? this.props.fetchBudgetFinancialFlow(financialFlowYear) : this.props.fetchExpenseFinancialFlow(financialFlowYear);

    switch (this.props.type) {
      case 'themes':
        this.props.fetchThemeSummaryData(year, budgetSources, operatingUnits);
        this.props.loadThemesMapData(year, themes, operatingUnits, budgetSources);
        break;
      case 'donors':
        this.props.fetchDonorFundListData(year, operatingUnits, budgetSources, themes, sdg);
        this.props.loadDonorsMapData(year, operatingUnits, themes, budgetSources, sdg);
        break;

      case 'sdg':
        this.props.loadSdgMapData(year, sdg, operatingUnits, budgetSources, "sdg");
        this.props.fetchSdgListData(year, operatingUnits, budgetSources);

        break;
      case 'signature':
        this.props.fetchSignatureSummaryData(year, budgetSources, operatingUnits);
        this.props.loadSignatureMapData(year, themes, operatingUnits, budgetSources);
        break;
      default:
    }
  };

  EmbedHomeTabs.prototype.render = function render(_ref, state) {
    var year = _ref.year,
        globalMapData = _ref.globalMapData,
        financialFlowYear = _ref.financialFlowYear,
        financialFlowType = _ref.financialFlowType,
        sdg = _ref.sdg,
        tabData = _ref.tabData,
        themes = _ref.themes,
        country = _ref.country,
        operatingUnits = _ref.operatingUnits,
        operatingUnitsLabel = _ref.operatingUnitsLabel,
        countryLabel = _ref.countryLabel,
        budgetSources = _ref.budgetSources,
        budgetSourcesLabel = _ref.budgetSourcesLabel;

    var operatingUnitsSidebar = operatingUnits ? operatingUnits : '',
        budgetSourcesSidebar = budgetSources ? budgetSources : '',
        themesSidebar = themes ? themes : "",
        sdgSidebar = sdg ? sdg : "",
        yearSidebar = year ? year : "",
        countrySidebar = country ? country : "";
    var array = tabData.themes && tabData.themes.data && (tabData.themes.data.data || tabData.themes.data.sector || tabData.themes.data.sdg) ? tabData.themes.data.data || tabData.themes.data.sector || tabData.themes.data.sdg : [],
        isEmpty = array.length === 0 ? true : false;

    return Object(preact_min["h"])(
      'div',
      null,
      this.props.title === 'true' ? Object(preact_min["h"])(
        'div',
        { 'class': homeTabcommon_style_default.a.titleWrapper },
        this.mapTitle[this.props.type]
      ) : null,
      this.props.summary === 'true' ? Object(preact_min["h"])(
        'div',
        null,
        Object(preact_min["h"])(
          'div',
          { 'class': homeTabcommon_style_default.a.filterTextWrapper },
          Object(preact_min["h"])(
            'div',
            { 'class': homeTabcommon_style_default.a.filterText },
            Object(preact_min["h"])(
              'span',
              { 'class': homeTabcommon_style_default.a.filterHighlight },
              this.props.budgetSourcesLabel + ' '
            ),
            'contribution',
            this.props.operatingUnitsLabel != '' ? Object(preact_min["h"])(
              'span',
              null,
              ' to ',
              Object(preact_min["h"])(
                'span',
                { 'class': homeTabcommon_style_default.a.filterHighlight },
                '' + this.props.operatingUnitsLabel
              )
            ) : Object(preact_min["h"])(
              'span',
              { 'class': homeTabcommon_style_default.a.filterHighlight },
              '' + this.props.operatingUnitsLabel
            ),
            themes ? Object(preact_min["h"])(
              'span',
              null,
              ' for ',
              Object(preact_min["h"])(
                'span',
                { 'class': homeTabcommon_style_default.a.filterHighlight },
                this.props.type === 'signature' ? this.getSignatureName(array) : this.mapLabelToValue(themes, this.props.masterThemeList)
              )
            ) : ' ',
            sdg ? Object(preact_min["h"])(
              'span',
              null,
              ' for ',
              Object(preact_min["h"])(
                'span',
                { 'class': homeTabcommon_style_default.a.filterHighlight },
                this.mapLabelToValue(sdg, this.props.masterSdgList)
              )
            ) : '',
            ' in ',
            Object(preact_min["h"])(
              'span',
              { 'class': homeTabcommon_style_default.a.filterHighlight },
              '' + this.props.year
            )
          )
        )
      ) : null,
      this.props.map === 'true' ? Object(preact_min["h"])(
        'div',
        { 'class': homeTabcommon_style_default.a.mapContainer },
        Object(preact_min["h"])(
          'div',
          { style: { height: 500 } },
          Object(preact_min["h"])(map["a" /* default */], { mapData: this.renderMapdata(),
            preventResetMap: true,
            code: operatingUnitsSidebar,
            yearSelected: yearSidebar,
            embed: true,
            sector: themesSidebar,
            sdg: sdgSidebar,
            source: budgetSourcesSidebar
          }),
          Object(preact_min["h"])(
            'div',
            { 'class': homeTabcommon_style_default.a.disclaimer },
            '* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'
          )
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': homeTabcommon_style_default.a.sidebarWrapper },
          Object(preact_min["h"])(
            lib["Scrollbars"],
            {
              renderTrackHorizontal: function renderTrackHorizontal(props) {
                return Object(preact_min["h"])('div', homeTabcommon__extends({}, props, { className: 'track-horizontal' }));
              } },
            this.props.themesLoading || this.props.donorsLoading || this.props.sdgLoading ? homeTabcommon__ref2 : !isEmpty ? Object(preact_min["h"])(listView["a" /* default */], {
              data: array.length ? this.filterArray(array) : [],
              renderItem: this.renderRow
            }) : homeTabcommon__ref3
          )
        )
      ) : null,
      (this.props.budgetSourcesLabel === '' || this.props.operatingUnitsLabel === '') && this.props.financialFlow === 'true' ? Object(preact_min["h"])(
        'div',
        null,
        Object(preact_min["h"])(
          'span',
          { 'class': homeTabcommon_style_default.a.subtitleWrapper },
          'Financial Flow - ' + this.mapFinancialType[financialFlowType] + ' - ' + financialFlowYear
        ),
        Object(preact_min["h"])(sankey["a" /* default */], {
          embed: true,
          financialFlowYear: financialFlowYear,
          financialFlowType: financialFlowType
        })
      ) : null
    );
  };

  return EmbedHomeTabs;
}(preact_min["Component"]);

var homeTabcommon_mapStateToProps = function mapStateToProps(state) {
  var mapCurrentYear = state.mapData.yearTimeline.mapCurrentYear,
      projectListMapData = state.mapData.projectListMapData,
      _state$projectList = state.projectList,
      loading = _state$projectList.loading,
      error = _state$projectList.error,
      projectList = _state$projectList.projectList;
  var _state$mapData = state.mapData,
      globalMapData = _state$mapData.globalMapData,
      themesMapData = _state$mapData.themesMapData,
      donorsMapData = _state$mapData.donorsMapData,
      sdgMapData = _state$mapData.sdgMapData,
      signatureMapData = _state$mapData.signatureMapData,
      countryData = state.countryData,
      tabData = state.tabData;


  return {
    router: state.router,
    mapCurrentYear: mapCurrentYear,
    masterSdgList: state.sdgData.masterSdgList,
    masterThemeList: state.themeList.masterThemeList,
    themesLoading: state.themeSummary.loading,
    donorsLoading: state.donorFundList.loading,
    sdgLoading: state.sdgAggregate.loading,
    projectListMapData: projectListMapData,
    projectList: projectList,
    loading: loading,
    globalMapData: globalMapData,
    countryData: countryData,
    tabData: tabData,
    themesMapData: themesMapData,
    donorsMapData: donorsMapData,
    sdgMapData: sdgMapData,
    signatureMapData: signatureMapData
  };
};
var homeTabcommon_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadProjectListMapData: function loadProjectListMapData(year, sector, unit, source, sdg) {
      return dispatch(Object(mapActions_projectListMapData["b" /* loadProjectListMapData */])(year, sector, unit, source, sdg));
    },
    setCurrentYear: function setCurrentYear(year) {
      return dispatch(Object(getYearList["b" /* setCurrentYear */])(year));
    },
    fetchBudgetFinancialFlow: function fetchBudgetFinancialFlow(year) {
      return dispatch(Object(budgetFinancialFlowActions["a" /* fetchBudgetFinancialFlow */])(year));
    },
    fetchExpenseFinancialFlow: function fetchExpenseFinancialFlow(year) {
      return dispatch(Object(expenseFinancialFlowActions["a" /* fetchExpenseFinancialFlow */])(year));
    },
    loadGlobalMapData: function loadGlobalMapData(year, unit) {
      return dispatch(Object(mapActions_globalMapData["b" /* loadGlobalMapData */])(year, unit));
    },
    fetchGlobalData: function fetchGlobalData(year) {
      return dispatch(Object(actions_countryData["c" /* fetchGlobalData */])(year));
    },
    fetchThemeSummaryData: function fetchThemeSummaryData(year, source, operatingUnit) {
      return dispatch(Object(YearSummary_actions["d" /* fetchThemeSummaryData */])(year, source, operatingUnit));
    },
    fetchSignatureSummaryData: function fetchSignatureSummaryData(year, source, operatingUnit) {
      return dispatch(Object(YearSummary_actions["c" /* fetchSignatureSummaryData */])(year, source, operatingUnit));
    },
    fetchSdgListData: function fetchSdgListData(year, recipentCountry, donor) {
      return dispatch(Object(sdgAggregate["b" /* fetchSdgListData */])(year, recipentCountry, donor));
    },
    fetchDonorFundListData: function fetchDonorFundListData(year, recipentCountry, donor, themes, sdg) {
      return dispatch(Object(getDonorFundAggrList["b" /* fetchDonorFundListData */])(year, recipentCountry, donor, themes, sdg));
    },
    onTabSwitch: function onTabSwitch(type) {
      return dispatch(Object(TabSection_actions["k" /* onTabSwitch */])(type));
    },
    loadSdgMapData: function loadSdgMapData(year, sdg, unit, source, tab) {
      return dispatch(Object(sdgMapData["b" /* loadSdgMapData */])(year, sdg, unit, source, tab));
    },
    loadThemesMapData: function loadThemesMapData(year, sector, unit, source) {
      return dispatch(Object(mapActions_themesMapData["b" /* loadThemesMapData */])(year, sector, unit, source));
    },
    loadDonorsMapData: function loadDonorsMapData(year, unit, sector, budgetSource, sdg) {
      return dispatch(Object(donorsMapData["b" /* loadDonorsMapData */])(year, unit, sector, budgetSource, sdg));
    },
    loadSignatureMapData: function loadSignatureMapData(year, sector, unit, source) {
      return dispatch(Object(mapActions_signatureMapData["b" /* loadSignatureMapData */])(year, sector, unit, source));
    }
  };
};

//

/* harmony default export */ var homeTabcommon = (Object(preact_redux_esm["a" /* connect */])(homeTabcommon_mapStateToProps, homeTabcommon_mapDispatchToProps)(homeTabcommon_EmbedHomeTabs));
// EXTERNAL MODULE: ./components/themeSlider/actions/signatureDonor.js
var signatureDonor = __webpack_require__("6W2b");

// EXTERNAL MODULE: ./routes/embedViews/signature/style.scss
var signature_style = __webpack_require__("dwnu");
var signature_style_default = /*#__PURE__*/__webpack_require__.n(signature_style);

// CONCATENATED MODULE: ./routes/embedViews/signature/index.js


function signature__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function signature__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function signature__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function signature__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










 // Themes Top Budget Sources, Top Recipient countries







var signature__ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var signature__ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var signature__ref4 = Object(preact_min["h"])(
    'span',
    null,
    'Programme Areas'
);

var signature__ref5 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var signature__ref6 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var signature__ref7 = Object(preact_min["h"])(
    'span',
    null,
    'Top 10 Donors'
);

var signature__ref8 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var signature__ref9 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var signature__ref10 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var signature__ref11 = Object(preact_min["h"])(
    'span',
    null,
    'Top 10 Recipient Countries'
);

var signature__ref12 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var signature__ref13 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var signature__ref14 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var signature_EmbedSignatureView = function (_Component) {
    signature__inherits(EmbedSignatureView, _Component);

    function EmbedSignatureView(props) {
        signature__classCallCheck(this, EmbedSignatureView);

        var _this = signature__possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            projectListArr: [],
            totalDataSize: 0,
            links: {},
            themeSliderData: {}, // Theme Slider Data object
            signatureMapData: {}, // Theme Map Data object
            projectList: {},
            outcomeChartData: {}
        };
        return _this;
    }

    EmbedSignatureView.prototype.componentWillMount = function componentWillMount() {
        this.props.fetchSignatureSliderData(this.props.year, this.props.themes);
        this.props.loadSignatureMapData(this.props.year, this.props.themes);
        this.props.fetchSignatureOutcome(this.props.themes, this.props.year);
    };

    EmbedSignatureView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {

        if (Object.keys(nextProps.themeSliderData.data).length) {
            this.setState({
                themeSliderData: nextProps.themeSliderData
            });
        }
        if (Object.keys(nextProps.signatureMapData.data).length) {
            this.setState({
                signatureMapData: nextProps.signatureMapData
            });
        }
        if (Object.keys(nextProps.projectList.projectList.data).length) {
            this.setState({
                projectList: nextProps.projectList
            });
        }

        if (Object.keys(nextProps.outcomeChartData.data).length) {
            this.setState({
                outcomeChartData: nextProps.outcomeChartData
            });
        }

        if (nextProps.projectList.projectList != this.props.projectList.projectList) {
            var data = nextProps.projectList.projectList.data;
            var parseData = function parseData(data) {
                data.forEach(function (item) {
                    item.country_name = item.country;
                    item.probObj = {
                        title: item.title,
                        project_id: item.project_id
                    };
                    item.total_budget = item.budget == null ? 0 : item.budget;
                    item.total_expense = item.expense == null ? 0 : item.expense;
                });
                return data;
            };
            this.setState({
                projectListArr: parseData(data),
                totalDataSize: nextProps.projectList.projectList.count,
                links: nextProps.projectList.projectList.links
            });
        }
    };

    EmbedSignatureView.prototype.render = function render(props, _ref) {
        var _h;

        var projectListArr = _ref.projectListArr,
            totalDataSize = _ref.totalDataSize,
            links = _ref.links,
            projectList = _ref.projectList,
            signatureMapData = _ref.signatureMapData,
            themeSliderData = _ref.themeSliderData,
            outcomeChartData = _ref.outcomeChartData;

        signature__objectDestructuringEmpty(props);

        var isNonEmpty = Object.keys(this.state.themeSliderData).length,
            isMapDataNonEmpty = Object.keys(this.state.signatureMapData).length,
            isOutcomeNonEmpty = Object.keys(this.state.outcomeChartData).length,
            isProjectListNonEmpty = this.state.projectList && this.state.projectList.projectList ? Object.keys(this.state.projectList.projectList).length : 0,
            aggregate = isNonEmpty ? themeSliderData.data && themeSliderData.data.aggregate : {},
            budgetSources = isNonEmpty ? themeSliderData.data && themeSliderData.data.budget_sources : {},
            recepientOffices = isNonEmpty ? themeSliderData.data && themeSliderData.data.top_recipient_offices : {},
            mapData = isMapDataNonEmpty ? signatureMapData && signatureMapData.data && signatureMapData : {},
            outcomeChartData = isMapDataNonEmpty && this.state.outcomeChartData ? this.state.outcomeChartData : {};
        return Object(preact_min["h"])(
            'div',
            null,
            this.props.title === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': signature_style_default.a.titleWrapper },
                ' ',
                this.props.themesLabel
            ) : null,
            Object(preact_min["h"])(
                'div',
                { 'class': signature_style_default.a.wrapper },
                this.props.themeSliderData.loading ? Object(preact_min["h"])(
                    'div',
                    { style: { position: "relative", height: 83 } },
                    signature__ref2
                ) : this.props.stats === 'true' ? Object(preact_min["h"])(
                    'ul',
                    { 'class': signature_style_default.a.list },
                    Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': signature_style_default.a.value },
                            aggregate.budget_amount && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(aggregate.budget_amount, 2)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': signature_style_default.a.label },
                            'Budget'
                        )
                    ),
                    Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': signature_style_default.a.value },
                            aggregate.expense_amount && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(aggregate.expense_amount, 2)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': signature_style_default.a.label },
                            'Expenditure'
                        )
                    ),
                    Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': signature_style_default.a.value },
                            aggregate.projects && Object(numberFormatter["c" /* numberToCommaFormatter */])(aggregate.projects)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': signature_style_default.a.label },
                            'Projects'
                        )
                    ),
                    Object(preact_min["h"])(
                        'li',
                        null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': signature_style_default.a.value },
                            aggregate.budget_sources && Object(numberFormatter["c" /* numberToCommaFormatter */])(aggregate.budget_sources)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': signature_style_default.a.label },
                            'Donors'
                        )
                    )
                ) : null
            ),
            this.props.map === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': signature_style_default.a.mapContainer, style: { position: 'relative', display: 'block' } },
                isMapDataNonEmpty ? Object(preact_min["h"])(map["a" /* default */], {
                    themes: this.props.themes,
                    mapData: mapData
                }) : signature__ref3,
                isMapDataNonEmpty ? Object(preact_min["h"])(
                    'div',
                    { 'class': signature_style_default.a.disclaimer },
                    '* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'
                ) : null
            ) : null,
            this.props.projectTable === 'true' ? Object(preact_min["h"])(bootstraptable["a" /* default */], (_h = { count: totalDataSize,
                loading: this.props.projectList.loading,
                currentYear: this.props.year,
                theme: this.props.themes,
                keyword: '',
                unit: '',
                source: ''
            }, _h['currentYear'] = this.props.year, _h.sdg = '', _h.data = projectListArr, _h.links = links, _h.embed = true, _h)) : null,
            this.props.ourFocus === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': signature_style_default.a.wrapper + ' ' + signature_style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': signature_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': signature_style_default.a.chartHead },
                        signature__ref4
                    ),
                    outcomeChartData && outcomeChartData.data && outcomeChartData.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: "relative", height: 344 } },
                        signature__ref5
                    ) : Object(preact_min["h"])(
                        'div',
                        null,
                        (outcomeChartData && outcomeChartData.data && outcomeChartData.data.country.length) > 0 ? Object(preact_min["h"])(
                            'div',
                            { 'class': signature_style_default.a.outcome_chart_wrapper + ' ' + signature_style_default.a.outcome_resources_modality },
                            Object(preact_min["h"])(donutChart["a" /* default */], {
                                donor_wrapper_styles: signature_style_default.a.outcome_wrapper_styles,
                                donut_styles: signature_style_default.a.donut_styles,
                                legend_styles: signature_style_default.a.legend_styles,
                                textWrapperStyle: signature_style_default.a.textWrapperStyle,
                                textFieldStyle: signature_style_default.a.textFieldStyle,
                                data: outcomeChartData.data.country,
                                legendData: outcomeChartData.data.total,
                                chartWidth: 560,
                                chartHeight: 400, chart_id: 'outcomes_chart_signature' })
                        ) : signature__ref6
                    )
                )
            ) : null,
            this.props.budgetSources === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': signature_style_default.a.wrapper + ' ' + signature_style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': signature_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': signature_style_default.a.chartHead },
                        signature__ref7,
                        signature__ref8
                    ),
                    themeSliderData.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: "relative", height: 344 } },
                        signature__ref9
                    ) : Object(preact_min["h"])(
                        'div',
                        null,
                        budgetSources.length > 0 ? Object(preact_min["h"])(
                            'div',
                            { 'class': signature_style_default.a.budget_sources_wrapper },
                            Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                chart_id: 'themes_embed_budget_sources',
                                width: 1250,
                                height: 500,
                                min_height: 540,
                                data: budgetSources,
                                label: 'short_name',
                                tspanSize: '12px',
                                textSize: '12px' })
                        ) : signature__ref10
                    )
                )
            ) : null,
            this.props.recepientOffices === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': signature_style_default.a.wrapper + ' ' + signature_style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': signature_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': signature_style_default.a.chartHead },
                        signature__ref11,
                        signature__ref12
                    ),
                    themeSliderData.loading ? Object(preact_min["h"])(
                        'div',
                        { style: { position: "relative", height: 344 } },
                        signature__ref13
                    ) : Object(preact_min["h"])(
                        'div',
                        null,
                        recepientOffices.length > 0 ? Object(preact_min["h"])(
                            'div',
                            { 'class': signature_style_default.a.budget_sources_wrapper },
                            Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                chart_id: 'themes_embed_top_recipient_offices',
                                width: 1250,
                                height: 500,
                                min_height: 540,
                                data: recepientOffices,
                                label: 'iso3',
                                tspanSize: '12px',
                                textSize: '12px' })
                        ) : signature__ref14
                    )
                )
            ) : null
        );
    };

    return EmbedSignatureView;
}(preact_min["Component"]);

var signature_mapStateToProps = function mapStateToProps(state) {
    var themeSliderData = state.themeSliderData,
        signatureMapData = state.mapData.signatureMapData,
        projectList = state.projectList,
        outcomeChartData = state.signatureOutcome;

    return {
        themeSliderData: themeSliderData,
        signatureMapData: signatureMapData,
        projectList: projectList,
        outcomeChartData: outcomeChartData
    };
};

var signature_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchSignatureSliderData: function fetchSignatureSliderData(year, sector) {
            return dispatch(Object(signatureDonor["b" /* fetchSignatureSliderData */])(year, sector));
        },
        loadSignatureMapData: function loadSignatureMapData(year, sector) {
            return dispatch(Object(mapActions_signatureMapData["b" /* loadSignatureMapData */])(year, sector));
        },
        updateProjectList: function updateProjectList(year, unit, source, theme, keyword, limit, offset, budget_type) {
            return dispatch(Object(getProjectList["c" /* updateProjectList */])(year, unit, source, theme, keyword, limit, offset, budget_type));
        },
        fetchSignatureOutcome: function fetchSignatureOutcome(code, year) {
            return dispatch(Object(signatureOutcome["c" /* fetchSignatureOutcome */])(code, year));
        }
    };
};

/* harmony default export */ var embedViews_signature = (Object(preact_redux_esm["a" /* connect */])(signature_mapStateToProps, signature_mapDispatchToProps)(signature_EmbedSignatureView));
// CONCATENATED MODULE: ./routes/sdgLanding/index.js

		

		function sdgLanding_load(cb) {
			__webpack_require__.e/* require.ensure */(10).then((function (require) {
				cb( __webpack_require__("X+7D") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var sdgLanding = (async_default()(sdgLanding_load));
	
// EXTERNAL MODULE: ./components/sdgLandingPage/actions/index.js
var sdgLandingPage_actions = __webpack_require__("qYVk");

// EXTERNAL MODULE: ./components/sunburstChart/index.js + 2 modules
var sunburstChart = __webpack_require__("k7Db");

// EXTERNAL MODULE: ./routes/embedViews/sdgLanding/style.scss
var sdgLanding_style = __webpack_require__("mmqk");
var sdgLanding_style_default = /*#__PURE__*/__webpack_require__.n(sdgLanding_style);

// CONCATENATED MODULE: ./routes/embedViews/sdgLanding/index.js


function sdgLanding__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function sdgLanding__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sdgLanding__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sdgLanding__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


 // Themes Top Budget Sources, Top Recipient countries






var sdgLanding__ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sdgLanding_EmbedSdgLandingView = function (_Component) {
    sdgLanding__inherits(EmbedSdgLandingView, _Component);

    function EmbedSdgLandingView(props) {
        sdgLanding__classCallCheck(this, EmbedSdgLandingView);

        var _this = sdgLanding__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleOnClick = function (e) {
            if (e.size && e.size != 1) {}
        };

        _this.onTargetClick = function (e) {
            if (e.name) {
                var targetIds = e.name.replace('Target', '').trim().split('.');
                window.open('/sdg/targets/' + targetIds[0] + '/' + targetIds[1], '_blank');
            }
        };

        _this.onSDGClick = function (e) {
            if (e.parent.name.includes('SDG')) {
                window.open('/sdg/' + e.parent.code + '/' + e.parent.fullName, '_blank');
            }
        };

        _this.state = {};
        return _this;
    }

    EmbedSdgLandingView.prototype.componentWillMount = function componentWillMount() {
        this.props.fetchSdgSunburstData(this.props.currentYear);
    };

    EmbedSdgLandingView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {};

    EmbedSdgLandingView.prototype.render = function render(props, _ref) {
        sdgLanding__objectDestructuringEmpty(_ref);

        return Object(preact_min["h"])(
            'div',
            null,
            this.props.title !== 'false' ? Object(preact_min["h"])(
                'div',
                { 'class': sdgLanding_style_default.a.titleWrapper },
                'Sustainable Development Goals'
            ) : null,
            this.props.summary !== 'false' ? Object(preact_min["h"])(
                'div',
                null,
                Object(preact_min["h"])(
                    'span',
                    { 'class': sdgLanding_style_default.a.SDGdisclaimer },
                    'The Sustainable Development Goals (SDGs) are a universal call to action to end poverty, protect the planet and ensure that all people enjoy peace and prosperity. The SDGs continue to guide IUCN policy and funding until 2030. As the lead United Nations development agency, IUCN is uniquely placed to help implement the Goals through our work in some 170 countries and territories.'
                )
            ) : null,
            !this.props.sdgSunburstData.loading ? Object(preact_min["h"])(
                'div',
                { 'class': sdgLanding_style_default.a.sunburstChartContainer },
                Object(preact_min["h"])(sunburstChart["a" /* default */], {
                    chart_id: 'sdg_sunburst_chart_embed',
                    width: 1250,
                    height: 600,
                    embed: 'true',
                    backButtonTop: sdgLanding_style_default.a.backButtonTop,
                    data: this.props.sdgSunburstData.data,
                    handleOnClick: this.handleOnClick,
                    onTargetClick: this.onTargetClick,
                    onSDGClick: this.onSDGClick
                })
            ) : Object(preact_min["h"])(
                'div',
                { style: { position: 'relative', height: 344 } },
                sdgLanding__ref2
            )
        );
    };

    return EmbedSdgLandingView;
}(preact_min["Component"]);

var sdgLanding_mapStateToProps = function mapStateToProps(state) {
    var sdgSunburstData = state.sdgSunburstData,
        currentYear = state.yearList.currentYear;

    return {
        sdgSunburstData: sdgSunburstData,
        currentYear: currentYear
    };
};
var sdgLanding_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchSdgSunburstData: function fetchSdgSunburstData(year) {
            return dispatch(Object(sdgLandingPage_actions["b" /* fetchSdgSunburstData */])(year));
        }
    };
};

/* harmony default export */ var embedViews_sdgLanding = (Object(preact_redux_esm["a" /* connect */])(sdgLanding_mapStateToProps, sdgLanding_mapDispatchToProps)(sdgLanding_EmbedSdgLandingView));
// EXTERNAL MODULE: ./components/paLandingPage/actions/index.js
var paLandingPage_actions = __webpack_require__("ehfr");

// EXTERNAL MODULE: ./routes/embedViews/paLanding/style.scss
var paLanding_style = __webpack_require__("RTlb");
var paLanding_style_default = /*#__PURE__*/__webpack_require__.n(paLanding_style);

// EXTERNAL MODULE: ./components/paSunburstChart/index.js + 2 modules
var paSunburstChart = __webpack_require__("Ho0Y");

// CONCATENATED MODULE: ./routes/embedViews/paLanding/index.js


function paLanding__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function paLanding__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function paLanding__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function paLanding__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


 // Themes Top Budget Sources, Top Recipient countries







var paLanding__ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var paLanding_EmbedSdgLandingView = function (_Component) {
    paLanding__inherits(EmbedSdgLandingView, _Component);

    function EmbedSdgLandingView(props) {
        paLanding__classCallCheck(this, EmbedSdgLandingView);

        var _this = paLanding__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleOnClick = function (e) {
            if (e.size && e.size != 1) {}
        };

        _this.onTargetClick = function (e) {
            if (e.name) {
                var targetIds = e.name.replace('Target', '').trim().split('.');
                window.open('/sdg/targets/' + targetIds[0] + '/' + targetIds[1], '_blank');
            }
        };

        _this.onSDGClick = function (e) {
            if (e.parent.name.includes('SDG')) {
                window.open('/sdg/' + e.parent.code + '/' + e.parent.fullName, '_blank');
            }
        };

        _this.state = {};
        return _this;
    }

    EmbedSdgLandingView.prototype.componentWillMount = function componentWillMount() {
        this.props.fetchSdgSunburstData(this.props.currentYear);
    };

    EmbedSdgLandingView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {};

    EmbedSdgLandingView.prototype.render = function render(props, _ref) {
        paLanding__objectDestructuringEmpty(_ref);

        return Object(preact_min["h"])(
            'div',
            null,
            this.props.title !== 'false' ? Object(preact_min["h"])(
                'div',
                { 'class': paLanding_style_default.a.titleWrapper },
                'IUCN Programme Areas'
            ) : null,
            this.props.summary !== 'false' ? Object(preact_min["h"])(
                'div',
                null,
                Object(preact_min["h"])(
                    'span',
                    { 'class': paLanding_style_default.a.SDGdisclaimer },
                    'IUCN\u2019s One Programme approach underpins and strengthens the delivery and impact of the IUCN Programme, effectively leveraging the respective roles, capacities and unique features of the constituent parts of the Union \u2013 our Members, Commissions, National and Regional Committees and Secretariat \u2013 in partnership with a diversity of sectors engaged in the sustainable development agenda. In a world facing unprecedented planetary challenges, IUCN is unique in its ability to respond at the scale needed for positive, timely transformative action for a more sustainable future. This uniqueness draws from IUCN\u2019s convening power, scientific strength, broad and diverse membership, and truly global presence. The Union will take advantage of its unique structure: generating the necessary science-based evidence and knowledge that decision makers require, building trust and consensus among disparate stakeholder groups, identifying feasible policy options and, critically, fostering a culture of delivery and action that accelerates early and sustainable implementation. It will deliver concrete and tangible positive impacts to People, Land, Water, Oceans and Climate.'
                )
            ) : null,
            !this.props.sdgSunburstData.loading ? Object(preact_min["h"])(
                'div',
                { 'class': paLanding_style_default.a.sunburstChartContainer },
                Object(preact_min["h"])(paSunburstChart["a" /* default */], { chart_id: 'sdg_sunburst_chart',
                    width: screen.width >= 650 ? 1600 : screen.width >= 550 ? 1200 : 1000,
                    height: 600,
                    data: this.props.sdgSunburstData.data,
                    handleOnClick: this.handleOnClick,
                    onTargetClick: this.onTargetClick,
                    onSDGClick: this.onSDGClick
                })
            ) : Object(preact_min["h"])(
                'div',
                { style: { position: 'relative', height: 344 } },
                paLanding__ref2
            )
        );
    };

    return EmbedSdgLandingView;
}(preact_min["Component"]);

var paLanding_mapStateToProps = function mapStateToProps(state) {
    var sdgSunburstData = state.sdgSunburstData,
        currentYear = state.yearList.currentYear;

    return {
        sdgSunburstData: sdgSunburstData,
        currentYear: currentYear
    };
};
var paLanding_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchSdgSunburstData: function fetchSdgSunburstData(year) {
            return dispatch(Object(paLandingPage_actions["a" /* fetchSdgSunburstData */])(year));
        }
    };
};

/* harmony default export */ var paLanding = (Object(preact_redux_esm["a" /* connect */])(paLanding_mapStateToProps, paLanding_mapDispatchToProps)(paLanding_EmbedSdgLandingView));
// CONCATENATED MODULE: ./routes/iucnProgrammeArea/index.js

		

		function iucnProgrammeArea_load(cb) {
			__webpack_require__.e/* require.ensure */(12).then((function (require) {
				cb( __webpack_require__("SK1t") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var iucnProgrammeArea = (async_default()(iucnProgrammeArea_load));
	
// CONCATENATED MODULE: ./routes/sscMarker/index.js

		

		function sscMarker_load(cb) {
			__webpack_require__.e/* require.ensure */(5).then((function (require) {
				cb( __webpack_require__("CiNY") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var sscMarker = (async_default()(sscMarker_load));
	
// EXTERNAL MODULE: ./components/markerPage/actions/barchartDataFetch.js
var barchartDataFetch = __webpack_require__("CFDo");

// EXTERNAL MODULE: ./routes/embedViews/markers/style.scss
var markers_style = __webpack_require__("9YiL");
var markers_style_default = /*#__PURE__*/__webpack_require__.n(markers_style);

// EXTERNAL MODULE: ./components/markerPage/actions/typeAndDesc.js
var typeAndDesc = __webpack_require__("IlGz");

// EXTERNAL MODULE: ./components/markerPage/actions/markerSubTypes.js
var markerSubTypes = __webpack_require__("UPaS");

// EXTERNAL MODULE: ./components/nestedDropList/actions/index.js
var nestedDropList_actions = __webpack_require__("doLN");

// EXTERNAL MODULE: ./components/bootstraptable/actions/setMarkerType.js
var setMarkerType = __webpack_require__("zNX7");

// CONCATENATED MODULE: ./routes/embedViews/markers/index.js
var markers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function markers__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function markers__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function markers__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function markers__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


 // Themes Top Budget Sources, Top Recipient countries
















var markers__ref2 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var markers__ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var markers__ref4 = Object(preact_min["h"])(
	'span',
	null,
	'Top 10 Recipients'
);

var markers__ref5 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var markers__ref6 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var markers__ref7 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var markers__ref8 = Object(preact_min["h"])(
	'span',
	null,
	'Top 10 Donors'
);

var markers__ref9 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var markers__ref10 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var markers__ref11 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var markers_EmbedMarkers = function (_Component) {
	markers__inherits(EmbedMarkers, _Component);

	function EmbedMarkers(props) {
		markers__classCallCheck(this, EmbedMarkers);

		var _this = markers__possibleConstructorReturn(this, _Component.call(this, props));

		_this.handleFilterChange = function (type, value) {
			var _extends2;

			_this.setState({
				dropListFilterobj: markers__extends({}, _this.state.dropListFilterobj, (_extends2 = {}, _extends2[type] = markers__extends({}, _this.state.dropListFilterobj[type], {
					value: value.value || value,
					label: value.label || ''
				}), _extends2))
			}, function () {
				_this.generateFilterListUrl();
			});
			switch (type) {
				case 'country':
					var countryVal = value.value;
					_this.setState({
						unitSelected: countryVal,
						unitLabel: value.name || value.label
					});
					_this.props.loadProjectListMapData(_this.props.year, _this.state.themeSelected, countryVal, _this.state.sourceSelected, _this.state.sdgSelected, _this.props.marker, _this.props.marker_id);

					_this.props.updateSearchCountryField(countryVal);
					break;

				case 'search':
					_this.setState({
						keyword: value
					});
					break;
				default:
					null;
			}
		};

		_this.state = {
			themeSelected: '',
			unitSelected: '',
			unitLabel: '',
			sourceSelected: '',
			sdgSelected: '',
			keyword: '',
			totalDataSize: 0,
			links: {}
		};
		return _this;
	}

	EmbedMarkers.prototype.generateSubLevels = function generateSubLevels(element) {
		if (element && element.description_details === '') {
			var cellData = element && element.description_title && element.description_title.map(function (item) {
				return Object(preact_min["h"])(
					'section',
					null,
					Object(preact_min["h"])(
						'span',
						{ 'class': markers_style_default.a.dataTitle },
						Object(preact_min["h"])('img', { src: '../../../static/assets/icons/dot.png', 'class': markers_style_default.a.bullet }),
						Object(preact_min["h"])(
							'span',
							{ 'class': markers_style_default.a.titleText },
							item.level_two_marker_title
						)
					),
					Object(preact_min["h"])(
						'span',
						{ 'class': markers_style_default.a.dataDetails },
						' ',
						item.level_two_marker_description
					)
				);
			});
			return cellData;
		} else {
			return Object(preact_min["h"])(
				'span',
				{ 'class': markers_style_default.a.dataDetails },
				'  ',
				element && element.description_details
			);
		}
	};

	EmbedMarkers.prototype.generateRows = function generateRows(data, marker) {
		var _this2 = this;

		var rows = null;
		if (marker && data.type) {
			if (marker.id === '2') {
				rows = data.type.map(function (element, index) {
					return Object(preact_min["h"])(
						'section',
						{ key: index, 'class': markers_style_default.a.row },
						Object(preact_min["h"])(
							'section',
							{ 'class': markers_style_default.a.cell },
							Object(preact_min["h"])(
								lib["Scrollbars"],
								{ 'class': markers_style_default.a.scroll },
								Object(preact_min["h"])(
									'section',
									{ 'class': markers_style_default.a.data },
									Object(preact_min["h"])(
										'section',
										{ 'class': markers_style_default.a.dataTitle },
										Object(preact_min["h"])('img', { src: '../../../static/assets/icons/dot.png', 'class': markers_style_default.a.bullet }),
										Object(preact_min["h"])(
											'span',
											{ 'class': markers_style_default.a.titleText },
											element.type_title
										)
									),
									Object(preact_min["h"])(
										'span',
										{ 'class': markers_style_default.a.dataDetails },
										element.type_details
									)
								)
							)
						),
						Object(preact_min["h"])(
							'section',
							{ 'class': markers_style_default.a.cell },
							Object(preact_min["h"])(
								lib["Scrollbars"],
								{ 'class': markers_style_default.a.scroll },
								Object(preact_min["h"])(
									'section',
									{ 'class': markers_style_default.a.data },
									_this2.generateSubLevels(element)
								)
							)
						)
					);
				});
			} else {
				rows = data.type.map(function (element, index) {
					return Object(preact_min["h"])(
						'section',
						{ key: index, 'class': markers_style_default.a.row },
						Object(preact_min["h"])(
							'section',
							{ 'class': markers_style_default.a.cell },
							Object(preact_min["h"])(
								lib["Scrollbars"],
								{ 'class': markers_style_default.a.scroll2 },
								Object(preact_min["h"])(
									'section',
									{ 'class': markers_style_default.a.data },
									Object(preact_min["h"])(
										'span',
										{ 'class': markers_style_default.a.dataTitle2 },
										element.type_title
									)
								)
							)
						),
						Object(preact_min["h"])(
							'section',
							{ 'class': markers_style_default.a.cell },
							Object(preact_min["h"])(
								lib["Scrollbars"],
								{ 'class': markers_style_default.a.scroll2 },
								Object(preact_min["h"])(
									'section',
									{ 'class': markers_style_default.a.data },
									element && element.description_details.constructor == Array ? element.description_details.map(function (item) {
										return Object(preact_min["h"])(
											'section',
											{ 'class': markers_style_default.a.listSection },
											Object(preact_min["h"])('img', { src: '../../../static/assets/icons/dot.png', 'class': markers_style_default.a.bullet2 }),
											Object(preact_min["h"])(
												'span',
												{ 'class': markers_style_default.a.textTitle2 },
												item
											)
										);
									}) : element && element.description_details === "" ? element.description_title.map(function (item) {
										return Object(preact_min["h"])(
											'section',
											{ 'class': markers_style_default.a.listSection },
											Object(preact_min["h"])('img', { src: '../../../static/assets/icons/dot.png', 'class': markers_style_default.a.bullet2 }),
											Object(preact_min["h"])(
												'span',
												{ 'class': markers_style_default.a.textTitle2 },
												item
											)
										);
									}) : Object(preact_min["h"])(
										'span',
										{ 'class': markers_style_default.a.textTitle2 },
										' ',
										element && element.description_details
									)
								)
							)
						)
					);
				});
			}
		}
		return rows;
	};

	EmbedMarkers.prototype.componentWillMount = function componentWillMount() {
		this.props.updateMarkerSubType(this.props.marker_id);
		this.props.loadProjectListMapData(this.props.year, this.props.themes, this.props.country, this.props.sources, this.props.sdg, this.props.marker, this.props.marker_id);
		this.props.fetchMarkerDescriptionData(this.props.year, this.props.marker, this.props.country, this.props.marker_id);
		this.props.fetchMarkerBarChartData(this.props.year, this.props.marker, this.props.country, this.props.marker_id);
		this.props.fetchmarkerSubType(this.props.marker, this.props.country);
		this.props.fetchMarkerProjectList(this.props.year, this.props.marker, '', 10, 0, this.props.country, this.props.isSSCMarker ? '' : this.props.marker_id, this.props.l2country);
	};

	EmbedMarkers.prototype.render = function render(props, _ref) {
		var _this3 = this;

		markers__objectDestructuringEmpty(_ref);

		var budgetSources = this.props.chartData.data.budget_sources ? this.props.chartData.data.budget_sources : [];
		var topRecipientOffices = this.props.chartData.data.top_recipient_offices ? this.props.chartData.data.top_recipient_offices : [];
		var optionData = void 0;
		var tableData = [];
		if (this.props.projectList.projectList) {
			if (this.props.projectList.projectList.data.length !== 0) {
				tableData = this.props.projectList.projectList.data.map(function (element) {
					return markers__extends({}, element, {
						country_name: element.country
					});
				});
			}
		}
		if (this.props.markerSubTypes.data && this.props.markerSubTypes.data[0]) {
			optionData = this.props.markerSubTypes.data.map(function (element) {
				return {
					label: element.title,
					value: element.marker_type
				};
			});
		} else {
			optionData = [];
		}

		return Object(preact_min["h"])(
			'div',
			null,
			this.props.title !== 'false' ? Object(preact_min["h"])(
				'div',
				{ 'class': markers_style_default.a.titleWrapper },
				'Our Approach - ',
				this.props.year
			) : null,
			this.props.title !== 'false' ? Object(preact_min["h"])(
				'div',
				{ 'class': markers_style_default.a.mapWrapper },
				Object(preact_min["h"])(map["a" /* default */], { sector: this.state.themeSelected,
					sdg: this.state.sdgSelected,
					source: this.state.sourceSelected,
					mapData: this.props.mapData.projectListMapData,
					onCountrySelect: function onCountrySelect(country) {
						return _this3.handleFilterChange("country", { value: country.country_iso3, name: country.country_name });
					},
					newclass: true
				}),
				Object(preact_min["h"])(
					'div',
					{ 'class': markers_style_default.a.disclaimer },
					'* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'
				)
			) : null,
			this.props.typesDescription === 'true' ? Object(preact_min["h"])(
				'section',
				{ 'class': markers_style_default.a.table },
				Object(preact_min["h"])(
					'section',
					{ 'class': markers_style_default.a.tableHeader },
					Object(preact_min["h"])(
						'section',
						{ 'class': markers_style_default.a.tableHeaderSection },
						Object(preact_min["h"])(
							'span',
							{ 'class': markers_style_default.a.tableHeaderData },
							' Type '
						)
					),
					Object(preact_min["h"])(
						'section',
						{ 'class': markers_style_default.a.tableHeaderSection },
						Object(preact_min["h"])(
							'span',
							{ 'class': markers_style_default.a.tableHeaderData },
							' Description '
						)
					)
				),
				Object(preact_min["h"])(
					'section',
					{ 'class': markers_style_default.a.tableBody },
					!this.props.markerDescData.data.loading ? this.props.markerDescData.data.type && this.props.markerDescData.data.type.length !== 0 ? this.generateRows(this.props.markerDescData.data, { id: this.props.marker }) : markers__ref2 : Object(preact_min["h"])(
						'div',
						{ style: { position: 'relative', height: 344 } },
						markers__ref3
					)
				)
			) : null,
			this.props.recipients === 'true' ? Object(preact_min["h"])(
				'div',
				{ 'class': markers_style_default.a.chartWrapper },
				Object(preact_min["h"])(
					'div',
					{ 'class': markers_style_default.a.top_budget_sources_wrapper },
					Object(preact_min["h"])(
						'span',
						{ 'class': markers_style_default.a.chartHead },
						markers__ref4,
						markers__ref5
					),
					!this.props.chartData.loading ? topRecipientOffices.length !== 0 ? Object(preact_min["h"])(
						'div',
						{ 'class': markers_style_default.a.budget_sources_wrapper },
						Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
							chart_id: 'sdg_profile_top_recipient_offices',
							width: 1250,
							height: 500,
							min_height: 540,
							data: topRecipientOffices,
							label: 'iso3',
							tspanSize: '12px',
							textSize: '12px'
						})
					) : markers__ref6 : Object(preact_min["h"])(
						'div',
						{ style: { position: 'relative', height: 344 } },
						markers__ref7
					)
				)
			) : null,
			this.props.donors === 'true' ? Object(preact_min["h"])(
				'div',
				{ 'class': markers_style_default.a.chartWrapper },
				Object(preact_min["h"])(
					'div',
					{ 'class': markers_style_default.a.top_budget_sources_wrapper },
					Object(preact_min["h"])(
						'span',
						{ 'class': markers_style_default.a.chartHead },
						markers__ref8,
						markers__ref9
					),
					!this.props.chartData.loading ? budgetSources.length !== 0 ? Object(preact_min["h"])(
						'div',
						{ 'class': markers_style_default.a.budget_sources_wrapper },
						Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
							chart_id: 'sdg_profile_top_donors',
							width: 1250,
							height: 500,
							min_height: 540,
							data: budgetSources,
							label: 'short_name',
							tspanSize: '12px',
							textSize: '12px'
						})
					) : markers__ref10 : Object(preact_min["h"])(
						'div',
						{ style: { position: 'relative', height: 344 } },
						markers__ref11
					)
				)
			) : null,
			this.props.projectTable === 'true' ? Object(preact_min["h"])(
				'div',
				{ 'class': markers_style_default.a.projectListWrapper },
				Object(preact_min["h"])(bootstraptable["a" /* default */], {
					data: tableData,
					enableMarkerDropDown: true
					// handleFilterChange={(type, value) => this.handleFilterChange(type, value)}
					, getSearchParam: function getSearchParam(param) {
						_this3.setState({ searchText: param });
					},
					theme: this.state.themeSelected,
					unit: this.state.unitSelected,
					keyword: this.state.keyword,
					source: this.state.sourceSelected
					// count={totalDataSize}
					// links={links}
					, yearSelected: this.props.year,
					marker: this.props.marker,
					optionData: optionData,
					country: this.props.country,
					loading: this.props.projectList.loading,
					count: this.props.projectList.projectList.count
				})
			) : null
		);
	};

	return EmbedMarkers;
}(preact_min["Component"]);

var markers_mapStateToProps = function mapStateToProps(state) {
	var currentYear = state.yearList.currentYear,
	    chartData = state.markerBarChartData,
	    markerSubTypes = state.markerSubTypes,
	    projectList = state.projectList,
	    mapData = state.mapData,
	    markerDescData = state.markerDescData;
	return {
		currentYear: currentYear,
		chartData: chartData,
		markerDescData: markerDescData,
		markerSubTypes: markerSubTypes,
		mapData: mapData,
		projectList: projectList
	};
};
var markers_mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		fetchmarkerSubType: function fetchmarkerSubType(marker, country) {
			return dispatch(Object(markerSubTypes["b" /* fetchmarkerSubType */])(marker, country));
		},
		updateMarkerSubType: function updateMarkerSubType(value) {
			return dispatch(Object(setMarkerType["b" /* updateMarkerSubType */])(value));
		},
		loadProjectListMapData: function loadProjectListMapData(year, sector, unit, source, sdg, marker, marker_id) {
			return dispatch(Object(mapActions_projectListMapData["b" /* loadProjectListMapData */])(year, sector, unit, source, sdg, marker, marker_id));
		},
		updateSearchCountryField: function updateSearchCountryField(countryCode) {
			return dispatch(Object(nestedDropList_actions["q" /* updateSearchCountryField */])(countryCode));
		},
		fetchMarkerProjectList: function fetchMarkerProjectList(year, markerId, keyword, limit, offset, country, markerType) {
			return dispatch(Object(getProjectList["b" /* fetchMarkerProjectList */])(year, markerId, keyword, limit, offset, country, markerType));
		},
		fetchMarkerBarChartData: function fetchMarkerBarChartData(year, marker, country, marker_id) {
			return dispatch(Object(barchartDataFetch["b" /* fetchMarkerBarChartData */])(year, marker, country, marker_id));
		},
		fetchMarkerDescriptionData: function fetchMarkerDescriptionData(year, marker, country, marker_id) {
			return dispatch(Object(typeAndDesc["b" /* fetchMarkerDescriptionData */])(year, marker, country, marker_id));
		}
	};
};

/* harmony default export */ var markers = (Object(preact_redux_esm["a" /* connect */])(markers_mapStateToProps, markers_mapDispatchToProps)(markers_EmbedMarkers));
// CONCATENATED MODULE: ./routes/oauth2/index.js

		

		function oauth2_load(cb) {
			__webpack_require__.e/* require.ensure */(19).then((function (require) {
				cb( __webpack_require__("678n") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var oauth2 = (async_default()(oauth2_load));
	
// CONCATENATED MODULE: ./routes/dataImport/index.js

		

		function dataImport_load(cb) {
			__webpack_require__.e/* require.ensure */(20).then((function (require) {
				cb( __webpack_require__("3K87") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var dataImport = (async_default()(dataImport_load));
	
// EXTERNAL MODULE: ../node_modules/preact-helmet/lib/Helmet.js
var Helmet = __webpack_require__("FJnM");
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./routes/marker/index.js
var routes_marker = __webpack_require__("je+9");

// EXTERNAL MODULE: ./shared/actions/commonDataActions.js
var commonDataActions = __webpack_require__("b7sF");

// EXTERNAL MODULE: ./shared/actions/sdgListActions.js
var sdgListActions = __webpack_require__("8R5k");

// EXTERNAL MODULE: ./shared/actions/getSystemInfo.js
var getSystemInfo = __webpack_require__("scl0");

// EXTERNAL MODULE: ./routes/embedViews/sscMarker/style.scss
var sscMarker_style = __webpack_require__("jDUJ");
var sscMarker_style_default = /*#__PURE__*/__webpack_require__.n(sscMarker_style);

// EXTERNAL MODULE: ./components/sscMarker/action/ourApproaches.js
var action_ourApproaches = __webpack_require__("I57u");

// EXTERNAL MODULE: ./components/sscMarkerlegend/index.js
var sscMarkerlegend = __webpack_require__("qVG8");

// EXTERNAL MODULE: ./components/verticalFlagList/index.js
var verticalFlagList = __webpack_require__("/jkn");

// EXTERNAL MODULE: ./components/markerPage/actions/index.js
var markerPage_actions = __webpack_require__("FYbH");

// EXTERNAL MODULE: ./components/sscMarker/action/selectCountry.js
var selectCountry = __webpack_require__("JTUf");

// EXTERNAL MODULE: ./components/sscMarker/action/selectL2Country.js
var action_selectL2Country = __webpack_require__("KAlA");

// EXTERNAL MODULE: ./components/sscMarker/action/selectMarkerType.js
var selectMarkerType = __webpack_require__("ptYD");

// CONCATENATED MODULE: ./routes/embedViews/sscMarker/index.js


function sscMarker__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sscMarker__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sscMarker__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























// http://localhost:8080/embed/projects?title=false&summary=false&map=false&projectTable=false&country=&sources=&themes=&sdg=


//title=false&summary=false&map=false&projectTable=false&country=&countryLabel=&sources=&sourcesLabel=&themes=&themesLabel=&sdg=&sdgLabel=&year=2018'}width={300}></frame>


// Projects <Budget Source> contributed in <Recipient Country Office / Operating Unit> for <year> under <No Poverty>


var sscMarker__ref3 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sscMarker__ref4 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sscMarker__ref5 = Object(preact_min["h"])(sscMarkerlegend["a" /* default */], null);

var sscMarker__ref6 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sscMarker__ref7 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sscMarker__ref8 = Object(preact_min["h"])(
    'span',
    null,
    'Top 10 Donors'
);

var sscMarker__ref9 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var sscMarker__ref10 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sscMarker__ref11 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sscMarker__ref12 = Object(preact_min["h"])(
    'span',
    null,
    'Top 10 Recipient Countries'
);

var sscMarker__ref13 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var sscMarker__ref14 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref15 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sscMarker_EmbedSSCMarkerView = function (_Component) {
    sscMarker__inherits(EmbedSSCMarkerView, _Component);

    function EmbedSSCMarkerView(props) {
        sscMarker__classCallCheck(this, EmbedSSCMarkerView);

        var _this = sscMarker__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleFilterChange = function (type, value) {
            if (_this.props.projectTable === 'true') {
                if (type === 'search') {
                    _this.setState({ keyword: value });
                }
            }
        };

        _this.generateFilteredList = function () {
            return _this.state.filterList.map(function (item) {
                if (item.label !== '') {
                    return Object(preact_min["h"])(
                        'span',
                        { 'class': sscMarker_style_default.a.filterLabels },
                        Object(preact_min["h"])(
                            'strong',
                            null,
                            item.displayLabel
                        ),
                        ': ',
                        item.label
                    );
                }
            });
        };

        _this.state = {
            projectList: [],
            totalDataSize: 0,
            links: {},
            keyword: _this.props.search,
            filterList: [{
                displayLabel: 'Donors',
                label: _this.props.sourcesLabel,
                text: ''

            }, {
                displayLabel: 'Recipient Country / Region',
                label: _this.props.countryLabel,
                text: ''

            }, {
                displayLabel: 'Year',
                label: _this.props.year,
                text: ''
            }, {
                displayLabel: 'Programme Areas',
                label: _this.props.themesLabel,
                text: ''

            }, {
                displayLabel: 'Sdg',
                label: _this.props.sdgLabel,
                text: ''

            }, {
                displayLabel: 'Signature Solutions',
                label: _this.props.signatureLabel,
                text: ''

            }]
        };
        _this.sscMarkerId = '3';
        _this.currentCountry_iso3 = '';
        _this.country = '', _this.level2CountryIso3 = '', _this.level2CountryName = '', _this.markerSubType = '';
        return _this;
    }

    EmbedSSCMarkerView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.projectTable === 'true') {
            if (nextProps.projectList != this.props.projectList) {
                var data = nextProps.projectList.data;
                var parseData = function parseData(data) {
                    data.forEach(function (item) {
                        item.country_name = item.country;
                        item.probObj = {
                            title: item.title,
                            project_id: item.project_id
                        };
                        item.total_budget = item.budget == null ? 0 : item.budget;
                        item.total_expense = item.expense == null ? 0 : item.expense;
                    });
                    return data;
                };
                this.setState({ projectList: parseData(data), totalDataSize: nextProps.projectList.count, links: nextProps.projectList.links });
            }
        }
    };

    EmbedSSCMarkerView.prototype.componentWillMount = function componentWillMount() {

        this.props.setCurrentYear(this.props.year);
        if (this.props.map === 'true') this.props.loadProjectListMapData(this.props.mapCurrentYear, '', '', '', '', this.sscMarkerId);

        this.country = '', this.level2CountryIso3 = '', this.level2CountryName = '', this.markerSubType = '';

        if (this.props.country && this.props.country !== '' && this.props.country !== 'all' && this.props.country !== 'undefined') {
            this.props.selectSSCCountry({
                country_iso3: this.props.country,
                isSelected: 1
            });
            this.country = this.props.country;
        }

        if (this.props.l2Country && this.props.l2Country !== '' && this.props.l2Country !== 'undefined') {
            this.level2CountryName = this.props.l2CountryName && this.props.l2CountryName !== '' && this.props.l2CountryName !== 'undefined' ? this.props.l2CountryName : '';
            this.level2CountryIso3 = this.props.l2Country;
            this.props.selectL2Country({
                country_iso3: this.level2CountryIso3,
                isSelected: 1,
                name: this.level2CountryName
            });
        }

        if (this.props.markerSubType && this.props.markerSubType !== 'undefined' && this.props.markerSubType !== '') {
            this.props.selectSSCMarkerType({ type: parseInt(this.props.markerSubType) });
            this.markerSubType = this.props.markerSubType;
        }

        if (this.props.approaches === 'true') {
            this.props.fetchOurApproachesData(this.country, this.level2CountryName, this.markerSubType);
        }

        if (this.props.donors === 'true' || this.props.recipients === 'true') this.props.fetchMarkerBarChartData(this.props.mapCurrentYear, this.sscMarkerId, this.country, this.markerSubType, this.level2CountryName);

        if (this.props.projectTable === 'true') {
            this.props.fetchmarkerSubType(this.sscMarkerId, '');
            this.props.fetchMarkerProjectList(this.props.mapCurrentYear, this.sscMarkerId, '', '', '', this.country, this.markerSubType, this.level2CountryName);
        }

        if (this.props.stats === 'true') this.props.fetchMarkerData(this.props.mapCurrentYear, this.sscMarkerId, this.country, this.markerSubType, this.level2CountryName);
    };

    EmbedSSCMarkerView.prototype.render = function render(_ref, _ref2) {
        var _this2 = this;

        var projectListMapData = _ref.projectListMapData;
        var links = _ref2.links,
            projectList = _ref2.projectList,
            totalDataSize = _ref2.totalDataSize;

        var optionData = void 0;
        if (this.props.markerSubtypes.data && this.props.markerSubtypes.data[0]) {
            optionData = this.props.markerSubtypes.data.map(function (element) {
                return {
                    label: element.title,
                    value: element.marker_type
                };
            });
        } else {
            optionData = [];
        }
        return Object(preact_min["h"])(
            'div',
            { 'class': sscMarker_style_default.a.container },
            this.props.title === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sscMarker_style_default.a.titleWrapper },
                'South-South And Triangular Cooperation - ',
                this.props.year
            ) : null,
            this.props.stats === 'true' ? Object(preact_min["h"])(
                'section',
                null,
                !this.props.aggregate.loading ? Object.keys(this.props.aggregate.data).length ? Object(preact_min["h"])(
                    'div',
                    { 'class': sscMarker_style_default.a.summaryWrapper },
                    this.state.sscMarkerId ? Object(preact_min["h"])(
                        'div',
                        { 'class': sscMarker_style_default.a.imgDiv },
                        Object(preact_min["h"])('img', { 'class': sscMarker_style_default.a.marker_image, src: this.currentMarker.image_2, alt: 'ssc' })
                    ) : null,
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': sscMarker_style_default.a.list + ' ' + sscMarker_style_default.a.ulWithFlag },
                        Object(preact_min["h"])(
                            'li',
                            { 'class': sscMarker_style_default.a.listItem },
                            Object(preact_min["h"])(
                                'span',
                                { 'class': sscMarker_style_default.a.value },
                                this.props.aggregate.data.budget && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(this.props.aggregate.data.budget, 2)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': sscMarker_style_default.a.label },
                                'Budget'
                            )
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': sscMarker_style_default.a.listItem },
                            Object(preact_min["h"])(
                                'span',
                                { 'class': sscMarker_style_default.a.value },
                                this.props.aggregate.data.expense && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(this.props.aggregate.data.expense, 2)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': sscMarker_style_default.a.label },
                                'Expenditure'
                            )
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': sscMarker_style_default.a.listItem },
                            Object(preact_min["h"])(
                                'span',
                                { 'class': sscMarker_style_default.a.value },
                                this.props.aggregate.data.projects_count && Object(numberFormatter["c" /* numberToCommaFormatter */])(this.props.aggregate.data.projects_count)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': sscMarker_style_default.a.label },
                                'Projects'
                            )
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': sscMarker_style_default.a.listItem },
                            Object(preact_min["h"])(
                                'span',
                                { 'class': sscMarker_style_default.a.value },
                                this.props.aggregate.data.budget_sources && Object(numberFormatter["c" /* numberToCommaFormatter */])(this.props.aggregate.data.budget_sources)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': sscMarker_style_default.a.label },
                                'Donors'
                            )
                        )
                    )
                ) : sscMarker__ref3 : Object(preact_min["h"])(
                    'div',
                    { style: { position: 'relative', height: 53, marginTop: 10, marginBottom: 10 } },
                    sscMarker__ref4
                )
            ) : null,
            this.props.map === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sscMarker_style_default.a.mapWrapper },
                Object(preact_min["h"])(map["a" /* default */], { sector: this.props.themes,
                    sdg: this.props.sdg,
                    source: this.props.sources,
                    mapData: this.props.projectListMapData,
                    enableTimeline: false,
                    embed: true,
                    isSSCMarker: 'true',
                    selectedMarkerSubtype: this.props.markerSubType
                }),
                sscMarker__ref5
            ) : null,
            this.props.approaches === 'true' ? this.props.sscApproachesData && !this.props.sscApproachesData.loading ? this.props.sscApproachesData.data.length ? Object(preact_min["h"])(
                'div',
                { 'class': sscMarker_style_default.a.flagListWrapper },
                Object(preact_min["h"])(verticalFlagList["a" /* default */], { apiBase: Object(commonMethods["d" /* getAPIBaseUrRl */])(), data: this.props.sscApproachesData.data })
            ) : sscMarker__ref6 : Object(preact_min["h"])(
                'div',
                { style: { position: 'relative', height: 120 } },
                sscMarker__ref7
            ) : null,
            this.props.donors === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sscMarker_style_default.a.chartWrapper + ' ' + sscMarker_style_default.a.paddingBottom },
                Object(preact_min["h"])(
                    'div',
                    { 'class': sscMarker_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sscMarker_style_default.a.chartHead },
                        sscMarker__ref8,
                        sscMarker__ref9
                    ),
                    !this.props.markerChartData.loading ? Object(preact_min["h"])(
                        'div',
                        null,
                        this.props.markerChartData.data.budget_sources && this.props.markerChartData.data.budget_sources.length ? Object(preact_min["h"])(
                            'div',
                            { 'class': sscMarker_style_default.a.budget_sources_wrapper },
                            Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                chart_id: 'marker_budget_sources',
                                width: 1250,
                                height: 500,
                                min_height: 540,
                                data: this.props.markerChartData.data.budget_sources,
                                label: 'short_name',
                                tspanSize: '12px',
                                textSize: '12px'
                            })
                        ) : sscMarker__ref10
                    ) : Object(preact_min["h"])(
                        'div',
                        { style: { position: 'relative', height: 344 } },
                        sscMarker__ref11
                    )
                )
            ) : null,
            this.props.recipients === 'true' ? Object(preact_min["h"])(
                'div',
                { 'class': sscMarker_style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': sscMarker_style_default.a.top_budget_sources_wrapper },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sscMarker_style_default.a.chartHead },
                        sscMarker__ref12,
                        sscMarker__ref13
                    ),
                    !this.props.markerChartData.loading ? this.props.markerChartData.data.top_recipient_offices && this.props.markerChartData.data.top_recipient_offices.length ? Object(preact_min["h"])(
                        'div',
                        { 'class': sscMarker_style_default.a.budget_sources_wrapper },
                        Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                            chart_id: 'sdg_profile_top_recipient_offices',
                            width: 1250,
                            height: 500,
                            min_height: 540,
                            data: this.props.markerChartData.data.top_recipient_offices,
                            label: 'iso3',
                            tspanSize: '12px',
                            textSize: '12px'
                        })
                    ) : sscMarker__ref14 : Object(preact_min["h"])(
                        'div',
                        { style: { position: 'relative', height: 344 } },
                        _ref15
                    )
                )
            ) : null,
            this.props.projectTable === 'true' ? this.props.projectList.data.length ? Object(preact_min["h"])(
                'div',
                { 'class': sscMarker_style_default.a.projectListWrapper },
                Object(preact_min["h"])(bootstraptable["a" /* default */], { data: this.props.projectList.data,
                    handleFilterChange: function handleFilterChange(type, value) {
                        return _this2.handleFilterChange(type, value);
                    },
                    loading: this.props.loading,
                    getSearchParam: function getSearchParam(param) {
                        _this2.setState({ searchText: param });
                    },
                    theme: this.state.themeSelected,
                    unit: this.state.unitSelected,
                    keyword: this.state.keyword,
                    source: this.state.sourceSelected,
                    count: totalDataSize,
                    links: links,
                    enableMarkerDropDown: true,
                    marker: this.sscMarkerId,
                    optionData: optionData,
                    selectedMarkerSubtype: this.markerSubType,
                    l2country: this.level2CountryName,
                    country: this.country,
                    isSSCMarker: 'true',
                    embed: true
                })
            ) : null : null
        );
    };

    return EmbedSSCMarkerView;
}(preact_min["Component"]);

var sscMarker_mapStateToProps = function mapStateToProps(state) {
    var mapCurrentYear = state.mapData.yearTimeline.mapCurrentYear,
        projectListMapData = state.mapData.projectListMapData,
        _state$projectList = state.projectList,
        loading = _state$projectList.loading,
        error = _state$projectList.error,
        projectList = _state$projectList.projectList;

    var sscApproachesData = state.sscApproachesData,
        markerChartData = state.markerBarChartData,
        aggregate = state.individualMarkerData,
        markerSubtypes = state.markerSubTypes;

    return {
        router: state.router,
        mapCurrentYear: mapCurrentYear,
        projectListMapData: projectListMapData,
        projectList: projectList,
        loading: loading,
        sscApproachesData: sscApproachesData,
        markerChartData: markerChartData,
        aggregate: aggregate,
        markerSubtypes: markerSubtypes

    };
};

var sscMarker_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        // onChangeRoute: (url) => dispatch(onChangeRoute(url))
        loadProjectListMapData: function loadProjectListMapData(year, sector, unit, source, sdg, marker) {
            return dispatch(Object(mapActions_projectListMapData["b" /* loadProjectListMapData */])(year, sector, unit, source, sdg, marker));
        },
        setCurrentYear: function setCurrentYear(year) {
            return dispatch(Object(getYearList["b" /* setCurrentYear */])(year));
        },
        fetchOurApproachesData: function fetchOurApproachesData(country, level2Marker, markerSubType) {
            return dispatch(Object(action_ourApproaches["b" /* fetchOurApproachesData */])(country, level2Marker, markerSubType));
        },
        selectSSCCountry: function selectSSCCountry(data) {
            return dispatch(Object(selectCountry["a" /* selectSSCCountry */])(data));
        },
        selectL2Country: function selectL2Country(data) {
            return dispatch(Object(action_selectL2Country["a" /* selectL2Country */])(data));
        },
        selectSSCMarkerType: function selectSSCMarkerType(data) {
            return dispatch(Object(selectMarkerType["a" /* selectSSCMarkerType */])(data));
        },
        fetchMarkerBarChartData: function fetchMarkerBarChartData(year, markerId, country, markerSubType, levelTwoMarker) {
            return dispatch(Object(barchartDataFetch["b" /* fetchMarkerBarChartData */])(year, markerId, country, markerSubType, levelTwoMarker));
        },
        fetchMarkerProjectList: function fetchMarkerProjectList(year, markerId, keyword, limit, offset, country, markerType, level2Marker) {
            return dispatch(Object(getProjectList["b" /* fetchMarkerProjectList */])(year, markerId, keyword, limit, offset, country, markerType, level2Marker));
        },
        fetchMarkerData: function fetchMarkerData(year, markerType, country, marker_id, level2Marker) {
            return dispatch(Object(markerPage_actions["b" /* fetchMarkerData */])(year, markerType, country, marker_id, level2Marker));
        },
        fetchmarkerSubType: function fetchmarkerSubType(markerId, country) {
            return dispatch(Object(markerSubTypes["b" /* fetchmarkerSubType */])(markerId, country));
        }
    };
};

/* harmony default export */ var embedViews_sscMarker = (Object(preact_redux_esm["a" /* connect */])(sscMarker_mapStateToProps, sscMarker_mapDispatchToProps)(sscMarker_EmbedSSCMarkerView));
// EXTERNAL MODULE: ./lib/api.js
var api = __webpack_require__("TOh2");

// CONCATENATED MODULE: ../node_modules/babel-loader/lib??ref--0!./routes/index.js


function lib__ref__0_routes__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function lib__ref__0_routes__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function lib__ref__0_routes__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/************************* Preact Files ************************/




/************************* Custom Component Files ************************/



































/**********************  Third party libraries x**********************/


/************************* Redux Action Files ************************/







var lib__ref__0_routes__ref = Object(preact_min["h"])(home["a" /* default */], { path: '/' });

var lib__ref__0_routes__ref2 = Object(preact_min["h"])(project["a" /* default */], { path: '/projects' });

var lib__ref__0_routes__ref3 = Object(preact_min["h"])(profile["a" /* default */], { path: '/profile/:code/:type' });

var lib__ref__0_routes__ref4 = Object(preact_min["h"])(searchResults, { path: '/search-results' });

var lib__ref__0_routes__ref5 = Object(preact_min["h"])(donors, { path: '/donors' });

var lib__ref__0_routes__ref6 = Object(preact_min["h"])(projectDetails["a" /* default */], { path: '/projects/:id' });

var lib__ref__0_routes__ref7 = Object(preact_min["h"])(aboutUs, { path: '/about-us' });

var lib__ref__0_routes__ref8 = Object(preact_min["h"])(routes_themes, { path: '/themes/:code/:type' });

var lib__ref__0_routes__ref9 = Object(preact_min["h"])(signature, { path: '/signature/:code/:type' });

var lib__ref__0_routes__ref10 = Object(preact_min["h"])(routes_sdg, { path: '/sdg/:code/:type' });

var lib__ref__0_routes__ref11 = Object(preact_min["h"])(signature, { path: '/programme-area/:code/:type' });

var lib__ref__0_routes__ref12 = Object(preact_min["h"])(sdgLanding, { path: '/sustainable-development-goals' });

var lib__ref__0_routes__ref13 = Object(preact_min["h"])(sdg_target_details, { path: '/sdg/targets/:code/:target_id' });

var lib__ref__0_routes__ref14 = Object(preact_min["h"])(pa_target_details, { path: '/programme-area/targets/:code/:target_id' });

var lib__ref__0_routes__ref15 = Object(preact_min["h"])(embedViews_project, { path: '/embed/projects' });

var _ref16 = Object(preact_min["h"])(embedViews_projectDetails, { path: '/embed/projects/:id' });

var _ref17 = Object(preact_min["h"])(embedViews_themes, { path: '/embed/themes' });

var _ref18 = Object(preact_min["h"])(embedViews_donors, { path: '/embed/donors' });

var _ref19 = Object(preact_min["h"])(embedViews_profile, { path: '/embed/profile/:code/:type' });

var _ref20 = Object(preact_min["h"])(embedViews_sdg, { path: '/embed/sdg/' });

var _ref21 = Object(preact_min["h"])(recipientCountry, { path: '/embed/home/recipientCountry' });

var _ref22 = Object(preact_min["h"])(homeTabcommon, { path: '/embed/home/:type' });

var _ref23 = Object(preact_min["h"])(markers, { path: '/embed/our-approaches' });

var _ref24 = Object(preact_min["h"])(sdgTarget, { path: '/embed/sdg/targets/' });

var _ref25 = Object(preact_min["h"])(sdgTarget, { path: '/embed/iucn-programme-area/targets/' });

var _ref26 = Object(preact_min["h"])(embedViews_signature, { path: '/embed/signature' });

var _ref27 = Object(preact_min["h"])(embedViews_sdgLanding, { path: '/embed/sustainable-development-goals/' });

var _ref28 = Object(preact_min["h"])(paLanding, { path: '/embed/iucn-programme-area/' });

var _ref29 = Object(preact_min["h"])(embedViews_sscMarker, { path: '/embed/our-approaches/ssc' });

var _ref30 = Object(preact_min["h"])(iucnProgrammeArea, { path: '/iucn-programme-area' });

var _ref31 = Object(preact_min["h"])(ourApproaches, { path: '/our-approaches' });

var _ref32 = Object(preact_min["h"])(routes_marker["a" /* default */], { path: '/our-approaches/:code' });

var _ref33 = Object(preact_min["h"])(oauth2, { path: '/oauth2/callback' });

var _ref34 = Object(preact_min["h"])(dataImport, { path: '/updation' });

var _ref35 = Object(preact_min["h"])(_04Page["a" /* default */], { 'default': true });

var _ref36 = Object(preact_min["h"])(sscMarker, { path: '/our-approaches/ssc/' });

var _ref37 = Object(preact_min["h"])(_04Page["a" /* default */], { 'default': true });

var _ref38 = Object(preact_min["h"])(
	'h1',
	null,
	'Service is not available now'
);

var _ref39 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var lib__ref__0_routes_Route = function (_Component) {
	lib__ref__0_routes__inherits(Route, _Component);

	function Route() {
		var _temp, _this, _ret;

		lib__ref__0_routes__classCallCheck(this, Route);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = lib__ref__0_routes__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleRoute = function (e) {
			_this.currentUrl = e.url;
		}, _temp), lib__ref__0_routes__possibleConstructorReturn(_this, _ret);
	}

	Route.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		this.props.onAppInit();
		this.props.fetchSystemInfo();
		var token = window.localStorage.token;
		var pathname = window.location.pathname;
		var _ = pathname.split('/').slice(-3);
		if (api["a" /* ADFS_LINK */] && window.location.host != "open.iucn.org") {
			if (_[0] === 'login' && _[1] === 'token' && _[2]) {
				window.localStorage.setItem('token', _[2]);
				window.location.href = api["b" /* HOME_LINK */];
			} else if (!token) {
				window.location.href = api["a" /* ADFS_LINK */];
			}
		}
		setInterval(function () {
			return _this2.props.fetchSystemInfo();
		}, 10000);
	};

	Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.mapCurrentYear != this.props.mapCurrentYear) {
			this.props.fetchMasterSdgList(nextProps.mapCurrentYear);
		}
	};

	Route.prototype.render = function render() {
		var title = 'IUCN Open Project Portal',
		    description = 'At the request of the MoH, IUCN procures a range of medicines and medical products as an emergency measure, and builds the capacity needed to support a transparent, cost-effective procurement system for the Ministry.';
		return Object(preact_min["h"])(
			'div',
			{ id: 'app' },
			Object(preact_min["h"])(Helmet_default.a, {
				meta: [{ property: 'og:type', content: 'website' }, { property: 'twitter:image', content: 'https://image.ibb.co/dSzZDH/open_graph_image.png' }, { property: 'twitter:card', content: 'summary_large_image' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:site_name', content: title }, { property: 'og:image', content: 'https://image.ibb.co/dSzZDH/open_graph_image.png' }, { property: 'og:secure_url', content: 'https://image.ibb.co/dSzZDH/open_graph_image.png' }, { property: 'og:url', content: window.location.href }, { name: 'description', content: description }, { property: 'og:title', content: title }, { property: 'og:description', content: description }, { property: 'twitter:title', content: title }, { property: 'twitter:description', content: description }]
			}),
			this.props.year.length ? Object(preact_min["h"])(
				'div',
				null,
				this.props.systemInfo.status === 1 ? Object(preact_min["h"])(
					preact_router_es["Router"],
					{ onChange: this.handleRoute },
					lib__ref__0_routes__ref,
					lib__ref__0_routes__ref2,
					lib__ref__0_routes__ref3,
					lib__ref__0_routes__ref4,
					lib__ref__0_routes__ref5,
					lib__ref__0_routes__ref6,
					lib__ref__0_routes__ref7,
					lib__ref__0_routes__ref8,
					lib__ref__0_routes__ref9,
					lib__ref__0_routes__ref10,
					lib__ref__0_routes__ref11,
					lib__ref__0_routes__ref12,
					lib__ref__0_routes__ref13,
					lib__ref__0_routes__ref14,
					lib__ref__0_routes__ref15,
					_ref16,
					_ref17,
					_ref18,
					_ref19,
					_ref20,
					_ref21,
					_ref22,
					_ref23,
					_ref24,
					_ref25,
					_ref26,
					_ref27,
					_ref28,
					_ref29,
					_ref30,
					_ref31,
					_ref32,
					_ref33,
					_ref34,
					_ref35,
					_ref36,
					_ref37
				) : Object(preact_min["h"])(
					'div',
					{ style: { height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
					Object(preact_min["h"])(
						'div',
						{ style: { width: '600px', textAlign: 'center' } },
						Object(preact_min["h"])('img', { style: { margin: '0 auto', display: 'block', width: '80px' }, src: '/static/assets/images/logo.png', alt: 'IUCN Logo' }),
						_ref38,
						this.props.systemInfo.status === 3 ? 'System is under maintenance' : 'Data are updating...'
					)
				)
			) : _ref39
		);
	};

	return Route;
}(preact_min["Component"]);

var lib__ref__0_routes_mapStateToProps = function mapStateToProps(state) {
	var year = state.projectTimeline.year;
	var countries = state.countryList.countries;
	var mapCurrentYear = state.mapData.yearTimeline.mapCurrentYear;

	var systemInfo = state.systemInfo.data;
	return {
		state: state,
		year: year,
		countries: countries,
		router: state.router,
		mapCurrentYear: mapCurrentYear,
		systemInfo: systemInfo
	};
};

var lib__ref__0_routes_mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		onChangeRoute: function onChangeRoute(url) {
			return dispatch(Object(routerActions["b" /* onChangeRoute */])(url));
		},
		onAppInit: function onAppInit() {
			return dispatch(Object(commonDataActions["o" /* onAppInit */])());
		},
		fetchMasterSdgList: function fetchMasterSdgList(year) {
			return dispatch(Object(sdgListActions["b" /* fetchMasterSdgList */])(year));
		},
		fetchSystemInfo: function fetchSystemInfo() {
			return dispatch(Object(getSystemInfo["b" /* fetchSystemInfo */])());
		}
	};
};

/* harmony default export */ var lib__ref__0_routes = __webpack_exports__["default"] = (Object(preact_redux_esm["a" /* connect */])(lib__ref__0_routes_mapStateToProps, lib__ref__0_routes_mapDispatchToProps)(lib__ref__0_routes_Route));

/***/ }),

/***/ "RTlb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__S1cwN","imageWrapper":"imageWrapper__1hgxI","sdg_image":"sdg_image__3wpLj","list":"list__2zxsI","value":"value__2F4zH","label":"label__wOqKs","mapContainer":"mapContainer__3qlMn","disclaimer":"disclaimer__hEOfY","chartWrapper":"chartWrapper__33Wcv","recipient_themes_wrapper":"recipient_themes_wrapper__1AcqZ","budget_percent":"budget_percent__3yvju","top_budget_sources_wrapper":"top_budget_sources_wrapper__19_sn","chartHead":"chartHead__2KX5T","infoWrapper":"infoWrapper__1K0g1","tableWrapper":"tableWrapper__RG7JM","titleWrapper":"titleWrapper__22GrA","backButtonTop":"backButtonTop__3n25V"};

/***/ }),

/***/ "RWBV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"themeSlider":"themeSlider__1W67C","closeSlider":"closeSlider__1gStG","headingWrapper":"headingWrapper__2c2se","year":"year__2j9Rg","countryName":"countryName__3MHR-","ssa":"ssa__XItcB","ssLong":"ssLong__3jBVu","iconWrapper":"iconWrapper__3xXll","imageWrapper":"imageWrapper__1nzkY","ssIcon":"ssIcon__26IXK","scrollSection":"scrollSection__1cKfY","theme_slider_wrapper":"theme_slider_wrapper__2jpGn","theme_donut_wrapper":"theme_donut_wrapper__34qVM","theme_slider_title":"theme_slider_title__3ZTTV","grouped_bar_chart":"grouped_bar_chart__kNNrN","display_none":"display_none__1_-3X","outcome_chart_wrapper":"outcome_chart_wrapper__2Srfx","legend_styles":"legend_styles__25CMj","donut_styles":"donut_styles__2NMks","outcome_wrapper_styles":"outcome_wrapper_styles__bcZQi","summarySection":"summarySection__cVP44","summaryDetails":"summaryDetails__2vVB2","summaryHeading":"summaryHeading__1uW8W","textWrapperStyle":"textWrapperStyle__1T_SA","perc":"perc__6I7Go","textFieldStyle":"textFieldStyle__1dnod","donutCenterText":"donutCenterText__7EBXv","dollor":"dollor__1FPeV","legendLabel":"legendLabel__T_Nci","donorWrapper":"donorWrapper__2mpU3","donorDetails":"donorDetails__2aKTV","donor_slider_title_bar":"donor_slider_title_bar__3sUqE","donor_slider_title_wrapper":"donor_slider_title_wrapper__1cytM","budgetSources":"budgetSources__1ree9","budget":"budget__1P7Yk","donorGraph":"donorGraph__1_RRh","donor_country_contribution":"donor_country_contribution__2p9li","outcome_resources_modality":"outcome_resources_modality__23uu7"};

/***/ }),

/***/ "SFpe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3zJMS"};

/***/ }),

/***/ "T/dI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"profile_page_container":"profile_page_container__3c_nZ","wrapper":"wrapper__H-q2W","btnListWrapper":"btnListWrapper__1StJO","btnList":"btnList__2w6-k","active":"active__3G0gN","accessibility":"accessibility__SJ6V9","list":"list__3MPgE","value":"value__2i6pA","label":"label__mArDx","mapWrapper":"mapWrapper__1M_7o","mapSwitchContainer":"mapSwitchContainer__2Wyu_","mapProjectSwitch":"mapProjectSwitch__2lz3o","mapProjectList":"mapProjectList__3m9jN","mapProjectButton":"mapProjectButton__2wlpw","mapProjectItem":"mapProjectItem__3u-y_","mapSwitch":"mapSwitch__3QS51","mapBtn":"mapBtn__3D6xO","listSelected":"listSelected__FgU4U","mapSelected":"mapSelected__1QIiy","mapContainer":"mapContainer__1S3OA","filterWrapper":"filterWrapper__fgpL8","chartWrapper":"chartWrapper__3cyjb","recipient_themes_wrapper":"recipient_themes_wrapper__3LH1N","budget_percent":"budget_percent__3eyAS","windroseWrapper":"windroseWrapper__3HL0k","chartSmall":"chartSmall__3N-oL","chartHead":"chartHead__bF0Es","chartSubHeading":"chartSubHeading__2I3jC","progress":"progress__3zr_L","contribution_wrapper":"contribution_wrapper__321Xv","textWrapperStyle":"textWrapperStyle__X1CK1","groupedBarChart2Wrapper":"groupedBarChart2Wrapper__fuIB6","recipient_charts_wrapper":"recipient_charts_wrapper__3tr1u","wind_rose_wrapper":"wind_rose_wrapper__103kD","top_budget_sources_wrapper":"top_budget_sources_wrapper__1WUE2","budget_sources_wrapper":"budget_sources_wrapper__2W1rn","contribution_other_resource_wrapper":"contribution_other_resource_wrapper__3g3GD","recipientDocumentWrapper":"recipientDocumentWrapper__3Uamw","dropDownWrapper":"dropDownWrapper__3yDLq","disclaimer":"disclaimer__JfAAQ","no_box_shadow":"no_box_shadow__LGMUM","imageWrapper":"imageWrapper__2a5jM","sdg_image":"sdg_image__3X4fd","infoWrapper":"infoWrapper__1rPet","tableWrapper":"tableWrapper__3imp_","SDGdisclaimer":"SDGdisclaimer__3t-1Y"};

/***/ }),

/***/ "TC6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SideBarItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listView__ = __webpack_require__("lo/D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__("Z3dE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_progressBar__ = __webpack_require__("HX72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_numberFormatter__ = __webpack_require__("Au7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_commonActionUtils__ = __webpack_require__("I9r4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_commonMethods__ = __webpack_require__("Cdrj");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SideBarItem = function (_Component) {
  _inherits(SideBarItem, _Component);

  function SideBarItem(props, context) {
    _classCallCheck(this, SideBarItem);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.renderTopRow = function (item) {
      var sdg_src = item.sdg_code && Object(__WEBPACK_IMPORTED_MODULE_6__utils_commonActionUtils__["c" /* getSDGImageFromCode */])(item.sdg_code),
          ssIcon = item.signature_solution ? item.ss_id === '0' ? '/static/assets/icons/placeHolder.svg' : _this.props.apiBase + '/static/assets/icons/sdg/PA-' + item.ss_id + '.svg' : '';
      var programIcon = '/static/assets/icons/placeHolder.svg';
      var newLink = _this.props.tabSelected === 'sdg';
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'section',
        { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.row },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'article',
          { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.columnLeft },
          (item.sdg_code || item.signature_solution) && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { style: item.signature_solution ? 'float:left' : '', 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.imageWrapper },
            _this.props.tabSelected === 'sdg' || _this.props.tabSelected === 'signature' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.sdg_image, src: item.signature_solution ? ssIcon : _this.props.apiBase + ('/static/assets/icons/' + sdg_src), alt: 'sdg image' }) : null,
            _this.props.tabSelected === 'themes' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.sdg_image, src: programIcon, alt: 'sdg image' }) : null
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': item.theme_name ? __WEBPACK_IMPORTED_MODULE_3__style___default.a.themesWrapper : __WEBPACK_IMPORTED_MODULE_3__style___default.a.sdgWrapper },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.theme_wrapper },
              item.theme_name && _this.props.tabSelected === 'themes' && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'a',
                { href: '/themes/' + item.sector + '/' + item.theme_name,
                  target: _this.props.embed ? "_blank" : "", title: item.theme_name, 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.theme_name },
                item.theme_name
              ),
              item.donor_name && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'span',
                { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.theme_name },
                item.donor_name
              ),
              item.sdg_name && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'a',
                { href: '/sdg/' + item.sdg_code + '/' + item.sdg_name,
                  target: _this.props.embed ? "_blank" : "", 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.theme_name },
                item.sdg_name
              ),
              item.signature_solution && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'a',
                { title: item.signature_solution, href: '/programme-area/' + item.ss_id + '/' + item.signature_solution,
                  target: _this.props.embed ? "_blank" : "", 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.theme_name },
                item.signature_solution
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'span',
                { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.theme_point },
                '(' + item.total_projects + ')'
              )
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'section',
              { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.rowMiddle },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'article',
                { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.columnLeft },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'div',
                  { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.percentageFill },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__components_progressBar__["a" /* default */], {
                    tabSelected: _this.props.tabSelected,
                    percentage: item.share_percent,
                    color: item.color })
                )
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.arrowDesktop },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'article',
                  { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.columnRight,
                    onClick: function onClick() {
                      return _this.handleLangChange();
                    } },
                  _this.props.embed ? null : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.theme_next })
                )
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.arrowMobile },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'article',
                  { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.columnRight,
                    onClick: function onClick() {
                      _this.props.selectMap && _this.props.selectMap();
                    } },
                  _this.props.embed ? null : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.theme_map })
                )
              )
            )
          )
        )
      );
    };

    _this.renderMiddleRow = function (item) {

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.textMiddleRow },
        item.theme_name && _this.props.tabSelected === 'themes' && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('p', { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.percentText }),
        item.theme_name && _this.props.tabSelected === 'signature' && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('p', { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.percentText }),
        item.sdg_name && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('p', { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.percentText })
      );
    };

    _this.handleLangChange = function () {
      var flag = true;

      _this.props.onSelectLanguage && _this.props.onSelectLanguage(flag);
    };

    _this.renderBottomRow = function (item) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'section',
        { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.rowBottom },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'article',
          { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.columnLeft },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.theme_content },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { style: _this.state.styles.alloted_budget },
              item.budget ? Object(__WEBPACK_IMPORTED_MODULE_5__utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(item.budget, 2) : Object(__WEBPACK_IMPORTED_MODULE_5__utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(0)
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.content_key },
              'Budget'
            )
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.theme_content },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.content_value },
              item.expense ? Object(__WEBPACK_IMPORTED_MODULE_5__utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(item.expense, 2) : Object(__WEBPACK_IMPORTED_MODULE_5__utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(0)
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { 'class': __WEBPACK_IMPORTED_MODULE_3__style___default.a.content_key },
              'Expenditure'
            )
          )
        )
      );
    };

    _this.state = {
      styles: {
        alloted_budget: {
          color: _this.props.data.color,
          fontSize: 18,
          fontWeight: 600,
          textTransform: 'uppercase'
        }
      }
    };
    return _this;
  }

  SideBarItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {

    this.setState({
      styles: {
        alloted_budget: {
          color: nextProps.data.color,
          fontSize: 18,
          fontWeight: 600,
          textTransform: 'uppercase'
        }
      }
    });
  };

  SideBarItem.prototype.render = function render() {
    var _this2 = this;

    var selectedRow = this.props.data.sdg_name ? this.props.data.sdg_code : this.props.data.sector;
    var type = this.props.data.sdg_name ? "sdg" : "sector";
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'article',
      { className: this.props.selected ? __WEBPACK_IMPORTED_MODULE_3__style___default.a.isActive : __WEBPACK_IMPORTED_MODULE_3__style___default.a.isInActive,
        onClick: function onClick(e) {
          e.stopPropagation();
          _this2.props.selectRow && _this2.props.selectRow(selectedRow, _this2.props.index, type);
        } },
      this.renderTopRow(this.props.data),
      this.renderMiddleRow(this.props.data),
      this.renderBottomRow(this.props.data)
    );
  };

  return SideBarItem;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "UTu5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"legend_wrapper":"legend_wrapper__2gLr0","legendCenter":"legendCenter__2ktFe","legendText":"legendText__3voBJ","legendColor":"legendColor__2rA5S","legendLabel":"legendLabel__17GU7"};

/***/ }),

/***/ "UZkw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("NyMt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grouped_bar_chart__ = __webpack_require__("2On6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__no_data_template__ = __webpack_require__("wdDn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__budget_expense_legend__ = __webpack_require__("COsE");






var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'span',
    null,
    'Top 10 Recipient Countries'
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__budget_expense_legend__["a" /* default */], null);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__no_data_template__["a" /* default */], null);

var generateDonorCharts = function generateDonorCharts(_ref) {
    var topRecipientOffices = _ref.topRecipientOffices,
        embed = _ref.embed,
        displayRecepientOffices = _ref.displayRecepientOffices;

    return (
        // Donor Profile  start
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'section',
            null,
            embed && displayRecepientOffices && displayRecepientOffices === 'true' || !embed ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.wrapper + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.chartWrapper },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'div',
                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.top_budget_sources_wrapper },
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'span',
                        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.chartHead },
                        _ref2,
                        _ref3
                    ),
                    topRecipientOffices.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'div',
                        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.budget_sources_wrapper },
                        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__grouped_bar_chart__["a" /* default */], {
                            chart_id: 'donor_profile_top_recipient_offices',
                            width: 1250,
                            height: 500,
                            min_height: 540,
                            data: topRecipientOffices,
                            label: 'iso3',
                            tspanSize: '12px',
                            textSize: '12px' })
                    ) : _ref4
                )
            ) : null
        )
        // Donor Profile  end

    );
};
/* harmony default export */ __webpack_exports__["a"] = (generateDonorCharts);

/***/ }),

/***/ "UhRM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"text":"text__2RsX9","rect":"rect__3uHGJ","img":"img__3bgZy","sdgImage":"sdgImage__27RRm","sdgCircle":"sdgCircle__3hk4H","toolTip":"toolTip__1CWCM","head":"head__15F0H","sdgWrapper":"sdgWrapper__X5tOt","backButtonContainer":"backButtonContainer__3Awkg","backButton":"backButton__1fkMa","backImg":"backImg__1YqL0","embedArray":"embedArray__2u4R0","leftArray":"leftArray__MAZLU","rightArray":"rightArray__YMyDS","svgIe":"svgIe__2s1Vl"};

/***/ }),

/***/ "V1bQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/projectDetailTable/style.scss
var style = __webpack_require__("/NpY");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/react-bootstrap-table/lib/index.js
var lib = __webpack_require__("X5Y7");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./components/preLoader/index.js
var preLoader = __webpack_require__("ufjx");

// EXTERNAL MODULE: ./components/projectDetailTable/component/style.scss
var component_style = __webpack_require__("4VU6");
var component_style_default = /*#__PURE__*/__webpack_require__.n(component_style);

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// EXTERNAL MODULE: ../node_modules/react-custom-scrollbars/lib/index.js
var react_custom_scrollbars_lib = __webpack_require__("E5f5");
var react_custom_scrollbars_lib_default = /*#__PURE__*/__webpack_require__.n(react_custom_scrollbars_lib);

// CONCATENATED MODULE: ./components/projectDetailTable/component/outputResults.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref3 = Object(preact_min["h"])(
    'h4',
    null,
    'Indicators'
);

var _ref4 = Object(preact_min["h"])(
    'h4',
    null,
    'Baseline'
);

var _ref5 = Object(preact_min["h"])(
    'h4',
    null,
    'Target'
);

var _ref6 = Object(preact_min["h"])(
    'h4',
    null,
    'Result'
);

var _ref7 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var outputResults_OutputResults = function (_Component) {
    _inherits(OutputResults, _Component);

    function OutputResults(props) {
        _classCallCheck(this, OutputResults);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.switchBtn = function (year) {
            var activeOutput = _this.output.filter(function (item, index) {
                return item.year == year;
            });
            _this.setState({ activeYear: year, activeOutput: activeOutput[0] });
        };

        _this.state = {
            yearSpan: [],
            activeYear: null,
            activeOutput: {
                target: [],
                actual: []
            }
        };
        return _this;
    }

    OutputResults.prototype.parseData = function parseData(modalData) {
        this.output = modalData.result_periods.map(function (item, index) {
            return {
                year: new Date(item.period_start).getFullYear(),
                actual: item.actual != null ? item.actual.split('\n') : '',
                target: item.target != null ? item.target.split('\n') : ''
            };
        });
        this.setState({
            yearSpan: modalData.result_period_span,
            activeYear: modalData.result_period_span[0],
            activeOutput: this.output[0]
        });
    };

    OutputResults.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        nextProps.data && this.parseData(nextProps.data);
    };

    OutputResults.prototype.componentDidMount = function componentDidMount() {
        this.props.data && this.parseData(this.props.data);
    };

    OutputResults.prototype.render = function render(_ref, _ref2) {
        var _this2 = this;

        var data = _ref.data;
        var yearSpan = _ref2.yearSpan,
            activeYear = _ref2.activeYear,
            activeOutput = _ref2.activeOutput;

        var indicators = data && data.indicator_description ? data.indicator_description.split('\n') : [];
        var baseline = data && data.baseline_comment ? data.baseline_comment.split('\n') : [];
        return Object(preact_min["h"])(
            'div',
            { 'class': component_style_default.a.modal },
            Object(preact_min["h"])(
                'section',
                { className: component_style_default.a.outerContainer },
                Object(preact_min["h"])(
                    'div',
                    { className: component_style_default.a.modalContainer },
                    Object(preact_min["h"])(
                        'header',
                        { 'class': component_style_default.a.headerWrapper },
                        Object(preact_min["h"])(
                            'h3',
                            { className: component_style_default.a.resultsHeader },
                            'Results'
                        ),
                        Object(preact_min["h"])('span', { className: component_style_default.a.closeBtn, onClick: function onClick() {
                                return _this2.props.onCloseModal();
                            } })
                    ),
                    this.props.data ? Object(preact_min["h"])(
                        'div',
                        { 'class': component_style_default.a.modalContent },
                        Object(preact_min["h"])(
                            react_custom_scrollbars_lib["Scrollbars"],
                            null,
                            Object(preact_min["h"])(
                                'section',
                                { 'class': component_style_default.a.desktop },
                                Object(preact_min["h"])(
                                    'section',
                                    { className: component_style_default.a.yearWrapper },
                                    this.state.yearSpan.map(function (year, index) {
                                        return Object(preact_min["h"])(
                                            'button',
                                            { className: component_style_default.a.yearBtn + ' ' + (year == activeYear ? component_style_default.a.activeYear : ''),
                                                onClick: function onClick() {
                                                    _this2.switchBtn(year);
                                                } },
                                            year
                                        );
                                    })
                                )
                            ),
                            Object(preact_min["h"])(
                                'div',
                                { 'class': component_style_default.a.results_container },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.results_item },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.results_container_wrapper },
                                        Object(preact_min["h"])(
                                            'div',
                                            { 'class': component_style_default.a.detailWrapper },
                                            Object(preact_min["h"])(
                                                'div',
                                                { 'class': component_style_default.a.topHeading },
                                                _ref3
                                            ),
                                            Object(preact_min["h"])(
                                                'ul',
                                                { 'class': component_style_default.a.detailsSection },
                                                indicators.length > 0 ? indicators.map(function (item, indexItem) {
                                                    return Object(preact_min["h"])(
                                                        'li',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'span',
                                                            { 'class': component_style_default.a.textValue },
                                                            item
                                                        )
                                                    );
                                                }) : Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': component_style_default.a.textValue },
                                                    'No data available'
                                                )
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'div',
                                            { 'class': component_style_default.a.detailWrapper },
                                            Object(preact_min["h"])(
                                                'div',
                                                { 'class': component_style_default.a.topHeading },
                                                _ref4
                                            ),
                                            Object(preact_min["h"])(
                                                'ul',
                                                { 'class': component_style_default.a.detailsSection },
                                                baseline.length > 0 ? baseline.map(function (item, indexItem) {
                                                    return Object(preact_min["h"])(
                                                        'li',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'span',
                                                            { 'class': component_style_default.a.textValue },
                                                            item
                                                        )
                                                    );
                                                }) : Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': component_style_default.a.textValue },
                                                    'No data available'
                                                )
                                            )
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.results_item },
                                    Object(preact_min["h"])(
                                        'section',
                                        { 'class': component_style_default.a.mobile },
                                        Object(preact_min["h"])(
                                            'section',
                                            { className: component_style_default.a.yearWrapper },
                                            this.state.yearSpan.map(function (year, index) {
                                                return Object(preact_min["h"])(
                                                    'button',
                                                    { className: component_style_default.a.yearBtn + ' ' + (year == activeYear ? component_style_default.a.activeYear : ''),
                                                        onClick: function onClick() {
                                                            _this2.switchBtn(year);
                                                        } },
                                                    year
                                                );
                                            })
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'footer',
                                        { className: component_style_default.a.footerContainer },
                                        Object(preact_min["h"])(
                                            'div',
                                            { className: component_style_default.a.footerDataWrapper },
                                            _ref5,
                                            Object(preact_min["h"])(
                                                'ul',
                                                { 'class': component_style_default.a.detailsSection },
                                                activeOutput.target.length > 0 ? activeOutput.target.map(function (item, indexItem) {
                                                    return Object(preact_min["h"])(
                                                        'li',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'span',
                                                            { 'class': component_style_default.a.textValue },
                                                            item
                                                        )
                                                    );
                                                }) : Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': component_style_default.a.textValue },
                                                    'No data available'
                                                )
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'div',
                                            { className: component_style_default.a.footerDataWrapper },
                                            _ref6,
                                            Object(preact_min["h"])(
                                                'ul',
                                                { 'class': component_style_default.a.detailsSection },
                                                activeOutput.actual.length > 0 ? activeOutput.actual.map(function (item, indexItem) {
                                                    return Object(preact_min["h"])(
                                                        'li',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'span',
                                                            { 'class': component_style_default.a.textValue },
                                                            item
                                                        )
                                                    );
                                                }) : Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': component_style_default.a.textValue },
                                                    'No data available'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ) : Object(preact_min["h"])(
                        'div',
                        { 'class': component_style_default.a.preloaderWrapper },
                        _ref7
                    )
                )
            )
        );
    };

    return OutputResults;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ./static/assets/json/undpAboutUsData.js
var undpAboutUsData = __webpack_require__("gglo");

// CONCATENATED MODULE: ./components/projectDetailTable/component/expandableRow.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function expandableRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function expandableRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function expandableRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var expandableRow_ScrollSection = function (_Component) {
    expandableRow__inherits(ScrollSection, _Component);

    function ScrollSection() {
        expandableRow__classCallCheck(this, ScrollSection);

        var _this = expandableRow__possibleConstructorReturn(this, _Component.call(this));

        _this.renderSubLevels = function (data) {
            var sectionData = data.map(function (subdata, index) {
                if (typeof subdata.sublevel !== 'undefined') {
                    return Object(preact_min["h"])(
                        'ul',
                        { key: index, 'class': component_style_default.a.sub_section_container },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': component_style_default.a.sub_header },
                            subdata.title
                        ),
                        _this.renderSubLevels(subdata.sublevel)
                    );
                } else {
                    return Object(preact_min["h"])(
                        'li',
                        { 'class': component_style_default.a.sub_section, key: subdata.title + index },
                        Object(preact_min["h"])('img', { src: '/static/assets/icons/bullets.svg', alt: '\\2022', 'class': component_style_default.a.bullet }),
                        subdata.title
                    );
                }
            });
            return sectionData;
        };

        _this.state = {
            overflow: false
        };
        return _this;
    }

    ScrollSection.prototype.componentDidMount = function componentDidMount() {
        if (this['sublevelWrapper' + this.props.index].clientHeight > 145) {
            this.setState({ overflow: true });
        }
    };

    ScrollSection.prototype.renderVerticalTrack = function renderVerticalTrack(props) {
        if (this.state.overflow) {
            return Object(preact_min["h"])('section', _extends({}, props, { 'class': component_style_default.a.track_vertical }));
        } else {
            return Object(preact_min["h"])('section', props);
        }
    };

    ScrollSection.prototype.render = function render() {
        var _this2 = this;

        return Object(preact_min["h"])(
            react_custom_scrollbars_lib["Scrollbars"],
            { 'class': component_style_default.a.sub_level,
                renderTrackVertical: function renderTrackVertical(props) {
                    return _this2.renderVerticalTrack(props);
                },
                renderThumbVertical: function renderThumbVertical(props) {
                    return Object(preact_min["h"])('section', _extends({}, props, { 'class': component_style_default.a.thumb_vertical }));
                },
                renderThumbHorizontal: function renderThumbHorizontal(props) {
                    return Object(preact_min["h"])('section', _extends({}, props, { 'class': component_style_default.a.thumb_horizontal }));
                }
            },
            Object(preact_min["h"])(
                'section',
                { ref: function ref(refs) {
                        return _this2['sublevelWrapper' + _this2.props.index] = refs;
                    } },
                this.renderSubLevels(this.props.marker.sublevel)
            )
        );
    };

    return ScrollSection;
}(preact_min["Component"]);

var expandableRow_ExpandableRow = function (_Component2) {
    expandableRow__inherits(ExpandableRow, _Component2);

    function ExpandableRow(props) {
        expandableRow__classCallCheck(this, ExpandableRow);

        var _this3 = expandableRow__possibleConstructorReturn(this, _Component2.call(this, props));

        _this3.cellTextItem = function (data) {
            return Object(preact_min["h"])(
                'div',
                { 'class': component_style_default.a.cellElement },
                Object(preact_min["h"])('span', { 'class': component_style_default.a.marker }),
                Object(preact_min["h"])(
                    'span',
                    null,
                    data
                )
            );
        };

        _this3.budgetSourcesFormatter = function (cell) {
            var dataArray = cell.map(function (data) {
                return _this3.cellTextItem(data);
            });
            return Object(preact_min["h"])(
                'div',
                null,
                dataArray
            );
        };

        _this3.renderbudgetUtilizationYear = function (cell, row) {
            var dataArray = cell.map(function (data) {
                return Object(preact_min["h"])(
                    'div',
                    { 'class': component_style_default.a.budgetInnerWrapper },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': component_style_default.a.yearColumn },
                        Object(preact_min["h"])(
                            'span',
                            null,
                            data.year
                        )
                    )
                );
            });
            return Object(preact_min["h"])(
                'div',
                { 'class': component_style_default.a.budgetUtiWrapper },
                dataArray
            );
        };

        _this3.renderbudgetUtilizationBudget = function (cell, row) {
            var dataArray = cell.map(function (data) {
                return Object(preact_min["h"])(
                    'div',
                    { 'class': component_style_default.a.budgetInnerWrapper },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': component_style_default.a.yearColumn },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': component_style_default.a.priceColumn },
                            Object(numberFormatter["e" /* numberToDollarFormatter */])(data.total_budget)
                        )
                    )
                );
            });
            return Object(preact_min["h"])(
                'div',
                { 'class': component_style_default.a.budgetUtiWrapper },
                dataArray
            );
        };

        _this3.renderbudgetUtilizationExpense = function (cell) {
            var dataArray = cell.map(function (data) {
                return Object(preact_min["h"])(
                    'div',
                    { 'class': component_style_default.a.budgetInnerWrapper },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': component_style_default.a.yearColumn },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': component_style_default.a.priceColumn },
                            Object(numberFormatter["e" /* numberToDollarFormatter */])(data.total_expense)
                        )
                    )
                );
            });
            return Object(preact_min["h"])(
                'div',
                { 'class': component_style_default.a.budgetUtiWrapper },
                dataArray
            );
        };

        _this3.renderMarkers = function (data) {
            return Object(preact_min["h"])(
                'section',
                { 'class': component_style_default.a.markerSection },
                data.map(function (marker, index) {
                    var imageSrc = _.find(undpAboutUsData["a" /* aboutUsInfo */].data, function (element) {
                        return element.title === marker.title;
                    });
                    imageSrc = imageSrc ? imageSrc.image_2 : '';
                    return Object(preact_min["h"])(
                        'section',
                        { key: 'marker' + index, 'class': component_style_default.a.parentMarkers },
                        Object(preact_min["h"])(
                            'section',
                            { 'class': component_style_default.a.level },
                            Object(preact_min["h"])(
                                'section',
                                { 'class': component_style_default.a.imageSection },
                                Object(preact_min["h"])('img', { 'class': component_style_default.a.headerImage, src: imageSrc })
                            ),
                            Object(preact_min["h"])(
                                'section',
                                { 'class': component_style_default.a.textSection },
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': component_style_default.a.marker_header },
                                    marker.title
                                )
                            )
                        ),
                        Object(preact_min["h"])(expandableRow_ScrollSection, { marker: marker, index: index })
                    );
                })
            );
        };

        _this3.state = {
            data: undefined
        };
        return _this3;
    }

    ExpandableRow.prototype.render = function render(_ref, state) {
        var data = _ref.data;

        return Object(preact_min["h"])(
            'div',
            { 'class': component_style_default.a.parent },
            this.props.data && Object(preact_min["h"])(
                'section',
                { 'class': component_style_default.a.container },
                Object(preact_min["h"])(
                    'section',
                    { 'class': component_style_default.a.marker_container },
                    Object(preact_min["h"])(
                        'section',
                        { 'class': component_style_default.a.parent_container },
                        Object(preact_min["h"])(
                            'section',
                            { style: { width: '100%' }, 'class': component_style_default.a.table_container },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': component_style_default.a.card_container },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.child_item },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.item_title + ' ' + component_style_default.a.textCenter },
                                        'Year'
                                    ),
                                    Object(preact_min["h"])(
                                        'span',
                                        null,
                                        this.renderbudgetUtilizationYear(this.props.data.budget_utilization)
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.child_item },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.item_title + ' ' + component_style_default.a.textCenter },
                                        'Budget'
                                    ),
                                    Object(preact_min["h"])(
                                        'span',
                                        null,
                                        this.renderbudgetUtilizationBudget(this.props.data.budget_utilization)
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.child_item },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.item_title + ' ' + component_style_default.a.textCenter },
                                        'Expenditure'
                                    ),
                                    Object(preact_min["h"])(
                                        'span',
                                        null,
                                        this.renderbudgetUtilizationExpense(this.props.data.budget_utilization)
                                    )
                                )
                            )
                        ),
                        Object(preact_min["h"])(
                            'section',
                            { style: { display: 'none' }, 'class': component_style_default.a.table_container },
                            this.props.data.sector ? Object(preact_min["h"])(
                                'section',
                                { 'class': component_style_default.a.subTables },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.budget_container },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.child_item },
                                        Object(preact_min["h"])(
                                            'div',
                                            { 'class': component_style_default.a.item_title },
                                            'Programme Areas'
                                        ),
                                        Object(preact_min["h"])(
                                            'div',
                                            { 'class': component_style_default.a.budgetBackground },
                                            Object(preact_min["h"])(
                                                'section',
                                                { 'class': component_style_default.a.cellElement },
                                                Object(preact_min["h"])(
                                                    'span',
                                                    null,
                                                    ' ',
                                                    this.props.data.sector,
                                                    ' '
                                                )
                                            )
                                        )
                                    )
                                )
                            ) : null,
                            this.props.signatureSol ? Object(preact_min["h"])(
                                'section',
                                { 'class': component_style_default.a.subTables },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.budget_container },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.child_item },
                                        Object(preact_min["h"])(
                                            'div',
                                            { 'class': component_style_default.a.item_title },
                                            'Signature Solutions'
                                        ),
                                        Object(preact_min["h"])(
                                            'div',
                                            { 'class': component_style_default.a.budgetBackground },
                                            Object(preact_min["h"])(
                                                'section',
                                                { 'class': component_style_default.a.cellElement },
                                                Object(preact_min["h"])(
                                                    'span',
                                                    null,
                                                    ' ',
                                                    this.props.signatureSol,
                                                    ' '
                                                )
                                            )
                                        )
                                    )
                                )
                            ) : null,
                            this.props.data.policy_significance ? Object(preact_min["h"])(
                                'div',
                                { 'class': component_style_default.a.budget_container },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.child_item },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.item_title },
                                        'Policy Marker'
                                    ),
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.budgetBackground },
                                        Object(preact_min["h"])(
                                            'section',
                                            { 'class': component_style_default.a.cellElement },
                                            Object(preact_min["h"])(
                                                'span',
                                                { 'class': component_style_default.a.policyMarker },
                                                ' ',
                                                this.props.data.policy_marker,
                                                ' : '
                                            ),
                                            Object(preact_min["h"])(
                                                'span',
                                                null,
                                                ' ',
                                                this.props.data.policy_significance,
                                                ' '
                                            )
                                        )
                                    )
                                )
                            ) : null
                        )
                    ),
                    Object(preact_min["h"])(
                        'section',
                        { style: { display: 'none' }, 'class': component_style_default.a.parent_container },
                        this.props.marker.data[this.props.index] ? Object(preact_min["h"])(
                            'div',
                            { 'class': component_style_default.a.child },
                            this.props.marker.data[this.props.index].length > 0 ? Object(preact_min["h"])(
                                'div',
                                { 'class': component_style_default.a.item_title },
                                'Our Approach'
                            ) : null,
                            Object(preact_min["h"])(
                                'div',
                                null,
                                this.renderMarkers(this.props.marker.data[this.props.index])
                            )
                        ) : null
                    )
                )
            )
        );
    };

    return ExpandableRow;
}(preact_min["Component"]);

var mapStateToProps = function mapStateToProps(state) {
    return {
        marker: state.markerDetails.output_list_markers
    };
};

/* harmony default export */ var expandableRow = (Object(preact_redux_esm["a" /* connect */])(mapStateToProps)(expandableRow_ExpandableRow));
// EXTERNAL MODULE: ./components/no-data-template/index.js
var no_data_template = __webpack_require__("wdDn");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/outputDetailActions.js
var outputDetailActions = __webpack_require__("mFZF");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/markerDetailsAction.js
var markerDetailsAction = __webpack_require__("x4+R");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/outputResultsActions.js
var outputResultsActions = __webpack_require__("voeE");

// CONCATENATED MODULE: ./static/assets/json/ourputResults.js
var outputResults = {
    "status": 200,
    "success": true,
    "data": [{
        "id": 92,
        "result_periods": [{
            "id": 233,
            "period_start": "2017-01-01",
            "period_end": "2017-12-31",
            "target": "3.  First Aid training and educational standards are unified and integrated into CMSA curriculum.\n5.1\n6.Early warning system established in 14 communities of Syunik region. The Geological Information System (GIS) software with cooperation of AUA and CMSA developed and tested  for the municipalities and MES for further replicated.\n7. DRM strategy adopted by the Government of Armenia.",
            "actual": "5.1\n6.Partially- Early warning system established in 7 communities of Syunik region.\n7.DRM strategy adopted by the Government of Armenia on April 7, 2017.",
            "result": 92
        }, {
            "id": 232,
            "period_start": "2016-01-01",
            "period_end": "2016-12-31",
            "target": "1. DRR Education policy for population mainstreamed into CMSA retraining curriculum.\n2. 0\n3. First Aid training and educational standards are unified and integrated into CMSA curriculum.\n4. 0\n5. 9\n6. Early warning system established in four cities (Center of Yerevan, Stepanavan, Dilijan and Kapan) and cellphone application developed and introduced. Smart city concept for Yerevan, Stepanavan developed and introduced.\n7. DRM capacity assessment conducted and DRM strategy developed based on the recommendations.\n8. The Minimum Initial Service training Package (MISP) developed and  integrated into CMSA professionals’ retraining  curriculum.\n9. City Resilience action plan for Dilijan and Kapan developed and for Stepanavan updated.\n10.3",
            "actual": "1.Available- Concept on DRR Education of Population mainstreamed into CMSA retraining curriculum.\n3.Partially-Inter-ministerial working group is formed and legislative framework is analyzed.\n5.9\n6.Partially-Early warning system established in four cities (Center of Yerevan, Stepanavan, Dilijan and Kapan) and cellphone application developed and introduced. Smart city concept for Yerevan and Stepanavan developed and introduced.\n7.Available-Capacity assessment conducted in cooperation with the World Bank and the Ministry of the Emergency Situations. The  report is developed and endorsed by the Government.\n8.Available- MISP training package developed in cooperation with UNFPA and integrated into CMSA  curriculum.\n9.Available-City Resilience Action Plan for Stepanavan, Dilijan and Kapan cities are developed.\n10.3",
            "result": 92
        }, {
            "id": 231,
            "period_start": "2015-01-01",
            "period_end": "2015-12-31",
            "target": "1. Concept on DRR Education of Population approved\n2. 8\n3. Renovation of the premises of CMSA completed, bio-safety class established and provided with transportation means \n4. 3    \n5. 0\n6. Draft of Smart city concept  for Yerevan city and cellphone application of early warning system developed\n7. Disaster Risk Reduction Strategy  update based on Sendai Framework for action (SFA) initiated\n8. Minimum Initial Service training package integrated into CMSA retraining curriculum\n9. Not applicable",
            "actual": "1. Available-concept on DRR Education of Population approved by the Government\n2. 8\n3. Available-two training packages integrated into curriculum, renovation of premises completed, transportation means provided and mobile bio-safety class  established\n4. 3\n5. 0\n6. Partially-the draft of the Smart city concept for Yerevan and mobile application of early warning system developed and presented to the Government \n7. Partially-thematic working group within DRR National Platform formed and Working  plan for  updating DRR National Strategy based on SFA  developed\n8. Partially - the development of the training package started\n9. Not applicable",
            "result": 92
        }],
        "sector": "Climate Change  Disaster Resilience",
        "result_type": 1,
        "aggregation_status": 1,
        "indicator_title": "Output Indicator",
        "indicator_description": "1. Availability of educational policy on Disaster Risk Reduction (DRR) for population. \n2. Number of Crisis Management Centers decentralized and replicated in the regions of Armenia \n3. Level of technical and educational capacities of the CMSA.\n4. Number of cities that joined City Resilience campaign.\n5. Number of communities where Local Level Risk Management has been conducted and Community Risk Certificate piloted.\n6. Availability of Information Technologies solution for the Disaster Risk Management (DRM)\n7. Availability of Disaster Risk Reduction strategy and Action Plan for 2016-2020 through Disaster Risk Reduction National Platform (DRR National Platform)\n8. Availability of  Minimum Initial Service training package integrated into  disaster management framework\n9. Availability of risk informed urban development plans in Dilijan and Stepanavan\n10.Number of the communities where multi-risk GIS based profile developed.",
        "indicator_measure": 1,
        "indicator_ascending": 0,
        "baseline_year": "2010",
        "baseline_comment": "1. None (2013)\n2. 0 (2014)\n3. Not available- technical and educational capacities at the Crisis Management State Academy CMSA (2013)\n4. 3 (2013)\n5. 12 (2013)\n6. Not available (2014)\n7. Lack of required capacities (2013)\n8. Not available (2013)\n9. Lack of risk informed urban development plans in Dilijan and Stepanavan (2014)\n10.0 (2015)",
        "output": "00076016",
        "project": "00011263"
    }]
};
// CONCATENATED MODULE: ./static/assets/json/outputDetailData.js
var outputDetailData = {
    "success": true,
    "data": {
        "output_id": "00076016",
        "project": "00011263",
        "sector": "Climate Change  Disaster Resilience",
        "budget_sources": ["European Comm. Humanit. Aid Of", "ARM-Syunic Dev. & Invest. Fdn.", "Armenia Government", "National Platform on DRR", "UNITED NATIONS DEVELOPMENT PRO"],
        "policy_marker": "Gender Equality",
        "budget_utilization": [{
            "total_budget": 420000,
            "total_expense": 418762.2,
            "year": 2011
        }, {
            "total_budget": 119458,
            "total_expense": 119363,
            "year": 2013
        }, {
            "total_budget": 37200,
            "total_expense": 22384,
            "year": 2014
        }, {
            "total_budget": 151841,
            "total_expense": 137734,
            "year": 2016
        }, {
            "total_budget": 82152,
            "total_expense": 63570,
            "year": 2017
        }],
        "aid_type": "Project-type interventions"
    },
    "status": 200
};
// EXTERNAL MODULE: ../node_modules/react-ga/dist/react-ga.js
var react_ga = __webpack_require__("Z70r");
var react_ga_default = /*#__PURE__*/__webpack_require__.n(react_ga);

// EXTERNAL MODULE: ./components/nestedCards/style.scss
var nestedCards_style = __webpack_require__("q4r3");
var nestedCards_style_default = /*#__PURE__*/__webpack_require__.n(nestedCards_style);

// EXTERNAL MODULE: ./static/assets/icons/View_Results_Icon.png
var View_Results_Icon = __webpack_require__("XI/t");
var View_Results_Icon_default = /*#__PURE__*/__webpack_require__.n(View_Results_Icon);

// CONCATENATED MODULE: ./components/nestedCards/index.js


function nestedCards__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function nestedCards__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function nestedCards__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var nestedCards__ref3 = Object(preact_min["h"])(
    'span',
    null,
    Object(preact_min["h"])(
        'b',
        null,
        'SDGs: '
    )
);

var nestedCards__ref4 = Object(preact_min["h"])(
    'span',
    null,
    Object(preact_min["h"])(
        'b',
        null,
        'Markers: '
    )
);

var nestedCards__ref5 = Object(preact_min["h"])(
    'tr',
    null,
    Object(preact_min["h"])(
        'th',
        null,
        'Year'
    ),
    Object(preact_min["h"])(
        'th',
        null,
        'Budget'
    ),
    Object(preact_min["h"])(
        'th',
        null,
        'Expenditure'
    )
);

var nestedCards_Card = function (_Component) {
    nestedCards__inherits(Card, _Component);

    function Card(props) {
        nestedCards__classCallCheck(this, Card);

        var _this = nestedCards__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleLessDetailsClick = function () {
            _this.setState({
                genderState: !_this.state.genderState
            }, function () {
                _this.props.fetchProjectOutputDetail(_this.props.data.output_id, _this.props.index);
                _this.props.fetchmarkerDetail(_this.props.data.output_id, _this.props.index);
            });
        };

        _this.handleViewResultsClick = function () {
            _this.props.renderViewDetailPhone(_this.props.data.has_result, _this.props.data, null, _this.props.index);
        };

        _this.generateBudgetSourcesList = function (data) {
            if (data.length) {
                return data.map(function (item) {
                    return Object(preact_min["h"])(
                        'li',
                        null,
                        item
                    );
                });
            }
        };

        _this.renderSubMarkers = function (data) {
            var sectionData = data.map(function (subdata, index) {
                if (typeof subdata.sublevel !== 'undefined') {
                    return Object(preact_min["h"])(
                        'ul',
                        { key: index },
                        Object(preact_min["h"])(
                            'li',
                            { 'class': nestedCards_style_default.a.subheader },
                            subdata.title
                        ),
                        _this.renderSubMarkers(subdata.sublevel)
                    );
                } else {
                    return Object(preact_min["h"])(
                        'li',
                        { 'class': nestedCards_style_default.a.sub_section, key: subdata.title + index },
                        Object(preact_min["h"])('img', { src: '/static/assets/icons/bullets.svg', alt: '\\2022', 'class': nestedCards_style_default.a.bullet }),
                        subdata.title
                    );
                }
            });
            return sectionData;
        };

        _this.renderMarkers = function (data) {
            var sectionData = data.map(function (subdata, index) {
                var imageSrc = _.find(undpAboutUsData["a" /* aboutUsInfo */].data, function (element) {
                    return subdata.title === element.title;
                });
                imageSrc = imageSrc ? imageSrc.image_2 : '';
                return Object(preact_min["h"])(
                    'ul',
                    { key: index },
                    Object(preact_min["h"])('img', { src: imageSrc, style: { width: 20, verticalAlign: 'top' } }),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': nestedCards_style_default.a.header },
                        subdata.title
                    ),
                    _this.renderSubMarkers(subdata.sublevel)
                );
            });
            return Object(preact_min["h"])(
                'section',
                null,
                sectionData
            );
        };

        _this.generateTable = function (data) {
            return data.map(function (element) {
                return Object(preact_min["h"])(
                    'tr',
                    null,
                    Object(preact_min["h"])(
                        'td',
                        null,
                        element.year
                    ),
                    Object(preact_min["h"])(
                        'td',
                        null,
                        Object(numberFormatter["e" /* numberToDollarFormatter */])(element.total_budget)
                    ),
                    Object(preact_min["h"])(
                        'td',
                        null,
                        Object(numberFormatter["e" /* numberToDollarFormatter */])(element.total_expense)
                    )
                );
            });
        };

        _this.state = {
            genderState: false
        };
        return _this;
    }

    Card.prototype.render = function render(_ref, _ref2) {
        var _this2 = this;

        var data = _ref.data,
            fields = _ref.fields;
        var genderState = _ref2.genderState;

        return Object(preact_min["h"])(
            'div',
            { 'class': nestedCards_style_default.a.container },
            Object(preact_min["h"])(
                'div',
                { 'class': nestedCards_style_default.a.innerContainer },
                Object(preact_min["h"])(
                    'div',
                    { 'class': nestedCards_style_default.a.cardDetails },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': '' + nestedCards_style_default.a.title },
                        data.title
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': '' + nestedCards_style_default.a.cardDetails },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': '' + nestedCards_style_default.a.projectId },
                        '# ' + data.output_id
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': nestedCards_style_default.a.cardDetails },
                    Object(preact_min["h"])(
                        'section',
                        { style: { marginTop: 20, marginBottom: 15 } },
                        nestedCards__ref3,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': nestedCards_style_default.a.sdgData },
                            data.sdg ? Object(preact_min["h"])(
                                'span',
                                { 'class': nestedCards_style_default.a.value },
                                data.sdg.map(function (element) {
                                    return Object(preact_min["h"])('img', { style: { width: 35, marginRight: 5 }, src: '/static/assets/icons/' + element + '.svg', alt: element });
                                })
                            ) : null
                        )
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': nestedCards_style_default.a.cardDetails },
                    Object(preact_min["h"])(
                        'div',
                        null,
                        data.description
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': nestedCards_style_default.a.cardDetails },
                    nestedCards__ref4,
                    Object(preact_min["h"])(
                        'span',
                        { 'class': nestedCards_style_default.a.value },
                        data.markers.map(function (element) {
                            var currentMarker = _.find(undpAboutUsData["a" /* aboutUsInfo */].data, function (marker) {
                                return marker.id === element;
                            });
                            return Object(preact_min["h"])('img', { style: { width: 35, marginRight: 5 }, src: currentMarker.img });
                        })
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': nestedCards_style_default.a.cardDetails },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': nestedCards_style_default.a.resultsWrapper },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': nestedCards_style_default.a.results },
                            this.props.data.has_result ? Object(preact_min["h"])('div', { 'class': nestedCards_style_default.a.view_results,
                                onClick: function onClick() {
                                    _this2.handleViewResultsClick();
                                }
                            }) : null
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { onClick: function onClick() {
                                    _this2.handleLessDetailsClick();
                                }, 'class': nestedCards_style_default.a.lessDetails },
                            Object(preact_min["h"])('div', { 'class': !genderState ? '' + nestedCards_style_default.a.moreDetailImage : ' ' + nestedCards_style_default.a.lessDetailImage + ' ' }),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': nestedCards_style_default.a.lessDetailsText },
                                genderState ? 'LESS DETAILS' : 'MORE DETAILS'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': nestedCards_style_default.a.genderEquality, style: genderState ? { display: 'block' } : { display: 'none' } },
                Object(preact_min["h"])(
                    'div',
                    { 'class': nestedCards_style_default.a.budgetSources },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': nestedCards_style_default.a.budgetSourcesHeading },
                        'Donors'
                    ),
                    Object(preact_min["h"])(
                        'ul',
                        null,
                        this.generateBudgetSourcesList(data.output_detail ? data.output_detail.budget_sources ? data.output_detail.budget_sources : [] : [])
                    ),
                    Object(preact_min["h"])(
                        'table',
                        { 'class': nestedCards_style_default.a.budgetTable },
                        nestedCards__ref5,
                        this.generateTable(data.output_detail ? data.output_detail.budget_utilization ? data.output_detail.budget_utilization : [] : [])
                    ),
                    data.sector ? Object(preact_min["h"])(
                        'section',
                        null,
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.budgetSourcesHeading },
                            ' Programme Areas'
                        ),
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.policyMarkerSection },
                            Object(preact_min["h"])(
                                'span',
                                { 'class': nestedCards_style_default.a.policyMarker },
                                ' ',
                                data.sector
                            )
                        )
                    ) : null,
                    data.signature_solution ? Object(preact_min["h"])(
                        'section',
                        null,
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.budgetSourcesHeading },
                            ' Signature Solutions'
                        ),
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.policyMarkerSection },
                            Object(preact_min["h"])(
                                'span',
                                { 'class': nestedCards_style_default.a.policyMarker },
                                ' ',
                                data.signature_solution
                            )
                        )
                    ) : null,
                    data.policy_significance ? Object(preact_min["h"])(
                        'section',
                        null,
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.budgetSourcesHeading },
                            ' Policy Marker'
                        ),
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.policyMarkerSection },
                            Object(preact_min["h"])(
                                'span',
                                { 'class': nestedCards_style_default.a.policyMarker },
                                ' ',
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': nestedCards_style_default.a.policyMarkerHeading },
                                    data.output_detail ? data.output_detail.policy_marker : null
                                ),
                                ' : ',
                                data.output_detail ? data.output_detail.policy_significance : null
                            )
                        )
                    ) : null,
                    this.props.marker.data ? Object(preact_min["h"])(
                        'section',
                        null,
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.budgetSourcesHeading },
                            'Our Approach'
                        ),
                        Object(preact_min["h"])(
                            'section',
                            null,
                            this.renderMarkers(this.props.marker.data)
                        )
                    ) : null
                )
            )
        );
    };

    return Card;
}(preact_min["Component"]);

var nestedCards_mapStateToProps = function mapStateToProps(state) {
    return {
        marker: state.markerDetails
    };
};

/* harmony default export */ var nestedCards = (Object(preact_redux_esm["a" /* connect */])(nestedCards_mapStateToProps)(nestedCards_Card));
// EXTERNAL MODULE: ./utils/commonMethods.js
var commonMethods = __webpack_require__("Cdrj");

// CONCATENATED MODULE: ./components/projectDetailTable/index.js


function projectDetailTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function projectDetailTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function projectDetailTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var projectDetailTable__ref = Object(preact_min["h"])(preLoader["a" /* default */], null);

var projectDetailTable__ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var projectDetailTable__ref4 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var projectDetailTable__ref5 = Object(preact_min["h"])('link', { rel: 'stylesheet', href: 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css' });

var projectDetailTable_ProjectOutputTable = function (_Component) {
    projectDetailTable__inherits(ProjectOutputTable, _Component);

    function ProjectOutputTable(props) {
        projectDetailTable__classCallCheck(this, ProjectOutputTable);

        var _this = projectDetailTable__possibleConstructorReturn(this, _Component.call(this, props));

        _this.imageFormatter = function (cell, row) {
            var imgSrc = [];
            if (cell) {
                if (typeof cell[0] === 'number') {
                    var currentMarker = void 0;
                    cell.forEach(function (element) {
                        currentMarker = _.find(undpAboutUsData["a" /* aboutUsInfo */].data, function (marker) {
                            return marker.id === element;
                        });
                        imgSrc.push(currentMarker ? { src: Object(commonMethods["d" /* getAPIBaseUrRl */])() + currentMarker.image_2, alt: currentMarker.title, type: 1 } : { src: '', alt: '', type: 1 });
                    });
                } else if (typeof cell[0] === 'string') {
                    cell.forEach(function (element) {
                        imgSrc.push({ src: Object(commonMethods["d" /* getAPIBaseUrRl */])() + ('/static/assets/icons/' + element + '.svg'), alt: element, type: 2 });
                    });
                }
            }
            return Object(preact_min["h"])(
                'section',
                { 'class': style_default.a.markerImageSection },
                imgSrc.map(function (element) {
                    return Object(preact_min["h"])('img', { style: { width: element.type === 1 ? 25 : 40, marginLeft: 10, marginBottom: 20 }, src: element.src, alt: element.alt });
                })
            );
        };

        _this.onCloseModal = function () {
            _this.setState({ modalState: false, resultIndex: undefined });
        };

        _this.onRowClick = function (row, cell, rowIndex) {
            _this.props.fetchProjectOutputDetail(row.output_id, rowIndex);
            _this.props.fetchmarkerDetail(row.output_id, rowIndex);
        };

        _this.renderViewDetail = function (cell, row, enumObject, rowIndex) {
            return Object(preact_min["h"])(
                'span',
                { className: style_default.a.viewDetail, onClick: function onClick() {
                        react_ga_default.a.ga('send', 'event', 'Output Results', 'Output ID', row.output_id);
                        if (row.has_result) {
                            _this.props.fetchProjectOutputResults(row.output_id, rowIndex);
                            if (!_this.state.modalState) {
                                _this.setState({ modalState: true, resultIndex: rowIndex });
                                // this.setState({ modalState: true, resultIndex:rowIndex, modalData: row.output_results });
                            }
                        }
                    } },
                cell && Object(preact_min["h"])('span', { 'class': style_default.a.view_results })
            );
        };

        _this.renderViewDetailPhone = function (cell, row, enumObject, rowIndex) {
            react_ga_default.a.ga('send', 'event', 'Output Results', 'Output ID', row.output_id);
            if (row.has_result) {
                _this.props.fetchProjectOutputResults(row.output_id, rowIndex);
                if (!_this.state.modalState) {
                    _this.setState({ modalState: true, resultIndex: rowIndex });
                    // this.setState({ modalState: true, resultIndex:rowIndex, modalData: row.output_results });
                }
            }
        };

        _this.renderThemeColumn = function (cell, row) {
            return Object(preact_min["h"])(
                'span',
                null,
                cell
            );
        };

        _this.isExpandableRow = function (row) {
            return true;
        };

        _this.expandComponent = function (row) {
            if (row.output_detail) {
                return Object(preact_min["h"])(expandableRow, { data: row.output_detail, index: row.id, signatureSol: row.signature_solution });
            } else return Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.preloaderWrapper },
                projectDetailTable__ref
            );
        };

        _this.expandComponentStyle = function (row, rowIndex, isExpanding) {
            if (!isExpanding) {
                //collapsed
                return null;
            } else {
                return style_default.a.selectedRow;
            }
        };

        _this.generateCardList = function (dataArray) {
            if (dataArray.length) {
                return dataArray.map(function (item, index) {
                    return Object(preact_min["h"])(nestedCards, {
                        data: item,
                        index: index,
                        fetchProjectOutputResults: _this.props.fetchProjectOutputResults,
                        fetchProjectOutputDetail: _this.props.fetchProjectOutputDetail,
                        fetchmarkerDetail: _this.props.fetchmarkerDetail,
                        renderViewDetailPhone: _this.renderViewDetailPhone
                    });
                });
            } else {
                return [];
            }
        };

        _this.state = {
            modalState: false,
            resultIndex: undefined,
            modalData: {},
            data: [{
                heading: 'Indicators',
                sub: [{
                    id: 1,
                    text: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.'
                }, {
                    id: 2,
                    text: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.'
                }, {
                    id: 3,
                    text: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.'
                }]
            }, {
                heading: 'Baseline',
                sub: [{
                    id: 1,
                    text: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.'
                }, {
                    id: 2,
                    text: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.'
                }, {
                    id: 3,
                    text: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.'
                }]
            }],
            years: [{
                id: 1,
                year: 2015,
                active: true
            }, {
                id: 2,
                year: 2016,
                active: false
            }],
            popupFooterContent: [{
                id: 1,
                heading: 'Target',
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.'
            }, {
                id: 2,
                heading: 'Result',
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.'
            }]
        };
        return _this;
    }

    ProjectOutputTable.prototype.getSDGColumnWidth = function getSDGColumnWidth() {
        if (!this.props.projectDetail.output_list.loading) {
            var maxLenItem = _.max(this.props.projectDetail.output_list.data, function (o) {
                return o.sdg.length;
            });
            if (maxLenItem && maxLenItem.sdg && maxLenItem.sdg.length >= 3) return '15%';else if (maxLenItem && maxLenItem.sdg && maxLenItem.sdg.length === 2) return '10%';else return '7%';
        }
    };

    ProjectOutputTable.prototype.render = function render(_ref2, state) {
        var _this2 = this;

        var data = _ref2.data;
        var outputs = this.props.projectDetail.output_list.data;
        var loading = this.props.projectDetail.output_list.loading;

        var options = {
            expandBy: 'column',
            expandBodyClass: this.expandComponentStyle,
            onRowClick: this.onRowClick,
            noDataText: loading ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.preloaderWrapper },
                projectDetailTable__ref3
            ) : projectDetailTable__ref4

        };
        var tableData = loading ? [] : this.props.projectDetail.output_list.data;
        tableData && tableData.length != 0 ? tableData = tableData.map(function (element, index) {
            element.id = index;return element;
        }) : [];

        var columns = [{
            dataField: 'output_id',
            text: 'Product ID'
        }, {
            dataField: 'title',
            text: 'Product Name'
        }, {
            dataField: 'start_date',
            text: 'Product Price'
        }, {
            dataField: 'end_date',
            text: 'Product Price'
        }, {
            dataField: 'status',
            text: 'Product Price'
        }];
        return Object(preact_min["h"])(
            'div',
            { 'class': style_default.a.projectList },
            projectDetailTable__ref5,
            Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.tableOuterWrapper },
                Object(preact_min["h"])(
                    lib["BootstrapTable"],
                    {
                        options: options,
                        expandableRow: function expandableRow(row) {
                            return _this2.isExpandableRow(row);
                        },
                        expandComponent: function expandComponent(row) {
                            return _this2.expandComponent(row);
                        },
                        data: loading ? [] : tableData,
                        striped: true,
                        bordered: false,
                        version: '4',
                        headerContainerClass: style_default.a.headerContainerClass,
                        headerStyle: { borderTop: '#337ab7 3px solid', borderBottom: 0, background: '#fffff' },
                        bodyStyle: { height: 'auto', background: '#cccc', marginBottom: 0, paddingRight: 0 },
                        tableBodyClass: style_default.a.tableBodyClass,
                        bodyContainerClass: style_default.a.bodyContainerClass
                    },
                    Object(preact_min["h"])(
                        lib["TableHeaderColumn"],
                        { width: '200',
                            tdStyle: { whiteSpace: 'normal', wordWrap: 'break-word' },
                            dataField: 'output_id', isKey: true },
                        'ID'
                    ),
                    Object(preact_min["h"])(
                        lib["TableHeaderColumn"],
                        { width: '200',
                            tdStyle: { whiteSpace: 'normal', wordWrap: 'break-word' }, dataField: 'title' },
                        'Contract Titles'
                    ),
                    Object(preact_min["h"])(
                        lib["TableHeaderColumn"],
                        { width: '200',
                            tdStyle: { whiteSpace: 'normal', wordWrap: 'break-word' }, dataField: 'budget_sources' },
                        'Donor'
                    ),
                    Object(preact_min["h"])(
                        lib["TableHeaderColumn"],
                        { width: '200',
                            tdStyle: { whiteSpace: 'normal', wordWrap: 'break-word' }, dataField: 'start_date' },
                        'Start Date'
                    ),
                    Object(preact_min["h"])(
                        lib["TableHeaderColumn"],
                        { width: '200',
                            tdStyle: { whiteSpace: 'normal', wordWrap: 'break-word' }, dataField: 'end_date' },
                        'End Date'
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.cardListOuterWrapper },
                this.generateCardList(this.props.projectDetail.output_list.data ? this.props.projectDetail.output_list.data : [])
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.modalWrapper },
                this.state.modalState && state.resultIndex >= 0 &&
                // outputs[state.resultIndex].output_results
                // && Object.keys(outputs[state.resultIndex].output_results).length > 0) &&
                Object(preact_min["h"])(outputResults_OutputResults, { onCloseModal: this.onCloseModal, data: outputs[state.resultIndex].output_results })
            )
        );
    };

    return ProjectOutputTable;
}(preact_min["Component"]);

var projectDetailTable_mapStateToProps = function mapStateToProps(state) {
    return {
        projectDetail: state.projectDetail
    };
};

var projectDetailTable_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchProjectOutputDetail: function fetchProjectOutputDetail(output_id, index) {
            return dispatch(Object(outputDetailActions["b" /* fetchProjectOutputDetail */])(output_id, index));
        },
        fetchmarkerDetail: function fetchmarkerDetail(output_id, index) {
            return dispatch(Object(markerDetailsAction["b" /* fetchmarkerDetail */])(output_id, index));
        },
        fetchProjectOutputResults: function fetchProjectOutputResults(output_id, index) {
            return dispatch(Object(outputResultsActions["b" /* fetchProjectOutputResults */])(output_id, index));
        }
    };
};

/* harmony default export */ var projectDetailTable = __webpack_exports__["a"] = (Object(preact_redux_esm["a" /* connect */])(projectDetailTable_mapStateToProps, projectDetailTable_mapDispatchToProps)(projectDetailTable_ProjectOutputTable));

/***/ }),

/***/ "VSTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__("tokj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__("sqGb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_redux__ = __webpack_require__("E/bI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_numberFormatter__ = __webpack_require__("Au7/");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var AreaChartView = function (_Component) {
    _inherits(AreaChartView, _Component);

    function AreaChartView() {
        _classCallCheck(this, AreaChartView);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.componentWillReceiveProps = function (nextProps) {
            var budget_utilization = nextProps.projectDetail.budget_utilization,
                expense_data = budget_utilization.expense_data,
                budget_data = budget_utilization.budget_data;


            if (nextProps.projectDetail.budget_utilization != _this.props.projectDetail.budget_utilization) {
                _this.setState({
                    budget_utilization: nextProps.projectDetail.budget_utilization
                }, function () {
                    if (expense_data && budget_data) {
                        _this.drawAreaChart();
                    }
                });
            }
        };

        _this.drawAreaChart = function () {
            var widthOfDevice = window.outerWidth;
            var formatxAxis = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.format('.0f');
            var formatyAxis = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.format('');
            var margin = { top: 20, right: 20, bottom: 30, left: 70 },
                height = 250 - margin.top - margin.bottom,
                width = 500 - margin.left - margin.right;
            var x = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.scale.linear().range([0, width]);

            var tickLength = _this.props.projectDetail.budget_utilization.expense_data.length !== 0 ? _this.props.projectDetail.budget_utilization.expense_data.length - 1 : 1;

            var addedHeigth = height + margin.top + margin.bottom;

            var y = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.scale.linear().range([height, 0]);
            var xAxis = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.svg.axis().scale(x).orient("bottom").ticks(tickLength).tickFormat(formatxAxis);

            var yAxis = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.svg.axis().scale(y).orient("left").ticks(5).tickFormat(function (d) {
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(d, 0);
            });

            var areaBudget = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.svg.area().x(function (d) {
                return x(d.year);
            }).y0(height).y1(function (d) {
                return y(d.budget);
            });
            var areaExpense = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.svg.area().x(function (d) {
                return x(d.year);
            }).y0(height).y1(function (d) {
                return y(d.expense);
            });

            var lineFuncExpense = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.svg.line().x(function (d) {
                return x(d.year);
            }).y(function (d) {
                return y(d.expense);
            });
            var lineFuncBudget = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.svg.line().x(function (d) {
                return x(d.year);
            }).y(function (d) {
                return y(d.budget);
            });

            if (!__WEBPACK_IMPORTED_MODULE_1_d3___default.a.select('#area_chart').empty()) {
                __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select('#area_chart' + ' svg').remove();
            }

            var addedWidth = width + margin.left + margin.right;

            var svg = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select("#area_chart").append("svg").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", "0 0 " + addedWidth + " " + addedHeigth).classed('' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.svgContent, true).classed('' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.svgIe, true).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

            var div = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select("#display_label").attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.tooltip).style("opacity", 0);

            x.domain(__WEBPACK_IMPORTED_MODULE_1_d3___default.a.extent(_this.props.projectDetail.budget_utilization.budget_data, function (d) {
                return d.year;
            }));
            y.domain([0, __WEBPACK_IMPORTED_MODULE_1_d3___default.a.max(_this.props.projectDetail.budget_utilization.expense_data, function (d) {
                return d.expense;
            }) > __WEBPACK_IMPORTED_MODULE_1_d3___default.a.max(_this.props.projectDetail.budget_utilization.budget_data, function (d) {
                return d.budget;
            }) ? __WEBPACK_IMPORTED_MODULE_1_d3___default.a.max(_this.props.projectDetail.budget_utilization.expense_data, function (d) {
                return d.expense;
            }) : __WEBPACK_IMPORTED_MODULE_1_d3___default.a.max(_this.props.projectDetail.budget_utilization.budget_data, function (d) {
                return d.budget;
            })]);

            svg.append("path").datum(_this.props.projectDetail.budget_utilization.budget_data).attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.chart_area1).attr("d", areaBudget);

            svg.append("path").datum(_this.props.projectDetail.budget_utilization.budget_data).attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.line_chart1) // with a darker color
            .attr("d", lineFuncBudget);

            svg.append("path").datum(_this.props.projectDetail.budget_utilization.expense_data).attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.chart_area2).attr("d", areaExpense);

            svg.append("path").datum(_this.props.projectDetail.budget_utilization.expense_data).attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.line_chart2) // with a darker color
            .attr("d", lineFuncExpense);

            svg.selectAll("dot").data(_this.props.projectDetail.budget_utilization.budget_data).enter().append("circle").attr("r", 3.5).attr("cx", function (d) {
                return x(d.year);
            }).attr("cy", function (d) {
                return y(d.budget);
            }).attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.budgetDot).on("mouseover", function (d) {
                div.transition().duration(200).style("opacity", 1);

                div.html('<span class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.yearDisplay + '>' + d.year + '</span><div class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.contentWrapper + '><div class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.markerWrapper + '><span class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.budgetMarker + '></span></div><div><span class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.expenseWrapper + '>Budget : ' + Object(__WEBPACK_IMPORTED_MODULE_4__utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(d.budget, 2) + '</span></div></div>').style("left", __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.pageX - 150 + "px").style("top", __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.pageY + "px");
            }).on("mouseout", function (d) {
                div.transition().duration(500).style("opacity", 0);
            });
            svg.selectAll("dot").data(_this.props.projectDetail.budget_utilization.expense_data).enter().append("circle").attr("r", 3.5).attr("cx", function (d) {
                return x(d.year);
            }).attr("cy", function (d) {
                return y(d.expense);
            }).attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.budgetDot).on("mouseover", function (d) {
                div.transition().duration(200).style("opacity", 1);

                div.html('<span class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.yearDisplay + '>' + d.year + '</span><div class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.contentWrapper + '><div class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.markerWrapper + '><span class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.expenseMarker + '></span></div><div><span class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.expenseWrapper + '>Expenditure : ' + Object(__WEBPACK_IMPORTED_MODULE_4__utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(d.expense, 2) + '</span></div></div>').style("left", __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.pageX - 150 + "px").style("top", __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.pageY + "px");
            }).on("mouseout", function (d) {
                div.transition().duration(500).style("opacity", 0);
            });

            svg.append("g").attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.xaxis).attr("transform", "translate(0," + height + ")").call(xAxis);
            //.attr("stroke", "#191818");


            svg.append("g").attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.yaxis).call(yAxis)
            //.attr("stroke", "#191818")
            .append("text").attr("transform", "rotate(-90)").attr("dy", "1em").style("text-anchor", "end");
        };

        _this.state = {
            budget_utilization: {}
        };
        return _this;
    }

    AreaChartView.prototype.componentDidMount = function componentDidMount() {
        var budget_data = this.props.projectDetail.budget_utilization.budget_data,
            expense_data = this.props.projectDetail.budget_utilization.expense_data;
        if (Object.keys(this.props.projectDetail.budget_utilization).length && budget_data && expense_data) this.drawAreaChart();
    };

    AreaChartView.prototype.render = function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { id: 'area_chart', 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.area_chart },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { id: 'display_label', className: __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.tooltip })
        );
    };

    return AreaChartView;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
    return {
        projectDetail: state.projectDetail
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {};
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_preact_redux__["a" /* connect */])(mapStateToProps, mapDispatchToProps)(AreaChartView));

/***/ }),

/***/ "Vhkl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_redux__ = __webpack_require__("E/bI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_map__ = __webpack_require__("wvix");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_areaChart__ = __webpack_require__("VSTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_project_timeline__ = __webpack_require__("OXGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__downloadModal__ = __webpack_require__("ItF+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_no_data_template__ = __webpack_require__("wdDn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_shared_actions_projectDetailActions__ = __webpack_require__("csCp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__donutBarChart__ = __webpack_require__("pwGw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__projectDonutBarChart__ = __webpack_require__("Gnd3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_preact_helmet__ = __webpack_require__("FJnM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_preact_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_preact_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_scss__ = __webpack_require__("JNi8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_d3__ = __webpack_require__("tokj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_d3__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/************************* Preact Files ************************/



/************************* Custom Component Files ************************/








/************************* Third Party  Files ************************/


/************************* Style Files ************************/



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'span',
	null,
	'Budget Utilisation'
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'span',
	null,
	'Budget'
);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'span',
	null,
	'Expenditure'
);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__components_areaChart__["a" /* default */], null);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	null,
	'SATELLITE DATA TEXT'
);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	null,
	'FINAL CONDITION'
);

var ProjectDescription = function (_Component) {
	_inherits(ProjectDescription, _Component);

	function ProjectDescription(props) {
		_classCallCheck(this, ProjectDescription);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.componentDidMount = function () {
			var year = _this.props.mapCurrentYear;
		};

		_this.openModal = function (type) {
			_this.setState({ expand: true, maptype: type });
		};

		_this.closeModal = function () {
			_this.setState({ expand: false });
		};

		_this.changeIframeSrc = function (type) {
			var source = '';
			switch (type) {
				case 'prev':
					if (_this.currentLocationIndex > 0) {
						_this.currentLocationIndex--;
						if (_this.props.satelliteData[_this.currentLocationIndex - 1]) {
							_this.setState({ prevLocation: _this.props.satelliteData[_this.currentLocationIndex - 1] });
							_this.showPrev = true;
						} else {
							_this.setState({ prevLocation: { location: '', source: '' } });
							_this.showPrev = false;
						}
						_this.setState({ currentLocation: _this.props.satelliteData[_this.currentLocationIndex] });
						_this.setState({ nextLocation: _this.props.satelliteData[_this.currentLocationIndex + 1] });
						source = _this.state.currentLocation.source;
					} else {
						_this.setState({ prevLocation: { location: '', source: '' } });
						_this.showPrev = false;
					}
					if (_this.state.nextLocation.source) _this.showNext = true;else _this.showNext = false;

					break;
				case 'next':
					if (_this.currentLocationIndex < _this.props.satelliteData.length - 1) {
						_this.setState({ prevLocation: _this.props.satelliteData[_this.currentLocationIndex] });
						_this.currentLocationIndex++;
						_this.setState({ currentLocation: _this.props.satelliteData[_this.currentLocationIndex] });
						_this.setState({ nextLocation: _this.props.satelliteData[_this.currentLocationIndex + 1] });
						source = _this.state.currentLocation.source;
						_this.showNext = true;
						if (_this.currentLocationIndex === _this.props.satelliteData.length - 1) {
							_this.setState({ nextLocation: { location: '', source: '' } });
							_this.showNext = false;
						}
					} else {
						_this.setState({ nextLocation: { location: '', source: '' } });
						_this.showNext = false;
					}
					if (_this.state.prevLocation.source) _this.showPrev = true;else _this.showPrev = false;
					break;
			}
		};

		_this.countryRegionList = function (dataArray) {
			if (dataArray && dataArray.length) {
				return dataArray.map(function (item, index) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'span',
						null,
						item.country_name,
						dataArray.length - 1 == index ? '' : ',',
						' '
					);
				});
			} else {
				return [];
			}
		};

		_this.state = {
			isInfo: false,
			expand: false,
			mapType: 'map',
			prevLocation: { location: '', source: '' },
			currentLocation: { location: '', source: '' },
			nextLocation: { location: '', source: '' },
			showText: false,
			showTextDesc2: false,
			iucnMember: false,
			iucnNonMember: false
		};
		_this.currentLocationIndex = 0;
		_this.showNext = false;
		_this.showPrev = false;

		return _this;
	}

	ProjectDescription.prototype.changeSatelliteSrc = function changeSatelliteSrc(currentLocationIndex) {
		this.currentLocationIndex = currentLocationIndex;
		if (this.props.satelliteData && this.props.satelliteData.length) {
			if (this.currentLocationIndex === 0) {
				this.setState({ prevLocation: { location: '', source: '' } });
				this.showPrev = false;
			} else {
				this.setState({ prevLocation: this.props.satelliteData[this.currentLocationIndex - 1] });
				this.showPrev = true;
			}
			this.setState({ currentLocation: this.props.satelliteData[this.currentLocationIndex] });
			if (this.props.satelliteData.length > 1 && this.currentLocationIndex !== this.props.satelliteData.length - 1) {
				this.setState({ nextLocation: this.props.satelliteData[this.currentLocationIndex + 1] });
				this.showNext = true;
			} else {
				this.showNext = false;
			}
		}
	};

	ProjectDescription.prototype.setMapType = function setMapType(type) {
		if (type === 'satellite') {
			this.setState({ mapType: 'satellite' });
			if (this.props.satelliteData && this.props.satelliteData.length) {
				this.setState({ prevLocation: { location: '', source: '' } });
				this.setState({ currentLocation: this.props.satelliteData[this.currentLocationIndex] });
				if (this.props.satelliteData.length > 1) {
					this.setState({ nextLocation: this.props.satelliteData[this.currentLocationIndex + 1] });
					this.showNext = true;
				} else {
					this.showNext = false;
				}
			}
		} else {
			this.setState({ mapType: 'map' });
		}
	};

	ProjectDescription.prototype.render = function render(props) {
		var _this2 = this,
		    _ref2;

		var isProjectDetailNonEmpty = Object.keys(this.props.projectDetail.project).length > 0;
		var data = this.props.mapCountryData.outputData.data ? this.props.mapCountryData.outputData.data[0] : [];
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.container, style: { paddingTop: "15px" } },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				{ style: { color: '#191818', fontWeight: "600", marginLeft: "1.4%" } },
				' Project ID: ',
				this.props.projectDetail && this.props.projectDetail.project.project_id,
				'  \xA0  Project Status: ',
				this.props.projectDetail && this.props.projectDetail.project && this.props.projectDetail.project.status,
				' '
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ style: { width: '100%', display: 'flex' } },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ style: { width: '50%', paddingRight: '2%' } },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': 'col-md-12 col-sm-12 col-xs-12', style: { position: 'static' } },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.description },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'p',
								{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.heading },
								'Summary '
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ style: { position: 'absolute' } },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'a',
									{ onClick: function onClick() {
											return _this2.setState({ showText: !_this2.state.showText });
										} },
									this.state.showText ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCircle },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'span',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.minusSign },
											'\u2013'
										)
									) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCircle },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'span',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.plusSign },
											'+'
										)
									)
								)
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ style: { marginLeft: '8%' } },
								!this.state.showText ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'span',
									{ style: { color: '#191818' } },
									this.props.projectDetail.project.description && this.props.projectDetail.project.description.split(" ").splice(0, 9).join(" "),
									'  '
								) : null,
								this.state.showText ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'p',
									null,
									this.props.projectDetail.project.description.split('\n').map(function (item, key) {
										return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'span',
											{ key: key },
											item,
											_ref
										);
									})
								) : null
							)
						),
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.projectStatus },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__components_project_timeline__["a" /* default */], { data: this.props.projectDetail.time_line }),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.arealChart },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.heading, style: (_ref2 = { marginTop: '10px' }, _ref2['marginTop'] = '25px', _ref2) },
									_ref3
								),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.areaHeaderWrapper },
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.legendWrapper },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.legendItemOuterWrapper },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.legendItemInnerWrapper },
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'div',
													{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.itemAlignmentWrapper },
													Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.legend + ' ' + __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.budgetLegend + ' ' }),
													_ref4
												)
											),
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.legendItemInnerWrapper },
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'div',
													{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.itemAlignmentWrapper },
													Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.legend + ' ' + __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.revenueLegend + ' ' }),
													_ref5
												)
											)
										)
									)
								),
								_ref6
							)
						)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ style: { width: '50%' } },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'section',
						null,
						this.state.expand ? this.state.mapType !== 'map' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__downloadModal__["a" /* default */], { onCloseModal: function onCloseModal() {
								return _this2.closeModal();
							}, mapType: this.state.mapType, satelliteData: this.props.satelliteData, currentLocationIndex: this.currentLocationIndex, changeSource: function changeSource(index) {
								return _this2.changeSatelliteSrc(index);
							} })
						// <DownloadModal onCloseModal={() => this.closeModal()} mapType = {this.state.mapType} projectId={this.props.projectId} projectDetailMapData = {data} />
						: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__downloadModal__["a" /* default */], { onCloseModal: function onCloseModal() {
								return _this2.closeModal();
							}, mapType: this.state.mapType, projectId: this.props.projectId, projectDetailMapData: props.projectDetailMapData }) : null
					),
					isProjectDetailNonEmpty && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': 'col-md-12 col-sm-12 col-xs-12' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_10_preact_helmet___default.a, {
							meta: [{ name: 'description', content: this.props.projectDetail.project.description }, { property: 'og:description', content: this.props.projectDetail.project.description }, { property: 'twitter:description', content: this.props.projectDetail.project.description }]
						}),
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': '' + __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.descriptionSection },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.description },
								this.props.projectDetail.project.description_type2 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									null,
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'p',
										{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.heading },
										'Objectives'
									),
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ style: { position: 'absolute' } },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'a',
											{ onClick: function onClick() {
													return _this2.setState({ showTextDesc2: !_this2.state.showTextDesc2 });
												} },
											this.state.showTextDesc2 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCircle },
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'span',
													{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.minusSign },
													'\u2013'
												)
											) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCircle },
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'span',
													{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.plusSign },
													'+'
												)
											)
										)
									),
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ style: { marginLeft: '6%' } },
										!this.state.showTextDesc2 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'span',
											{ style: { color: '#191818' } },
											this.props.projectDetail.project.description_type2 && this.props.projectDetail.project.description_type2.split(" ").splice(0, 9).join(" "),
											'  '
										) : null,
										this.state.showTextDesc2 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'p',
											null,
											this.props.projectDetail.project.description_type2.split('\n').map(function (item, key) {
												return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'span',
													{ key: key },
													item,
													_ref7
												);
											})
										) : null
									)
								) : null
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.mapArea },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.description, style: { margin: '0px', paddingBottom: '20px', borderTopLeftRadius: '14px', borderTopRightRadius: '14px', borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px' } },
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'p',
										{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.heading },
										'Recipient Country / Region',
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'section',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.mapOptions, style: { position: 'relative', float: 'right' } },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'section',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.mapMenu },
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.expandButton, src: './../../static/assets/icons/expand.svg', onClick: function onClick() {
														return _this2.openModal(_this2.state.mapType);
													} })
											)
										)
									),
									this.countryRegionList(this.props.mapCountryData && this.props.mapCountryData.outputData && this.props.mapCountryData.outputData.data)
								),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ style: { 'padding-top': '0px' }, 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.projectMap },
									this.state.mapType === 'map' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__components_map__["a" /* default */], {
										clusterMode: true,
										projectId: this.props.projectId,
										mapData: this.props.projectDetailMapData,
										mapId: 'individualProjectMap',
										autoCenter: true
									}) : this.props.satelliteData.length ? _ref8 : _ref9
								),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.disclaimer },
									'* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'
								)
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.description },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'p',
									{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.heading },
									'Implementing Partners'
								),
								this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation['iucn_members'].length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									null,
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'a',
										{ onClick: function onClick() {
												return _this2.setState({ iucnMember: !_this2.state.iucnMember });
											} },
										this.state.iucnMember ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCirclePartner },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'span',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.minusSign },
												'\u2013'
											)
										) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCirclePartner },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'span',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.plusSign },
												'+'
											)
										),
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'p',
											{ style: { marginLeft: '33px', 'postions': 'absolute', color: '#000' } },
											'IUCN member'
										)
									),
									this.state.iucnMember ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'span',
										null,
										this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation['iucn_members'].join(', ')
									) : null
								) : null,
								this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation['iucn_nonmembers'].length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									null,
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'a',
										{ onClick: function onClick() {
												return _this2.setState({ iucnNonMember: !_this2.state.iucnNonMember });
											} },
										this.state.iucnNonMember ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCirclePartner },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'span',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.minusSign },
												'\u2013'
											)
										) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCirclePartner },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'span',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.plusSign },
												'+'
											)
										),
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'p',
											{ style: { marginLeft: '33px', 'postions': 'absolute', color: '#000' } },
											'IUCN non member'
										)
									),
									this.state.iucnNonMember ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'span',
										null,
										this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation['iucn_nonmembers'].join(', ')
									) : null
								) : null
							)
						)
					)
				)
			)
		);
	};

	return ProjectDescription;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
	var projectDetailMapData = state.mapData.projectDetailMapData;

	var mapCountryData = state.mapData;
	return {
		projectDetail: state.projectDetail,
		projectDetailMapData: projectDetailMapData,
		mapCountryData: mapCountryData
	};
};

var mapDispatch = function mapDispatch(dispatch) {
	return {};
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_preact_redux__["a" /* connect */])(mapStateToProps, mapDispatch)(ProjectDescription));

/***/ }),

/***/ "Vq5U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sankey_container":"sankey_container__34U0R","sankey":"sankey__1d4mf","legend_container":"legend_container__1OrDk","legend_row":"legend_row__MRm3c","legend_row_title":"legend_row_title__wB6em","legend_row_detail":"legend_row_detail__3_0nL","child2":"child2__1mbu5","child3":"child3__2k3L1","child4":"child4__2dkAl"};

/***/ }),

/***/ "XSnv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__Dy0SM"};

/***/ }),

/***/ "YZJ9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progressBar":"progressBar__18wql","progressBarChild":"progressBarChild__3cqRJ","bar_step":"bar_step__ZPSR6","label_line":"label_line__1G6cT","label_txt":"label_txt__THHQn","label_percent":"label_percent__sqJK0","dateWrapper":"dateWrapper___Zw9E","timeLine":"timeLine__17LEM","timeLineWrapper":"timeLineWrapper__3oWjV","headingTimeline":"headingTimeline__id374"};

/***/ }),

/***/ "Z3dE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"isInActive":"isInActive__2hj4F","row":"row__2fMD-","columnLeft":"columnLeft__3OOtl","sdgWrapper":"sdgWrapper__SlCQ9","themeWrapper":"themeWrapper__3senr","theme_wrapper":"theme_wrapper__GcIF3","theme_name":"theme_name__1T9W_","isActive":"isActive__2io-z","rowBottom":"rowBottom__3qdoe","theme_point":"theme_point__1Xa68","theme_content":"theme_content__2FubU","content_key":"content_key__2ukVO","content_value":"content_value__1GDrY","arrowDesktop":"arrowDesktop__2TjGe","arrowMobile":"arrowMobile__2mG0E","columnRight":"columnRight__1AcsK","theme_more":"theme_more__XBVnS","theme_next":"theme_next__2zb2i","theme_map":"theme_map__c1CNB","rowMiddle":"rowMiddle__1F7oj","percentageFill":"percentageFill__1M5j8","imageWrapper":"imageWrapper__3oZBa","sdg_image":"sdg_image__NfxXS","textMiddleRow":"textMiddleRow__116or","percentText":"percentText__ozKq6"};

/***/ }),

/***/ "ZuJw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1zNnS","imageWrapper":"imageWrapper__1hnKm","sdg_image":"sdg_image__1Gz9u","list":"list__1zRhk","value":"value__10Gdc","label":"label__374r4","mapContainer":"mapContainer__2oOqH","disclaimer":"disclaimer__2I2mJ","chartWrapper":"chartWrapper__1BXxx","recipient_themes_wrapper":"recipient_themes_wrapper__35lKP","budget_percent":"budget_percent__OfvTx","top_budget_sources_wrapper":"top_budget_sources_wrapper__34YdU","targetChartWrapper":"targetChartWrapper__3YbgG","chartHead":"chartHead__vMVlA","infoWrapper":"infoWrapper__hrlo_","tableWrapper":"tableWrapper__3hRfa","titleWrapper":"titleWrapper__KsRXc"};

/***/ }),

/***/ "afRJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"donorSlider":"donorSlider__2Wc3X","closeSlider":"closeSlider__1J3PB","budgetList":"budgetList__2Sv8p","tableRow":"tableRow__xc9jl","projectName":"projectName__Z7Nyd","expense":"expense__YHnZE","rowClass":"rowClass__16-o4","headingWrapper":"headingWrapper__3O6YY","dataSection":"dataSection__21n-8","countryName":"countryName__27-WU","year":"year__3DbIC","listHead":"listHead__KJeyQ","donorDetails":"donorDetails__2BxmV","contributionDetails":"contributionDetails__3U42h","summarySection":"summarySection__k10pA","summaryDetails":"summaryDetails__3wFb1","summaryHeading":"summaryHeading__2AaHT","dummyDonor":"dummyDonor__2u8A8","scrollSection":"scrollSection__1oCeF","contributionSplitup":"contributionSplitup__22CsH","contributionSplitupTitle":"contributionSplitupTitle__N71XA","donorWrapper":"donorWrapper__3Gsve","donor_slider_title_bar":"donor_slider_title_bar__3ogtX","donor_slider_title_wrapper":"donor_slider_title_wrapper__jwSAf","budgetSources":"budgetSources__3RpkP","budget":"budget__TB9ZE","donor_chart_wrapper":"donor_chart_wrapper__2zTz9","donorGraph":"donorGraph__2NNFQ","textWrapperStyleOther":"textWrapperStyleOther__l-QVK","textWrapperStyle":"textWrapperStyle__1i9sT","perc":"perc__7zB4l","dollor":"dollor__1cIne","donutCenterOther":"donutCenterOther__DflP9","donutCenterText":"donutCenterText__2DzuJ","donor_wrapper_styles":"donor_wrapper_styles__2vuOu","legend_styles":"legend_styles__-OFot","donut_styles":"donut_styles__1YPPZ","contributionSliderWrapper":"contributionSliderWrapper__14WbW","donorLogo":"donorLogo__3R875","donor_country_contribution":"donor_country_contribution__29zYs","donor_resources_modality":"donor_resources_modality__1XMil"};

/***/ }),

/***/ "ai+R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__RDYLe","list_wrapper":"list_wrapper__ZdUwn","legendOuterWrapper":"legendOuterWrapper__wuGF7","legendInnerWrapper":"legendInnerWrapper__7mLNu","contributionWrapper":"contributionWrapper__21hLB","wrapperItem":"wrapperItem__1esnl","DonorContribution":"DonorContribution___fMHw","allDonorContribution":"allDonorContribution__3SAwD","contributionText":"contributionText__1BrzX"};

/***/ }),

/***/ "cMIP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2xsti","barChart":"barChart__1hrSR","tooltipDonors":"tooltipDonors__69haq","tooltipDisplay":"tooltipDisplay__1vXyt","displayTextWrapper":"displayTextWrapper__1REjv","title":"title__2P-GR","donorName":"donorName__3W47G","bgdEpxArticle":"bgdEpxArticle__3xNtA","bgdEpxSection":"bgdEpxSection__1LOuV","bgtDiv":"bgtDiv__ypyyY","expDiv":"expDiv__1QhSl","innerChartWrapper":"innerChartWrapper__2dSoZ","percentText":"percentText__2Xegf","boldnumber":"boldnumber__ESSmt","mobile_responsive":"mobile_responsive__1wMN3","barChartBlock":"barChartBlock__2HlkT","desktop_responsive":"desktop_responsive__Pj7BW"};

/***/ }),

/***/ "cMmm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"windRoseChart":"windRoseChart__2YDlG","emptyDataDisplay":"emptyDataDisplay__2l2q5","labeWrapper":"labeWrapper__I2Tko","tooltip":"tooltip__11phy","text":"text__1v6WK","textDescription":"textDescription__1ZsXt","actualDescriptionWrapper":"actualDescriptionWrapper__1PxUQ","actual":"actual__2oUTy","target":"target__S8l1B","closeIconWrapper":"closeIconWrapper__1ARLe","closeIcon":"closeIcon__3jyZT","svgIe":"svgIe__qfvTU"};

/***/ }),

/***/ "cN8x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"statsWrapper":"statsWrapper__2LLoT","titleWrapper":"titleWrapper__3_elH","sectionTitle":"sectionTitle__c-bfo","list":"list__2Fh1E","value":"value__3XVVm","label":"label__cBCJX","wrapper":"wrapper__1xaNQ","mapContainer":"mapContainer__1kpkv","disclaimer":"disclaimer__2L-Zf","recipientDocumentWrapper":"recipientDocumentWrapper__2IlvV"};

/***/ }),

/***/ "dIRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export purchaseOrderData */
var purchaseOrderData = [{
  poId: "21336",
  vendor: "DAN Office",
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  date: 'Nov 11, 2017',
  amount: '32000000.00'
}, {
  poId: "21337",
  vendor: "DAN Office",
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  date: 'Nov 11, 2017',
  amount: '64000000.00'
}, {
  poId: "21338",
  vendor: "DAN Office",
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  date: 'Nov 11, 2017',
  amount: '76000000.00'
}];

/***/ }),

/***/ "dXTN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1i_IP","titleWrapper":"titleWrapper__2H227","projectListWrapper":"projectListWrapper__1wBZj","mapWrapper":"mapWrapper__1pwS7","disclaimer":"disclaimer__1cJNI","filterHighlight":"filterHighlight__3atUE","filterTextWrapper":"filterTextWrapper__3tlsm","topographyIconsContainer":"topographyIconsContainer__3EEKz","filterText":"filterText__3nX0r","filterTitle":"filterTitle__1ccme","filterListWrapper":"filterListWrapper__1dq8I","filterInnerWrapper":"filterInnerWrapper__h0O5U","filterLabels":"filterLabels__1kRQB"};

/***/ }),

/***/ "dqug":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * d3.chart.sankey - v0.4.0
 * License: MIT
 * Date: 2017-00-16
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if (true) module.exports = factory(__webpack_require__("tokj"), __webpack_require__("OBrC"));else if (typeof define === 'function' && define.amd) define(["d3", "d3.chart"], factory);else {
		var a = typeof exports === 'object' ? factory(require("d3"), require("d3.chart")) : factory(root["d3"], root["d3"]["chart"]);
		for (var i in a) {
			(typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	}
})(this, function (__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_5__) {
	return (/******/function (modules) {
			// webpackBootstrap
			/******/ // The module cache
			/******/var installedModules = {};

			/******/ // The require function
			/******/function __webpack_require__(moduleId) {

				/******/ // Check if module is in cache
				/******/if (installedModules[moduleId])
					/******/return installedModules[moduleId].exports;

				/******/ // Create a new module (and put it into the cache)
				/******/var module = installedModules[moduleId] = {
					/******/exports: {},
					/******/id: moduleId,
					/******/loaded: false
					/******/ };

				/******/ // Execute the module function
				/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

				/******/ // Flag the module as loaded
				/******/module.loaded = true;

				/******/ // Return the exports of the module
				/******/return module.exports;
				/******/
			}

			/******/ // expose the modules object (__webpack_modules__)
			/******/__webpack_require__.m = modules;

			/******/ // expose the module cache
			/******/__webpack_require__.c = installedModules;

			/******/ // __webpack_public_path__
			/******/__webpack_require__.p = "";

			/******/ // Load entry module and return exports
			/******/return __webpack_require__(0);
			/******/
		}(
		/************************************************************************/
		/******/[
		/* 0 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";
			/*jshint node: true */

			var Sankey = __webpack_require__(1);

			Sankey.Sankey = Sankey;
			Sankey.Base = __webpack_require__(4);
			Sankey.Selection = __webpack_require__(6);
			Sankey.Path = __webpack_require__(7);

			module.exports = Sankey;

			/***/
		},
		/* 1 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";
			/*jshint node: true */

			var d3 = __webpack_require__(2);
			//var sankey = require("d3-plugins-sankey"); // @todo move loader to config and make it work
			var sankey = __webpack_require__(3);
			var Base = __webpack_require__(4);

			module.exports = Base.extend("Sankey", {

				initialize: function initialize() {
					var chart = this;

					chart.d3.sankey = sankey();
					chart.d3.path = chart.d3.sankey.link();
					chart.d3.sankey.size([chart.features.width, chart.features.height]);

					chart.features.spread = false;
					chart.features.iterations = 32;
					chart.features.nodeWidth = chart.d3.sankey.nodeWidth();
					chart.features.nodePadding = chart.d3.sankey.nodePadding();
					chart.features.alignLabel = "auto";

					chart.layers.links = chart.layers.base.append("g").classed("links", true);
					chart.layers.nodes = chart.layers.base.append("g").classed("nodes", true);

					chart.on("change:sizes", function () {
						chart.d3.sankey.nodeWidth(chart.features.nodeWidth);
						chart.d3.sankey.nodePadding(chart.features.nodePadding);
					});

					chart.layer("links", chart.layers.links, {
						dataBind: function dataBind(data) {
							return this.selectAll(".link").data(data.links);
						},

						insert: function insert() {
							return this.append("path").classed("link", true);
						},

						events: {
							"enter": function enter() {
								this.on("mouseover", function (e) {
									chart.trigger("link:mouseover", e);
								});
								this.on("mouseout", function (e) {
									chart.trigger("link:mouseout", e);
								});
								this.on("click", function (e) {
									chart.trigger("link:click", e);
								});
							},

							"merge": function merge() {
								this.attr("d", chart.d3.path).style("stroke", colorLinks).style("stroke-width", function (d) {
									return Math.max(1, d.dy);
								}).sort(function (a, b) {
									return b.dy - a.dy;
								});
							},

							"exit": function exit() {
								this.remove();
							}
						}
					});

					chart.layer("nodes", chart.layers.nodes, {
						dataBind: function dataBind(data) {
							return this.selectAll(".node").data(data.nodes);
						},

						insert: function insert() {
							return this.append("g").classed("node", true).attr("data-node-id", function (d) {
								return d.id;
							});
						},

						events: {
							"enter": function enter() {
								this.append("rect");
								this.append("text").attr("dy", ".85em").attr("transform", null);

								this.on("mouseover", function (e) {
									chart.trigger("node:mouseover", e);
								});
								this.on("mouseout", function (e) {
									chart.trigger("node:mouseout", e);
								});
								this.on("click", function (e) {
									chart.trigger("node:click", e);
								});
							},

							"merge": function merge() {
								this.attr("transform", function (d) {
									return "translate(" + d.x + "," + d.y + ")";
								});

								this.select("rect").attr("height", function (d) {
									return d.dy + 4;
								}).attr("width", chart.features.nodeWidth).style("fill", colorNodes).style("stroke", function (d) {
									return d3.rgb(colorNodes(d)).darker(2);
								});

								this.select("text").text(chart.features.name).style("pointer-events", "none").attr("y", function (d) {
									return d.dy / 2;
								}).attr("x", function (d) {
									return textAnchor(d) === "start" ? 6 + chart.features.nodeWidth : -6;
								}).attr("text-anchor", textAnchor);
							},

							"exit": function exit() {
								this.remove();
							}
						}
					});

					function textAnchor(node) {
						var align = chart.features.alignLabel;
						if (typeof align === "function") {
							align = align(node);
						}
						if (align === "auto") {
							align = node.x < chart.features.width / 2 ? "start" : "end";
						}
						return align;
					}

					function colorNodes(node) {
						if (typeof chart.features.colorNodes === "function") {
							// allow using d3 scales, but also custom function with node as 2nd argument
							return chart.features.colorNodes(chart.features.name(node), node);
						} else {
							return chart.features.colorNodes;
						}
					}

					function colorLinks(link) {
						if (typeof chart.features.colorLinks === "function") {
							// always expect custom function, there"s no sensible default with d3 scales here
							return chart.features.colorLinks(link);
						} else {
							return chart.features.colorLinks;
						}
					}
				},

				transform: function transform(data) {
					var chart = this;

					chart.data = data;

					chart.d3.sankey.nodes(data.nodes).links(data.links).layout(chart.features.iterations);

					if (this.features.spread) {
						this._spreadNodes(data);
						chart.d3.sankey.relayout();
					}

					return data;
				},

				iterations: function iterations(_) {
					if (!arguments.length) {
						return this.features.iterations;
					}
					this.features.iterations = _;

					if (this.data) {
						this.draw(this.data);
					}

					return this;
				},

				nodeWidth: function nodeWidth(_) {
					if (!arguments.length) {
						return this.features.nodeWidth;
					}
					this.features.nodeWidth = _;

					this.trigger("change:sizes");
					if (this.data) {
						this.draw(this.data);
					}

					return this;
				},

				nodePadding: function nodePadding(_) {
					if (!arguments.length) {
						return this.features.nodePadding;
					}
					this.features.nodePadding = _;

					this.trigger("change:sizes");
					if (this.data) {
						this.draw(this.data);
					}

					return this;
				},

				spread: function spread(_) {
					if (!arguments.length) {
						return this.features.spread;
					}
					this.features.spread = _;

					if (this.data) {
						this.draw(this.data);
					}

					return this;
				},

				alignLabel: function alignLabel(_) {
					if (!arguments.length) {
						return this.features.alignLabel;
					}
					this.features.alignLabel = _;

					if (this.data) {
						this.draw(this.data);
					}

					return this;
				},

				_spreadNodes: function _spreadNodes(data) {
					var chart = this,
					    nodesByBreadth = d3.nest().key(function (d) {
						return d.x;
					}).entries(data.nodes).map(function (d) {
						return d.values;
					});

					nodesByBreadth.forEach(function (nodes) {
						var i,
						    node,
						    sum = d3.sum(nodes, function (o) {
							return o.dy;
						}),
						    padding = (chart.features.height - sum) / nodes.length,
						    y0 = 0;
						nodes.sort(function (a, b) {
							return a.y - b.y;
						});
						for (i = 0; i < nodes.length; ++i) {
							node = nodes[i];
							node.y = y0;
							y0 += node.dy + padding;
						}
					});
				}

			});

			/***/
		},
		/* 2 */
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

			/***/
		},
		/* 3 */
		/***/function (module, exports, __webpack_require__) {

			/*** IMPORTS FROM imports-loader ***/
			var d3 = __webpack_require__(2);

			d3.sankey = function () {
				var sankey = {},
				    nodeWidth = 24,
				    nodePadding = 8,
				    size = [1, 1],
				    nodes = [],
				    links = [];

				sankey.nodeWidth = function (_) {
					if (!arguments.length) return nodeWidth;
					nodeWidth = +_;
					return sankey;
				};

				sankey.nodePadding = function (_) {
					if (!arguments.length) return nodePadding;
					nodePadding = +_;
					return sankey;
				};

				sankey.nodes = function (_) {
					if (!arguments.length) return nodes;
					nodes = _;
					return sankey;
				};

				sankey.links = function (_) {
					if (!arguments.length) return links;
					links = _;
					return sankey;
				};

				sankey.size = function (_) {
					if (!arguments.length) return size;
					size = _;
					return sankey;
				};

				sankey.layout = function (iterations) {
					computeNodeLinks();
					computeNodeValues();
					computeNodeBreadths();
					computeNodeDepths(iterations);
					computeLinkDepths();
					return sankey;
				};

				sankey.relayout = function () {
					computeLinkDepths();
					return sankey;
				};

				sankey.link = function () {
					var curvature = .5;

					function link(d) {
						var x0 = d.source.x + d.source.dx,
						    x1 = d.target.x,
						    xi = d3.interpolateNumber(x0, x1),
						    x2 = xi(curvature),
						    x3 = xi(1 - curvature),
						    y0 = d.source.y + d.sy + d.dy / 2,
						    y1 = d.target.y + d.ty + d.dy / 2;
						return "M" + x0 + "," + y0 + "C" + x2 + "," + y0 + " " + x3 + "," + y1 + " " + x1 + "," + y1;
					}

					link.curvature = function (_) {
						if (!arguments.length) return curvature;
						curvature = +_;
						return link;
					};

					return link;
				};

				// Populate the sourceLinks and targetLinks for each node.
				// Also, if the source and target are not objects, assume they are indices.
				function computeNodeLinks() {
					nodes.forEach(function (node) {
						node.sourceLinks = [];
						node.targetLinks = [];
					});
					links.forEach(function (link) {
						var source = link.source,
						    target = link.target;
						if (typeof source === "number") source = link.source = nodes[link.source];
						if (typeof target === "number") target = link.target = nodes[link.target];
						source.sourceLinks.push(link);
						target.targetLinks.push(link);
					});
				}

				// Compute the value (size) of each node by summing the associated links.
				function computeNodeValues() {
					nodes.forEach(function (node) {
						node.value = Math.max(d3.sum(node.sourceLinks, value), d3.sum(node.targetLinks, value));
					});
				}

				// Iteratively assign the breadth (x-position) for each node.
				// Nodes are assigned the maximum breadth of incoming neighbors plus one;
				// nodes with no incoming links are assigned breadth zero, while
				// nodes with no outgoing links are assigned the maximum breadth.
				function computeNodeBreadths() {
					var remainingNodes = nodes,
					    nextNodes,
					    x = 0;

					while (remainingNodes.length) {
						nextNodes = [];
						remainingNodes.forEach(function (node) {
							node.x = x;
							node.dx = nodeWidth;
							node.sourceLinks.forEach(function (link) {
								nextNodes.push(link.target);
							});
						});
						remainingNodes = nextNodes;
						++x;
					}

					//
					moveSinksRight(x);
					scaleNodeBreadths((size[0] - nodeWidth) / (x - 1));
				}

				function moveSourcesRight() {
					nodes.forEach(function (node) {
						if (!node.targetLinks.length) {
							node.x = d3.min(node.sourceLinks, function (d) {
								return d.target.x;
							}) - 1;
						}
					});
				}

				function moveSinksRight(x) {
					nodes.forEach(function (node) {
						if (!node.sourceLinks.length) {
							node.x = x - 1;
						}
					});
				}

				function scaleNodeBreadths(kx) {
					nodes.forEach(function (node) {
						node.x *= kx;
					});
				}

				function computeNodeDepths(iterations) {
					var nodesByBreadth = d3.nest().key(function (d) {
						return d.x;
					}).sortKeys(d3.ascending).entries(nodes).map(function (d) {
						return d.values;
					});

					//
					initializeNodeDepth();
					resolveCollisions();
					for (var alpha = 1; iterations > 0; --iterations) {
						relaxRightToLeft(alpha *= .99);
						resolveCollisions();
						relaxLeftToRight(alpha);
						resolveCollisions();
					}

					function initializeNodeDepth() {
						var ky = d3.min(nodesByBreadth, function (nodes) {
							return (size[1] - (nodes.length - 1) * nodePadding) / d3.sum(nodes, value);
						});

						nodesByBreadth.forEach(function (nodes) {
							nodes.forEach(function (node, i) {
								node.y = i;
								node.dy = node.value * ky;
							});
						});

						links.forEach(function (link) {
							link.dy = link.value * ky;
						});
					}

					// function relaxLeftToRight(alpha) {
					//   nodesByBreadth.forEach(function(nodes, breadth) {
					//     nodes.forEach(function(node) {
					//       if (node.targetLinks.length) {
					//         var y = d3.sum(node.targetLinks, weightedSource) / d3.sum(node.targetLinks, value);
					//         node.y += (y - center(node)) * alpha;
					//       }
					//     });
					//   });

					//   function weightedSource(link) {
					//     return center(link.source) * link.value;
					//   }
					// }
					function relaxLeftToRight(alpha) {
						nodesByBreadth.forEach(function (nodes, breadth) {
							nodes.forEach(function (node) {
								if (node.targetLinks.length) {
									// Value-weighted average of the y-position of source node centers linked to this node.
									// var y = d3.sum(node.targetLinks, weightedSource) / d3.sum(node.targetLinks, value);
									var y = d3.sum(node.targetLinks);
									node.y += (y - center(node)) * alpha;
								}
							});
						});

						function weightedSource(link) {
							return (link.source.y + link.sy + link.dy / 2) * link.value;
						}
					}

					// function relaxRightToLeft(alpha) {
					//   nodesByBreadth.slice().reverse().forEach(function(nodes) {
					//     nodes.forEach(function(node) {
					//       if (node.sourceLinks.length) {
					//         var y = d3.sum(node.sourceLinks, weightedTarget) / d3.sum(node.sourceLinks, value);
					//         node.y += (y - center(node)) * alpha;
					//       }
					//     });
					//   });

					//   function weightedTarget(link) {
					//     return center(link.target) * link.value;
					//   }
					// }
					function relaxRightToLeft(alpha) {
						nodesByBreadth.slice().reverse().forEach(function (nodes) {
							nodes.forEach(function (node) {
								if (node.sourceLinks.length) {
									// Value-weighted average of the y-positions of target nodes linked to this node.
									// var y = d3.sum(node.sourceLinks, weightedTarget) / d3.sum(node.sourceLinks, value);
									var y = d3.sum(node.sourceLinks);
									node.y += (y - center(node)) * alpha;
								}
							});
						});

						function weightedTarget(link) {
							return (link.target.y + link.ty + link.dy / 2) * link.value;
						}
					}

					function resolveCollisions() {
						nodesByBreadth.forEach(function (nodes) {
							var node,
							    dy,
							    y0 = 0,
							    n = nodes.length,
							    i;

							// Push any overlapping nodes down.
							nodes.sort(ascendingDepth);
							for (i = 0; i < n; ++i) {
								node = nodes[i];
								dy = y0 - node.y;
								if (dy > 0) node.y += dy;
								y0 = node.y + node.dy + nodePadding;
							}

							// If the bottommost node goes outside the bounds, push it back up.
							dy = y0 - nodePadding - size[1];
							if (dy > 0) {
								y0 = node.y -= dy;

								// Push any overlapping nodes back up.
								for (i = n - 2; i >= 0; --i) {
									node = nodes[i];
									dy = node.y + node.dy + nodePadding - y0;
									if (dy > 0) node.y -= dy;
									y0 = node.y;
								}
							}
						});
					}

					function ascendingDepth(a, b) {
						return a.y - b.y;
					}
				}

				function computeLinkDepths() {
					nodes.forEach(function (node) {
						node.sourceLinks.sort(ascendingTargetDepth);
						node.targetLinks.sort(ascendingSourceDepth);
					});
					nodes.forEach(function (node) {
						var sy = 0,
						    ty = 0;
						node.sourceLinks.forEach(function (link) {
							link.sy = sy;
							sy += link.dy;
						});
						node.targetLinks.forEach(function (link) {
							link.ty = ty;
							ty += link.dy;
						});
					});

					function ascendingSourceDepth(a, b) {
						return a.source.y - b.source.y;
					}

					function ascendingTargetDepth(a, b) {
						return a.target.y - b.target.y;
					}
				}

				function center(node) {
					return node.y + node.dy / 2;
				}

				function value(link) {
					return link.value;
				}

				return sankey;
			};

			/*** EXPORTS FROM exports-loader ***/
			module.exports = d3.sankey;

			/***/
		},
		/* 4 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";
			/*jshint node: true */

			var d3 = __webpack_require__(2);
			var Chart = __webpack_require__(5);

			/*jshint newcap: false */
			module.exports = Chart("Sankey.Base", {

				initialize: function initialize() {
					var chart = this;

					// Inspired by d3.chart.layout.hierarchy's hierarchy.js, though also different
					chart.features = {};
					chart.d3 = {};
					chart.layers = {};

					// when using faux-dom, be sure to set the width and height attributes
					if (!chart.base.attr("width")) {
						chart.base.attr("width", chart.base.node().parentNode.clientWidth);
					}
					if (!chart.base.attr("height")) {
						chart.base.attr("height", chart.base.node().parentNode.clientHeight);
					}

					// dimensions, with space for node stroke and labels (smallest at bottom)
					chart.features.margins = { top: 1, right: 1, bottom: 6, left: 1 };
					chart.features.width = chart.base.attr("width") - chart.features.margins.left - chart.features.margins.right;
					chart.features.height = chart.base.attr("height") - chart.features.margins.top - chart.features.margins.bottom;

					chart.features.name = function (d) {
						return d.name;
					};
					// there is no value property, because we also need to set it on parents
					chart.features.colorNodes = d3.scale.category20c();
					chart.features.colorLinks = null; // css styles by default

					chart.layers.base = chart.base.append("g").attr("transform", "translate(" + chart.features.margins.left + "," + chart.features.margins.top + ")");
				},

				name: function name(_) {
					if (!arguments.length) {
						return this.features.name;
					}
					this.features.name = _;

					this.trigger("change:name");
					if (this.root) {
						this.draw(this.root);
					}

					return this;
				},

				colorNodes: function colorNodes(_) {
					if (!arguments.length) {
						return this.features.colorNodes;
					}
					this.features.colorNodes = _;

					this.trigger("change:color");
					if (this.root) {
						this.draw(this.root);
					}

					return this;
				},

				colorLinks: function colorLinks(_) {
					if (!arguments.length) {
						return this.features.colorLinks;
					}
					this.features.colorLinks = _;

					this.trigger("change:color");
					if (this.data) {
						this.draw(this.data);
					}

					return this;
				}

			});

			/***/
		},
		/* 5 */
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

			/***/
		},
		/* 6 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";
			/*jshint node: true */

			var Sankey = __webpack_require__(1);

			// Sankey diagram with a hoverable selection
			module.exports = Sankey.extend("Sankey.Selection", {

				initialize: function initialize() {
					var chart = this;

					chart.features.selection = null;
					chart.features.unselectedOpacity = 0.1;

					chart.on("link:mouseover", chart.selection);
					chart.on("link:mouseout", function () {
						chart.selection(null);
					});
					chart.on("node:mouseover", chart.selection);
					chart.on("node:mouseout", function () {
						chart.selection(null);
					});

					// going through the whole draw cycle can be a little slow, so we use
					// a selection changed event to update existing nodes directly
					chart.on("change:selection", updateTransition);
					this.layer("links").on("enter", update);
					this.layer("nodes").on("enter", update);

					function update() {
						/*jshint validthis:true */
						if (chart.features.selection && chart.features.selection.length) {
							return this.style("opacity", function (o) {
								return chart.features.selection.indexOf(o) >= 0 ? 1 : chart.features.unselectedOpacity;
							});
						} else {
							return this.style("opacity", 1);
						}
					}

					function updateTransition() {
						var transition = chart.layers.base.selectAll(".node, .link").transition();
						if (!chart.features.selection || !chart.features.selection.length) {
							// short delay for the deselect transition to avoid flicker
							transition = transition.delay(100);
						}
						update.apply(transition.duration(50));
					}
				},

				selection: function selection(_) {
					if (!arguments.length) {
						return this.features.selection;
					}
					this.features.selection = !_ || _ instanceof Array ? _ : [_];

					this.trigger("change:selection");

					return this;
				},

				unselectedOpacity: function unselectedOpacity(_) {
					if (!arguments.length) {
						return this.features.unselectedOpacity;
					}
					this.features.unselectedOpacity = _;

					this.trigger("change:selection");

					return this;
				}

			});

			/***/
		},
		/* 7 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";
			/*jshint node: true */

			var Selection = __webpack_require__(6);

			// Sankey diagram with a path-hover effect
			module.exports = Selection.extend("Sankey.Path", {

				selection: function selection(_) {
					var chart = this;

					if (!arguments.length) {
						return chart.features.selection;
					}
					chart.features.selection = !_ || _ instanceof Array ? _ : [_];

					// expand selection with connections
					if (chart.features.selection) {
						chart.features.selection.forEach(function (o) {
							getConnections(o).forEach(function (p) {
								chart.features.selection.push(p);
							});
						});
					}

					chart.trigger("change:selection");

					return chart;
				}

			});

			function getConnections(o, direction) {
				if (o.source && o.target) {
					return getConnectionsLink(o, direction);
				} else {
					return getConnectionsNode(o, direction);
				}
			}

			// Return the link and its connected nodes with their links etc.
			function getConnectionsLink(o, direction) {
				var links = [o];
				direction = direction || "both";

				if (direction == "source" || direction == "both") {
					links = links.concat(getConnectionsNode(o.source, "source"));
				}
				if (direction == "target" || direction == "both") {
					links = links.concat(getConnectionsNode(o.target, "target"));
				}

				return links;
			}

			// Return the node and its connected links. If direction is "both", just return
			// all links; if direction is "source", only return the source link when there
			// is one target link (or none, in which case the node is an endnode); if
			// direction is "target" vice versa. Open the product example to see why.
			function getConnectionsNode(o, direction) {
				var links = [o];
				direction = direction || "both";

				if (direction == "source" && o.sourceLinks.length < 2 || direction == "both") {
					o.targetLinks.forEach(function (p) {
						links = links.concat(getConnectionsLink(p, direction));
					});
				}
				if (direction == "target" && o.targetLinks.length < 2 || direction == "both") {
					o.sourceLinks.forEach(function (p) {
						links = links.concat(getConnectionsLink(p, direction));
					});
				}

				return links;
			}

			/***/
		}
		/******/])
	);
});
;

/***/ }),

/***/ "dwnu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3B04m","outcome_chart_wrapper":"outcome_chart_wrapper__3Ux3z","textWrapperStyle":"textWrapperStyle__1w4VZ","textFieldStyle":"textFieldStyle__Y0X-z","imageWrapper":"imageWrapper__1vVpH","sdg_image":"sdg_image__3bWMX","list":"list__22bxw","value":"value__2lzEG","label":"label__JWpjX","mapContainer":"mapContainer__2npl5","disclaimer":"disclaimer__2egRa","chartWrapper":"chartWrapper__2a0EJ","recipient_themes_wrapper":"recipient_themes_wrapper__2WrdO","budget_percent":"budget_percent__1fvb7","top_budget_sources_wrapper":"top_budget_sources_wrapper__32Q9w","chartHead":"chartHead__3wLHQ","infoWrapper":"infoWrapper__2_pMl","tableWrapper":"tableWrapper__10K8N","titleWrapper":"titleWrapper__2ul4s","filterText":"filterText__2fNQe","filterTitle":"filterTitle__Bfbd4","filterTextWrapper":"filterTextWrapper__2y0Gi"};

/***/ }),

/***/ "eJ/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"isInActive":"isInActive__1YDyS","row":"row__1ELhv","columnLeft":"columnLeft__yGl0I","theme_wrapper":"theme_wrapper__2eaMK","donorDataSection":"donorDataSection__21p1u","donorImg":"donorImg__Ju3PU","theme_name":"theme_name__3fxfT","isActive":"isActive__37mXi","rowMiddle":"rowMiddle__27LUF","rowBottom":"rowBottom__1ZYUL","theme_point":"theme_point__KE80x","theme_content":"theme_content__3Fvva","content_key":"content_key__2ZIC6","content_value":"content_value__2V7QX","arrowDesktop":"arrowDesktop__3sbTK","arrowMobile":"arrowMobile__8TOOl","columnRight":"columnRight__-GSL4","theme_more":"theme_more__3huvI","theme_next":"theme_next__2t7dg","theme_map":"theme_map__1EPAU","percentageFill":"percentageFill__OUDMk","percentText":"percentText__2k_95"};

/***/ }),

/***/ "ehfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SDG_SUNBURST_DATA */
/* unused harmony export sdgSunburstDataFetchStart */
/* unused harmony export sdgSunburstDataFetchEnd */
/* unused harmony export sdgSunburstDataClear */
/* unused harmony export sdgSunburstDataFetchSuccess */
/* unused harmony export sdgSunburstDataFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchSdgSunburstData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");


var SDG_SUNBURST_DATA = {
    start: 'fetch_start/sdg_sunburst_data',
    end: 'fetch_end/sdg_sunburst_data',
    success: 'fetch_success/sdg_sunburst_data',
    failed: 'fetch_failed/sdg_sunburst_data',
    clear: 'clear/sdg_sunburst_data'
};

var sdgSunburstDataFetchStart = function sdgSunburstDataFetchStart() {
    return {
        type: SDG_SUNBURST_DATA.start
    };
};

var sdgSunburstDataFetchEnd = function sdgSunburstDataFetchEnd() {
    return {
        type: SDG_SUNBURST_DATA.end
    };
};
var sdgSunburstDataClear = function sdgSunburstDataClear() {
    return {
        type: SDG_SUNBURST_DATA.clear
    };
};

var sdgSunburstDataFetchSuccess = function sdgSunburstDataFetchSuccess(data) {
    return {
        type: SDG_SUNBURST_DATA.success,
        data: data
    };
};

var sdgSunburstDataFetchFailed = function sdgSunburstDataFetchFailed(error) {
    return {
        type: SDG_SUNBURST_DATA.failed,
        error: error
    };
};

var fetchSdgSunburstData = function fetchSdgSunburstData(year) {
    return function (dispatch, getState) {
        dispatch(sdgSunburstDataFetchStart());
        if (year !== '') {
            return __WEBPACK_IMPORTED_MODULE_0__lib_api__["c" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["c" /* default */].API_PA_SUNBURST_DATA(year)).then(function (resp) {
                if (resp.success && resp.data) {
                    resp.data.sdg.map(function (obj) {
                        obj.fullName = obj.name;
                        obj.name = 'PA ' + obj.code;
                        obj.image = '/static/assets/icons/sdg/PA-' + obj.code + '.svg';
                    });
                    var tempData = { name: '', size: 1 };
                    tempData.children = resp.data.sdg;
                    resp.data = tempData;
                    dispatch(sdgSunburstDataFetchEnd());
                    dispatch(sdgSunburstDataFetchSuccess(resp.data));
                } else {
                    dispatch(sdgSunburstDataFetchEnd());
                }
            }).catch(function (exception) {
                dispatch(sdgSunburstDataFetchEnd());
                dispatch(sdgSunburstDataFetchFailed(exception));
            });
        } else {
            dispatch(sdgSunburstDataClear());
            dispatch(sdgSunburstDataFetchEnd());
        }
    };
};

/***/ }),

/***/ "eogv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/horizontalStackedBarChart/style.scss
var style = __webpack_require__("5PBJ");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/d3/d3.js
var d3 = __webpack_require__("tokj");
var d3_default = /*#__PURE__*/__webpack_require__.n(d3);

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// EXTERNAL MODULE: ./components/listView/index.js + 1 modules
var listView = __webpack_require__("lo/D");

// EXTERNAL MODULE: ./components/target-budget-expense-item/style.scss
var target_budget_expense_item_style = __webpack_require__("7QFR");
var target_budget_expense_item_style_default = /*#__PURE__*/__webpack_require__.n(target_budget_expense_item_style);

// CONCATENATED MODULE: ./components/target-budget-expense-item/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var target_budget_expense_item_DonorContributionItem = function (_Component) {
  _inherits(DonorContributionItem, _Component);

  function DonorContributionItem(props, context) {
    _classCallCheck(this, DonorContributionItem);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.tooltipOut = function (data) {
      _this.setState({ showtooltip: false });
    };

    _this.state = {
      styles: {
        targetExpenseWrapper: {
          width: _this.getWidthPercentage(_this.props.data, 'expense') + "%",
          height: 25,
          backgroundColor: "#cae1f7",
          borderLeftWidth: 1,
          borderColor: "#cae1f7",
          verticalAlign: "middle"
        },
        targetBudgetWrapper: {
          width: _this.getWidthPercentage(_this.props.data, 'budget') + "%",
          height: 25,
          backgroundColor: "#42689b",
          borderColor: "#42689b",
          verticalAlign: "middle"
        }
      },
      showtooltip: '',
      tooltipData: '',
      tooltipPosition: [0, 0]
    };
    return _this;
  }

  DonorContributionItem.prototype.getWidthPercentage = function getWidthPercentage(data, type) {
    switch (type) {
      case 'expense':
        return data.expense_percentage === 'NaN' && this.props.section === 'sdgPage' ? 0 : data.expense_percentage;
        break;
      case 'budget':
        return data.target_percentage === 'NaN' && this.props.section === 'sdgPage' ? 0 : data.target_percentage;
        break;
      default:

    }
  };

  DonorContributionItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      styles: {
        targetExpenseWrapper: {
          height: 25,
          verticalAlign: "middle",
          width: this.getWidthPercentage(nextProps.data, 'expense') + "%",
          backgroundColor: "#cae1f7",
          borderLeftWidth: 1,
          borderColor: "#cae1f7"
        },
        targetBudgetWrapper: {
          width: this.getWidthPercentage(nextProps.data, 'budget') + "%",
          height: 25,
          backgroundColor: "#42689b",
          borderColor: "#42689b",
          verticalAlign: "middle"
        }
      }
    });
  };

  DonorContributionItem.prototype.showTooltip = function showTooltip(e, data) {
    this.setState({ showtooltip: true, tooltipData: data, tooltipPosition: [e.clientX, e.clientY] });
  };

  DonorContributionItem.prototype.render = function render() {
    var _this2 = this;

    return Object(preact_min["h"])(
      "section",
      { "class": target_budget_expense_item_style_default.a.wrapper },
      Object(preact_min["h"])(
        "a",
        { onMouseOver: function onMouseOver(e) {
            return _this2.showTooltip(e, _this2.props.data);
          },
          onMouseOut: function onMouseOut() {
            return _this2.tooltipOut(_this2.props.data);
          },
          href: '/programme-area/targets/' + this.props.data.target_id.replace('.', '/'),
          "class": target_budget_expense_item_style_default.a.row },
        'Impact Target ' + this.props.data.target_id
      ),
      Object(preact_min["h"])(
        "div",
        { "class": target_budget_expense_item_style_default.a.row },
        Object(preact_min["h"])(
          "div",
          { "class": target_budget_expense_item_style_default.a.rowWrapper },
          Object(preact_min["h"])("div", {
            "class": target_budget_expense_item_style_default.a.targetBudgetWrapper + " " + target_budget_expense_item_style_default.a.rowWrapperItem,
            style: this.state.styles.targetBudgetWrapper
          }),
          Object(preact_min["h"])(
            "div",
            { "class": target_budget_expense_item_style_default.a.rowText },
            Object(preact_min["h"])(
              "span",
              null,
              Object(numberFormatter["d" /* numberToCurrencyFormatter */])(this.props.data.target_budget, 2)
            )
          )
        ),
        Object(preact_min["h"])(
          "div",
          { "class": target_budget_expense_item_style_default.a.rowWrapper },
          Object(preact_min["h"])("div", {
            "class": target_budget_expense_item_style_default.a.targetExpenseWrapper + " " + target_budget_expense_item_style_default.a.rowWrapperItem,
            style: this.state.styles.targetExpenseWrapper
          }),
          Object(preact_min["h"])(
            "div",
            { "class": target_budget_expense_item_style_default.a.rowText },
            Object(numberFormatter["d" /* numberToCurrencyFormatter */])(this.props.data.target_expense, 2)
          )
        )
      ),
      Object(preact_min["h"])(
        "span",
        {
          "class": this.state.showtooltip ? target_budget_expense_item_style_default.a.tooltipDonors + " " + target_budget_expense_item_style_default.a.otherTooltip : target_budget_expense_item_style_default.a.tooltipDisplay,
          style: { top: this.state.tooltipPosition[1] + "px", left: this.state.tooltipPosition[0] + "px" }
        },
        Object(preact_min["h"])(
          "span",
          { "class": target_budget_expense_item_style_default.a.targetTitle },
          'Impact Target ' + this.state.tooltipData.target_id + ':'
        ),
        Object(preact_min["h"])(
          "span",
          null,
          this.state.tooltipData.target_description
        )
      )
    );
  };

  return DonorContributionItem;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/horizontalStackedBarChart/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return horizontalStackedBarChart_HorizontalStackedBarChart; });


function horizontalStackedBarChart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function horizontalStackedBarChart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function horizontalStackedBarChart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var horizontalStackedBarChart_HorizontalStackedBarChart = function (_Component) {
    horizontalStackedBarChart__inherits(HorizontalStackedBarChart, _Component);

    function HorizontalStackedBarChart() {
        var _temp, _this, _ret;

        horizontalStackedBarChart__classCallCheck(this, HorizontalStackedBarChart);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = horizontalStackedBarChart__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderRow = function (item, index) {
            return Object(preact_min["h"])(target_budget_expense_item_DonorContributionItem, {
                data: item.item,
                index: index,
                section: _this.props.section
            });
        }, _temp), horizontalStackedBarChart__possibleConstructorReturn(_this, _ret);
    }

    HorizontalStackedBarChart.prototype.componentDidMount = function componentDidMount() {
        this._onHorizontalStackedBarChart();
    };

    HorizontalStackedBarChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.data) {
            this._onHorizontalStackedBarChart();
        }
    };

    HorizontalStackedBarChart.prototype.formatChartData = function formatChartData(data) {
        var chartData = [];
        var expense = _.map(data, function (o) {
            return {
                target: {
                    id: o.target_id,
                    name: o.target_id,
                    percentage: o.target_percentage
                },
                count: o.target_expense,
                budget: o.target_budget
            };
        });
        chartData.push({
            data: expense,
            source: 'Expenditure'
        });
        var budget = _.map(data, function (o) {
            return {
                target: {
                    id: o.target_id,
                    name: o.target_id,
                    percentage: o.target_percentage
                },
                count: o.target_budget,
                expense: o.target_budget
            };
        });
        chartData.push({
            data: budget,
            source: 'Budget'
        });

        return chartData;
    };

    HorizontalStackedBarChart.prototype._onHorizontalStackedBarChart = function _onHorizontalStackedBarChart() {
        var thisPropsData = this.props.data;
    };

    HorizontalStackedBarChart.prototype.render = function render() {
        var max = this.props.data.length ? _.max(this.props.data, function (o) {
            return o.target_budget;
        }) : {};
        if (max && max.target_budget) {
            _.map(this.props.data, function (item) {
                var tempPer = (item.target_expense * 100 / item.target_budget).toFixed(2);
                item.expense_percentage = (tempPer * item.target_percentage / 100).toFixed(2);;
            });
        }
        return Object(preact_min["h"])(
            'div',
            { 'class': style_default.a.hStackedBar_chart,
                id: this.props.chart_id },
            Object(preact_min["h"])(listView["a" /* default */], {
                data: this.props.data,
                renderItem: this.renderRow
            })
        );
    };

    return HorizontalStackedBarChart;
}(preact_min["Component"]);



/***/ }),

/***/ "fuiZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"financialTab":"financialTab__1ydKo","loaderWrapper":"loaderWrapper__2m5b5","switch":"switch__N2ogT","switchLabel":"switchLabel__UEx5x","switchLabeloff":"switchLabeloff__1hIOg","switchLabelon":"switchLabelon__VY3Zy","switchInput":"switchInput__3Ivs1","switchSelection":"switchSelection__2vPq7","buttonsWrapper":"buttonsWrapper__2g9YJ","buttons":"buttons__2vN43","yearWrapper":"yearWrapper__1OhZm","pageSizeModal":"pageSizeModal__3jyVz","dropDownWrapper":"dropDownWrapper__8HKdF"};

/***/ }),

/***/ "gEA8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/listView/index.js + 1 modules
var listView = __webpack_require__("lo/D");

// EXTERNAL MODULE: ./components/sideBarItem/index.js
var sideBarItem = __webpack_require__("TC6b");

// EXTERNAL MODULE: ./components/sideBarItemDonors/index.js
var sideBarItemDonors = __webpack_require__("udqz");

// EXTERNAL MODULE: ./components/preLoader/index.js
var preLoader = __webpack_require__("ufjx");

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ./components/allThemesBar/style.scss
var style = __webpack_require__("LBG8");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// CONCATENATED MODULE: ./components/allThemesBar/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var allThemesBar_AllThemesBar = function (_Component) {
	_inherits(AllThemesBar, _Component);

	function AllThemesBar() {
		var _temp, _this, _ret;

		_classCallCheck(this, AllThemesBar);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderBottomRow = function () {
			var projectDetails = _this.props.data;
			return Object(preact_min["h"])(
				'section',
				{ 'class': style_default.a.rowBottom },
				Object(preact_min["h"])(
					'article',
					{ 'class': style_default.a.columnLeft },
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.all_theme_content },
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.content_value },
							projectDetails && projectDetails.budget ? Object(numberFormatter["d" /* numberToCurrencyFormatter */])(projectDetails.budget, 2) : '-'
						),
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.content_key },
							'Total Budget'
						)
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.all_theme_content },
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.content_value },
							projectDetails && projectDetails.expense ? Object(numberFormatter["d" /* numberToCurrencyFormatter */])(projectDetails.expense, 2) : '-'
						),
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.content_key },
							'Total Expenditure'
						)
					)
				)
			);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	AllThemesBar.prototype.render = function render() {
		var _this2 = this;

		return Object(preact_min["h"])(
			'article',
			{ className: this.props.selected === -1 ? style_default.a.isActive : style_default.a.isInActive, onClick: function onClick() {
					return _this2.props.selectRow(_this2.props.index);
				} },
			this.renderBottomRow(this.props.data)
		);
	};

	return AllThemesBar;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/DonorSlider/style.scss
var DonorSlider_style = __webpack_require__("afRJ");
var DonorSlider_style_default = /*#__PURE__*/__webpack_require__.n(DonorSlider_style);

// EXTERNAL MODULE: ../node_modules/react-custom-scrollbars/lib/index.js
var lib = __webpack_require__("E5f5");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./components/donutChart/index.js
var donutChart = __webpack_require__("nZhv");

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ./components/contribution-indicator/index.js
var contribution_indicator = __webpack_require__("/HVV");

// EXTERNAL MODULE: ./components/no-data-template/index.js
var no_data_template = __webpack_require__("wdDn");

// EXTERNAL MODULE: ./static/assets/json/legendData.js
var legendData = __webpack_require__("PHpd");

// EXTERNAL MODULE: ./utils/commonMethods.js
var commonMethods = __webpack_require__("Cdrj");

// EXTERNAL MODULE: ./components/donor-contribution-chart/index.js + 1 modules
var donor_contribution_chart = __webpack_require__("98F3");

// CONCATENATED MODULE: ./components/DonorSlider/index.js


function DonorSlider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DonorSlider__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function DonorSlider__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var DonorSlider__ref = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref2 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref3 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref4 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var DonorSlider_DonorSlider = function (_Component) {
  DonorSlider__inherits(DonorSlider, _Component);

  function DonorSlider() {
    var _temp, _this, _ret;

    DonorSlider__classCallCheck(this, DonorSlider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = DonorSlider__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderRow = function (item, index) {
      return Object(preact_min["h"])(
        'div',
        { 'class': DonorSlider_style_default.a.tableRow },
        Object(preact_min["h"])(
          'a',
          {
            href: '/profile/' + item.item.ref_id + '/donorprofile',
            'class': DonorSlider_style_default.a.projectName },
          item.item.org_name
        ),
        Object(preact_min["h"])(
          'span',
          { 'class': DonorSlider_style_default.a.expense },
          Object(numberFormatter["e" /* numberToDollarFormatter */])(item.item.total_budget)
        )
      );
    }, _temp), DonorSlider__possibleConstructorReturn(_this, _ret);
  }

  DonorSlider.prototype.render = function render() {
    var _this2 = this;

    var data = this.props.data,
        basicDetails = data.basicDetails,
        budgetSources = data.budgetSources,
        regularAndOthers = data.regularAndOthers,
        resourcesModalityContribution = data.resourcesModalityContribution,
        topRecipientOffices = data.topRecipientOffices,
        isLoading = basicDetails.loading || budgetSources.loading || regularAndOthers.loading || resourcesModalityContribution.loading || topRecipientOffices.loading;
    var imgSrc = basicDetails.data.level_3_type ? Object(commonMethods["d" /* getAPIBaseUrRl */])() + '/static/assets/flag_icons/' + basicDetails.data.level_3_type + '.svg' : '';
    return Object(preact_min["h"])(
      'div',
      null,
      !isLoading ? Object(preact_min["h"])(
        'div',
        { 'class': DonorSlider_style_default.a.donorSlider },
        Object(preact_min["h"])(
          'div',
          { 'class': DonorSlider_style_default.a.headingWrapper },
          Object(preact_min["h"])('span', { 'class': DonorSlider_style_default.a.closeSlider, onClick: function onClick() {
              return _this2.props.closeSlider();
            } }),
          Object(preact_min["h"])(
            'section',
            { 'class': DonorSlider_style_default.a.dataSection },
            Object(preact_min["h"])('img', { src: imgSrc,
              onError: function onError(e) {
                e.target.src = '/static/assets/images/Empty.svg';
              },
              'class': DonorSlider_style_default.a.donorLogo }),
            Object(preact_min["h"])(
              'a',
              { 'class': DonorSlider_style_default.a.countryName,
                href: '/profile/' + basicDetails.data.code + '/donorprofile'
              },
              basicDetails.data.donor_name
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': DonorSlider_style_default.a.scrollSection },
          Object(preact_min["h"])(
            lib["Scrollbars"],
            null,
            Object(preact_min["h"])(
              'div',
              { 'class': DonorSlider_style_default.a.year },
              basicDetails.data.year
            ),
            Object(preact_min["h"])('div', { 'class': DonorSlider_style_default.a.donorWrapper }),
            Object(preact_min["h"])(
              'div',
              { 'class': DonorSlider_style_default.a.donorWrapper },
              Object(preact_min["h"])(
                'div',
                { 'class': DonorSlider_style_default.a.donorDetails },
                Object(preact_min["h"])(
                  'span',
                  { 'class': DonorSlider_style_default.a.donor_slider_title_bar },
                  'Contribution to Project Agreements and Institutional'
                ),
                resourcesModalityContribution && resourcesModalityContribution.data && resourcesModalityContribution.data.country && resourcesModalityContribution.data.country.length > 0 ? Object(preact_min["h"])(
                  'div',
                  { 'class': DonorSlider_style_default.a.donor_chart_wrapper + ' ' + DonorSlider_style_default.a.donor_resources_modality },
                  Object(preact_min["h"])(donutChart["a" /* default */], {
                    donor_wrapper_styles: DonorSlider_style_default.a.donor_wrapper_styles,
                    donut_styles: DonorSlider_style_default.a.donut_styles,
                    legend_styles: DonorSlider_style_default.a.legend_styles,
                    textWrapperStyle: DonorSlider_style_default.a.textWrapperStyle,
                    donutCenterText: DonorSlider_style_default.a.donutCenterText,
                    data: resourcesModalityContribution.data.country,
                    legendData: resourcesModalityContribution.data.total,
                    chartWidth: 560,
                    chartHeight: 400, chart_id: 'resources_modality' })
                ) : DonorSlider__ref
              )
            ),
            Object(preact_min["h"])(
              'div',
              { className: DonorSlider_style_default.a.contributionSplitup },
              Object(preact_min["h"])(
                'span',
                { className: DonorSlider_style_default.a.contributionSplitupTitle },
                'Contribution - ' + basicDetails.data.donor_name + ' vs All Donors'
              ),
              this.props.data.resourcesModalityContribution.data.country && this.props.data.resourcesModalityContribution.data.country.length > 0 ? Object(preact_min["h"])(
                'div',
                null,
                Object(preact_min["h"])(donor_contribution_chart["a" /* default */], {
                  data: this.props.data.resourcesModalityContribution.data.total,
                  country: basicDetails.data.donor_name
                })
              ) : _ref2
            ),
            Object(preact_min["h"])(
              'div',
              { 'class': DonorSlider_style_default.a.donorWrapper },
              Object(preact_min["h"])(
                'div',
                { 'class': DonorSlider_style_default.a.donorDetails },
                Object(preact_min["h"])(
                  'span',
                  { 'class': DonorSlider_style_default.a.donor_slider_title_bar + ' ' + DonorSlider_style_default.a.donor_slider_title_wrapper },
                  Object(preact_min["h"])(
                    'span',
                    { 'class': DonorSlider_style_default.a.budgetSources },
                    'Donors'
                  ),
                  Object(preact_min["h"])(
                    'span',
                    { 'class': DonorSlider_style_default.a.budget },
                    'Budget'
                  )
                ),
                data.budgetSources.data.length > 0 ? Object(preact_min["h"])(
                  'div',
                  { 'class': DonorSlider_style_default.a.budgetList },
                  Object(preact_min["h"])(listView["a" /* default */], {
                    rowClass: DonorSlider_style_default.a.rowClass,
                    data: data.budgetSources.data,
                    renderItem: this.renderRow
                  })
                ) : _ref3
              )
            )
          )
        )
      ) : Object(preact_min["h"])(
        'div',
        { style: { position: 'relative', height: 544 } },
        _ref4
      )
    );
  };

  return DonorSlider;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/themeSlider/style.scss
var themeSlider_style = __webpack_require__("RWBV");
var themeSlider_style_default = /*#__PURE__*/__webpack_require__.n(themeSlider_style);

// EXTERNAL MODULE: ./components/grouped-bar-chart/index.js
var grouped_bar_chart = __webpack_require__("2On6");

// EXTERNAL MODULE: ./components/budget-expense-legend/index.js
var budget_expense_legend = __webpack_require__("COsE");

// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// EXTERNAL MODULE: ./components/percentageBarChart/barElement/style.scss
var barElement_style = __webpack_require__("cMIP");
var barElement_style_default = /*#__PURE__*/__webpack_require__.n(barElement_style);

// CONCATENATED MODULE: ./components/percentageBarChart/barElement/index.js


function barElement__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function barElement__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function barElement__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var barElement_BarElement = function (_Component) {
	barElement__inherits(BarElement, _Component);

	function BarElement(props) {
		barElement__classCallCheck(this, BarElement);

		var _this = barElement__possibleConstructorReturn(this, _Component.call(this, props));

		_this.tooltipHover = function (e, data) {
			_this.setState({ showtooltip: true, tooltipData: data, tooltipPosition: [e.clientX, e.clientY] });
		};

		_this.tooltipOut = function (data) {
			_this.setState({ showtooltip: false });
		};

		_this.renderPercentageBar = function (data) {
			var _h;

			return Object(preact_min["h"])(
				'div',
				{ 'class': barElement_style_default.a.barChart },
				Object(preact_min["h"])(
					'div',
					{ 'class': barElement_style_default.a.displayTextWrapper + ' ' + barElement_style_default.a.mobile_responsive },
					Object(preact_min["h"])(
						'div',
						{ 'class': barElement_style_default.a.title },
						Object(preact_min["h"])(
							'a',
							(_h = { 'class': barElement_style_default.a.donorName,
								target: _this.props.embed ? "_blank" : "",
								href: '/profile/' + data.donor_code + '/donorprofile' }, _h['target'] = true, _h),
							data.name
						)
					)
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': barElement_style_default.a.container },
					Object(preact_min["h"])('div', { 'class': barElement_style_default.a.innerChartWrapper, style: { width: data.target_percentage + '%' } }),
					Object(preact_min["h"])(
						'div',
						{ 'class': barElement_style_default.a.percentText },
						Math.round(data.target_percentage * 10) / 10,
						'%'
					)
				),
				Object(preact_min["h"])(
					'span',
					{
						'class': _this.state.showtooltip ? barElement_style_default.a.tooltipDonors + ' ' + barElement_style_default.a.otherTooltip : barElement_style_default.a.tooltipDisplay,
						style: { top: _this.state.tooltipPosition[1] + 'px', left: _this.state.tooltipPosition[0] + 'px' }
					},
					_this.state.tooltipData
				)
			);
		};

		_this.state = {
			showtooltip: '',
			tooltipData: '',
			tooltipPosition: [0, 0]
		};
		return _this;
	}

	BarElement.prototype.render = function render(_ref, state) {
		var data = _ref.data;

		return Object(preact_min["h"])(
			'div',
			{ 'class': barElement_style_default.a.barChartBlock },
			Object(preact_min["h"])(
				'div',
				{ 'class': barElement_style_default.a.displayTextWrapper + ' ' + barElement_style_default.a.desktop_responsive },
				Object(preact_min["h"])(
					'div',
					{ 'class': barElement_style_default.a.title },
					Object(preact_min["h"])(
						'a',
						{ 'class': barElement_style_default.a.donorName, href: '/programme-area/targets/' + data.target_id.replace('.', '/') },
						'Impact Target ',
						data.target_id
					)
				)
			),
			this.renderPercentageBar(data),
			Object(preact_min["h"])(
				'section',
				{ 'class': barElement_style_default.a.bgdEpxSection },
				Object(preact_min["h"])(
					'article',
					{ 'class': barElement_style_default.a.bgdEpxArticle },
					Object(preact_min["h"])(
						'div',
						{ 'class': barElement_style_default.a.bgtDiv },
						Object(preact_min["h"])(
							'div',
							null,
							'Budget:',
							Object(preact_min["h"])(
								'span',
								{ 'class': barElement_style_default.a.boldnumber },
								Object(numberFormatter["d" /* numberToCurrencyFormatter */])(data.target_budget, 2)
							)
						)
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': barElement_style_default.a.expDiv },
						Object(preact_min["h"])(
							'div',
							null,
							'Expenditure:',
							Object(preact_min["h"])(
								'span',
								{ 'class': barElement_style_default.a.boldnumber },
								Object(numberFormatter["d" /* numberToCurrencyFormatter */])(data.target_expense, 2)
							)
						)
					)
				)
			)
		);
	};

	return BarElement;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/percentageBarChart/style.scss
var percentageBarChart_style = __webpack_require__("SFpe");
var percentageBarChart_style_default = /*#__PURE__*/__webpack_require__.n(percentageBarChart_style);

// CONCATENATED MODULE: ./components/percentageBarChart/index.js


function percentageBarChart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function percentageBarChart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function percentageBarChart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var percentageBarChart_PercentageBarChart = function (_Component) {
    percentageBarChart__inherits(PercentageBarChart, _Component);

    function PercentageBarChart(props) {
        percentageBarChart__classCallCheck(this, PercentageBarChart);

        var _this = percentageBarChart__possibleConstructorReturn(this, _Component.call(this, props));

        _this.generateList = function (data) {
            return data.map(function (item) {
                return Object(preact_min["h"])(barElement_BarElement, { data: item });
            });
        };

        return _this;
    }

    PercentageBarChart.prototype.render = function render(_ref, state) {
        var data = _ref.data;

        return Object(preact_min["h"])(
            'div',
            { 'class': percentageBarChart_style_default.a.container },
            this.generateList(data)
        );
    };

    return PercentageBarChart;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/themeSlider/index.js


function themeSlider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function themeSlider__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function themeSlider__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var themeSlider__ref = Object(preact_min["h"])(
    'span',
    null,
    'Impact Targets'
);

var themeSlider__ref2 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var themeSlider__ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var themeSlider__ref4 = Object(preact_min["h"])(
    'span',
    null,
    'Signature Solutions'
);

var _ref5 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref6 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref7 = Object(preact_min["h"])(
    'span',
    null,
    'Top 5 Donors'
);

var _ref8 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var _ref9 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref10 = Object(preact_min["h"])(
    'span',
    null,
    'Top 5 Recipient Countries'
);

var _ref11 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var _ref12 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref13 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var themeSlider_ThemeSlider = function (_Component) {
    themeSlider__inherits(ThemeSlider, _Component);

    function ThemeSlider() {
        var _temp, _this, _ret;

        themeSlider__classCallCheck(this, ThemeSlider);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = themeSlider__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.generateHeaderList = function (data) {
            return Object(preact_min["h"])(
                'ul',
                { 'class': themeSlider_style_default.a.summarySection },
                Object(preact_min["h"])(
                    'li',
                    { 'class': themeSlider_style_default.a.summaryDetails },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': themeSlider_style_default.a.summaryHeading },
                        'Budget'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': themeSlider_style_default.a.expense },
                        Object(numberFormatter["d" /* numberToCurrencyFormatter */])(data.budget_amount, 2)
                    )
                ),
                Object(preact_min["h"])(
                    'li',
                    { 'class': themeSlider_style_default.a.summaryDetails },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': themeSlider_style_default.a.summaryHeading },
                        'Expenditure'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': themeSlider_style_default.a.expense },
                        Object(numberFormatter["d" /* numberToCurrencyFormatter */])(data.expense_amount, 2)
                    )
                ),
                Object(preact_min["h"])(
                    'li',
                    { 'class': themeSlider_style_default.a.summaryDetails },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': themeSlider_style_default.a.summaryHeading },
                        'Projects'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': themeSlider_style_default.a.expense },
                        Object(numberFormatter["c" /* numberToCommaFormatter */])(data.projects)
                    )
                ),
                Object(preact_min["h"])(
                    'li',
                    { 'class': themeSlider_style_default.a.summaryDetails },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': themeSlider_style_default.a.summaryHeading },
                        'Donors'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': themeSlider_style_default.a.expense },
                        Object(numberFormatter["c" /* numberToCommaFormatter */])(data.budget_sources)
                    )
                ),
                Object(preact_min["h"])(
                    'li',
                    { 'class': themeSlider_style_default.a.summaryDetails },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': themeSlider_style_default.a.summaryHeading },
                        'Countries'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': themeSlider_style_default.a.expense },
                        Object(numberFormatter["c" /* numberToCommaFormatter */])(data.countries)
                    )
                )
            );
        }, _temp), themeSlider__possibleConstructorReturn(_this, _ret);
    }

    ThemeSlider.prototype.render = function render() {
        var _this2 = this;

        var isNonEmpty = Object.keys(this.props.data).length > 0,
            data = this.props.data,
            isLoading = this.props.loading,
            tabSelected = this.props.tab,
            outcomeChartData = this.props.outcomeData.resourcesModalityContribution;

        // signatureSolutionChartData=null;
        var sdgTargetData = data && data.percentage;
        return Object(preact_min["h"])(
            'div',
            null,
            !isLoading && isNonEmpty ? Object(preact_min["h"])(
                'div',
                { 'class': themeSlider_style_default.a.themeSlider },
                Object(preact_min["h"])(
                    'div',
                    { 'class': themeSlider_style_default.a.headingWrapper },
                    tabSelected === 'themes' ? Object(preact_min["h"])(
                        'a',
                        { href: '/themes/' + data.aggregate.sector + '/' + data.aggregate.sector_name,
                            'class': themeSlider_style_default.a.countryName },
                        data.aggregate.sector_name
                    ) : Object(preact_min["h"])(
                        'div',
                        null,
                        Object(preact_min["h"])(
                            'div',
                            { 'class': themeSlider_style_default.a.imageWrapper },
                            Object(preact_min["h"])('img', { 'class': themeSlider_style_default.a.ssIcon, src: data.aggregate.ss_id === '0' ? '/assets/icons/placeHolder.svg' : Object(commonMethods["d" /* getAPIBaseUrRl */])() + '/static/assets/icons/sdg/PA-' + data.aggregate.ss_id + '.svg', alt: 'Programme area  image' })
                        ),
                        Object(preact_min["h"])(
                            'a',
                            { href: '/programme-area/' + data.aggregate.sector + '/' + data.aggregate.sector_name,
                                'class': data.aggregate.sector_name.length > 50 ? themeSlider_style_default.a.countryName + ' ' + themeSlider_style_default.a.ssLong : themeSlider_style_default.a.countryName + ' ' + themeSlider_style_default.a.ssa },
                            data.aggregate.sector_name
                        ),
                        Object(preact_min["h"])('span', { 'class': themeSlider_style_default.a.closeSlider, onClick: function onClick() {
                                return _this2.props.closeSlider();
                            } })
                    ),
                    tabSelected === 'themes' ? Object(preact_min["h"])('span', { 'class': themeSlider_style_default.a.closeSlider,
                        onClick: function onClick() {
                            return _this2.props.closeSlider();
                        } }) : null
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': themeSlider_style_default.a.scrollSection },
                    Object(preact_min["h"])(
                        lib["Scrollbars"],
                        null,
                        Object(preact_min["h"])(
                            'div',
                            { 'class': themeSlider_style_default.a.year },
                            data.aggregate.year
                        ),
                        this.generateHeaderList(data.aggregate),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': themeSlider_style_default.a.theme_slider_wrapper },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': themeSlider_style_default.a.theme_slider_title },
                                themeSlider__ref
                            ),
                            sdgTargetData ? sdgTargetData && Object.keys(sdgTargetData).length && sdgTargetData.length > 0 ? Object(preact_min["h"])(
                                'div',
                                { 'class': themeSlider_style_default.a.per_bar_chart },
                                Object(preact_min["h"])(percentageBarChart_PercentageBarChart, { data: sdgTargetData })
                            ) : themeSlider__ref2 : Object(preact_min["h"])(
                                'div',
                                { style: { position: "relative", height: 544 } },
                                themeSlider__ref3
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': tabSelected === 'themes' && data.aggregate.year >= constants["a" /* default */].SIGNATURE_SOLUTION_YEAR ? themeSlider_style_default.a.theme_slider_wrapper : themeSlider_style_default.a.display_none },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': themeSlider_style_default.a.theme_slider_title },
                                themeSlider__ref4
                            ),
                            outcomeChartData.loading ? Object(preact_min["h"])(
                                'div',
                                { style: { position: "relative", height: 200 } },
                                _ref5
                            ) : outcomeChartData && outcomeChartData.data && outcomeChartData.data.country && outcomeChartData.data.country.length > 0 ? Object(preact_min["h"])(
                                'div',
                                { 'class': themeSlider_style_default.a.outcome_chart_wrapper + ' ' + themeSlider_style_default.a.outcome_resources_modality },
                                Object(preact_min["h"])(donutChart["a" /* default */], {
                                    donor_wrapper_styles: themeSlider_style_default.a.outcome_wrapper_styles,
                                    donut_styles: themeSlider_style_default.a.donut_styles,
                                    legend_styles: themeSlider_style_default.a.legend_styles,
                                    textWrapperStyle: themeSlider_style_default.a.textWrapperStyle,
                                    legendLabel: themeSlider_style_default.a.legendLabel,
                                    data: outcomeChartData.data.country,
                                    legendData: outcomeChartData.data.total,
                                    textFieldStyle: themeSlider_style_default.a.textFieldStyle,
                                    donutCenterText: themeSlider_style_default.a.donutCenterText,
                                    dollor: themeSlider_style_default.a.dollor,
                                    chartWidth: 560,
                                    chartHeight: 400, chart_id: 'signatureSolution_chart' })
                            ) : _ref6
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': themeSlider_style_default.a.theme_slider_wrapper },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': themeSlider_style_default.a.theme_slider_title },
                                _ref7,
                                _ref8
                            ),
                            Object(preact_min["h"])(
                                'div',
                                { 'class': themeSlider_style_default.a.grouped_bar_chart },
                                data.budget_sources.length > 0 ? Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                    chart_id: 'budget_sources',
                                    width: 1200,
                                    height: 600,
                                    slice_limit: 5,
                                    translate_xaxis: 60,
                                    translate_yaxis: 100,
                                    translate_graph: 80,
                                    data: data.budget_sources,
                                    label: 'short_name',
                                    min_height: 650,
                                    tspanSize: '20px',
                                    textSize: '20px'
                                }) : _ref9
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': themeSlider_style_default.a.theme_slider_wrapper },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': themeSlider_style_default.a.theme_slider_title },
                                _ref10,
                                _ref11
                            ),
                            Object(preact_min["h"])(
                                'div',
                                { 'class': themeSlider_style_default.a.grouped_bar_chart },
                                data.top_recipient_offices.length > 0 ? Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                    chart_id: 'recipient_offices',
                                    width: 1200,
                                    height: 600,
                                    slice_limit: 5,
                                    translate_xaxis: 60,
                                    translate_yaxis: 100,
                                    translate_graph: 80,
                                    data: data.top_recipient_offices,
                                    label: 'iso3',
                                    recipientLabel: 'name',
                                    min_height: 650,
                                    tspanSize: '20px',
                                    textSize: '20px'
                                }) : _ref12
                            )
                        )
                    )
                )
            ) : Object(preact_min["h"])(
                'div',
                { style: { position: "relative", height: 544 } },
                _ref13
            )
        );
    };

    return ThemeSlider;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/sdgSlider/style.scss
var sdgSlider_style = __webpack_require__("5iAr");
var sdgSlider_style_default = /*#__PURE__*/__webpack_require__.n(sdgSlider_style);

// EXTERNAL MODULE: ./utils/commonActionUtils.js
var commonActionUtils = __webpack_require__("I9r4");

// CONCATENATED MODULE: ./components/sdgSlider/index.js


function sdgSlider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sdgSlider__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sdgSlider__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var sdgSlider__ref = Object(preact_min["h"])(
    'span',
    null,
    'Top 5 Donors'
);

var sdgSlider__ref2 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var sdgSlider__ref3 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sdgSlider__ref4 = Object(preact_min["h"])(
    'span',
    null,
    'Top 5 Recipient Countries'
);

var sdgSlider__ref5 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var sdgSlider__ref6 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sdgSlider__ref7 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sdgSlider_SdgSlider = function (_Component) {
    sdgSlider__inherits(SdgSlider, _Component);

    function SdgSlider() {
        var _temp, _this, _ret;

        sdgSlider__classCallCheck(this, SdgSlider);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = sdgSlider__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.generateHeaderList = function (data) {
            return Object(preact_min["h"])(
                'ul',
                { 'class': sdgSlider_style_default.a.summarySection },
                Object(preact_min["h"])(
                    'li',
                    { 'class': sdgSlider_style_default.a.summaryDetails },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgSlider_style_default.a.summaryHeading },
                        'Budget'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgSlider_style_default.a.expense },
                        Object(numberFormatter["d" /* numberToCurrencyFormatter */])(data.total_budget, 2)
                    )
                ),
                Object(preact_min["h"])(
                    'li',
                    { 'class': sdgSlider_style_default.a.summaryDetails },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgSlider_style_default.a.summaryHeading },
                        'Expenditure'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgSlider_style_default.a.expense },
                        Object(numberFormatter["d" /* numberToCurrencyFormatter */])(data.total_expense, 2)
                    )
                ),
                Object(preact_min["h"])(
                    'li',
                    { 'class': sdgSlider_style_default.a.summaryDetails },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgSlider_style_default.a.summaryHeading },
                        'Projects'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgSlider_style_default.a.expense },
                        Object(numberFormatter["c" /* numberToCommaFormatter */])(data.total_projects)
                    )
                ),
                Object(preact_min["h"])(
                    'li',
                    { 'class': sdgSlider_style_default.a.summaryDetails },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgSlider_style_default.a.summaryHeading },
                        'Donors'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgSlider_style_default.a.expense },
                        Object(numberFormatter["c" /* numberToCommaFormatter */])(data.budget_sources)
                    )
                ),
                Object(preact_min["h"])(
                    'li',
                    { 'class': sdgSlider_style_default.a.summaryDetails },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgSlider_style_default.a.summaryHeading },
                        'Countries'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': sdgSlider_style_default.a.expense },
                        Object(numberFormatter["c" /* numberToCommaFormatter */])(data.countries)
                    )
                )
            );
        }, _temp), sdgSlider__possibleConstructorReturn(_this, _ret);
    }

    SdgSlider.prototype.render = function render() {
        var _this2 = this;

        var isNonEmpty = Object.keys(this.props.data).length > 0,
            data = this.props.data,
            isLoading = this.props.loading,
            sdg_src = data && data.aggregate && data.aggregate.sdg && Object(commonActionUtils["c" /* getSDGImageFromCode */])(data.aggregate.sdg),
            sdgTargetData = this.props.sdgTargetData;

        return Object(preact_min["h"])(
            'div',
            null,
            !isLoading && isNonEmpty ? Object(preact_min["h"])(
                'div',
                { 'class': sdgSlider_style_default.a.themeSlider },
                Object(preact_min["h"])(
                    'div',
                    { 'class': sdgSlider_style_default.a.headingWrapper },
                    Object(preact_min["h"])(
                        'div',
                        null,
                        data.aggregate.sdg && Object(preact_min["h"])(
                            'div',
                            { 'class': sdgSlider_style_default.a.imageWrapper },
                            Object(preact_min["h"])('img', { 'class': sdgSlider_style_default.a.sdg_image, src: this.props.baseURL + ('/static/assets/icons/' + sdg_src), alt: 'sdg icon' })
                        ),
                        Object(preact_min["h"])(
                            'a',
                            { href: '/sdg/' + data.aggregate.sdg + '/' + data.aggregate.sdg_name,
                                'class': sdgSlider_style_default.a.countryName },
                            data.aggregate.sdg_name
                        ),
                        Object(preact_min["h"])('span', { 'class': sdgSlider_style_default.a.closeSlider,
                            onClick: function onClick() {
                                return _this2.props.closeSlider();
                            } })
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': sdgSlider_style_default.a.scrollSection },
                    Object(preact_min["h"])(
                        lib["Scrollbars"],
                        null,
                        Object(preact_min["h"])(
                            'div',
                            { 'class': sdgSlider_style_default.a.year },
                            data.aggregate.year
                        ),
                        this.generateHeaderList(data.aggregate),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': sdgSlider_style_default.a.theme_slider_wrapper },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': sdgSlider_style_default.a.theme_slider_title },
                                sdgSlider__ref,
                                sdgSlider__ref2
                            ),
                            Object(preact_min["h"])(
                                'div',
                                { 'class': sdgSlider_style_default.a.grouped_bar_chart },
                                data.budget_sources.length > 0 ? Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                    chart_id: 'budget_sources_sdg',
                                    width: 1200,
                                    height: 600,
                                    slice_limit: 5,
                                    translate_xaxis: 60,
                                    translate_yaxis: 100,
                                    translate_graph: 80,
                                    data: data.budget_sources,
                                    label: 'short_name',
                                    fullLabel: 'organisation_name',
                                    min_height: 650,
                                    tspanSize: '20px',
                                    textSize: '20px'
                                }) : sdgSlider__ref3
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': sdgSlider_style_default.a.theme_slider_wrapper },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': sdgSlider_style_default.a.theme_slider_title },
                                sdgSlider__ref4,
                                sdgSlider__ref5
                            ),
                            Object(preact_min["h"])(
                                'div',
                                { 'class': sdgSlider_style_default.a.grouped_bar_chart },
                                data.top_recipient_offices.length > 0 ? Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
                                    chart_id: 'recipient_offices_sdg',
                                    width: 1200,
                                    height: 600,
                                    slice_limit: 5,
                                    translate_xaxis: 60,
                                    translate_yaxis: 100,
                                    translate_graph: 80,
                                    data: data.top_recipient_offices,
                                    label: 'iso3',
                                    min_height: 650,
                                    tspanSize: '20px',
                                    textSize: '20px'
                                }) : sdgSlider__ref6
                            )
                        )
                    )
                )
            ) : Object(preact_min["h"])(
                'div',
                { style: { position: "relative", height: 544 } },
                sdgSlider__ref7
            )
        );
    };

    return SdgSlider;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/nestedList/index.js
var nestedList = __webpack_require__("GGbt");

// EXTERNAL MODULE: ./components/themeSlider/actions/index.js
var actions = __webpack_require__("yuQp");

// EXTERNAL MODULE: ./components/themeSlider/actions/signatureDonor.js
var signatureDonor = __webpack_require__("6W2b");

// EXTERNAL MODULE: ./components/themeSlider/actions/signatureOutcome.js
var signatureOutcome = __webpack_require__("A1ba");

// EXTERNAL MODULE: ./components/sdgSlider/actions/index.js
var sdgSlider_actions = __webpack_require__("aYEV");

// EXTERNAL MODULE: ./components/profilePage/actions/donorActions/index.js
var donorActions = __webpack_require__("JMhk");

// EXTERNAL MODULE: ./components/sideBar/style.scss
var sideBar_style = __webpack_require__("CCOa");
var sideBar_style_default = /*#__PURE__*/__webpack_require__.n(sideBar_style);

// EXTERNAL MODULE: ./components/sideBar/action/updateSS.js
var updateSS = __webpack_require__("yg2x");

// EXTERNAL MODULE: ./components/sdgSlider/actions/targetAction.js
var targetAction = __webpack_require__("TVaU");

// CONCATENATED MODULE: ./components/sideBar/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function sideBar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sideBar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sideBar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var sideBar__ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var sideBar__ref3 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var sideBar_SideBar = function (_Component) {
	sideBar__inherits(SideBar, _Component);

	function SideBar(props, context) {
		sideBar__classCallCheck(this, SideBar);

		var _this = sideBar__possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.selectRow = function (item, index, type) {
			_this.props.selectThemeSdg(item, type);
			_this.props.updateSSThemesFilter(_this.props.tabSelected, item);
			_this.props.tabSelected === 'signature' ? _this.props.updateSignatureSolution(item) : null;
			if (type == 'sector') {
				if (_this.state.slider && _this.props.tabSelected == 'themes') {
					_this.props.fetchDonorSliderData(_this.props.mapCurrentYear, item);
				}
				if (_this.props.tabSelected == 'signature') {
					_this.props.fetchSignatureSliderData(_this.props.mapCurrentYear, item);
					_this.props.fetchSignatureOutcome(item, _this.props.mapCurrentYear);
				}
				if (_this.props.tabSelected == 'themes' && _this.props.mapCurrentYear >= constants["a" /* default */].SIGNATURE_SOLUTION_YEAR) {
					_this.props.fetchSignatureSolutionChartData(item, _this.props.mapCurrentYear);
				}
				_this.props.updateThemeFilter('selectedTheme', item);
				_this.setState({
					selectedIndex: index,
					allThemesSelected: false
				});
				_this.updateSSThemesIndex(_this.props.tabSelected, item);
			} else {
				if (_this.state.slider && _this.props.tabSelected == 'sdg') {
					_this.props.fetchSdgSliderData(_this.props.mapCurrentYear, item);
					_this.props.fetchSdgSliderTargetData(_this.props.mapCurrentYear, item);
				}
				_this.props.updateSdgFilter('selectedSdg', item);
				_this.setState({
					selectedIndex: index
				});
			}
		};

		_this.selectDonorRow = function (index, level_3_code, donorName) {
			if (_this.state.slider && _this.props.tabSelected == 'donors') {
				_this.props.getDonorDetails(level_3_code, _this.props.mapCurrentYear);
			}
			_this.props.updateSearchDonorsText(donorName);
			_this.props.updateDonorFilter('budgetSources', level_3_code);
			_this.props.updateDonorFilter('budgetSourcesLabel', donorName);
			_this.setState({
				selectedIndex: index,
				allThemesSelected: false
			});
			_this.props.selectDonor(level_3_code);
		};

		_this.selectAllThemes = function () {
			if (_this.props.tabSelected !== 'donors') {
				_this.setState({
					selectedIndex: -1,
					allThemesSelected: true,
					slider: false
				}, function () {
					_this.props.updateSSThemesFilter(_this.props.tabSelected, '');
					_this.updateSSThemesIndex(_this.props.tabSelected, '');
					_this.props.selectThemeSdg(null, _this.props.tabSelected);
				});
			}
		};

		_this.enableSlider = function (flag) {
			if (flag === _this.state.slider) {
				_this.setState({ slider: false });
			} else {
				_this.setState({ slider: flag });
			}
		};

		_this.handleLanguage = function (flag) {
			_this.enableSlider(flag);
			_this.setState({
				selectedIndex: -1,
				allThemesSelected: true
			});
		};

		_this.renderRow = function (item, index) {
			return _this.props.tabSelected === 'themes' || _this.props.tabSelected === 'sdg' || _this.props.tabSelected === 'signature' ? Object(preact_min["h"])(sideBarItem["a" /* default */], { data: item.item,
				tabSelected: _this.props.tabSelected,
				index: index,
				apiBase: Object(commonMethods["d" /* getAPIBaseUrRl */])(),
				selectMap: function selectMap() {
					return _this.props.selectMap();
				},
				selected: _this.state.selectedIndex === index || _this.state.selectedIndex == null ? true : false,
				selectRow: function selectRow(item, index, type) {
					return _this.selectRow(item, index, type);
				},
				onSelectLanguage: _this.handleLanguage
			}) : Object(preact_min["h"])(sideBarItemDonors["a" /* default */], { data: item.item,
				mapCurrentYear: _this.props.mapCurrentYear,
				index: index,
				selectMap: function selectMap() {
					return _this.props.selectMap();
				},
				selected: _this.state.selectedIndex === index || _this.state.selectedIndex == null ? true : false,
				selectRow: function selectRow(item) {
					var code = item.data.ref_id ? item.data.ref_id : item.data.level_3_code;
					var donorName = item.data.level_3_name;
					_this.selectDonorRow(item.index, code, donorName);
				},
				onSelectLanguage: _this.handleLanguage
			});
		};

		_this.handleSearchClose = function () {
			_this.setState({ showSelect: false, selectedIndex: -1 });
			_this.props.selectThemeSdg(null, _this.props.tabSelected);
			_this.props.searchResult('', 'searcbar');
			_this.props.updateDonorFilter('budgetSources', '');
			_this.props.updateDonorFilter('budgetSourcesLabel', '');
			_this.props.fetchDonorFundListData();
			_this.props.updateSearchDonorsText('');
			_this.props.searchCountryListData('');
		};

		_this.handleOnInputChange = function (e) {
			if (_this.props.donorFilter.budgetSourcesLabel) {
				_this.props.updateDonorFilter('budgetSources', '');
				_this.props.updateDonorFilter('budgetSourcesLabel', '');
			}

			_this.props.updateSearchDonorsText(e.target.value);
			_this.setState({
				donorSearch: e.target.value
			}, function () {
				if (_this.state.donorSearch === '') {
					_this.setState({ showSelect: false, selectedIndex: -1 });
					_this.props.searchResult(_this.state.donorSearch, 'searcbar');
					_this.props.updateDonorFilter('budgetSources', '');
					_this.props.fetchDonorFundListData();
				} else {
					_this.setState({ showSelect: true });
					_this.props.searchResult(_this.state.donorSearch, 'searcbar');
					// this.props.fetchDonorFundListData(this.props.mapCurrentYear,this.props.donorFilter.operatingUnits);
				}
			});
		};

		_this.handleSelectBudgetSourcesDonors = function (data) {
			_this.setState({ showSelect: false, selectedText: data.name });
			_this.props.searchCountryListData(data.code);
			_this.props.updateDonorFilter('budgetSources', data.code);
			_this.props.updateDonorFilter('budgetSourcesLabel', data.name);
			_this.props.fetchDonorFundListData();
		};

		_this.state = {
			donorSearch: '',
			selectedIndex: -1,
			slider: false,
			allThemesSelected: true,
			showSelect: false,
			selectedText: '',
			data: {}

		};
		_this.selectedSSId = '';
		_this.selectedThemesId = '';
		_this.lastSelectedTab = 'country';
		return _this;
	}

	SideBar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		var _this2 = this;

		this.setState({
			allThemesSelected: true,
			data: nextProps.data.data
		});
		if (this.props.mapCurrentYear !== nextProps.mapCurrentYear) {
			if (nextProps.tabSelected === 'signature') this.selectedSSId = '';else if (nextProps.tabSelected === 'themes') this.selectedThemesId = '';else if (nextProps.tabSelected === 'sdg') nextProps.sdgFilter.selectedSdg = '';
		}

		if (nextProps.tabSelected === 'donors') {
			this.setState({ selectedIndex: -1 });
			if (this.props.donorFilter.budgetSources != nextProps.donorFilter.budgetSources) {
				if (nextProps.donorFilter.budgetSources == '') {
					this.props.updateSearchDonorsText('');
				}
			}
			if (nextProps.data && nextProps.data.data && nextProps.data.data.data) {
				nextProps.data.data.data.forEach(function (item, index) {
					if (item.level_3_code !== '' && item.level_3_code === nextProps.donorFilter.budgetSources || item.ref_id && item.ref_id === nextProps.donorFilter.budgetSources) {
						_this2.setState({ selectedIndex: index });
						return;
					}
				});
			}
		} else if (nextProps.tabSelected == 'themes') {
			this.setState({ selectedIndex: -1 });
			if (nextProps.data && nextProps.data.data && nextProps.data.data.sector) {
				nextProps.data.data.sector.forEach(function (item, itemIndex) {
					if (_this2.selectedThemesId && item.sector != '' && item.sector == _this2.selectedThemesId) {
						_this2.setState({ selectedIndex: itemIndex });
						return;
					}
				});
			}
		} else if (nextProps.tabSelected === 'signature') {
			this.setState({ selectedIndex: -1 });
			if (nextProps.data && nextProps.data.data && nextProps.data.data.sector) {
				nextProps.data.data.sector.forEach(function (item, itemIndex) {
					if (_this2.selectedSSId && item.ss_id != '' && item.ss_id == _this2.selectedSSId) {
						_this2.setState({ selectedIndex: itemIndex });
						return;
					}
				});
			}
		} else if (nextProps.tabSelected == 'sdg') {
			this.setState({ selectedIndex: -1 });
			if (nextProps.data && nextProps.data.data && nextProps.data.data.sdg) {
				nextProps.data.data.sdg.forEach(function (item, index) {
					if (item.sdg_code != '' && item.sdg_code == nextProps.sdgFilter.selectedSdg) {
						_this2.setState({ selectedIndex: index });
						return;
					}
				});
			}
		}
		if (this.props.donorFilter != nextProps.donorFilter) {
			if (nextProps.tabSelected == 'donors') {
				if (nextProps.donorFilter.budgetSourcesLabel == '') {
					this.setState({ slider: false });
				}
			} else {
				this.setState({ slider: false, selectedIndex: -1 });
			}
		}

		if (this.props.mapCurrentYear !== nextProps.mapCurrentYear || this.props.tabSelected !== nextProps.tabSelected) {
			this.setState({ slider: false });
		}
		if (this.lastSelectedTab !== nextProps.tabSelected) this.lastSelectedTab = nextProps.tabSelected;
	};

	SideBar.prototype.updateSSThemesIndex = function updateSSThemesIndex(tabSelected, item) {
		switch (tabSelected) {
			case 'themes':
				this.selectedThemesId = item;
				break;
			case 'signature':
				this.selectedSSId = item;
				break;
		}
	};
	// searchDonorText


	SideBar.prototype.render = function render(_ref, state) {
		var _this3 = this;

		var themeSummary = _ref.themeSummary,
		    tabSelected = _ref.tabSelected,
		    budgetSourceSearch = _ref.budgetSourceSearch,
		    donorFilter = _ref.donorFilter;


		var isEmpty = tabSelected === 'themes' || tabSelected === 'signature' ? this.props.data && this.props.data.data && this.props.data.data.sector && this.props.data.data.sector.length !== 0 : tabSelected === 'donors' ? this.props.data && this.props.data.data && this.props.data.data.data && this.props.data.data.data.length !== 0 : this.props.data && this.props.data.data && this.props.data.data.sdg && this.props.data.data.sdg.length !== 0,
		    tabData = tabSelected === 'themes' || tabSelected === 'signature' ? this.props.data.data.sector : tabSelected === 'donors' ? this.props.data.data.data : this.props.data.data.sdg;

		var searchDonorText = budgetSourceSearch.searchDonorText;
		return Object(preact_min["h"])(
			'aside',
			{ 'class': tabSelected === 'donors' ? sideBar_style_default.a.theme_container + ' ' + sideBar_style_default.a.themedonor_container : sideBar_style_default.a.theme_container },
			tabSelected === 'donors' && Object(preact_min["h"])(
				'div',
				{ 'class': sideBar_style_default.a.searchContainer },
				Object(preact_min["h"])(
					'span',
					{ 'class': sideBar_style_default.a.searchLabel },
					'Search for donors'
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': sideBar_style_default.a.donorSearch },
					Object(preact_min["h"])(
						'div',
						{ 'class': sideBar_style_default.a.searchItems },
						Object(preact_min["h"])('input', { id: 'donorManual', type: 'text', name: 'search',
							value: donorFilter.budgetSourcesLabel ? donorFilter.budgetSourcesLabel : budgetSourceSearch.searchDonorText,
							'class': sideBar_style_default.a.searchField,
							placeholder: 'Enter donor name',
							onInput: function onInput(e) {
								_this3.handleOnInputChange(e);
							},
							autocomplete: 'off'
						}),
						searchDonorText === '' ? Object(preact_min["h"])('span', { 'class': sideBar_style_default.a.searchIcon + ' ' + sideBar_style_default.a.searchIconSearch }) : Object(preact_min["h"])('span', { onClick: function onClick() {
								_this3.handleSearchClose();
							}, 'class': ' ' + sideBar_style_default.a.searchIcon + ' ' + sideBar_style_default.a.searchIconClose + ' ' })
					),
					this.state.showSelect ? Object(preact_min["h"])(nestedList["a" /* default */], {
						loading: budgetSourceSearch.searchBarResultLoading,
						searchText: budgetSourceSearch.searchDonorText,
						handleChange: this.handleSelectBudgetSourcesDonors,
						dataList: this.props.budgetSourceSearch.searchResultSearchBar,
						wrapperStyle: { left: 0, right: 0, top: 25, position: 'absolute', paddingTop: 35 },
						donor: tabSelected === 'donors' ? true : false }) : null
				)
			),
			Object(preact_min["h"])(
				lib["Scrollbars"],
				{
					renderTrackHorizontal: function renderTrackHorizontal(props) {
						return Object(preact_min["h"])('div', _extends({}, props, { className: 'track-horizontal' }));
					} },
				Object(preact_min["h"])(allThemesBar_AllThemesBar, { data: this.state.data.project,
					tabSelected: tabSelected,
					selectRow: function selectRow() {
						return _this3.selectAllThemes();
					},
					selected: this.state.selectedIndex
				}),
				this.props.themesLoading || this.props.donorsLoading || this.props.sdgLoading ? sideBar__ref2 : isEmpty ? Object(preact_min["h"])(listView["a" /* default */], {
					data: tabData,
					renderItem: this.renderRow
				}) : sideBar__ref3
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': this.state.slider && tabSelected === 'donors' ? sideBar_style_default.a.sliderDonor + ' ' + sideBar_style_default.a.sliderVisible : ' ' + sideBar_style_default.a.sliderDonor },
				Object(preact_min["h"])(DonorSlider_DonorSlider, {
					data: this.props.donorSliderData,
					donutBudget: this.state.donutBudget,
					donutModality: this.state.donutModality,
					slider: this.state.slider,
					closeSlider: function closeSlider() {
						return _this3.setState({ slider: false });
					} })
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': this.state.slider && (tabSelected === 'themes' || tabSelected === 'signature') ? sideBar_style_default.a.sliderDonor + ' ' + sideBar_style_default.a.sliderVisible : ' ' + sideBar_style_default.a.sliderDonor },
				Object(preact_min["h"])(themeSlider_ThemeSlider, {
					slider: this.state.slider,
					tab: tabSelected,
					closeSlider: function closeSlider() {
						return _this3.setState({ slider: false });
					},
					data: this.props.themeSliderData,
					loading: this.props.themeSliderLoading,
					outcomeData: this.props.donorSliderData
				})
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': this.state.slider && tabSelected === 'sdg' ? sideBar_style_default.a.sliderDonor + ' ' + sideBar_style_default.a.sliderVisible : ' ' + sideBar_style_default.a.sliderDonor },
				Object(preact_min["h"])(sdgSlider_SdgSlider, {
					slider: this.state.slider,
					closeSlider: function closeSlider() {
						return _this3.setState({ slider: false });
					},
					data: this.props.sdgSliderData,
					loading: this.props.sdgSliderLoading,
					sdgTargetData: this.props.sdgTargetSliderData,
					baseURL: Object(commonMethods["d" /* getAPIBaseUrRl */])()
				})
			)
		);
	};

	return SideBar;
}(preact_min["Component"]);

var mapStateToProps = function mapStateToProps(state) {
	var mapCurrentYear = state.mapData.yearTimeline.mapCurrentYear;
	var _state$tabData = state.tabData,
	    donorFilter = _state$tabData.donorFilter,
	    themeFilter = _state$tabData.themeFilter,
	    sdgFilter = _state$tabData.sdgFilter;

	return {
		year: state.yearSummary.data.year,
		themeSliderData: state.themeSliderData.data,
		themeSliderLoading: state.themeSliderData.loading,
		donorSliderData: state.donorProfile,
		sdgSliderData: state.sdgSliderData.data,
		sdgSliderLoading: state.sdgSliderData.loading,
		mapCurrentYear: mapCurrentYear,
		donorFilter: donorFilter,
		themeFilter: themeFilter,
		sdgFilter: sdgFilter,
		themesLoading: state.themeSummary.loading,
		donorsLoading: state.donorFundList.loading,
		sdgLoading: state.sdgAggregate.loading,
		tabSelected: state.tabData.tabSelected,
		sdgTargetSliderData: state.sdgTargetSliderData
	};
};
var sideBar_mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		fetchDonorSliderData: function fetchDonorSliderData(year, sector) {
			return dispatch(Object(actions["b" /* fetchDonorSliderData */])(year, sector));
		},
		fetchSdgSliderData: function fetchSdgSliderData(year, sdg) {
			return dispatch(Object(sdgSlider_actions["b" /* fetchSdgSliderData */])(year, sdg));
		},
		getDonorDetails: function getDonorDetails(code, year) {
			return Object(donorActions["a" /* default */])(dispatch, code, year);
		},
		fetchSignatureOutcome: function fetchSignatureOutcome(code, year) {
			return dispatch(Object(signatureOutcome["c" /* fetchSignatureOutcome */])(code, year));
		},
		updateSignatureSolution: function updateSignatureSolution(index) {
			return dispatch(Object(updateSS["b" /* updateSignatureSolution */])(index));
		},
		fetchSignatureSolutionChartData: function fetchSignatureSolutionChartData(code, year) {
			return dispatch(Object(signatureOutcome["d" /* fetchSignatureSolutionChartData */])(code, year));
		},
		fetchSignatureSliderData: function fetchSignatureSliderData(year, sector) {
			return dispatch(Object(signatureDonor["b" /* fetchSignatureSliderData */])(year, sector));
		},
		fetchSdgSliderTargetData: function fetchSdgSliderTargetData(year, sdg) {
			return dispatch(Object(targetAction["b" /* fetchSdgSliderTargetData */])(year, sdg));
		}
	};
};

/* harmony default export */ var sideBar = __webpack_exports__["a"] = (Object(preact_redux_esm["a" /* connect */])(mapStateToProps, sideBar_mapDispatchToProps)(sideBar_SideBar));

/***/ }),

/***/ "gxLQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1pDhJ","donutChartWrapper":"donutChartWrapper__1_HLR","donuttopWrapper":"donuttopWrapper__2OpZD","barChartWrapper":"barChartWrapper__2qFpd","preLoaderWrapper":"preLoaderWrapper__25rzu","noDataTemplateWrapper":"noDataTemplateWrapper__3htBj","textWrapperStyle":"textWrapperStyle__2lc_A","headerWrapper":"headerWrapper__2xjsg","recipientProfileChartHeaderInfo":"recipientProfileChartHeaderInfo__SrtdQ","textFieldStyle":"textFieldStyle__Ti-eE"};

/***/ }),

/***/ "h90+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/profilePage/components/style.scss
var style = __webpack_require__("NyMt");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// EXTERNAL MODULE: ./components/donorDonutChart/style.scss
var donorDonutChart_style = __webpack_require__("OP7B");
var donorDonutChart_style_default = /*#__PURE__*/__webpack_require__.n(donorDonutChart_style);

// EXTERNAL MODULE: ../node_modules/d3/d3.js
var d3 = __webpack_require__("tokj");
var d3_default = /*#__PURE__*/__webpack_require__.n(d3);

// EXTERNAL MODULE: ./components/donor-donut-chart-legend/index.js
var donor_donut_chart_legend = __webpack_require__("jQ4o");

// EXTERNAL MODULE: ./components/regular-other-legend/style.scss
var regular_other_legend_style = __webpack_require__("mZqR");
var regular_other_legend_style_default = /*#__PURE__*/__webpack_require__.n(regular_other_legend_style);

// CONCATENATED MODULE: ./components/regular-other-legend/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var regular_other_legend_RegularOtherLegend = function (_Component) {
	_inherits(RegularOtherLegend, _Component);

	function RegularOtherLegend() {
		_classCallCheck(this, RegularOtherLegend);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	RegularOtherLegend.prototype.render = function render() {
		return Object(preact_min["h"])(
			'div',
			null,
			this.props.data.map(function (item, index) {
				return Object(preact_min["h"])(
					'div',
					{ 'class': regular_other_legend_style_default.a.regularOtherItem, key: index },
					Object(preact_min["h"])(
						'span',
						null,
						Object(preact_min["h"])(
							'span',
							{ 'class': regular_other_legend_style_default.a.total_contribution },
							Object(numberFormatter["d" /* numberToCurrencyFormatter */])(item.total_contribution, 2)
						),
						Object(preact_min["h"])(
							'span',
							{ 'class': regular_other_legend_style_default.a.percentage },
							'(' + Object(numberFormatter["a" /* formatPercentage */])(item.percentage) + '%)'
						)
					),
					Object(preact_min["h"])(
						'span',
						{ 'class': regular_other_legend_style_default.a.fundType },
						item.fund_type
					)
				);
			})
		);
	};

	return RegularOtherLegend;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./utils/commonActionUtils.js
var commonActionUtils = __webpack_require__("I9r4");

// CONCATENATED MODULE: ./components/donorDonutChart/index.js


function donorDonutChart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function donorDonutChart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function donorDonutChart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var donorDonutChart_DonorDonutChart = function (_Component) {
    donorDonutChart__inherits(DonorDonutChart, _Component);

    function DonorDonutChart(props) {
        donorDonutChart__classCallCheck(this, DonorDonutChart);

        var _this = donorDonutChart__possibleConstructorReturn(this, _Component.call(this, props));

        _this.drawDonut = function () {
            var EDGE = window.navigator.userAgent.indexOf("Edge") > -1,
                IE = false || !!document.documentMode,
                EDGE_IE = EDGE || IE;

            var that = _this;

            var data = _this.state.data;
            var width = _this.props.chartWidth ? _this.props.chartWidth : 400,
                height = _this.props.chartHeight ? _this.props.chartHeight : 400,
                radius = Math.min(width, height) / 2,
                labelr = radius + 40,
                outerRadius = _this.props.outerRadius || radius - 10,
                innerRadius = _this.props.innerRadius || radius - 70;

            var arc = d3_default.a.svg.arc().outerRadius(outerRadius).innerRadius(innerRadius);

            var pie = d3_default.a.layout.pie().sort(null).value(function (d) {
                return d.percentage;
            }).padAngle(0);

            var onHover = function onHover(d) {
                _this.setState({
                    label: d.data.fund_stream || d.data.fund_type || d.data.sector_name,
                    percentage: d.data.percentage,
                    sdg_code: d.data.sdg_code,
                    total_contribution: !isNaN(d.data.total_contribution) ? d.data.total_contribution : d.data.theme_budget
                }, function () {});
            };

            if (!d3_default.a.select('#' + _this.props.chart_id).empty()) {
                d3_default.a.select('#' + _this.props.chart_id + ' svg').remove();
            }

            var svg = d3_default.a.select('#' + _this.props.chart_id).append("svg").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", "0 0 " + width + " " + height).classed('' + donorDonutChart_style_default.a.svgIe, true).append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ") scale(0.7, 0.7)");

            var g = svg.selectAll(".arc").data(pie(data)).enter().append("g").attr("class", "arc");

            var newArcs = g.append("path").attr("d", arc).style("fill", function (d) {
                return "#" + (d.data.color || d.data.sector_color);
            });

            var _newArcs$ = newArcs[0],
                firstArc = _newArcs$[0],
                lastArc = _newArcs$.slice(1);

            firstArc.style.opacity = 1;
            firstArc.setAttribute("transform", 'scale(1.025,1.025)');
            firstArc.style.stroke = "#eee";
            firstArc.style.strokeWidth = "1px";
            lastArc.forEach(function (item) {
                item.style.transform = 'scale(1, 1)';
                item.style.stroke = "#eee";
                item.style.strokeWidth = "1px";
            });
            !_this.props.exportLegend && newArcs.on("mouseover", function (d, i) {

                if (EDGE_IE) {
                    var newArray = [];
                    d3_default.a.select('#' + that.props.chart_id).selectAll(".arc")[0].forEach(function (item) {

                        for (var i = 0, len = item.childNodes.length; i < 1; ++i) {
                            var child = item.childNodes[i];
                            newArray.push(child);
                            if (child.nodeType !== 1 /*Node.ELEMENT_NODE*/) continue;
                            // Now, do whatever you want with the child element.
                        }
                    });
                    var all = [].concat(newArray);

                    all.forEach(function (item) {
                        item.style.opacity = 1;
                        item.setAttribute("transform", 'scale(1,1)');
                    });

                    var current = d3_default.a.event.target;
                    current.setAttribute("transform", 'scale(1.025,1.025)');
                    current.style.stroke = "#eee";
                    current.style.strokeWidth = "1px";
                    onHover(d);
                } else {
                    var all = d3_default.a.select('#' + that.props.chart_id).selectAll(".arc")[0].filter(function (item) {
                        return item.children && item.children[0] !== d3_default.a.event.target;
                    });
                    d3_default.a.selectAll(all).selectAll("path").style('transform', 'scale(1,1)').style('opacity', 1);

                    var _current = d3_default.a.event.target;
                    _current.style.transform = 'scale(1.025,1.025)';
                    _current.style.stroke = "#eee";
                    _current.style.strokeWidth = "1px";
                    onHover(d);
                }
            });
        };

        _this.state = {
            data: _this.props.data ? _this.props.data : [],
            label: _this.props.data[0] && (_this.props.data[0].fund_stream || _this.props.data[0].fund_type || _this.props.data[0].sector_name) ? _this.props.data[0].fund_stream || _this.props.data[0].fund_type || _this.props.data[0].sector_name : "",
            sdg_code: _this.props.data[0] && _this.props.data[0].sdg_code ? _this.props.data[0].sdg_code : "",
            percentage: _this.props.data[0] && _this.props.data[0].percentage ? _this.props.data[0].percentage : 0,
            total_contribution: _this.props.data[0] ? !isNaN(_this.props.data[0].total_contribution) ? _this.props.data[0].total_contribution : _this.props.data[0].theme_budget : 0
        };
        return _this;
    }

    DonorDonutChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        this.setState({
            data: nextProps.data,
            label: nextProps.data[0] && (nextProps.data[0].fund_stream || nextProps.data[0].fund_type || nextProps.data[0].sector_name) ? nextProps.data[0].fund_stream || nextProps.data[0].fund_type || nextProps.data[0].sector_name : "",
            sdg_code: nextProps.data[0] && nextProps.data[0].sdg_code ? nextProps.data[0].sdg_code : "",
            percentage: nextProps.data[0] && nextProps.data[0].percentage ? nextProps.data[0].percentage : 0,
            total_contribution: nextProps.data[0] ? !isNaN(nextProps.data[0].total_contribution) ? nextProps.data[0].total_contribution : nextProps.data[0].theme_budget : 0
        }, function () {
            if (nextProps.data.length !== 0) {
                _this2.drawDonut();
            }
        });
    };

    DonorDonutChart.prototype.componentDidMount = function componentDidMount() {
        if (this.props.data.length !== 0 && this.props.chart_id) {
            this.drawDonut();
        }
    };

    DonorDonutChart.prototype.calculateTotalContribution = function calculateTotalContribution(dataset) {
        var total_contribution = 0;
        dataset.forEach(function (item, index) {
            total_contribution += item.theme_budget;
        });
        return Object(numberFormatter["d" /* numberToCurrencyFormatter */])(parseFloat(total_contribution), 2);
    };

    DonorDonutChart.prototype.render = function render(props, _ref) {
        var label = _ref.label,
            percentage = _ref.percentage,
            total_contribution = _ref.total_contribution,
            sdg_code = _ref.sdg_code;

        var sdg_src = sdg_code && Object(commonActionUtils["c" /* getSDGImageFromCode */])(sdg_code);
        this.props.legendData = _.remove(this.props.legendData, function (n) {
            return n.fund_stream !== 'Regular Resources';
        });
        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(
                'div',
                { 'class': donorDonutChart_style_default.a.donut_wrapper + ' ' + this.props.donor_wrapper_styles },
                Object(preact_min["h"])(
                    'div',
                    { 'class': donorDonutChart_style_default.a.donut + ' ' + this.props.donut_styles, id: this.props.chart_id },
                    !this.props.exportLegend && (percentage != 0 || percentage != "") ? Object(preact_min["h"])(
                        'span',
                        { 'class': donorDonutChart_style_default.a.textLabel + ' ' + this.props.textWrapperStyle },
                        sdg_code ? Object(preact_min["h"])(
                            'span',
                            { 'class': donorDonutChart_style_default.a.imageWrapper },
                            Object(preact_min["h"])('img', { 'class': donorDonutChart_style_default.a.sdg_image, src: '../../../static/assets/icons/' + sdg_src, alt: 'sdg image' })
                        ) : null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': donorDonutChart_style_default.a.perc + ' ' + this.props.perc },
                            percentage == parseInt(percentage) ? parseInt(percentage) + '%' : percentage >= 1 ? Object(numberFormatter["f" /* roundTo */])(percentage, 1) + '%' : '< 1%'
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': donorDonutChart_style_default.a.textField + ' ' + this.props.textFieldStyle },
                            label
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': donorDonutChart_style_default.a.dollor + ' ' + this.props.dollor },
                            Object(numberFormatter["d" /* numberToCurrencyFormatter */])(total_contribution, 2)
                        )
                    ) : null,
                    this.props.exportLegend && Object(preact_min["h"])(
                        'span',
                        { 'class': donorDonutChart_style_default.a.textLabel + ' ' + this.props.textWrapperStyle },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': donorDonutChart_style_default.a.dollor },
                            this.calculateTotalContribution(props.data)
                        ),
                        Object(preact_min["h"])(
                            'span',
                            { 'class': donorDonutChart_style_default.a.textField + ' ' + this.props.textFieldStyle },
                            'Total Contribution'
                        )
                    )
                ),
                this.props.displayRegularLegend && this.props.displayRegularLegend == 'false' ? null : Object(preact_min["h"])(
                    'div',
                    { 'class': donorDonutChart_style_default.a.legend + ' ' + this.props.legend_styles },
                    Object(preact_min["h"])(regular_other_legend_RegularOtherLegend, { data: _.sortByOrder(this.props.regularOtherData, ['fund_type'], ['desc']) })
                ),
                this.props.exportLegend ? Object(preact_min["h"])(
                    'div',
                    { 'class': donorDonutChart_style_default.a.exportLegend + ' ' + this.props.legend_styles },
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': donorDonutChart_style_default.a.legendWrapper },
                        this.props.data.map(function (item, index) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': donorDonutChart_style_default.a.legendItem },
                                Object(preact_min["h"])('span', { 'class': donorDonutChart_style_default.a.legendColor, style: { backgroundColor: '#' + item.color } }),
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': donorDonutChart_style_default.a.legendDescription },
                                    item.fund_stream
                                ),
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': donorDonutChart_style_default.a.legendPercentage },
                                    Object(numberFormatter["f" /* roundTo */])(item.percentage, 2),
                                    '%'
                                )
                            );
                        })
                    )
                ) : null
            ),
            this.props.displayLegend && this.props.displayLegend == 'false' ? null : Object(preact_min["h"])(
                'div',
                { 'class': donorDonutChart_style_default.a.regularOtherLegend },
                Object(preact_min["h"])(donor_donut_chart_legend["a" /* default */], { legendLabel: this.props.legendLabel, legendData: this.props.data })
            )
        );
    };

    return DonorDonutChart;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/grouped-bar-chart/index.js
var grouped_bar_chart = __webpack_require__("2On6");

// EXTERNAL MODULE: ./components/contribution-indicator/index.js
var contribution_indicator = __webpack_require__("/HVV");

// EXTERNAL MODULE: ./components/donor-contribution-chart/index.js + 1 modules
var donor_contribution_chart = __webpack_require__("98F3");

// EXTERNAL MODULE: ./components/no-data-template/index.js
var no_data_template = __webpack_require__("wdDn");

// EXTERNAL MODULE: ./components/budget-expense-legend/index.js
var budget_expense_legend = __webpack_require__("COsE");

// EXTERNAL MODULE: ./static/assets/json/legendData.js
var legendData = __webpack_require__("PHpd");

// CONCATENATED MODULE: ./components/profilePage/helper.js
function regularAndOthersSplitter(regular, others) {
    var map1 = void 0,
        arr3 = void 0,
        arr4 = void 0;
    if (regular.length > 0 && others.length > 0) {

        var otherPercent = _.find(regular, function (obj) {
            return obj.fund_type === 'Other Resources';
        });

        otherPercent ? otherPercent = otherPercent.percentage : null;

        map1 = others.map(function (item) {
            item.percentage = item.percentage;
            return item;
        });

        arr3 = regular.filter(function (obj) {
            return obj.fund_type !== 'Other Resources';
        });
        map1 = _.remove(map1, function (n) {
            return n.fund_stream !== 'Regular Resources';
        });
        arr4 = [].concat(arr3, map1);
    }
    var result = {
        isChanged: true,
        data: arr4
    };

    return result;
}
// EXTERNAL MODULE: ./components/preLoader/index.js
var preLoader = __webpack_require__("ufjx");

// CONCATENATED MODULE: ./components/profilePage/components/generateDonorSummary.js














var _ref2 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref3 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref4 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var generateDonorSummary_generateDonorSummary = function generateDonorSummary(_ref) {
    var countryDetails = _ref.countryDetails,
        donutBudget = _ref.donutBudget,
        donutModality = _ref.donutModality,
        otherResourcesContributions = _ref.otherResourcesContributions,
        embed = _ref.embed,
        displayContributionSplit = _ref.displayContributionSplit,
        displayfundModality = _ref.displayfundModality,
        donorBasicDetails = _ref.donorBasicDetails,
        baseURL = _ref.baseURL,
        donorUrl = _ref.donorUrl,
        listStyle = _ref.listStyle,
        labelStyle = _ref.labelStyle,
        valueStyle = _ref.valueStyle;

    var countryDetailName = countryDetails && countryDetails.name ? countryDetails.name : "";
    var result = {
        isChanged: false,
        data: []
    };
    var totalContribution = void 0;
    if (donutBudget.length && donutModality.length && result.isChanged === false) {
        var regular = JSON.parse(JSON.stringify(donutBudget)),
            others = JSON.parse(JSON.stringify(donutModality));
        result = regularAndOthersSplitter(donutBudget, others);
    }
    if (donutBudget.length) {
        totalContribution = donutBudget.map(function (item) {
            return item.total_contribution;
        }).reduce(function (prev, next) {
            return prev + next;
        });
    }
    var iso3 = countryDetails.level_3_code ? countryDetails.level_3_code : countryDetails.iso3;
    return (
        // Donor Profile  start
        Object(preact_min["h"])(
            'section',
            { style: { margin: "3rem" } },
            Object(preact_min["h"])(
                'div',
                { style: { marginBottom: "3rem" }, className: style_default.a.boxWrapper },
                !donorBasicDetails.loading && !embed ? Object(preact_min["h"])('img', { 'class': style_default.a.flagIcon, onError: function onError(e) {
                        e.target.src = '/static/assets/images/Empty.svg';
                    }, src: countryDetails.unit_type !== 'OTH' ? baseURL + '/static/assets/flag_icons/' + iso3 + '.svg' : donorUrl }) : null,
                donorBasicDetails.loading ? Object(preact_min["h"])(
                    'div',
                    { style: { position: "relative", height: 83 } },
                    _ref2
                ) : Object(preact_min["h"])(
                    'div',
                    { style: { flexGrow: "1" } },
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': style_default.a.list + ' ' + style_default.a.ulWithFlag + ' ' + listStyle },
                        Object(preact_min["h"])(
                            'li',
                            null,
                            Object(preact_min["h"])(
                                'span',
                                { 'class': style_default.a.value + ' ' + valueStyle },
                                totalContribution ? Object(numberFormatter["d" /* numberToCurrencyFormatter */])(totalContribution, 2) : Object(numberFormatter["d" /* numberToCurrencyFormatter */])(0)
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': style_default.a.label + ' ' + labelStyle },
                                ' Total Contribution'
                            )
                        )
                    )
                )
            ),
            embed && displayContributionSplit && displayContributionSplit === 'true' || displayfundModality && displayfundModality === 'true' || !embed ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.wrapper + ' ' + style_default.a.chartWrapper },
                Object(preact_min["h"])(
                    'section',
                    { 'class': '' + style_default.a.contribution_other_resource_wrapper },
                    embed && displayContributionSplit && displayContributionSplit === 'true' || !embed ? Object(preact_min["h"])(
                        'div',
                        { style: { width: '48%' } },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': style_default.a.chartDonorHead },
                            countryDetailName,
                            '\'s Contribution'
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': '' + style_default.a.chartSmall },
                            result.data.length == 0 || Object(commonActionUtils["d" /* isAllPercentageZero */])('percentage', result.data) ? _ref3 : Object(preact_min["h"])(donorDonutChart_DonorDonutChart, {
                                regularOtherData: donutBudget,
                                donor_wrapper_styles: style_default.a.donor_wrapper_styles,
                                donut_styles: style_default.a.donut_styles,
                                legend_styles: style_default.a.legend_styles,
                                data: donutBudget,
                                legendData: [].concat(legendData["a" /* budgetSource */], otherResourcesContributions),
                                chartWidth: 456,
                                chartHeight: 456,
                                textFieldStyle: style_default.a.textFieldStyle,
                                chart_id: 'country_contribution',
                                textWrapperStyle: style_default.a.textWrapperStyle,
                                perc: embed ? style_default.a.perc : '',
                                dollor: embed ? style_default.a.dollor : ''
                            })
                        )
                    ) : null,
                    embed && displayfundModality && displayfundModality === 'true' || !embed ? Object(preact_min["h"])(
                        'div',
                        { style: { width: '48%' } },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': style_default.a.chartDonorHead },
                            'Contribution - ',
                            countryDetailName,
                            ' vs All Donors'
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': '' + style_default.a.chartSmall },
                            otherResourcesContributions.length ? Object(preact_min["h"])(
                                'div',
                                { 'class': style_default.a.progress },
                                Object(preact_min["h"])(donor_contribution_chart["a" /* default */], {
                                    data: otherResourcesContributions,
                                    country: countryDetailName })
                            ) : _ref4
                        )
                    ) : null
                )
            ) : null
        )
    );
};
/* harmony default export */ var components_generateDonorSummary = __webpack_exports__["a"] = (generateDonorSummary_generateDonorSummary);

/***/ }),

/***/ "iN9L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"text":"text__lJxlb","rect":"rect__1hw1k","img":"img__2gdCk","sdgImage":"sdgImage__RARRp","sdgCircle":"sdgCircle__2Bk03","toolTip":"toolTip__Q_n8m","head":"head__DiQcn","sdgWrapper":"sdgWrapper__AZNT7","backButtonContainer":"backButtonContainer__34GZW","backButton":"backButton__uA8aF","backImg":"backImg__2nq2n","embedArray":"embedArray__3GhMc","leftArray":"leftArray__2xyKG","rightArray":"rightArray__2G7Kx","svgIe":"svgIe__TFaKa"};

/***/ }),

/***/ "j+nI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export budgetFlowFetchStart */
/* unused harmony export budgetFlowFetchEnd */
/* unused harmony export budgetFlowClear */
/* unused harmony export budgetFlowFetchSuccess */
/* unused harmony export budgetFlowFetchFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchBudgetFinancialFlow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__("TOh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("dzhT");



var budgetFlowFetchStart = function budgetFlowFetchStart() {
	return {
		type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* FINANCIAL_FLOW */].start
	};
};

var budgetFlowFetchEnd = function budgetFlowFetchEnd() {
	return {
		type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* FINANCIAL_FLOW */].end
	};
};
var budgetFlowClear = function budgetFlowClear() {
	return {
		type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* FINANCIAL_FLOW */].clear
	};
};

var budgetFlowFetchSuccess = function budgetFlowFetchSuccess(data) {
	return {
		type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* FINANCIAL_FLOW */].success,
		data: data
	};
};

var budgetFlowFetchFailed = function budgetFlowFetchFailed(error) {
	return {
		type: __WEBPACK_IMPORTED_MODULE_1__index__["a" /* FINANCIAL_FLOW */].failed,
		error: error
	};
};

var fetchBudgetFinancialFlow = function fetchBudgetFinancialFlow(year) {
	return function (dispatch) {
		dispatch(budgetFlowFetchStart());
		if (year !== '') {
			return __WEBPACK_IMPORTED_MODULE_0__lib_api__["c" /* default */].get(__WEBPACK_IMPORTED_MODULE_0__lib_api__["c" /* default */].API_BUDGET_FINANCIAL_FLOW(year)).then(function (resp) {
				if (resp.success && resp.data) {
					dispatch(budgetFlowFetchEnd());
					dispatch(budgetFlowFetchSuccess(resp.data));
				} else {
					dispatch(budgetFlowFetchFailed());
				}
			}).catch(function (exception) {
				dispatch(budgetFlowFetchEnd());
				dispatch(budgetFlowFetchFailed(exception));
			});
		} else {
			dispatch(budgetFlowClear());
			dispatch(budgetFlowFetchFailed());
		}
	};
};

/***/ }),

/***/ "jDUJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3G5WI","titleWrapper":"titleWrapper__266CA","projectListWrapper":"projectListWrapper__2uuVA","mapWrapper":"mapWrapper__11tkO","flagListWrapper":"flagListWrapper__1KXqa","disclaimer":"disclaimer__1Bol_","filterHighlight":"filterHighlight__3TtNx","filterTextWrapper":"filterTextWrapper__2LSdP","topographyIconsContainer":"topographyIconsContainer__2FOlw","filterText":"filterText__3ujB5","filterTitle":"filterTitle__2AKuT","filterListWrapper":"filterListWrapper__IkiG-","filterInnerWrapper":"filterInnerWrapper__3nGBF","filterLabels":"filterLabels__XOk9U","chartWrapper":"chartWrapper__2CNHs","recipient_themes_wrapper":"recipient_themes_wrapper__1RyMj","budget_percent":"budget_percent__Ig27H","top_budget_sources_wrapper":"top_budget_sources_wrapper__3C3-O","chartHead":"chartHead__Qp-yF","budget_sources_wrapper":"budget_sources_wrapper__w7YxW","paddingBottom":"paddingBottom__1Ustl","summaryWrapper":"summaryWrapper__2Xqm7","imgDiv":"imgDiv__CV-Oy","ulWithFlag":"ulWithFlag__2aGdQ","list":"list__1vNSR","listItem":"listItem__3sG-e","value":"value__36PQ_","label":"label__1WBuI"};

/***/ }),

/***/ "jKcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/map/index.js + 6 modules
var map = __webpack_require__("wvix");

// EXTERNAL MODULE: ./components/bootstraptable/index.js + 2 modules
var bootstraptable = __webpack_require__("yNoq");

// EXTERNAL MODULE: ./components/budget-expense-legend/index.js
var budget_expense_legend = __webpack_require__("COsE");

// EXTERNAL MODULE: ./components/grouped-bar-chart/index.js
var grouped_bar_chart = __webpack_require__("2On6");

// EXTERNAL MODULE: ./components/no-data-template/index.js
var no_data_template = __webpack_require__("wdDn");

// EXTERNAL MODULE: ./components/preLoader/index.js
var preLoader = __webpack_require__("ufjx");

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// EXTERNAL MODULE: ./utils/commonActionUtils.js
var commonActionUtils = __webpack_require__("I9r4");

// EXTERNAL MODULE: ./components/sdgPage/components/style.scss
var style = __webpack_require__("T/dI");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/horizontalStackedBarChart/index.js + 1 modules
var horizontalStackedBarChart = __webpack_require__("eogv");

// CONCATENATED MODULE: ./components/sdgPage/components/index.js


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**************************** Preact files ******************************/


/**************************** Custom components *************************/
 // Themes Map
 // Themes Profile Projects Table
 // Budget Expense Legend
 // Themes Top Budget Sources, Top Recipient countries
 // No Data Template
 // No Data Template

/**************************** Util Actions *******************************/



/**************************** Style Files ********************************/



/*************************************************************************/

var _ref2 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref4 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref5 = Object(preact_min["h"])(
	'span',
	null,
	'Top 10 Donors'
);

var _ref6 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var _ref7 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref8 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref9 = Object(preact_min["h"])(
	'span',
	null,
	'Top 10 Recipient Countries'
);

var _ref10 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var _ref11 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref12 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var components_SdgPage = function (_Component) {
	_inherits(SdgPage, _Component);

	function SdgPage(props, context) {
		_classCallCheck(this, SdgPage);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.state = {
			themeSliderData: {}, // Theme Slider Data object
			themesMapData: {}, // Theme Map Data object
			projectList: {},
			listSelected: false,
			totalDataSize: 0,
			links: '',
			projectListArr: []
		};
		return _this;
	}

	SdgPage.prototype.componentWillMount = function componentWillMount() {
		this.props.fetchSdgSliderTargetData(this.props.currentYear, this.props.sdg_code);
		this.props.target_code ? this.props.fetchSdgTargetData(this.props.currentYear, this.props.target_code) : this.props.fetchSdgSliderData(this.props.currentYear, this.props.sdg_code);
		this.props.target_code ? this.props.loadTargetMapData(this.props.currentYear, this.props.target_code, "", "", "sdg_target") : this.props.loadSdgMapData(this.props.currentYear, this.props.sdg_code, "", "", "sdg");
	};

	SdgPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.currentYear !== this.props.currentYear) {
			this.props.target_code ? null : this.props.fetchSdgSliderTargetData(nextProps.currentYear, this.props.sdg_code);
			this.props.target_code ? this.props.fetchSdgTargetData(nextProps.currentYear, this.props.target_code) : this.props.fetchSdgSliderData(nextProps.currentYear, this.props.sdg_code);

			this.props.target_code ? this.props.loadTargetMapData(nextProps.currentYear, this.props.target_code, "", "", "sdg_target") : this.props.loadSdgMapData(nextProps.currentYear, this.props.sdg_code, "", "", "sdg");
		}
		if (Object.keys(nextProps.sdgSliderData.data).length) {
			this.setState({
				themeSliderData: nextProps.sdgSliderData
			});
		}

		if (Object.keys(nextProps.sdgMapData.data).length) {
			this.setState({
				themesMapData: nextProps.sdgMapData
			});
		}
		if (Object.keys(nextProps.projectList.projectList.data).length) {
			this.setState({
				projectList: nextProps.projectList
			});
		}
		if (nextProps.projectList.projectList !== this.props.projectList.projectList) {
			var data = nextProps.projectList.projectList.data;
			var parseData = function parseData(data) {
				data.forEach(function (item) {
					item.country_name = item.country;
					item.probObj = {
						title: item.title,
						project_id: item.project_id
					};
					item.total_budget = item.budget === null ? 0 : item.budget;
					item.total_expense = item.expense === null ? 0 : item.expense;
				});
				return data;
			};
			this.setState({
				projectListArr: parseData(data),
				totalDataSize: nextProps.projectList.projectList.count,
				links: nextProps.projectList.projectList.links
			});
		}
	};

	SdgPage.prototype.render = function render(props, _ref) {
		var _this2 = this;

		var projectList = _ref.projectList,
		    totalDataSize = _ref.totalDataSize,
		    themesMapData = _ref.themesMapData,
		    themeSliderData = _ref.themeSliderData,
		    sdgSliderData = _ref.sdgSliderData,
		    projectListArr = _ref.projectListArr;

		_objectDestructuringEmpty(props);

		var isNonEmpty = Object.keys(this.state.themeSliderData).length,
		    isMapDataNonEmpty = Object.keys(this.state.themesMapData).length,
		    aggregate = isNonEmpty ? themeSliderData.data && themeSliderData.data.aggregate : {},
		    budgetSources = isNonEmpty ? themeSliderData.data && themeSliderData.data.budget_sources : {},
		    topRecipientOffices = isNonEmpty ? themeSliderData.data && themeSliderData.data.top_recipient_offices : {},
		    mapData = isMapDataNonEmpty ? themesMapData && themesMapData.data && themesMapData : {},
		    sdgSrc = aggregate && aggregate.sdg && Object(commonActionUtils["c" /* getSDGImageFromCode */])(aggregate.sdg),
		    sdgMapData = this.props.sdgMapData;
		if (this.props.target_code && Object.keys(aggregate).length) this.props.onUpdateSDG(aggregate);

		return Object(preact_min["h"])(
			'div',
			{ 'class': style_default.a.profile_page_container },
			Object(preact_min["h"])(
				'div',
				{ 'class': style_default.a.wrapper },
				Object(preact_min["h"])(
					'div',
					null,
					!this.props.target_code ? null : Object(preact_min["h"])(
						'span',
						{ 'class': style_default.a.SDGdisclaimer },
						Object.keys(this.props.sdgSliderData.data).length ? this.props.sdgSliderData.targetTitle : ''
					),
					!this.props.sdgSliderData.loading ? Object.keys(aggregate).length && this.props.sdgSliderData.data.aggregate ? Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.infoWrapper },
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.imageWrapper },
							sdgSrc ? Object(preact_min["h"])('img', { 'class': style_default.a.sdg_image, src: '/static/assets/icons/' + sdgSrc, alt: 'sdg icon' }) : null
						),
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.tableWrapper },
							Object(preact_min["h"])(
								'ul',
								{ 'class': style_default.a.list },
								Object(preact_min["h"])(
									'li',
									null,
									Object(preact_min["h"])(
										'span',
										{ 'class': style_default.a.value },
										aggregate.total_budget && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(aggregate.total_budget, 2)
									),
									Object(preact_min["h"])(
										'span',
										{ 'class': style_default.a.label },
										'Budget'
									)
								),
								Object(preact_min["h"])(
									'li',
									null,
									Object(preact_min["h"])(
										'span',
										{ 'class': style_default.a.value },
										aggregate.total_expense && Object(numberFormatter["d" /* numberToCurrencyFormatter */])(aggregate.total_expense, 2)
									),
									Object(preact_min["h"])(
										'span',
										{ 'class': style_default.a.label },
										'Expenditure'
									)
								),
								Object(preact_min["h"])(
									'li',
									null,
									Object(preact_min["h"])(
										'span',
										{ 'class': style_default.a.value },
										aggregate.total_projects && Object(numberFormatter["c" /* numberToCommaFormatter */])(aggregate.total_projects)
									),
									Object(preact_min["h"])(
										'span',
										{ 'class': style_default.a.label },
										'Projects'
									)
								),
								Object(preact_min["h"])(
									'li',
									null,
									Object(preact_min["h"])(
										'span',
										{ 'class': style_default.a.value },
										aggregate.budget_sources && Object(numberFormatter["c" /* numberToCommaFormatter */])(aggregate.budget_sources)
									),
									Object(preact_min["h"])(
										'span',
										{ 'class': style_default.a.label },
										'Donors'
									)
								)
							)
						)
					) : _ref2 : Object(preact_min["h"])(
						'div',
						{ style: { position: 'relative', height: 53 } },
						_ref3
					)
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': style_default.a.mapWrapper, style: this.state.listSelected && { height: 'auto' } },
				Object(preact_min["h"])(
					'span',
					{ 'class': style_default.a.mapSwitchContainer },
					Object(preact_min["h"])(
						'span',
						{ 'class': style_default.a.mapSwitch },
						Object(preact_min["h"])('button', {
							'class': this.state.listSelected ? style_default.a.mapBtn : style_default.a.mapBtn + ' ' + style_default.a.mapSelected,
							onClick: function onClick() {
								return _this2.setState({ listSelected: false });
							}
						}),
						Object(preact_min["h"])('button', { 'class': this.state.listSelected ? style_default.a.mapBtn + ' ' + style_default.a.listSelected : style_default.a.mapBtn,
							onClick: function onClick() {
								return _this2.setState({ listSelected: true });
							}
						})
					)
				),
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						'div',
						{ style: { paddingTop: '9px', display: this.state.listSelected ? 'block' : 'none' } },
						Object(preact_min["h"])(bootstraptable["a" /* default */], { count: totalDataSize,
							currentYear: this.props.currentYear,
							sdg: this.props.sdg_code,
							data: projectListArr,
							sdg_targets: this.props.target_code
						})
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.mapContainer, style: { position: 'relative', display: this.state.listSelected ? 'none' : 'block' } },
						Object.keys(sdgMapData).length && !sdgMapData.loading ? Object(preact_min["h"])(map["a" /* default */], {
							sdg: this.props.sdg_code,
							mapData: sdgMapData,
							sdgTarget: this.props.target_code,
							startYear: this.props.target_code ? 2018 : 2016,
							yearSelected: this.props.currentYear
						}) : _ref4,
						isMapDataNonEmpty ? Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.disclaimer },
							'* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'
						) : null
					)
				),
				!this.state.listSelected ? window.dispatchEvent(new Event('resize')) : null
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': style_default.a.wrapper + ' ' + style_default.a.chartWrapper },
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.top_budget_sources_wrapper },
					Object(preact_min["h"])(
						'span',
						{ 'class': style_default.a.chartHead },
						_ref5,
						_ref6
					),
					!this.props.sdgSliderData.loading ? Object(preact_min["h"])(
						'div',
						null,
						budgetSources.length > 0 && this.props.sdgSliderData.data.budget_sources ? Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.budget_sources_wrapper },
							Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
								chart_id: 'sdg_profile_budget_sources',
								width: 1200,
								height: 500,
								min_height: 540,
								data: budgetSources,
								label: 'short_name',
								tspanSize: '12px',
								textSize: '12px'
							})
						) : _ref7
					) : Object(preact_min["h"])(
						'div',
						{ style: { position: 'relative', height: 344 } },
						_ref8
					)
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': style_default.a.wrapper + ' ' + style_default.a.chartWrapper },
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.top_budget_sources_wrapper },
					Object(preact_min["h"])(
						'span',
						{ 'class': style_default.a.chartHead },
						_ref9,
						_ref10
					),
					!this.props.sdgSliderData.loading ? Object.keys(topRecipientOffices).length && this.props.sdgSliderData.data.top_recipient_offices ? Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.budget_sources_wrapper },
						Object(preact_min["h"])(grouped_bar_chart["a" /* default */], {
							chart_id: 'sdg_profile_top_recipient_offices',
							width: 1200,
							height: 500,
							min_height: 540,
							data: topRecipientOffices,
							label: 'iso3',
							tspanSize: '12px',
							textSize: '12px'
						})
					) : _ref11 : Object(preact_min["h"])(
						'div',
						{ style: { position: 'relative', height: 344 } },
						_ref12
					)
				)
			)
		);
	};

	return SdgPage;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/themeSlider/actions/index.js
var actions = __webpack_require__("yuQp");

// EXTERNAL MODULE: ./components/sdgSlider/actions/index.js
var sdgSlider_actions = __webpack_require__("aYEV");

// EXTERNAL MODULE: ./shared/actions/mapActions/themesMapData.js
var mapActions_themesMapData = __webpack_require__("t4UN");

// EXTERNAL MODULE: ./shared/actions/mapActions/sdgMapData.js
var mapActions_sdgMapData = __webpack_require__("H+FH");

// EXTERNAL MODULE: ./shared/actions/getProjectList.js
var getProjectList = __webpack_require__("STnb");

// EXTERNAL MODULE: ./components/sdgSlider/actions/targetAction.js
var targetAction = __webpack_require__("TVaU");

// CONCATENATED MODULE: ./components/sdgPage/index.js
/**************************** Preact files ******************************/


/**************************** Custom components *************************/


/**************************** Redux Actions *******************************/







var mapStateToProps = function mapStateToProps(state) {
	var themeSliderData = state.themeSliderData,
	    sdgSliderData = state.sdgSliderData,
	    _state$mapData = state.mapData,
	    themesMapData = _state$mapData.themesMapData,
	    sdgMapData = _state$mapData.sdgMapData,
	    projectList = state.projectList,
	    currentYear = state.yearList.currentYear,
	    sdgTargetSliderData = state.sdgTargetSliderData;

	return {
		themeSliderData: themeSliderData,
		themesMapData: themesMapData,
		projectList: projectList,
		currentYear: currentYear,
		sdgSliderData: sdgSliderData,
		sdgMapData: sdgMapData,
		sdgTargetSliderData: sdgTargetSliderData
	};
};
var sdgPage_mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		fetchDonorSliderData: function fetchDonorSliderData(year, sector) {
			return dispatch(Object(actions["b" /* fetchDonorSliderData */])(year, sector));
		},
		loadThemesMapData: function loadThemesMapData(year, sector) {
			return dispatch(Object(mapActions_themesMapData["b" /* loadThemesMapData */])(year, sector));
		},
		loadTargetMapData: function loadTargetMapData(year, target, unit, source, tab) {
			return dispatch(Object(mapActions_sdgMapData["c" /* loadTargetMapData */])(year, target, unit, source, tab));
		},
		loadSdgMapData: function loadSdgMapData(year, sdg, unit, source, tab) {
			return dispatch(Object(mapActions_sdgMapData["b" /* loadSdgMapData */])(year, sdg, unit, source, tab));
		},
		updateProjectList: function updateProjectList(year, unit, source, theme, keyword, limit, offset, budgetType, sdg, target) {
			return dispatch(Object(getProjectList["c" /* updateProjectList */])(year, unit, source, theme, keyword, limit, offset, budgetType, sdg, target));
		},
		fetchSdgSliderData: function fetchSdgSliderData(year, sdg) {
			return dispatch(Object(sdgSlider_actions["b" /* fetchSdgSliderData */])(year, sdg));
		},
		fetchSdgTargetData: function fetchSdgTargetData(year, targetId) {
			return dispatch(Object(sdgSlider_actions["c" /* fetchSdgTargetData */])(year, targetId));
		},
		fetchSdgSliderTargetData: function fetchSdgSliderTargetData(year, sdg) {
			return dispatch(Object(targetAction["b" /* fetchSdgSliderTargetData */])(year, sdg));
		}
	};
};

/* harmony default export */ var sdgPage = __webpack_exports__["a"] = (Object(preact_redux_esm["a" /* connect */])(mapStateToProps, sdgPage_mapDispatchToProps)(components_SdgPage));

/***/ }),

/***/ "jQ4o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DonorDonutChartLegend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("UTu5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DonorDonutChartLegend = function (_Component) {
	_inherits(DonorDonutChartLegend, _Component);

	function DonorDonutChartLegend() {
		_classCallCheck(this, DonorDonutChartLegend);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	DonorDonutChartLegend.prototype.render = function render() {
		var _this2 = this;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.legend_wrapper },
			this.props.legendData.map(function (item, index) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.legendText },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.legendColor, style: { backgroundColor: '#' + item.color } }),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.legendLabel + ' ' + _this2.props.legendLabel },
						item.fund_type
					)
				);
			})
		);
	};

	return DonorDonutChartLegend;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "jUQA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sdgLegend":"sdgLegend__3fL7m","rightSDG":"rightSDG__2Brdt","sdgImage":"sdgImage__Dw40b","leftSDG":"leftSDG__3Wltu","sdgItem":"sdgItem__Tl_sJ","sdgPercent":"sdgPercent__zxIz9","imageItem":"imageItem__3DcL7","othersItem":"othersItem__2evrH","sdgImageTop":"sdgImageTop__3Fyna","sdgName":"sdgName__2SR9U","sdgItemRight":"sdgItemRight__jGCMx","sdgTooltip":"sdgTooltip__2dlSn","mainPercentageWrapper":"mainPercentageWrapper__32UoI"};

/***/ }),

/***/ "k7Db":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ./components/sunburstChart/style.scss
var style = __webpack_require__("UhRM");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/d3/d3.js
var d3 = __webpack_require__("tokj");
var d3_default = /*#__PURE__*/__webpack_require__.n(d3);

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// EXTERNAL MODULE: ./utils/commonActionUtils.js
var commonActionUtils = __webpack_require__("I9r4");

// EXTERNAL MODULE: ./utils/commonMethods.js
var commonMethods = __webpack_require__("Cdrj");

// EXTERNAL MODULE: ./components/sunburstChart/components/sdgLegend/style.scss
var sdgLegend_style = __webpack_require__("/lS5");
var sdgLegend_style_default = /*#__PURE__*/__webpack_require__.n(sdgLegend_style);

// CONCATENATED MODULE: ./components/sunburstChart/constants.js


var TOOLTIP_LABEL = 'rightSDGTooltip';
var SDG_OTHERS = "0";

function TOOLTIP_HTML(sdg) {
    return '<span><b>' + sdg.name + ': </b></span><span>' + sdg.fullName + '</span><br><span"><b>Budget: </b></span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(sdg.size.budget, 0) + '</span><br><span"><b> Expenditure: </b></span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(sdg.size.expense, 0) + '</span>';
}
// CONCATENATED MODULE: ./components/sunburstChart/components/sdgLegend/index.js




var getData = function getData(data, side) {
	return side === "right" ? data.slice(0, Math.ceil(data.length / 2)) : data.slice(Math.ceil(data.length / 2), data.length);
};

var sdgLegend_SDGLegend = function SDGLegend(props) {

	return Object(preact_min["h"])(
		'div',
		{ 'class': sdgLegend_style_default.a.sdgLegend },
		getData(props.data, props.side).map(function (item, index) {
			return Object(preact_min["h"])(
				'div',
				{ 'class': sdgLegend_style_default.a.sdgItem + ' ' + (props.sdgTooltip === TOOLTIP_LABEL ? sdgLegend_style_default.a.rightSDG : sdgLegend_style_default.a.leftSDG), key: index },
				Object(preact_min["h"])(
					'span',
					{ style: { 'width': '10%', 'marginRight': '20px' } },
					Number(item.size.percentage).toFixed(1),
					'%'
				),
				Object(preact_min["h"])(
					'span',
					{ 'class': sdgLegend_style_default.a.sdgImage,
						style: item.code !== SDG_OTHERS ? { backgroundColor: '#' + item.color } : null
					},
					Object(preact_min["h"])('img', { 'class': item.code !== SDG_OTHERS ? sdgLegend_style_default.a.imageItem : sdgLegend_style_default.a.othersItem,
						src: props.baseURL + ('' + item.image)
					})
				),
				item.code === SDG_OTHERS ? Object(preact_min["h"])(
					'span',
					{ id: props.sdgTooltip + '-' + index, 'class': sdgLegend_style_default.a.sdgName },
					' ',
					item.fullName,
					' '
				) : Object(preact_min["h"])(
					'a',
					{ style: { 'padding': '0 10px' }, id: props.sdgTooltip + '-' + index,
						href: '/sdg/' + item.code + '/' + item.fullName,
						target: props.embed ? '_blank' : '_self'
					},
					Object(preact_min["h"])(
						'span',
						{ 'class': sdgLegend_style_default.a.sdgName },
						item.fullName
					)
				)
			);
		}),
		Object(preact_min["h"])('div', { id: props.sdgTooltip, 'class': sdgLegend_style_default.a.sdgTooltip })
	);
};

/* harmony default export */ var sdgLegend = (sdgLegend_SDGLegend);
// EXTERNAL MODULE: ./routes/sdgLanding/action/index.js
var action = __webpack_require__("24AF");

// CONCATENATED MODULE: ./components/sunburstChart/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**************************** Preact files ******************************/



/**************************** Style files******************************/


/**************************** Components ******************************/







var sunburstChart_SunburstChart = function (_Component) {
    _inherits(SunburstChart, _Component);

    function SunburstChart(props) {
        _classCallCheck(this, SunburstChart);

        var _this2 = _possibleConstructorReturn(this, _Component.call(this, props));

        _this2.isIE = false;
        return _this2;
    }

    SunburstChart.prototype.componentDidMount = function componentDidMount() {
        this._onSunburstBarChart(this);
    };

    SunburstChart.prototype._onSunburstBarChart = function _onSunburstBarChart(sunburstChart) {

        if (Object(commonActionUtils["b" /* getBrowserInformation */])() && Object(commonActionUtils["b" /* getBrowserInformation */])().toString().indexOf('IE') !== -1) this.isIE = true;

        var userAgentString = window.navigator.userAgent.toLocaleLowerCase(),
            isSafari = userAgentString.indexOf("safari") && (userAgentString.indexOf("iphone") > -1 || userAgentString.indexOf("ipad") > -1);

        var margins = {
            top: 40,
            right: 40,
            bottom: 45,
            left: 40
        },
            translateIndex = this.isIE ? -70 : 30;
        ;
        var width = this.props.width ? this.props.width : 400,
            height = this.props.height ? this.props.height - margins.bottom : 300,
            radius = Math.min(this.props.width, this.props.height) / 2,
            lastSelectedNode,
            _this = this;

        var x = d3_default.a.scale.linear().range([0, 2 * Math.PI]);

        var y = d3_default.a.scale.linear().range([0, radius]);

        var partition = d3_default.a.layout.partition().sort(function (a, b) {
            return d3_default.a.ascending(Number(a.code), Number(b.code));
        }).value(function (d) {
            return d.size ? d.size.budget : 1;
        });
        if (!d3_default.a.select('#' + this.props.chart_id).empty()) {
            d3_default.a.select('#' + this.props.chart_id + ' svg').remove();
        }
        var svg = d3_default.a.select('#' + this.props.chart_id).append("svg").attr("id", "multi_level_svg").attr("preserveAspectRatio", "xMidYMid meet").attr("viewBox", "0 0 " + width + " " + (height + margins.bottom + margins.top)).classed("svg-content", true).classed(this.isIE ? '' + style_default.a.svgIe : '', true).append("g").attr("transform", "translate(" + width / 2 + "," + (height / 2 + translateIndex) + ")");

        var tooltip = d3_default.a.select("body").append("div").attr("class", style_default.a.toolTip);
        var isLevelOne = true;

        d3_default.a.select("g").append("foreignObject").html(function (d) {
            return '<div style="line-height:55px;justify-content:center;text-align:center;display:flex;font-weight: 1000;font-size: 45px;color: #000;margin-right: 41px;">Sustainable Development Goals</div>';
        }).attr("x", -115).attr("y", -90).attr("width", 300).attr("height", 200);

        var startAngle = 0;
        var endAngle = 0;
        var arc = d3_default.a.svg.arc().startAngle(function (d) {
            startAngle = Math.max(0, Math.min(2 * Math.PI, x(d.x)));
            return Math.max(0, Math.min(2 * Math.PI, x(d.x)));
        }).endAngle(function (d) {
            endAngle = Math.max(0, Math.min(2 * Math.PI, x(d.x + d.dx)));
            // return (endAngle - startAngle ) < 0.17? d.depth === 2?  0.17 : endAngle :endAngle ;
            return endAngle;
        }).innerRadius(function (d) {
            return isLevelOne ? 180 : Math.max(0, y(d.y));
        }).outerRadius(function (d) {
            return 307;
        });

        var g = svg.selectAll("path").data(partition.nodes(this.props.data)).enter().append("g");

        var path = g.append("path").attr("d", arc).style("fill", function (d) {
            return '#' + d.color;
        }).style("stroke", "#ffffff").style("stroke-width", function (d) {
            return d.image ? '0px' : '1px';
        }).attr("opacity", function (d) {
            return d.name === '' || d.code !== "0" && !d.children ? 0 : 1;
        }).style("display", function (d) {
            return d.name === '' || d.code !== "0" && !d.children ? 'none' : 'block';
        }).attr('class', style_default.a.rect).on("click", click);
        if (!isSafari) {
            path.on("mousemove", function (d) {
                if (d.name) {
                    tooltip.style("left", d3_default.a.event.pageX + 50 + "px").style("top", d3_default.a.event.pageY - 70 + "px").style("display", "inline-block").style("z-index", 2).html(d.code !== "0" && !d.children ? '<span class="' + style_default.a.head + '">' + d.name + ': </span><span>' + d.description + '</span><br><span class="' + style_default.a.head + '">Budget: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.budget, 0) + '</span><br><span class="' + style_default.a.head + '"> Expenditure: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.expense, 0) + '</span>' : '<span class="' + style_default.a.head + '">' + d.name + ': </span><span>' + d.fullName + '</span><br><span class="' + style_default.a.head + '">Budget: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.budget, 0) + '</span><br><span class="' + style_default.a.head + '"> Expenditure: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.expense, 0) + '</span>');
                }
            }).on("mouseout", function (d) {
                tooltip.style("display", "none");
            });
        }

        var text = g.append("text").filter(filter_min_arc_size_text).attr("transform", function (d) {
            return "translate(" + arc.centroid(d) + ")rotate(" + computeTextRotation(d) + ")";
        }).attr("text-anchor", "middle").attr("dx", "0") // margin
        .attr("dy", ".35em") // vertical-align

        .style("font-size", "15px").style("display", function (d) {
            return d.name === '' || d.code !== "0" && !d.children ? 'none' : 'block';
        }).style("fill", "#ffffff").on("click", click).style("cursor", "pointer").on("mousemove", function (d) {
            if (d.name) {
                tooltip.style("left", d3_default.a.event.pageX + 50 + "px").style("top", d3_default.a.event.pageY - 70 + "px").style("display", "inline-block").html(d.code !== "0" && !d.children ? '<span class="' + style_default.a.head + '">' + d.name + ': </span><span>' + d.description + '</span>' : '<span class="' + style_default.a.head + '">' + d.name + ': </span><span>' + d.fullName + '</span><br><span class="' + style_default.a.head + '">Budget: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.budget, 0) + '</span><br><span class="' + style_default.a.head + '"> Expenditure: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.expense, 0) + '</span>');
            }
        }).on("mouseout", function (d) {
            tooltip.style("display", "none");
        });

        g.append("svg:image").attr("transform", function (d) {
            return "translate(" + arc.centroid(d) + ")rotate(" + computeImageRotation(d) + ")";
        }).attr("text-anchor", "middle").attr("dx", "0") // margin
        .attr("dy", ".35em") // vertical-align
        .attr('width', 156).attr('height', 156).style("display", 'none').attr("opacity", 0).attr('class', style_default.a.rect).on("click", imageClick).attr("xlink:href", function (d) {
            return d.image ? d.image : '';
        });

        function filter_min_arc_size_text(d, i) {
            var compare = void 0;
            if (d.depth > 1) {
                compare = 0.1;
                if (d.parent.name === 'SDG 3') {
                    compare = 0.25;
                }
                if (d.parent.name === 'SDG 16') {
                    compare = 0.3;
                }
            } else {
                compare = 1;
            }
            return d.dx * d.depth * radius / 2 > compare;
        };

        function click(d, isImgClick) {
            var goBack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (d.code !== "0") {
                isLevelOne = goBack;
                tooltip.style("display", "none");
                d.code ? sunburstChart.props.updateSDG(parseInt(d.code)) : sunburstChart.props.updateSDG('');
                var glowCircle = d3_default.a.select('#glowCircle');
                glowCircle ? glowCircle.remove() : null;
                if (!isLevelOne) {
                    setTimeout(function () {
                        var path2 = d3_default.a.select("g").append("circle").attr("cx", 0).attr("cy", 0).attr("r", 158).attr('class', '' + style_default.a.sdgCircle).attr("id", 'glowCircle').style("fill", function (d) {
                            return 'transparent';
                        }).style("stroke", "#fdfdfd").style("stroke-width", '3px').style("stroke-linejoin", "round").style("stroke-linecap", "round");
                    }, 1000);
                }
                if (isImgClick === 0) return;

                if (!d.children) {
                    _this.props.onTargetClick(d);
                    return;
                }

                text.transition().attr("opacity", 0);
                path.transition().duration(750).attrTween("d", arcTween(d)).each("end", function (e, i) {
                    var arcTextAll = d3_default.a.select(this.parentNode).select("text");
                    arcTextAll.transition().duration(750).style("display", 'none');
                    // check if the animated element's data e lies within the visible angle span given in d
                    if (e.x >= d.x && e.x < d.x + d.dx) {
                        // get a selection of the associated text element
                        if (!isLevelOne) {
                            document.getElementById("leftArray").style.display = "none";
                            document.getElementById("rightArray").style.display = "none";
                            document.getElementById("sdgBackButton").style.display = "inline-block";
                            document.getElementById('sdgBackButton').onclick = function goBack() {
                                if (lastSelectedNode) {
                                    click(lastSelectedNode.parent, true, true);
                                }
                            };
                            var arcText = d3_default.a.select(this.parentNode).select("text");
                            // fade in the text element and recalculate positions
                            arcText.filter(filter_min_arc_size_text).attr("transform", function (d) {
                                return "translate(" + arc.centroid(d) + ")rotate(" + computeTextRotation(d) + ")";
                            }).attr("text-anchor", "middle").attr("dx", "0") // margin
                            .attr("dy", ".35em") // vertical-align
                            .text(function (d, i) {
                                return d.name;
                            }).style("font-size", "15px").style("pointer-events", "none").style("display", function (d) {
                                return d.name === '' || d.code !== "0" && !d.children ? 'none' : 'block';
                            }).style("fill", "#ffffff").on("click", click).style("cursor", "pointer").on("mousemove", function (d) {
                                if (d.name) {
                                    tooltip.style("left", d3_default.a.event.pageX + 50 + "px").style("top", d3_default.a.event.pageY - 70 + "px").style("display", "inline-block").html(d.code !== "0" && !d.children ? '<span class="' + style_default.a.head + '">' + d.name + ': </span><span>' + d.description + '</span>' : '<span class="' + style_default.a.head + '">' + d.name + ': </span><span>' + d.fullName + '</span><br><span class="' + style_default.a.head + '">Budget: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.budget, 0) + '</span><br><span class="' + style_default.a.head + '"> Expenditure: </span><span>' + Object(numberFormatter["d" /* numberToCurrencyFormatter */])(d.size.expense, 0) + '</span>');
                                }
                            }).on("mouseout", function (d) {
                                tooltip.style("display", "none");
                            }).transition().duration(750).attr("opacity", function (d) {
                                return d.image ? isImgClick === true ? 1 : 0 : 1;
                            }).attr("transform", function (d) {
                                return "translate(" + arc.centroid(d) + ")rotate(" + computeTextRotation(d) + ")";
                            }).style("display", function (d) {
                                return getPathOpacity(d, isImgClick) === 1 ? 'block' : 'none';
                            }).attr("text-anchor", "middle");
                        } else {
                            document.getElementById("leftArray").style.display = "inline-block";
                            document.getElementById("rightArray").style.display = "inline-block";
                            document.getElementById("sdgBackButton").style.display = "none";
                        }

                        var arcImage = d3_default.a.select(this.parentNode).select("image");
                        arcImage.transition().duration(750).attr("opacity", d.image ? 1 : 0).style("display", d.image ? 'block' : 'none').attr("transform", function (d) {
                            return "translate(" + -70 + ", -80)rotate(" + computeImageRotation(d) + ")";
                        }).attr("text-anchor", "middle");

                        var pathItem = d3_default.a.select(this.parentNode).select("path");
                        pathItem.transition().duration(750).attr("opacity", function (d) {
                            return getPathOpacity(d, isImgClick);
                        }).style("display", function (d) {
                            return getPathOpacity(d, isImgClick) === 1 ? 'block' : 'none';
                        });
                    }
                });

                lastSelectedNode = d;
                _this.props.handleOnClick(lastSelectedNode);
            }
        }

        function imageClick(d) {
            _this.props.onSDGClick(d);
        }
        function getPathOpacity(d, isImgClick) {
            var opacityVal = 0;
            if (isImgClick === true) {
                opacityVal = d.name ? d.code === "0" || d.children ? 1 : 0 : 0;
            } else opacityVal = d.name ? 1 : 0;

            return opacityVal;
        }
        function arcTween(d) {
            var xd = d3_default.a.interpolate(x.domain(), [d.x, d.x + d.dx]),
                yd = d3_default.a.interpolate(y.domain(), [d.y, 1]),
                yr = d3_default.a.interpolate(y.range(), [d.y ? 20 : 0, radius]);
            return function (d, i) {
                return i ? function (t) {
                    return arc(d);
                } : function (t) {
                    x.domain(xd(t));
                    y.domain(yd(t)).range(yr(t));
                    return arc(d);
                };
            };
        }

        function computeTextRotation(d) {
            var ang = (x(d.x + d.dx / 2) - Math.PI / 2) / Math.PI * 180;
            return ang > 90 ? 180 + ang : ang;
        }
        function computeImageRotation(d) {
            return 0;
        }
    };

    SunburstChart.prototype.render = function render() {
        if (this.props.data && this.props.data.children) {
            var windowWidth = window.innerWidth;
            return Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.sdgWrapper },
                Object(preact_min["h"])(
                    'span',
                    { style: {
                            display: 'inline-block',
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            zIndex: 1
                        },
                        id: 'rightArray',
                        'class': this.props.embed ? style_default.a.rightArray + ' ' + style_default.a.embedArray : style_default.a.rightArray
                    },
                    Object(preact_min["h"])(sdgLegend, {
                        data: this.props.data.children,
                        side: 'right',
                        embed: this.props.embed,
                        sdgTooltip: 'rightSDGTooltip',
                        baseURL: Object(commonMethods["d" /* getAPIBaseUrRl */])()
                    })
                ),
                Object(preact_min["h"])('div', { style: {
                        height: 'auto', position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0
                    },
                    'class': style_default.a.hStackedBar_chart,
                    id: this.props.chart_id }),
                Object(preact_min["h"])(
                    'span',
                    { style: {
                            display: 'inline-block', position: 'absolute',
                            top: 0,
                            left: 0
                        },
                        id: 'leftArray',
                        'class': this.props.embed ? style_default.a.leftArray + ' ' + style_default.a.embedArray : style_default.a.leftArray },
                    Object(preact_min["h"])(sdgLegend, {
                        data: this.props.data.children,
                        side: 'left',
                        embed: this.props.embed,
                        baseURL: Object(commonMethods["d" /* getAPIBaseUrRl */])()
                    })
                ),
                Object(preact_min["h"])(
                    'section',
                    { 'class': style_default.a.backButtonContainer + ' ' + this.props.backButtonTop },
                    Object(preact_min["h"])(
                        'button',
                        { id: 'sdgBackButton', 'class': style_default.a.backButton },
                        windowWidth >= 650 ? Object(preact_min["h"])('img', { src: Object(commonMethods["d" /* getAPIBaseUrRl */])() + '/static/assets/icons/backButtonImg.png', 'class': style_default.a.backImg }) : null,
                        'Back'
                    )
                )
            );
        }
    };

    return SunburstChart;
}(preact_min["Component"]);

var mapStateToProps = function mapStateToProps(state) {
    var sdgSelected = state.sdgSelected;

    return {
        sdgSelected: sdgSelected
    };
};

var sunburstChart_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        updateSDG: function updateSDG(sdg) {
            return dispatch(Object(action["b" /* updateSDG */])(sdg));
        }
    };
};

/* harmony default export */ var components_sunburstChart = __webpack_exports__["a"] = (Object(preact_redux_esm["a" /* connect */])(mapStateToProps, sunburstChart_mapDispatchToProps)(sunburstChart_SunburstChart));

/***/ }),

/***/ "mZqR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"legend_wrapper":"legend_wrapper__3HF5p","regularOtherItem":"regularOtherItem__ExVT0","total_contribution":"total_contribution__2y8ED","percentage":"percentage__3mspL","fundType":"fundType__jrtpy","legendCenter":"legendCenter__zkwaI","legendText":"legendText__341Ts","legendColor":"legendColor__3mTk-","legendLabel":"legendLabel__sr9kY"};

/***/ }),

/***/ "mmqk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3prFI","imageWrapper":"imageWrapper__3f9rs","sdg_image":"sdg_image__1eXiZ","list":"list__3qEO5","value":"value__2QcMo","label":"label__2OccX","mapContainer":"mapContainer__3VMcB","disclaimer":"disclaimer__2wWWm","chartWrapper":"chartWrapper__2qmLp","recipient_themes_wrapper":"recipient_themes_wrapper__1D-cF","budget_percent":"budget_percent__XclWT","top_budget_sources_wrapper":"top_budget_sources_wrapper__cDQhr","chartHead":"chartHead__1cltg","infoWrapper":"infoWrapper__2FpI5","tableWrapper":"tableWrapper__3wdXl","titleWrapper":"titleWrapper__1tsZY","backButtonTop":"backButtonTop__2p2sM"};

/***/ }),

/***/ "n5Fx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chartWrapper":"chartWrapper__34I-J","titleWrapper":"titleWrapper__3TjH8","filterTextWrapper":"filterTextWrapper__26aL5","topographyIconsContainer":"topographyIconsContainer__1qWgi","filterText":"filterText__U6QVP","filterTitle":"filterTitle__2rROm","filterListWrapper":"filterListWrapper__2Ctmv","filterInnerWrapper":"filterInnerWrapper__3wy18","filterLabels":"filterLabels__KVPOr","preLoaderWrapper":"preLoaderWrapper__2YHvS","detailViewWrapper":"detailViewWrapper__28je1","donorsourceTitle":"donorsourceTitle__3AMB5","detailView":"detailView__1Ef95","statsWrapper":"statsWrapper__3vS8q","stats":"stats__2iOQf","contributionBarWrapper":"contributionBarWrapper__3jdXF","contributionBar":"contributionBar__1_p7r","barLabel":"barLabel__18Jmr","barValue":"barValue__2jm61","barTextWrapper":"barTextWrapper__ebkcI","barTextLeft":"barTextLeft__Lg1tR","barTextRight":"barTextRight__1zrZT"};

/***/ }),

/***/ "pqrH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PurchaseOrderTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("+Un9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__ = __webpack_require__("X5Y7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal__ = __webpack_require__("Dpjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_assets_icons_closeIcon_png__ = __webpack_require__("k8Z6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_assets_icons_closeIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_assets_icons_closeIcon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_assets_json_projectDetailDocuments__ = __webpack_require__("CamH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dropList__ = __webpack_require__("wdAp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__preLoader__ = __webpack_require__("ufjx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tableCards__ = __webpack_require__("3y4k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dateFormatter__ = __webpack_require__("GXBc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__no_data_template__ = __webpack_require__("wdDn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_numberFormatter__ = __webpack_require__("Au7/");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var DocumentCategoryList = ["sdvksdgs", "svkjdhsg"];

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__preLoader__["a" /* default */], null);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_10__no_data_template__["a" /* default */], null);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('link', { rel: 'stylesheet', href: 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css' });

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],
    {
        width: '10%',
        isKey: true,
        dataField: 'order_id' },
    'PO ID'
);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],
    { width: '20%',
        dataField: 'vendor_name' },
    'Vendor'
);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],
    { width: '30%',
        dataField: 'description' },
    'Description'
);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__preLoader__["a" /* default */], null);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_10__no_data_template__["a" /* default */], null);

var PurchaseOrderTable = function (_Component) {
    _inherits(PurchaseOrderTable, _Component);

    function PurchaseOrderTable(props) {
        _classCallCheck(this, PurchaseOrderTable);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.currencyFormat = function (cell, row) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.priceColumn },
                Object(__WEBPACK_IMPORTED_MODULE_11__utils_numberFormatter__["e" /* numberToDollarFormatter */])(cell)
            );
        };

        _this.dateFormat = function (cell, row) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_9__utils_dateFormatter__["a" /* getFormmattedDate */])(cell)
            );
        };

        _this.parseTableData = function () {
            var obj = {
                order_id: "PO ID",
                vendor_name: "Vendor",
                description: "Description",
                order_date: "Date",
                amount: "Amount"
            };
            var formattedarray = _this.props.data.map(function (item) {
                return _extends({}, item, {
                    order_date: Object(__WEBPACK_IMPORTED_MODULE_9__utils_dateFormatter__["a" /* getFormmattedDate */])(item.order_date),
                    amount: Object(__WEBPACK_IMPORTED_MODULE_11__utils_numberFormatter__["e" /* numberToDollarFormatter */])(item.amount)
                });
            });
            return [obj].concat(formattedarray);
        };

        _this.onMaximize = function () {
            _this.setState({ showMore: false });
        };

        _this.generateCardList = function (dataArray) {
            if (dataArray.length) {
                return dataArray.map(function (item) {
                    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__tableCards__["a" /* default */], {
                        data: item,
                        fields: [{
                            title: 'TITILE',
                            key: 'vendor_name',
                            displayTitle: false,
                            renderElement: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                'div',
                                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.vendorWrapper },
                                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                    'div',
                                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.docCategorylabel },
                                    'Vendor :'
                                ),
                                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                    'div',
                                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.docCategorytext },
                                    item.vendor_name
                                )
                            )

                        }, {
                            title: 'ID',
                            key: 'order_id',
                            displayTitle: false,
                            renderElement: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                'div',
                                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.projectId },
                                '# ' + item.project_id
                            )
                        }, {
                            title: 'COUNTRY',
                            key: 'description',
                            displayTitle: false,
                            renderElement: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                'div',
                                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.purchaseOrderDescription },
                                item.description
                            )

                        }, {
                            title: 'BUDGET',
                            key: 'order_date',
                            displayTitle: false,
                            renderElement: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                'div',
                                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.amountDateWrapper },
                                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                    'div',
                                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.amount },
                                    Object(__WEBPACK_IMPORTED_MODULE_9__utils_dateFormatter__["a" /* getFormmattedDate */])(item.order_date)
                                ),
                                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                    'div',
                                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.date },
                                    Object(__WEBPACK_IMPORTED_MODULE_11__utils_numberFormatter__["e" /* numberToDollarFormatter */])(item.amount)
                                )
                            )

                        }] });
                });
            } else {
                return [];
            }
        };

        _this.state = {
            showMore: props.data.length <= 20 ? false : true
        };
        _this.data = [{
            order_id: 'dssvdsvd',
            vendor_name: 'dsdvdsvdsvdd',
            description: 'ddsvdsvdsvd',
            order_date: 'ddsdvdsvdv',
            amount: 'ssssdvdsvdsv'
        }];
        return _this;
    }

    PurchaseOrderTable.prototype.componentDidMount = function componentDidMount() {
        if (this.props.data.length <= 20) this.setState({ showMore: false });else this.setState({ showMore: true });
    };

    PurchaseOrderTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.data.length <= 20) this.setState({ showMore: false });else this.setState({ showMore: true });
    };

    PurchaseOrderTable.prototype.render = function render(_ref, state) {
        var _this2 = this;

        var data = _ref.data;

        var options = {
            noDataText: this.props.loading ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.preloaderWrapper },
                _ref2
            ) : _ref3
        };
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.projectList + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.tableOuterWrapper },
                _ref4,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["BootstrapTable"],
                    {
                        data: !this.props.loading ? this.state.showMore === false ? data : data.slice(0, 20) : [],
                        options: options,
                        bordered: true,
                        version: '4',
                        headerContainerClass: __WEBPACK_IMPORTED_MODULE_1__style___default.a.headerContainerClass,
                        headerStyle: { borderBottom: 0, background: '#fffff' },
                        bodyStyle: { height: 'auto', background: '#f4f5fa', marginBottom: 0, paddingRight: 0 },
                        tableBodyClass: __WEBPACK_IMPORTED_MODULE_1__style___default.a.tableBodyClass,
                        containerClass: __WEBPACK_IMPORTED_MODULE_1__style___default.a.containerClass
                    },
                    _ref5,
                    _ref6,
                    _ref7,
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],
                        { width: '20%',
                            dataField: 'order_date',
                            dataFormat: this.dateFormat
                        },
                        'Date'
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],
                        { width: '20%',
                            dataFormat: this.currencyFormat,
                            dataField: 'amount'
                        },
                        'Amount'
                    )
                )
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.cardListOuterWrapper },
                this.props.loading ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'div',
                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.preloaderWrapper },
                    _ref8
                ) : data.length ? this.generateCardList(data) : _ref9
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.loadWrapper },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'button',
                    { 'class': this.state.showMore === true ? __WEBPACK_IMPORTED_MODULE_1__style___default.a.buttons : __WEBPACK_IMPORTED_MODULE_1__style___default.a.hideButtons,
                        onClick: function onClick() {
                            return _this2.onMaximize();
                        }
                    },
                    'Load more..'
                )
            )
        );
    };

    return PurchaseOrderTable;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "ptYD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SELECT_SSC_MARKER */
/* harmony export (immutable) */ __webpack_exports__["a"] = selectSSCMarkerType;
var SELECT_SSC_MARKER = 'SELECT_SSC_MARKER';

function selectSSCMarkerType(data) {
    if (typeof data === typeof {}) {
        return {
            type: SELECT_SSC_MARKER,
            data: data
        };
    }

    return {
        type: SELECT_SSC_MARKER,
        data: {}
    };
}

/***/ }),

/***/ "q4r3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1M__r","innerContainer":"innerContainer__MlaBb","cardDetails":"cardDetails__2_ce0","title":"title__U45Pv","projectId":"projectId__1cggV","description":"description__1nvZ1","value":"value__yzMUL","sdgData":"sdgData__31Ktd","resultsWrapper":"resultsWrapper__ESYSE","results":"results__9FQA9","lessDetails":"lessDetails__-GYlz","lessDetailsText":"lessDetailsText__HEjZp","lessDetailImage":"lessDetailImage__2WbAA","moreDetailImage":"moreDetailImage__BnlNM","genderEquality":"genderEquality__2VkMu","heading":"heading__2LDYK","budgetSources":"budgetSources__2q1Th","header":"header__1RgN3","subheader":"subheader__1fRL2","sub_section":"sub_section__2s_Qs","bullet":"bullet__35Zuq","budgetSourcesHeading":"budgetSourcesHeading__GGslo","policyMarkerSection":"policyMarkerSection__1qqgq","policyMarker":"policyMarker__LO4rO","policyMarkerHeading":"policyMarkerHeading__D5IKw","view_results":"view_results__3cpxY","budgetTable":"budgetTable__vQKia"};

/***/ }),

/***/ "qVG8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SscMarkerlegend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("2cq4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__donor_donut_chart_legend__ = __webpack_require__("jQ4o");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SscMarkerlegend = function (_Component) {
    _inherits(SscMarkerlegend, _Component);

    function SscMarkerlegend(props) {
        _classCallCheck(this, SscMarkerlegend);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.onSelectMarkerType = function (type) {
            _this.props.onSelectMarkerType(type);
        };

        _this.state = {};
        return _this;
    }

    SscMarkerlegend.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {};

    SscMarkerlegend.prototype.componentDidMount = function componentDidMount() {};

    SscMarkerlegend.prototype.render = function render(props) {
        var _this2 = this;

        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.legend_container },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'span',
                { onClick: function onClick() {
                        return _this2.onSelectMarkerType(2);
                    }, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.legend_item },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.capacity_legend_block }),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'span',
                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.legend_text + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.capacity_text },
                    'Capacity builder'
                )
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'span',
                { onClick: function onClick() {
                        return _this2.onSelectMarkerType(1);
                    }, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.legend_item },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.knowledge_legend_block }),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'span',
                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.legend_text + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.knowledge_text },
                    'Knowledge broker'
                )
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'span',
                { onClick: function onClick() {
                        return _this2.onSelectMarkerType(3);
                    }, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.legend_item },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.partnership_legend_block }),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'span',
                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.legend_text + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.partnership_text },
                    'Partnership facilitator'
                )
            )
        );
    };

    return SscMarkerlegend;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "r7Tw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__("eW0v");

var DetectPassiveEvents = __webpack_require__("O8Wv").default;

function getInitialState() {
  return {
    x: null,
    y: null,
    swiping: false,
    start: 0
  };
}

function getMovingPosition(e) {
  return 'changedTouches' in e ? { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY } : { x: e.clientX, y: e.clientY };
}
function getPosition(e) {
  return 'touches' in e ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : { x: e.clientX, y: e.clientY };
}

function calculatePos(e, state) {
  var _getMovingPosition = getMovingPosition(e),
      x = _getMovingPosition.x,
      y = _getMovingPosition.y;

  var deltaX = state.x - x;
  var deltaY = state.y - y;

  var absX = Math.abs(deltaX);
  var absY = Math.abs(deltaY);

  var time = Date.now() - state.start;
  var velocity = Math.sqrt(absX * absX + absY * absY) / time;

  return { deltaX: deltaX, deltaY: deltaY, absX: absX, absY: absY, velocity: velocity };
}

var Swipeable = function (_React$Component) {
  _inherits(Swipeable, _React$Component);

  function Swipeable(props, context) {
    _classCallCheck(this, Swipeable);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.eventStart = _this.eventStart.bind(_this);
    _this.eventMove = _this.eventMove.bind(_this);
    _this.eventEnd = _this.eventEnd.bind(_this);
    _this.mouseDown = _this.mouseDown.bind(_this);
    _this.mouseMove = _this.mouseMove.bind(_this);
    _this.mouseUp = _this.mouseUp.bind(_this);
    _this.cleanupMouseListeners = _this.cleanupMouseListeners.bind(_this);
    _this.setupMouseListeners = _this.setupMouseListeners.bind(_this);
    _this.elementRef = _this.elementRef.bind(_this);
    _this.setupTouchmoveEvent = _this.setupTouchmoveEvent.bind(_this);
    _this.cleanupTouchmoveEvent = _this.cleanupTouchmoveEvent.bind(_this);
    _this.hasPassiveSupport = DetectPassiveEvents.hasSupport;
    return _this;
  }

  Swipeable.prototype.componentWillMount = function componentWillMount() {
    this.swipeable = getInitialState();
  };

  Swipeable.prototype.componentDidMount = function componentDidMount() {
    if (this.props.preventDefaultTouchmoveEvent) {
      this.setupTouchmoveEvent();
    }
  };

  Swipeable.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.disabled !== this.props.disabled) {
      this.cleanupMouseListeners();

      this.swipeable = getInitialState();
    }

    if (prevProps.preventDefaultTouchmoveEvent && !this.props.preventDefaultTouchmoveEvent) {
      this.cleanupTouchmoveEvent();
    } else if (!prevProps.preventDefaultTouchmoveEvent && this.props.preventDefaultTouchmoveEvent) {
      this.setupTouchmoveEvent();
    }
  };

  Swipeable.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cleanupMouseListeners();
  };

  Swipeable.prototype.setupTouchmoveEvent = function setupTouchmoveEvent() {
    if (this.element && this.hasPassiveSupport) {
      this.element.addEventListener('touchmove', this.eventMove, { passive: false });
    }
  };

  Swipeable.prototype.setupMouseListeners = function setupMouseListeners() {
    document.addEventListener('mousemove', this.mouseMove);
    document.addEventListener('mouseup', this.mouseUp);
  };

  Swipeable.prototype.cleanupTouchmoveEvent = function cleanupTouchmoveEvent() {
    if (this.element && this.hasPassiveSupport) {
      this.element.removeEventListener('touchmove', this.eventMove, { passive: false });
    }
  };

  Swipeable.prototype.cleanupMouseListeners = function cleanupMouseListeners() {
    document.removeEventListener('mousemove', this.mouseMove);
    document.removeEventListener('mouseup', this.mouseUp);
  };

  Swipeable.prototype.mouseDown = function mouseDown(e) {
    if (!this.props.trackMouse || e.type !== 'mousedown') {
      return;
    }

    if (typeof this.props.onMouseDown === 'function') this.props.onMouseDown(e);

    this.setupMouseListeners();

    this.eventStart(e);
  };

  Swipeable.prototype.mouseMove = function mouseMove(e) {
    this.eventMove(e);
  };

  Swipeable.prototype.mouseUp = function mouseUp(e) {
    this.cleanupMouseListeners();
    this.eventEnd(e);
  };

  Swipeable.prototype.eventStart = function eventStart(e) {
    if (e.touches && e.touches.length > 1) return;

    var _getPosition = getPosition(e),
        x = _getPosition.x,
        y = _getPosition.y;

    if (this.props.stopPropagation) e.stopPropagation();

    this.swipeable = { start: Date.now(), x: x, y: y, swiping: false };
  };

  Swipeable.prototype.eventMove = function eventMove(e) {
    var _props = this.props,
        stopPropagation = _props.stopPropagation,
        delta = _props.delta,
        onSwiping = _props.onSwiping,
        onSwipingLeft = _props.onSwipingLeft,
        onSwipedLeft = _props.onSwipedLeft,
        onSwipingRight = _props.onSwipingRight,
        onSwipedRight = _props.onSwipedRight,
        onSwipingUp = _props.onSwipingUp,
        onSwipedUp = _props.onSwipedUp,
        onSwipingDown = _props.onSwipingDown,
        onSwipedDown = _props.onSwipedDown,
        preventDefaultTouchmoveEvent = _props.preventDefaultTouchmoveEvent;

    if (!this.swipeable.x || !this.swipeable.y || e.touches && e.touches.length > 1) {
      return;
    }

    var pos = calculatePos(e, this.swipeable);

    if (pos.absX < delta && pos.absY < delta && !this.swipeable.swiping) return;

    if (stopPropagation) e.stopPropagation();

    if (onSwiping) {
      onSwiping(e, pos.deltaX, pos.deltaY, pos.absX, pos.absY, pos.velocity);
    }

    var cancelablePageSwipe = false;
    if (pos.absX > pos.absY) {
      if (pos.deltaX > 0) {
        if (onSwipingLeft || onSwipedLeft) {
          onSwipingLeft && onSwipingLeft(e, pos.absX);
          cancelablePageSwipe = true;
        }
      } else if (onSwipingRight || onSwipedRight) {
        onSwipingRight && onSwipingRight(e, pos.absX);
        cancelablePageSwipe = true;
      }
    } else if (pos.deltaY > 0) {
      if (onSwipingUp || onSwipedUp) {
        onSwipingUp && onSwipingUp(e, pos.absY);
        cancelablePageSwipe = true;
      }
    } else if (onSwipingDown || onSwipedDown) {
      onSwipingDown && onSwipingDown(e, pos.absY);
      cancelablePageSwipe = true;
    }

    this.swipeable.swiping = true;

    if (cancelablePageSwipe && preventDefaultTouchmoveEvent) e.preventDefault();
  };

  Swipeable.prototype.eventEnd = function eventEnd(e) {
    var _props2 = this.props,
        stopPropagation = _props2.stopPropagation,
        flickThreshold = _props2.flickThreshold,
        onSwiped = _props2.onSwiped,
        onSwipedLeft = _props2.onSwipedLeft,
        onSwipedRight = _props2.onSwipedRight,
        onSwipedUp = _props2.onSwipedUp,
        onSwipedDown = _props2.onSwipedDown,
        onTap = _props2.onTap;

    if (this.swipeable.swiping) {
      var pos = calculatePos(e, this.swipeable);

      if (stopPropagation) e.stopPropagation();

      var isFlick = pos.velocity > flickThreshold;

      onSwiped && onSwiped(e, pos.deltaX, pos.deltaY, isFlick, pos.velocity);

      if (pos.absX > pos.absY) {
        if (pos.deltaX > 0) {
          onSwipedLeft && onSwipedLeft(e, pos.deltaX, isFlick);
        } else {
          onSwipedRight && onSwipedRight(e, pos.deltaX, isFlick);
        }
      } else if (pos.deltaY > 0) {
        onSwipedUp && onSwipedUp(e, pos.deltaY, isFlick);
      } else {
        onSwipedDown && onSwipedDown(e, pos.deltaY, isFlick);
      }
    } else {
      onTap && onTap(e);
    }

    this.swipeable = getInitialState();
  };

  Swipeable.prototype.elementRef = function elementRef(element) {
    this.element = element;
    this.props.innerRef && this.props.innerRef(element);
  };

  Swipeable.prototype.render = function render() {
    var newProps = _extends({}, this.props);
    if (!this.props.disabled) {
      newProps.onTouchStart = this.eventStart;

      if (!this.props.preventDefaultTouchmoveEvent || !this.hasPassiveSupport) {
        newProps.onTouchMove = this.eventMove;
      }

      newProps.onTouchEnd = this.eventEnd;
      newProps.onMouseDown = this.mouseDown;
    }

    newProps.ref = this.elementRef;

    delete newProps.onSwiped;
    delete newProps.onSwiping;
    delete newProps.onSwipingUp;
    delete newProps.onSwipingRight;
    delete newProps.onSwipingDown;
    delete newProps.onSwipingLeft;
    delete newProps.onSwipedUp;
    delete newProps.onSwipedRight;
    delete newProps.onSwipedDown;
    delete newProps.onSwipedLeft;
    delete newProps.onTap;
    delete newProps.flickThreshold;
    delete newProps.delta;
    delete newProps.preventDefaultTouchmoveEvent;
    delete newProps.stopPropagation;
    delete newProps.nodeName;
    delete newProps.children;
    delete newProps.trackMouse;
    delete newProps.disabled;
    delete newProps.innerRef;

    return React.createElement(this.props.nodeName, newProps, this.props.children);
  };

  return Swipeable;
}(React.Component);

Swipeable.defaultProps = {
  flickThreshold: 0.6,
  delta: 10,
  preventDefaultTouchmoveEvent: false,
  stopPropagation: false,
  nodeName: 'div',
  disabled: false
};

module.exports = Swipeable;

/***/ }),

/***/ "rP0b":
/***/ (function(module, exports) {

d3.sankey = function () {
  var sankey = {},
      nodeWidth = 24,
      nodePadding = 8,
      size = [1, 1],
      nodes = [],
      links = [];

  sankey.nodeWidth = function (_) {
    if (!arguments.length) return nodeWidth;
    nodeWidth = +_;
    return sankey;
  };

  sankey.nodePadding = function (_) {
    if (!arguments.length) return nodePadding;
    nodePadding = +_;
    return sankey;
  };

  sankey.nodes = function (_) {
    if (!arguments.length) return nodes;
    nodes = _;
    return sankey;
  };

  sankey.links = function (_) {
    if (!arguments.length) return links;
    links = _;
    return sankey;
  };

  sankey.size = function (_) {
    if (!arguments.length) return size;
    size = _;
    return sankey;
  };

  sankey.layout = function (iterations) {
    computeNodeLinks();
    computeNodeValues();
    computeNodeBreadths();
    computeNodeDepths(iterations);
    computeLinkDepths();
    return sankey;
  };

  sankey.relayout = function () {
    computeLinkDepths();
    return sankey;
  };

  sankey.link = function () {
    var curvature = .5;

    function link(d) {
      var x0 = d.source.x + d.source.dx,
          x1 = d.target.x,
          xi = d3.interpolateNumber(x0, x1),
          x2 = xi(curvature),
          x3 = xi(1 - curvature),
          y0 = d.source.y + d.sy + d.dy / 2,
          y1 = d.target.y + d.ty + d.dy / 2;
      return "M" + x0 + "," + y0 + "C" + x2 + "," + y0 + " " + x3 + "," + y1 + " " + x1 + "," + y1;
    }

    link.curvature = function (_) {
      if (!arguments.length) return curvature;
      curvature = +_;
      return link;
    };

    return link;
  };

  // Populate the sourceLinks and targetLinks for each node.
  // Also, if the source and target are not objects, assume they are indices.
  function computeNodeLinks() {
    nodes.forEach(function (node) {
      node.sourceLinks = [];
      node.targetLinks = [];
    });
    links.forEach(function (link) {
      var source = link.source,
          target = link.target;
      if (typeof source === "number") source = link.source = nodes[link.source];
      if (typeof target === "number") target = link.target = nodes[link.target];
      source.sourceLinks.push(link);
      target.targetLinks.push(link);
    });
  }

  // Compute the value (size) of each node by summing the associated links.
  function computeNodeValues() {
    nodes.forEach(function (node) {
      node.value = Math.max(d3.sum(node.sourceLinks, value), d3.sum(node.targetLinks, value));
    });
  }

  // Iteratively assign the breadth (x-position) for each node.
  // Nodes are assigned the maximum breadth of incoming neighbors plus one;
  // nodes with no incoming links are assigned breadth zero, while
  // nodes with no outgoing links are assigned the maximum breadth.
  function computeNodeBreadths() {
    var remainingNodes = nodes,
        nextNodes,
        x = 0;

    while (remainingNodes.length) {
      nextNodes = [];
      remainingNodes.forEach(function (node) {
        node.x = x;
        node.dx = nodeWidth;
        node.sourceLinks.forEach(function (link) {
          nextNodes.push(link.target);
        });
      });
      remainingNodes = nextNodes;
      ++x;
    }

    //
    moveSinksRight(x);
    scaleNodeBreadths((size[0] - nodeWidth) / (x - 1));
  }

  function moveSourcesRight() {
    nodes.forEach(function (node) {
      if (!node.targetLinks.length) {
        node.x = d3.min(node.sourceLinks, function (d) {
          return d.target.x;
        }) - 1;
      }
    });
  }

  function moveSinksRight(x) {
    nodes.forEach(function (node) {
      if (!node.sourceLinks.length) {
        node.x = x - 1;
      }
    });
  }

  function scaleNodeBreadths(kx) {
    nodes.forEach(function (node) {
      node.x *= kx;
    });
  }

  function computeNodeDepths(iterations) {
    var nodesByBreadth = d3.nest().key(function (d) {
      return d.x;
    }).sortKeys(d3.ascending).entries(nodes).map(function (d) {
      return d.values;
    });

    //
    initializeNodeDepth();
    resolveCollisions();
    for (var alpha = 1; iterations > 0; --iterations) {
      relaxRightToLeft(alpha *= .99);
      resolveCollisions();
      relaxLeftToRight(alpha);
      resolveCollisions();
    }

    function initializeNodeDepth() {
      var ky = d3.min(nodesByBreadth, function (nodes) {
        return (size[1] - (nodes.length - 1) * nodePadding) / d3.sum(nodes, value);
      });

      nodesByBreadth.forEach(function (nodes) {
        nodes.forEach(function (node, i) {
          node.y = i;
          node.dy = node.value * ky;
        });
      });

      links.forEach(function (link) {
        link.dy = link.value * ky;
      });
    }

    function relaxLeftToRight(alpha) {
      nodesByBreadth.forEach(function (nodes, breadth) {
        nodes.forEach(function (node) {
          if (node.targetLinks.length) {
            var y = d3.sum(node.targetLinks, weightedSource) / d3.sum(node.targetLinks, value);
            node.y += (y - center(node)) * alpha;
          }
        });
      });

      function weightedSource(link) {
        return center(link.source) * link.value;
      }
    }

    function relaxRightToLeft(alpha) {
      nodesByBreadth.slice().reverse().forEach(function (nodes) {
        nodes.forEach(function (node) {
          if (node.sourceLinks.length) {
            var y = d3.sum(node.sourceLinks, weightedTarget) / d3.sum(node.sourceLinks, value);
            node.y += (y - center(node)) * alpha;
          }
        });
      });

      function weightedTarget(link) {
        return center(link.target) * link.value;
      }
    }

    function resolveCollisions() {
      nodesByBreadth.forEach(function (nodes) {
        var node,
            dy,
            y0 = 0,
            n = nodes.length,
            i;

        // Push any overlapping nodes down.
        nodes.sort(ascendingDepth);
        for (i = 0; i < n; ++i) {
          node = nodes[i];
          dy = y0 - node.y;
          if (dy > 0) node.y += dy;
          y0 = node.y + node.dy + nodePadding;
        }

        // If the bottommost node goes outside the bounds, push it back up.
        dy = y0 - nodePadding - size[1];
        if (dy > 0) {
          y0 = node.y -= dy;

          // Push any overlapping nodes back up.
          for (i = n - 2; i >= 0; --i) {
            node = nodes[i];
            dy = node.y + node.dy + nodePadding - y0;
            if (dy > 0) node.y -= dy;
            y0 = node.y;
          }
        }
      });
    }

    function ascendingDepth(a, b) {
      return a.y - b.y;
    }
  }

  function computeLinkDepths() {
    nodes.forEach(function (node) {
      node.sourceLinks.sort(ascendingTargetDepth);
      node.targetLinks.sort(ascendingSourceDepth);
    });
    nodes.forEach(function (node) {
      var sy = 0,
          ty = 0;
      node.sourceLinks.forEach(function (link) {
        link.sy = sy;
        sy += link.dy;
      });
      node.targetLinks.forEach(function (link) {
        link.ty = ty;
        ty += link.dy;
      });
    });

    function ascendingSourceDepth(a, b) {
      return a.source.y - b.source.y;
    }

    function ascendingTargetDepth(a, b) {
      return a.target.y - b.target.y;
    }
  }

  function center(node) {
    return node.y + node.dy / 2;
  }

  function value(link) {
    return link.value;
  }

  return sankey;
};

/***/ }),

/***/ "sqGb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"budgetDot":"budgetDot__iBcfy","area_chart":"area_chart__3_b1N","tooltip":"tooltip__3Fjv-","contentWrapper":"contentWrapper__2bdyH","markerWrapper":"markerWrapper__3rnTP","budgetMarker":"budgetMarker__e5Ub8","expenseMarker":"expenseMarker__2r1PW","expenseWrapper":"expenseWrapper__Er7s2","yearDisplay":"yearDisplay__1f54w","chart_area1":"chart_area1__1I0kp","line_chart1":"line_chart1__2kD7p","line_chart2":"line_chart2__1yhq2","chart_area2":"chart_area2__1A_mX","xaxis":"xaxis__3u4zJ","yaxis":"yaxis__1ZQwO","svgIe":"svgIe__22DaN"};

/***/ }),

/***/ "uO0A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/stackedBarChart2/barElement/style.scss
var style = __webpack_require__("Lztf");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// EXTERNAL MODULE: ./utils/commonMethods.js
var commonMethods = __webpack_require__("Cdrj");

// CONCATENATED MODULE: ./components/stackedBarChart2/barElement/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var barElement_BarElement = function (_Component) {
	_inherits(BarElement, _Component);

	function BarElement(props) {
		_classCallCheck(this, BarElement);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.calculatePerc = function (data) {
			var regularPerc = data.regular / data.contribution * 100,
			    otherPerc = data.other / data.contribution * 100;
			return {
				regularPerc: regularPerc,
				otherPerc: otherPerc
			};
		};

		_this.tooltipHover = function (e, data) {
			_this.setState({ showtooltip: true, tooltipData: data, tooltipPosition: [e.clientX, e.clientY] });
		};

		_this.tooltipOut = function (data) {
			_this.setState({ showtooltip: false });
		};

		_this.renderPercentageBar = function (data) {
			var _h;

			var _this$calculatePerc = _this.calculatePerc(data),
			    regularPerc = _this$calculatePerc.regularPerc,
			    otherPerc = _this$calculatePerc.otherPerc,
			    regular = Object(numberFormatter["e" /* numberToDollarFormatter */])(data.regular),
			    other = Object(numberFormatter["e" /* numberToDollarFormatter */])(data.other),
			    imgSrc = _this.props.donors === 'true' ? Object(commonMethods["d" /* getAPIBaseUrRl */])() + '/static/assets/flag_icons/' + data.donor_code + '.svg' : '';

			return Object(preact_min["h"])(
				'div',
				{ 'class': style_default.a.barChart },
				Object(preact_min["h"])(
					'div',
					{ 'class': _this.props.donors ? style_default.a.displayTextWrapper + ' ' + style_default.a.mobile_responsive + ' ' + style_default.a.donorLegendMobile : style_default.a.displayTextWrapper + ' ' + style_default.a.mobile_responsive },
					_this.props.donors ? Object(preact_min["h"])('img', { src: imgSrc, alt: 'logo', 'class': style_default.a.donorFlag, onError: function onError(e) {
							e.target.src = '../../../static/assets/images/Empty.svg';
						} }) : null,
					Object(preact_min["h"])(
						'div',
						null,
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.title },
							Object(preact_min["h"])(
								'a',
								(_h = { 'class': style_default.a.donorName,
									target: _this.props.embed ? "_blank" : "",
									href: '/profile/' + data.code + '/donorprofile' }, _h['target'] = true, _h),
								data.name
							)
						),
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.contribution },
							Object(numberFormatter["e" /* numberToDollarFormatter */])(data.contribution)
						)
					)
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.innerChartWrapper, style: { width: data.perc + '%' } },
					Object(preact_min["h"])('div', { onMouseOver: function onMouseOver(e) {
							return _this.tooltipHover(e, regular);
						}, 'class': style_default.a.regular, style: { width: regularPerc + '%' }, onMouseOut: function onMouseOut() {
							return _this.tooltipOut(regular);
						} }),
					Object(preact_min["h"])('div', { onMouseOver: function onMouseOver(e) {
							return _this.tooltipHover(e, other);
						}, 'class': style_default.a.other, style: { width: otherPerc + '%' }, onMouseOut: function onMouseOut() {
							return _this.tooltipOut(other);
						} })
				),
				Object(preact_min["h"])(
					'span',
					{
						'class': _this.state.showtooltip ? style_default.a.tooltipDonors + ' ' + style_default.a.otherTooltip : style_default.a.tooltipDisplay,
						style: { top: _this.state.tooltipPosition[1] + 'px', left: _this.state.tooltipPosition[0] + 'px' }
					},
					_this.state.tooltipData
				)
			);
		};

		_this.state = {
			showtooltip: '',
			tooltipData: '',
			tooltipPosition: [0, 0]
		};
		return _this;
	}

	BarElement.prototype.render = function render(_ref, state) {
		var data = _ref.data;

		var imgSrc = this.props.donors === 'true' ? Object(commonMethods["d" /* getAPIBaseUrRl */])() + '/static/assets/flag_icons/' + data.donor_code + '.svg' : '';
		return Object(preact_min["h"])(
			'div',
			{ 'class': style_default.a.container },
			Object(preact_min["h"])(
				'div',
				{ 'class': this.props.donors ? style_default.a.displayTextWrapper + ' ' + style_default.a.desktop_responsive + ' ' + style_default.a.donorLegend : style_default.a.displayTextWrapper + ' ' + style_default.a.desktop_responsive + ' ' },
				this.props.donors ? Object(preact_min["h"])('img', { src: imgSrc, alt: 'logo', 'class': style_default.a.donorFlag, onError: function onError(e) {
						e.target.src = '../../../static/assets/images/Empty.svg';
					} }) : null,
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.title },
						Object(preact_min["h"])(
							'a',
							{ 'class': style_default.a.donorName, href: '/profile/' + data.donor_code + '/donorprofile' },
							data.name
						),
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.contribution },
							Object(numberFormatter["e" /* numberToDollarFormatter */])(data.contribution)
						)
					)
				)
			),
			this.renderPercentageBar(data)
		);
	};

	return BarElement;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/stackedBarChart2/style.scss
var stackedBarChart2_style = __webpack_require__("XSnv");
var stackedBarChart2_style_default = /*#__PURE__*/__webpack_require__.n(stackedBarChart2_style);

// CONCATENATED MODULE: ./components/stackedBarChart2/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stackedBarChart2_StackedBarChart2; });


function stackedBarChart2__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function stackedBarChart2__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function stackedBarChart2__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var stackedBarChart2_StackedBarChart2 = function (_Component) {
    stackedBarChart2__inherits(StackedBarChart2, _Component);

    function StackedBarChart2(props) {
        stackedBarChart2__classCallCheck(this, StackedBarChart2);

        var _this = stackedBarChart2__possibleConstructorReturn(this, _Component.call(this, props));

        _this.generateList = function (data) {
            return data.map(function (item) {
                return Object(preact_min["h"])(barElement_BarElement, { data: item, donors: _this.props.donors });
            });
        };

        return _this;
    }

    StackedBarChart2.prototype.render = function render(_ref, state) {
        var data = _ref.data;

        return Object(preact_min["h"])(
            'div',
            { 'class': stackedBarChart2_style_default.a.container },
            this.generateList(data)
        );
    };

    return StackedBarChart2;
}(preact_min["Component"]);



/***/ }),

/***/ "udqz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_listView__ = __webpack_require__("lo/D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__("eJ/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_progressBar__ = __webpack_require__("HX72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_numberFormatter__ = __webpack_require__("Au7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__profilePage_actions_donorActions__ = __webpack_require__("JMhk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_preact_redux__ = __webpack_require__("E/bI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_commonMethods__ = __webpack_require__("Cdrj");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SideBarDonorItem = function (_Component) {
    _inherits(SideBarDonorItem, _Component);

    function SideBarDonorItem(props, context) {
        _classCallCheck(this, SideBarDonorItem);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.renderTopRow = function (item) {
            var donor_name = item.ref_id ? item.org_name : item.level_3_name,
                donor_code = item.ref_id ? item.ref_id : item.level_3_code,
                donor_img = item.donor_lvl === 'OTH' ? '/static/assets/images/Empty.svg' : Object(__WEBPACK_IMPORTED_MODULE_7__utils_commonMethods__["d" /* getAPIBaseUrRl */])() + '/static/assets/flag_icons/' + item.level_3_code + '.svg';
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'section',
                { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.row },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'article',
                    { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.columnLeft },
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'div',
                        { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.theme_wrapper },
                        donor_name ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                            'section',
                            { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.donorDataSection },
                            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: donor_img, 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.donorImg,
                                onError: function onError(e) {
                                    e.target.src = '/static/assets/images/Empty.svg';
                                }
                            }),
                            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                'a',
                                { href: '/profile/' + donor_code + '/donorprofile',
                                    target: _this.props.embed ? "_blank" : "",
                                    'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.theme_name },
                                donor_name
                            )
                        ) : null
                    )
                )
            );
        };

        _this.renderMiddleRow = function (item) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'section',
                    { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.rowMiddle },
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'article',
                        { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.columnLeft },
                        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                            'div',
                            { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.percentageFill },
                            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                'span',
                                null,
                                item.total_budget ? Object(__WEBPACK_IMPORTED_MODULE_4__utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(item.total_budget, 2) : Object(__WEBPACK_IMPORTED_MODULE_4__utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(0)
                            )
                        )
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'div',
                        { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.arrowDesktop },
                        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                            'article',
                            { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.columnRight,
                                onClick: function onClick() {
                                    return _this.handleLangChange();
                                } },
                            _this.props.embed ? null : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.theme_next })
                        )
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'div',
                        { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.arrowMobile },
                        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                            'article',
                            { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.columnRight,
                                onClick: function onClick() {
                                    _this.props.selectMap && _this.props.selectMap();
                                }
                            },
                            _this.props.embed ? null : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.theme_map })
                        )
                    )
                )
            );
        };

        _this.handleLangChange = function () {
            var flag = true;
            _this.props.onSelectLanguage && _this.props.onSelectLanguage(flag);
        };

        _this.state = {
            styles: {
                alloted_budget: {
                    color: _this.props.data.color,
                    fontSize: 18,
                    fontWeight: 600,
                    textTransform: 'uppercase'
                }
            }
        };
        return _this;
    }

    SideBarDonorItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.setState({
            styles: {
                alloted_budget: {
                    color: nextProps.data.color,
                    fontSize: 18,
                    fontWeight: 600,
                    textTransform: 'uppercase'
                }
            }
        });
    };

    SideBarDonorItem.prototype.render = function render() {
        var _this2 = this;

        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'article',
            { className: this.props.selected ? __WEBPACK_IMPORTED_MODULE_2__style___default.a.isActive : __WEBPACK_IMPORTED_MODULE_2__style___default.a.isInActive,
                onClick: function onClick() {
                    _this2.props.selectRow && _this2.props.selectRow(_this2.props);
                } },
            this.renderTopRow(this.props.data),
            this.renderMiddleRow(this.props.data)
        );
    };

    return SideBarDonorItem;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        getDonorDetails: function getDonorDetails(code, year) {
            return Object(__WEBPACK_IMPORTED_MODULE_5__profilePage_actions_donorActions__["a" /* default */])(dispatch, code, year);
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_preact_redux__["a" /* connect */])(mapDispatchToProps)(SideBarDonorItem));

/***/ }),

/***/ "uq14":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"projectMap":"projectMap__3xccb","info":"info__eIBjV","info_popup":"info_popup__y5vuR","projectTopoIconsLegend":"projectTopoIconsLegend__1WGIV","satellite":"satellite__rLlLz","container":"container__UknRT","titleWrapper":"titleWrapper__2_igE","projectListWrapper":"projectListWrapper__34Uqd","mapWrapper":"mapWrapper__2ojLc","disclaimer":"disclaimer__27Rrx","filterTextWrapper":"filterTextWrapper__2UrfE","topographyIconsContainer":"topographyIconsContainer__3TAPb","filterText":"filterText__3SE8j","filterTitle":"filterTitle__2tI5X","filterListWrapper":"filterListWrapper__2C7db","filterInnerWrapper":"filterInnerWrapper__1b6ft","filterLabels":"filterLabels__8j5k4","projectstatusWrapper":"projectstatusWrapper__94bNa","budgetSourceWrapper":"budgetSourceWrapper__2xYpC","table_title":"table_title__1vWSh","source":"source__3Dwpc","arealChart":"arealChart__2o7UL","areaHeaderWrapper":"areaHeaderWrapper__2GfNS","legendWrapper":"legendWrapper__jv4Ec","legendItemOuterWrapper":"legendItemOuterWrapper__1ax8u","legendItemInnerWrapper":"legendItemInnerWrapper__285py","itemAlignmentWrapper":"itemAlignmentWrapper__2SBGo","legend":"legend__1Px-b","budgetLegend":"budgetLegend__27hIv","revenueLegend":"revenueLegend__UJCPB","satellite_btn_container":"satellite_btn_container__qZ_FA","rightBtn":"rightBtn__1jV7q","leftBtn":"leftBtn__2oCDg","centerBtn":"centerBtn__39xkt","satelliteWrapper":"satelliteWrapper__1-iqp","accordion__arrow__left":"accordion__arrow__left__JsJTf","accordion__arrow__right":"accordion__arrow__right__3o1Cr","locationText":"locationText__F0Rl4","buttonMode":"buttonMode__dz41T"};

/***/ }),

/***/ "uq96":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _reactSwipeable = __webpack_require__("r7Tw");

var _reactSwipeable2 = _interopRequireDefault(_reactSwipeable);

var _lodash = __webpack_require__("FNy/");

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__("4PZ+");

var _lodash4 = _interopRequireDefault(_lodash3);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var screenChangeEvents = ['fullscreenchange', 'MSFullscreenChange', 'mozfullscreenchange', 'webkitfullscreenchange'];

var ImageGallery = function (_React$Component) {
  _inherits(ImageGallery, _React$Component);

  function ImageGallery(props) {
    _classCallCheck(this, ImageGallery);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ImageGallery).call(this, props));

    _this.slideToIndex = function (index, event) {
      var _this$state = _this.state;
      var currentIndex = _this$state.currentIndex;
      var isTransitioning = _this$state.isTransitioning;

      if (!isTransitioning) {
        if (event) {
          if (_this._intervalId) {
            // user triggered event while ImageGallery is playing, reset interval
            _this.pause(false);
            _this.play(false);
          }
        }

        var slideCount = _this.props.items.length - 1;
        var nextIndex = index;

        if (index < 0) {
          nextIndex = slideCount;
        } else if (index > slideCount) {
          nextIndex = 0;
        }

        _this.setState({
          previousIndex: currentIndex,
          currentIndex: nextIndex,
          isTransitioning: nextIndex !== currentIndex,
          offsetPercentage: 0,
          style: {
            transition: 'all ' + _this.props.slideDuration + 'ms ease-out'
          }
        }, _this._onSliding);
      }
    };

    _this._onSliding = function () {
      var isTransitioning = _this.state.isTransitioning;

      window.setTimeout(function () {
        if (isTransitioning) {
          _this.setState({ isTransitioning: !isTransitioning });
        }
      }, _this.props.slideDuration + 50);
    };

    _this._handleScreenChange = function () {
      /*
        handles screen change events that the browser triggers e.g. esc key
      */
      var fullScreenElement = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;

      if (_this.props.onScreenChange) {
        _this.props.onScreenChange(fullScreenElement);
      }

      _this.setState({ isFullscreen: !!fullScreenElement });
    };

    _this._toggleFullScreen = function () {
      if (_this.state.isFullscreen) {
        _this.exitFullScreen();
      } else {
        _this.fullScreen();
      }
    };

    _this._togglePlay = function () {
      if (_this._intervalId) {
        _this.pause();
      } else {
        _this.play();
      }
    };

    _this._handleResize = function () {
      // delay initial resize to get the accurate this._imageGallery height/width
      _this._resizeTimer = window.setTimeout(function () {
        if (_this._imageGallery) {
          _this.setState({
            galleryWidth: _this._imageGallery.offsetWidth
          });
        }

        // adjust thumbnail container when thumbnail width or height is adjusted
        _this._setThumbsTranslate(-_this._getThumbsTranslate(_this.state.currentIndex > 0 ? 1 : 0) * _this.state.currentIndex);

        if (_this._imageGallerySlideWrapper) {
          _this.setState({
            gallerySlideWrapperHeight: _this._imageGallerySlideWrapper.offsetHeight
          });
        }

        if (_this._thumbnailsWrapper) {
          if (_this._isThumbnailHorizontal()) {
            _this.setState({ thumbnailsWrapperHeight: _this._thumbnailsWrapper.offsetHeight });
          } else {
            _this.setState({ thumbnailsWrapperWidth: _this._thumbnailsWrapper.offsetWidth });
          }
        }
      }, 50);
    };

    _this._handleKeyDown = function (event) {
      var LEFT_ARROW = 37;
      var RIGHT_ARROW = 39;
      var ESC_KEY = 27;
      var key = parseInt(event.keyCode || event.which || 0);

      switch (key) {
        case LEFT_ARROW:
          if (_this._canSlideLeft() && !_this._intervalId) {
            _this._slideLeft();
          }
          break;
        case RIGHT_ARROW:
          if (_this._canSlideRight() && !_this._intervalId) {
            _this._slideRight();
          }
          break;
        case ESC_KEY:
          if (_this.state.isFullscreen && !_this.props.useBrowserFullscreen) {
            _this.exitFullScreen();
          }
      }
    };

    _this._handleMouseLeaveThumbnails = function () {
      if (_this._thumbnailTimer) {
        window.clearTimeout(_this._thumbnailTimer);
        _this._thumbnailTimer = null;
        if (_this.props.autoPlay === true) {
          _this.play(false);
        }
      }
      _this.setState({ hovering: false });
    };

    _this._handleImageError = function (event) {
      if (_this.props.defaultImage && event.target.src.indexOf(_this.props.defaultImage) === -1) {
        event.target.src = _this.props.defaultImage;
      }
    };

    _this._handleOnSwiped = function (e, deltaX, deltaY, isFlick) {
      var _this$state2 = _this.state;
      var scrollingUpDown = _this$state2.scrollingUpDown;
      var scrollingLeftRight = _this$state2.scrollingLeftRight;

      if (scrollingUpDown) {
        // user stopped scrollingUpDown
        _this.setState({ scrollingUpDown: false });
      }

      if (scrollingLeftRight) {
        // user stopped scrollingLeftRight
        _this.setState({ scrollingLeftRight: false });
      }

      if (!scrollingUpDown) {
        // don't swipe if user is scrolling
        var side = deltaX > 0 ? 1 : -1;
        _this._handleOnSwipedTo(side, isFlick);
      }
    };

    _this._handleSwiping = function (e, deltaX, deltaY, delta) {
      var _this$state3 = _this.state;
      var galleryWidth = _this$state3.galleryWidth;
      var isTransitioning = _this$state3.isTransitioning;
      var scrollingUpDown = _this$state3.scrollingUpDown;
      var swipingTransitionDuration = _this.props.swipingTransitionDuration;

      _this._setScrollDirection(deltaX, deltaY);
      if (!isTransitioning && !scrollingUpDown) {
        var side = deltaX < 0 ? 1 : -1;

        var offsetPercentage = delta / galleryWidth * 100;
        if (Math.abs(offsetPercentage) >= 100) {
          offsetPercentage = 100;
        }

        var swipingTransition = {
          transition: 'transform ' + swipingTransitionDuration + 'ms ease-out'
        };

        _this.setState({
          offsetPercentage: side * offsetPercentage,
          style: swipingTransition
        });
      } else {
        // don't move the slide
        _this.setState({ offsetPercentage: 0 });
      }
    };

    _this._slideLeft = function (event) {
      _this.slideToIndex(_this.state.currentIndex - 1, event);
    };

    _this._slideRight = function (event) {
      _this.slideToIndex(_this.state.currentIndex + 1, event);
    };

    _this._renderItem = function (item) {
      var onImageError = _this.props.onImageError || _this._handleImageError;

      return _react2.default.createElement('div', { className: 'image-gallery-image' }, item.imageSet ? _react2.default.createElement('picture', {
        onLoad: _this.props.onImageLoad,
        onError: onImageError
      }, item.imageSet.map(function (source, index) {
        return _react2.default.createElement('source', {
          key: index,
          media: source.media,
          srcSet: source.srcSet
        });
      }), _react2.default.createElement('img', {
        alt: item.originalAlt,
        src: item.original
      })) : _react2.default.createElement('img', {
        src: item.original,
        alt: item.originalAlt,
        srcSet: item.srcSet,
        sizes: item.sizes,
        title: item.originalTitle,
        onLoad: _this.props.onImageLoad,
        onError: onImageError
      }), item.description && _react2.default.createElement('span', { className: 'image-gallery-description' }, item.description));
    };

    _this._renderThumbInner = function (item) {
      var onThumbnailError = _this.props.onThumbnailError || _this._handleImageError;

      return _react2.default.createElement('div', null, _react2.default.createElement('img', {
        src: item.thumbnail,
        alt: item.thumbnailAlt,
        title: item.thumbnailTitle,
        onError: onThumbnailError
      }), _react2.default.createElement('div', { className: 'image-gallery-thumbnail-label' }, item.thumbnailLabel));
    };

    _this.state = {
      currentIndex: props.startIndex,
      thumbsTranslate: 0,
      offsetPercentage: 0,
      galleryWidth: 0,
      thumbnailsWrapperWidth: 0,
      thumbnailsWrapperHeight: 0,
      isFullscreen: false,
      isPlaying: false
    };

    if (props.lazyLoad) {
      _this._lazyLoaded = [];
    }
    return _this;
  }

  _createClass(ImageGallery, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.disableArrowKeys !== nextProps.disableArrowKeys) {
        if (nextProps.disableArrowKeys) {
          window.removeEventListener('keydown', this._handleKeyDown);
        } else {
          window.addEventListener('keydown', this._handleKeyDown);
        }
      }

      if (nextProps.lazyLoad && (!this.props.lazyLoad || this.props.items !== nextProps.items)) {
        this._lazyLoaded = [];
      }

      if (this.state.currentIndex >= nextProps.items.length) {
        this.slideToIndex(0);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.thumbnailPosition !== this.props.thumbnailPosition || prevProps.showThumbnails !== this.props.showThumbnails || prevState.thumbnailsWrapperHeight !== this.state.thumbnailsWrapperHeight || prevState.thumbnailsWrapperWidth !== this.state.thumbnailsWrapperWidth) {
        this._handleResize();
      }

      if (prevState.currentIndex !== this.state.currentIndex) {
        if (this.props.onSlide) {
          this.props.onSlide(this.state.currentIndex);
        }

        this._updateThumbnailTranslate(prevState);
      }

      if (prevProps.slideDuration !== this.props.slideDuration) {
        this.slideToIndex = (0, _lodash2.default)(this._unthrottledSlideToIndex, this.props.slideDuration, { trailing: false });
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Used to update the throttle if slideDuration changes
      this._unthrottledSlideToIndex = this.slideToIndex;
      this.slideToIndex = (0, _lodash2.default)(this._unthrottledSlideToIndex, this.props.slideDuration, { trailing: false });

      this._handleResize = this._handleResize;
      this._debounceResize = (0, _lodash4.default)(this._handleResize, 500);
      this._handleScreenChange = this._handleScreenChange;
      this._thumbnailDelay = 300;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._handleResize();

      if (this.props.autoPlay) {
        this.play();
      }
      if (!this.props.disableArrowKeys) {
        window.addEventListener('keydown', this._handleKeyDown);
      }
      window.addEventListener('resize', this._debounceResize);
      this._onScreenChangeEvent();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.props.disableArrowKeys) {
        window.removeEventListener('keydown', this._handleKeyDown);
      }

      if (this._debounceResize) {
        window.removeEventListener('resize', this._debounceResize);
        this._debounceResize.cancel();
      }

      this._offScreenChangeEvent();

      if (this._intervalId) {
        window.clearInterval(this._intervalId);
        this._intervalId = null;
      }

      if (this._resizeTimer) {
        window.clearTimeout(this._resizeTimer);
      }
    }
  }, {
    key: 'play',
    value: function play() {
      var _this2 = this;

      var callback = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      if (!this._intervalId) {
        var _props = this.props;
        var slideInterval = _props.slideInterval;
        var slideDuration = _props.slideDuration;

        this.setState({ isPlaying: true });
        this._intervalId = window.setInterval(function () {
          if (!_this2.state.hovering) {
            if (!_this2.props.infinite && !_this2._canSlideRight()) {
              _this2.pause();
            } else {
              _this2.slideToIndex(_this2.state.currentIndex + 1);
            }
          }
        }, Math.max(slideInterval, slideDuration));

        if (this.props.onPlay && callback) {
          this.props.onPlay(this.state.currentIndex);
        }
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      var callback = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      if (this._intervalId) {
        window.clearInterval(this._intervalId);
        this._intervalId = null;
        this.setState({ isPlaying: false });

        if (this.props.onPause && callback) {
          this.props.onPause(this.state.currentIndex);
        }
      }
    }
  }, {
    key: 'setModalFullscreen',
    value: function setModalFullscreen(state) {
      this.setState({ modalFullscreen: state });
      // manually call because browser does not support screenchange events
      if (this.props.onScreenChange) {
        this.props.onScreenChange(state);
      }
    }
  }, {
    key: 'fullScreen',
    value: function fullScreen() {
      var gallery = this._imageGallery;

      if (this.props.useBrowserFullscreen) {
        if (gallery.requestFullscreen) {
          gallery.requestFullscreen();
        } else if (gallery.msRequestFullscreen) {
          gallery.msRequestFullscreen();
        } else if (gallery.mozRequestFullScreen) {
          gallery.mozRequestFullScreen();
        } else if (gallery.webkitRequestFullscreen) {
          gallery.webkitRequestFullscreen();
        } else {
          // fallback to fullscreen modal for unsupported browsers
          this.setModalFullscreen(true);
        }
      } else {
        this.setModalFullscreen(true);
      }

      this.setState({ isFullscreen: true });
    }
  }, {
    key: 'exitFullScreen',
    value: function exitFullScreen() {
      if (this.state.isFullscreen) {
        if (this.props.useBrowserFullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          } else {
            // fallback to fullscreen modal for unsupported browsers
            this.setModalFullscreen(false);
          }
        } else {
          this.setModalFullscreen(false);
        }

        this.setState({ isFullscreen: false });
      }
    }
  }, {
    key: 'getCurrentIndex',
    value: function getCurrentIndex() {
      return this.state.currentIndex;
    }
  }, {
    key: '_onScreenChangeEvent',
    value: function _onScreenChangeEvent() {
      var _this3 = this;

      screenChangeEvents.map(function (eventName) {
        document.addEventListener(eventName, _this3._handleScreenChange);
      });
    }
  }, {
    key: '_offScreenChangeEvent',
    value: function _offScreenChangeEvent() {
      var _this4 = this;

      screenChangeEvents.map(function (eventName) {
        document.removeEventListener(eventName, _this4._handleScreenChange);
      });
    }
  }, {
    key: '_isThumbnailHorizontal',
    value: function _isThumbnailHorizontal() {
      var thumbnailPosition = this.props.thumbnailPosition;

      return thumbnailPosition === 'left' || thumbnailPosition === 'right';
    }
  }, {
    key: '_handleMouseOverThumbnails',
    value: function _handleMouseOverThumbnails(index) {
      var _this5 = this;

      if (this.props.slideOnThumbnailHover) {
        this.setState({ hovering: true });
        if (this._thumbnailTimer) {
          window.clearTimeout(this._thumbnailTimer);
          this._thumbnailTimer = null;
        }
        this._thumbnailTimer = window.setTimeout(function () {
          _this5.slideToIndex(index);
        }, this._thumbnailDelay);
      }
    }
  }, {
    key: '_setScrollDirection',
    value: function _setScrollDirection(deltaX, deltaY) {
      var _state = this.state;
      var scrollingUpDown = _state.scrollingUpDown;
      var scrollingLeftRight = _state.scrollingLeftRight;

      var x = Math.abs(deltaX);
      var y = Math.abs(deltaY);

      // If y > x the user is scrolling up and down
      if (y > x && !scrollingUpDown && !scrollingLeftRight) {
        this.setState({ scrollingUpDown: true });
      } else if (!scrollingLeftRight && !scrollingUpDown) {
        this.setState({ scrollingLeftRight: true });
      }
    }
  }, {
    key: '_handleOnSwipedTo',
    value: function _handleOnSwipedTo(side, isFlick) {
      var _state2 = this.state;
      var currentIndex = _state2.currentIndex;
      var isTransitioning = _state2.isTransitioning;

      var slideTo = currentIndex;

      if ((this._sufficientSwipeOffset() || isFlick) && !isTransitioning) {
        slideTo += side;
      }

      if (side < 0) {
        if (!this._canSlideLeft()) {
          slideTo = currentIndex;
        }
      } else {
        if (!this._canSlideRight()) {
          slideTo = currentIndex;
        }
      }

      this._unthrottledSlideToIndex(slideTo);
    }
  }, {
    key: '_sufficientSwipeOffset',
    value: function _sufficientSwipeOffset() {
      return Math.abs(this.state.offsetPercentage) > this.props.swipeThreshold;
    }
  }, {
    key: '_onSwipingNoOp',
    value: function _onSwipingNoOp() {
      /*
      Do nothing, only defined so preventDefaultTouchmoveEvent works
      */
    }
  }, {
    key: '_canNavigate',
    value: function _canNavigate() {
      return this.props.items.length >= 2;
    }
  }, {
    key: '_canSlideLeft',
    value: function _canSlideLeft() {
      return this.props.infinite || this.state.currentIndex > 0;
    }
  }, {
    key: '_canSlideRight',
    value: function _canSlideRight() {
      return this.props.infinite || this.state.currentIndex < this.props.items.length - 1;
    }
  }, {
    key: '_updateThumbnailTranslate',
    value: function _updateThumbnailTranslate(prevState) {
      if (this.state.currentIndex === 0) {
        this._setThumbsTranslate(0);
      } else {
        var indexDifference = Math.abs(prevState.currentIndex - this.state.currentIndex);
        var scroll = this._getThumbsTranslate(indexDifference);
        if (scroll > 0) {
          if (prevState.currentIndex < this.state.currentIndex) {
            this._setThumbsTranslate(this.state.thumbsTranslate - scroll);
          } else if (prevState.currentIndex > this.state.currentIndex) {
            this._setThumbsTranslate(this.state.thumbsTranslate + scroll);
          }
        }
      }
    }
  }, {
    key: '_setThumbsTranslate',
    value: function _setThumbsTranslate(thumbsTranslate) {
      this.setState({ thumbsTranslate: thumbsTranslate });
    }
  }, {
    key: '_getThumbsTranslate',
    value: function _getThumbsTranslate(indexDifference) {
      if (this.props.disableThumbnailScroll) {
        return 0;
      }

      var _state3 = this.state;
      var thumbnailsWrapperWidth = _state3.thumbnailsWrapperWidth;
      var thumbnailsWrapperHeight = _state3.thumbnailsWrapperHeight;

      var totalScroll = void 0;

      if (this._thumbnails) {

        // total scroll required to see the last thumbnail
        if (this._isThumbnailHorizontal()) {
          if (this._thumbnails.scrollHeight <= thumbnailsWrapperHeight) {
            return 0;
          }
          totalScroll = this._thumbnails.scrollHeight - thumbnailsWrapperHeight;
        } else {
          if (this._thumbnails.scrollWidth <= thumbnailsWrapperWidth || thumbnailsWrapperWidth <= 0) {
            return 0;
          }
          totalScroll = this._thumbnails.scrollWidth - thumbnailsWrapperWidth;
        }

        var totalThumbnails = this._thumbnails.children.length;
        // scroll-x required per index change
        var perIndexScroll = totalScroll / (totalThumbnails - 1);

        return indexDifference * perIndexScroll;
      }
    }
  }, {
    key: '_getAlignmentClassName',
    value: function _getAlignmentClassName(index) {
      // LEFT, and RIGHT alignments are necessary for lazyLoad
      var currentIndex = this.state.currentIndex;

      var alignment = '';
      var LEFT = 'left';
      var CENTER = 'center';
      var RIGHT = 'right';

      switch (index) {
        case currentIndex - 1:
          alignment = ' ' + LEFT;
          break;
        case currentIndex:
          alignment = ' ' + CENTER;
          break;
        case currentIndex + 1:
          alignment = ' ' + RIGHT;
          break;
      }

      if (this.props.items.length >= 3 && this.props.infinite) {
        if (index === 0 && currentIndex === this.props.items.length - 1) {
          // set first slide as right slide if were sliding right from last slide
          alignment = ' ' + RIGHT;
        } else if (index === this.props.items.length - 1 && currentIndex === 0) {
          // set last slide as left slide if were sliding left from first slide
          alignment = ' ' + LEFT;
        }
      }

      return alignment;
    }
  }, {
    key: '_isGoingFromFirstToLast',
    value: function _isGoingFromFirstToLast() {
      var _state4 = this.state;
      var currentIndex = _state4.currentIndex;
      var previousIndex = _state4.previousIndex;

      var totalSlides = this.props.items.length - 1;
      return previousIndex === 0 && currentIndex === totalSlides;
    }
  }, {
    key: '_isGoingFromLastToFirst',
    value: function _isGoingFromLastToFirst() {
      var _state5 = this.state;
      var currentIndex = _state5.currentIndex;
      var previousIndex = _state5.previousIndex;

      var totalSlides = this.props.items.length - 1;
      return previousIndex === totalSlides && currentIndex === 0;
    }
  }, {
    key: '_getTranslateXForTwoSlide',
    value: function _getTranslateXForTwoSlide(index) {
      // For taking care of infinite swipe when there are only two slides
      var _state6 = this.state;
      var currentIndex = _state6.currentIndex;
      var offsetPercentage = _state6.offsetPercentage;
      var previousIndex = _state6.previousIndex;

      var baseTranslateX = -100 * currentIndex;
      var translateX = baseTranslateX + index * 100 + offsetPercentage;

      // keep track of user swiping direction
      if (offsetPercentage > 0) {
        this.direction = 'left';
      } else if (offsetPercentage < 0) {
        this.direction = 'right';
      }

      // when swiping make sure the slides are on the correct side
      if (currentIndex === 0 && index === 1 && offsetPercentage > 0) {
        translateX = -100 + offsetPercentage;
      } else if (currentIndex === 1 && index === 0 && offsetPercentage < 0) {
        translateX = 100 + offsetPercentage;
      }

      if (currentIndex !== previousIndex) {
        // when swiped move the slide to the correct side
        if (previousIndex === 0 && index === 0 && offsetPercentage === 0 && this.direction === 'left') {
          translateX = 100;
        } else if (previousIndex === 1 && index === 1 && offsetPercentage === 0 && this.direction === 'right') {
          translateX = -100;
        }
      } else {
        // keep the slide on the correct slide even when not a swipe
        if (currentIndex === 0 && index === 1 && offsetPercentage === 0 && this.direction === 'left') {
          translateX = -100;
        } else if (currentIndex === 1 && index === 0 && offsetPercentage === 0 && this.direction === 'right') {
          translateX = 100;
        }
      }

      return translateX;
    }
  }, {
    key: '_getThumbnailBarHeight',
    value: function _getThumbnailBarHeight() {
      if (this._isThumbnailHorizontal()) {
        return {
          height: this.state.gallerySlideWrapperHeight
        };
      }
      return {};
    }
  }, {
    key: '_shouldPushSlideOnInfiniteMode',
    value: function _shouldPushSlideOnInfiniteMode(index) {
      /*
        Push(show) slide if slide is the current slide, and the next slide
        OR
        The slide is going more than 1 slide left, or right, but not going from
        first to last and not going from last to first
         There is an edge case where if you go to the first or last slide, when they're
        not left, or right of each other they will try to catch up in the background
        so unless were going from first to last or vice versa we don't want the first
        or last slide to show up during our transition
      */
      return !this._slideIsTransitioning(index) || this._ignoreIsTransitioning() && !this._isFirstOrLastSlide(index);
    }
  }, {
    key: '_slideIsTransitioning',
    value: function _slideIsTransitioning(index) {
      /*
      returns true if the gallery is transitioning and the index is not the
      previous or currentIndex
      */
      var _state7 = this.state;
      var isTransitioning = _state7.isTransitioning;
      var previousIndex = _state7.previousIndex;
      var currentIndex = _state7.currentIndex;

      var indexIsNotPreviousOrNextSlide = !(index === previousIndex || index === currentIndex);
      return isTransitioning && indexIsNotPreviousOrNextSlide;
    }
  }, {
    key: '_isFirstOrLastSlide',
    value: function _isFirstOrLastSlide(index) {
      var totalSlides = this.props.items.length - 1;
      var isLastSlide = index === totalSlides;
      var isFirstSlide = index === 0;
      return isLastSlide || isFirstSlide;
    }
  }, {
    key: '_ignoreIsTransitioning',
    value: function _ignoreIsTransitioning() {
      /*
        Ignore isTransitioning because were not going to sibling slides
        e.g. center to left or center to right
      */
      var _state8 = this.state;
      var previousIndex = _state8.previousIndex;
      var currentIndex = _state8.currentIndex;

      var totalSlides = this.props.items.length - 1;
      // we want to show the in between slides transition
      var slidingMoreThanOneSlideLeftOrRight = Math.abs(previousIndex - currentIndex) > 1;
      var notGoingFromFirstToLast = !(previousIndex === 0 && currentIndex === totalSlides);
      var notGoingFromLastToFirst = !(previousIndex === totalSlides && currentIndex === 0);

      return slidingMoreThanOneSlideLeftOrRight && notGoingFromFirstToLast && notGoingFromLastToFirst;
    }
  }, {
    key: '_getSlideStyle',
    value: function _getSlideStyle(index) {
      var _state9 = this.state;
      var currentIndex = _state9.currentIndex;
      var offsetPercentage = _state9.offsetPercentage;
      var _props2 = this.props;
      var infinite = _props2.infinite;
      var items = _props2.items;
      var useTranslate3D = _props2.useTranslate3D;

      var baseTranslateX = -100 * currentIndex;
      var totalSlides = items.length - 1;

      // calculates where the other slides belong based on currentIndex
      var translateX = baseTranslateX + index * 100 + offsetPercentage;

      if (infinite && items.length > 2) {
        if (currentIndex === 0 && index === totalSlides) {
          // make the last slide the slide before the first
          translateX = -100 + offsetPercentage;
        } else if (currentIndex === totalSlides && index === 0) {
          // make the first slide the slide after the last
          translateX = 100 + offsetPercentage;
        }
      }

      // Special case when there are only 2 items with infinite on
      if (infinite && items.length === 2) {
        translateX = this._getTranslateXForTwoSlide(index);
      }

      var translate = 'translate(' + translateX + '%, 0)';

      if (useTranslate3D) {
        translate = 'translate3d(' + translateX + '%, 0, 0)';
      }

      return {
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        transform: translate
      };
    }
  }, {
    key: '_getThumbnailStyle',
    value: function _getThumbnailStyle() {
      var translate = void 0;
      var useTranslate3D = this.props.useTranslate3D;

      if (this._isThumbnailHorizontal()) {
        translate = 'translate(0, ' + this.state.thumbsTranslate + 'px)';
        if (useTranslate3D) {
          translate = 'translate3d(0, ' + this.state.thumbsTranslate + 'px, 0)';
        }
      } else {
        translate = 'translate(' + this.state.thumbsTranslate + 'px, 0)';
        if (useTranslate3D) {
          translate = 'translate3d(' + this.state.thumbsTranslate + 'px, 0, 0)';
        }
      }
      return {
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        transform: translate
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _state10 = this.state;
      var currentIndex = _state10.currentIndex;
      var isFullscreen = _state10.isFullscreen;
      var modalFullscreen = _state10.modalFullscreen;
      var isPlaying = _state10.isPlaying;
      var scrollingLeftRight = _state10.scrollingLeftRight;
      var _props3 = this.props;
      var infinite = _props3.infinite;
      var preventDefaultTouchmoveEvent = _props3.preventDefaultTouchmoveEvent;

      var thumbnailStyle = this._getThumbnailStyle();
      var thumbnailPosition = this.props.thumbnailPosition;

      var slideLeft = this._slideLeft;
      var slideRight = this._slideRight;

      var slides = [];
      var thumbnails = [];
      var bullets = [];

      this.props.items.forEach(function (item, index) {
        var alignment = _this6._getAlignmentClassName(index);
        var originalClass = item.originalClass ? ' ' + item.originalClass : '';
        var thumbnailClass = item.thumbnailClass ? ' ' + item.thumbnailClass : '';

        var renderItem = item.renderItem || _this6.props.renderItem || _this6._renderItem;

        var renderThumbInner = item.renderThumbInner || _this6.props.renderThumbInner || _this6._renderThumbInner;

        var showItem = !_this6.props.lazyLoad || alignment || _this6._lazyLoaded[index];
        if (showItem && _this6.props.lazyLoad) {
          _this6._lazyLoaded[index] = true;
        }

        var slideStyle = _this6._getSlideStyle(index);

        var slide = _react2.default.createElement('div', {
          key: index,
          className: 'image-gallery-slide' + alignment + originalClass,
          style: _extends(slideStyle, _this6.state.style),
          onClick: _this6.props.onClick,
          onTouchMove: _this6.props.onTouchMove,
          onTouchEnd: _this6.props.onTouchEnd,
          onTouchStart: _this6.props.onTouchStart,
          onMouseOver: _this6.props.onMouseOver,
          onMouseLeave: _this6.props.onMouseLeave,
          role: _this6.props.onClick && 'button'
        }, showItem ? renderItem(item) : _react2.default.createElement('div', { style: { height: '100%' } }));

        if (infinite) {
          // don't add some slides while transitioning to avoid background transitions
          if (_this6._shouldPushSlideOnInfiniteMode(index)) {
            slides.push(slide);
          }
        } else {
          slides.push(slide);
        }

        if (_this6.props.showThumbnails) {
          thumbnails.push(_react2.default.createElement('a', {
            onMouseOver: _this6._handleMouseOverThumbnails.bind(_this6, index),
            onMouseLeave: _this6._handleMouseLeaveThumbnails,
            key: index,
            role: 'button',
            'aria-pressed': currentIndex === index ? 'true' : 'false',
            'aria-label': 'Go to Slide ' + (index + 1),
            className: 'image-gallery-thumbnail' + (currentIndex === index ? ' active' : '') + thumbnailClass,
            onClick: function onClick(event) {
              _this6.slideToIndex.call(_this6, index, event);
              if (_this6.props.onThumbnailClick) {
                _this6.props.onThumbnailClick(event, index);
              }
            }
          }, renderThumbInner(item)));
        }

        if (_this6.props.showBullets) {
          var bulletOnClick = function bulletOnClick(event) {
            if (item.bulletOnClick) {
              item.bulletOnClick({ item: item, itemIndex: index, currentIndex: currentIndex });
            }
            return _this6.slideToIndex.call(_this6, index, event);
          };
          bullets.push(_react2.default.createElement('button', {
            key: index,
            type: 'button',
            className: ['image-gallery-bullet', currentIndex === index ? 'active' : '', item.bulletClass || ''].join(' '),
            onClick: bulletOnClick,
            'aria-pressed': currentIndex === index ? 'true' : 'false',
            'aria-label': 'Go to Slide ' + (index + 1)
          }));
        }
      });

      var slideWrapper = _react2.default.createElement('div', {
        ref: function ref(i) {
          return _this6._imageGallerySlideWrapper = i;
        },
        className: 'image-gallery-slide-wrapper ' + thumbnailPosition
      }, this.props.renderCustomControls && this.props.renderCustomControls(), this.props.showFullscreenButton && this.props.renderFullscreenButton(this._toggleFullScreen, isFullscreen), this.props.showPlayButton && this.props.renderPlayPauseButton(this._togglePlay, isPlaying), this._canNavigate() ? [this.props.showNav && _react2.default.createElement('span', { key: 'navigation' }, this.props.renderLeftNav(slideLeft, !this._canSlideLeft()), this.props.renderRightNav(slideRight, !this._canSlideRight())), this.props.disableSwipe ? _react2.default.createElement('div', { className: 'image-gallery-slides', key: 'slides' }, slides) : _react2.default.createElement(_reactSwipeable2.default, {
        className: 'image-gallery-swipe',
        key: 'swipeable',
        delta: 0,
        flickThreshold: this.props.flickThreshold,
        onSwiping: this._handleSwiping,
        onSwipingLeft: this._onSwipingNoOp,
        onSwipingRight: this._onSwipingNoOp,
        onSwipingUp: this._onSwipingNoOp,
        onSwipingDown: this._onSwipingNoOp,
        onSwiped: this._handleOnSwiped,
        stopPropagation: this.props.stopPropagation,
        preventDefaultTouchmoveEvent: preventDefaultTouchmoveEvent || scrollingLeftRight
      }, _react2.default.createElement('div', { className: 'image-gallery-slides' }, slides))] : _react2.default.createElement('div', { className: 'image-gallery-slides' }, slides), this.props.showBullets && _react2.default.createElement('div', { className: 'image-gallery-bullets' }, _react2.default.createElement('div', {
        className: 'image-gallery-bullets-container',
        role: 'navigation',
        'aria-label': 'Bullet Navigation'
      }, bullets)), this.props.showIndex && _react2.default.createElement('div', { className: 'image-gallery-index' }, _react2.default.createElement('span', { className: 'image-gallery-index-current' }, this.state.currentIndex + 1), _react2.default.createElement('span', { className: 'image-gallery-index-separator' }, this.props.indexSeparator), _react2.default.createElement('span', { className: 'image-gallery-index-total' }, this.props.items.length)));

      var classNames = ['image-gallery', this.props.additionalClass, modalFullscreen ? 'fullscreen-modal' : ''].filter(function (name) {
        return typeof name === 'string';
      }).join(' ');

      return _react2.default.createElement('div', {
        ref: function ref(i) {
          return _this6._imageGallery = i;
        },
        className: classNames,
        'aria-live': 'polite'
      }, _react2.default.createElement('div', {
        className: 'image-gallery-content' + (isFullscreen ? ' fullscreen' : '')
      }, (thumbnailPosition === 'bottom' || thumbnailPosition === 'right') && slideWrapper, this.props.showThumbnails && _react2.default.createElement('div', {
        className: 'image-gallery-thumbnails-wrapper ' + thumbnailPosition,
        style: this._getThumbnailBarHeight()
      }, _react2.default.createElement('div', {
        className: 'image-gallery-thumbnails',
        ref: function ref(i) {
          return _this6._thumbnailsWrapper = i;
        }
      }, _react2.default.createElement('div', {
        ref: function ref(t) {
          return _this6._thumbnails = t;
        },
        className: 'image-gallery-thumbnails-container',
        style: thumbnailStyle,
        'aria-label': 'Thumbnail Navigation'
      }, thumbnails))), (thumbnailPosition === 'top' || thumbnailPosition === 'left') && slideWrapper));
    }
  }]);

  return ImageGallery;
}(_react2.default.Component);

ImageGallery.propTypes = {
  flickThreshold: _propTypes2.default.number,
  items: _propTypes2.default.array.isRequired,
  showNav: _propTypes2.default.bool,
  autoPlay: _propTypes2.default.bool,
  lazyLoad: _propTypes2.default.bool,
  infinite: _propTypes2.default.bool,
  showIndex: _propTypes2.default.bool,
  showBullets: _propTypes2.default.bool,
  showThumbnails: _propTypes2.default.bool,
  showPlayButton: _propTypes2.default.bool,
  showFullscreenButton: _propTypes2.default.bool,
  slideOnThumbnailHover: _propTypes2.default.bool,
  disableThumbnailScroll: _propTypes2.default.bool,
  disableArrowKeys: _propTypes2.default.bool,
  disableSwipe: _propTypes2.default.bool,
  useBrowserFullscreen: _propTypes2.default.bool,
  preventDefaultTouchmoveEvent: _propTypes2.default.bool,
  defaultImage: _propTypes2.default.string,
  indexSeparator: _propTypes2.default.string,
  thumbnailPosition: _propTypes2.default.string,
  startIndex: _propTypes2.default.number,
  slideDuration: _propTypes2.default.number,
  slideInterval: _propTypes2.default.number,
  swipeThreshold: _propTypes2.default.number,
  swipingTransitionDuration: _propTypes2.default.number,
  onSlide: _propTypes2.default.func,
  onScreenChange: _propTypes2.default.func,
  onPause: _propTypes2.default.func,
  onPlay: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onImageLoad: _propTypes2.default.func,
  onImageError: _propTypes2.default.func,
  onTouchMove: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onMouseOver: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onThumbnailError: _propTypes2.default.func,
  onThumbnailClick: _propTypes2.default.func,
  renderCustomControls: _propTypes2.default.func,
  renderLeftNav: _propTypes2.default.func,
  renderRightNav: _propTypes2.default.func,
  renderPlayPauseButton: _propTypes2.default.func,
  renderFullscreenButton: _propTypes2.default.func,
  renderItem: _propTypes2.default.func,
  stopPropagation: _propTypes2.default.bool,
  additionalClass: _propTypes2.default.string,
  useTranslate3D: _propTypes2.default.bool
};
ImageGallery.defaultProps = {
  items: [],
  showNav: true,
  autoPlay: false,
  lazyLoad: false,
  infinite: true,
  showIndex: false,
  showBullets: false,
  showThumbnails: true,
  showPlayButton: true,
  showFullscreenButton: true,
  slideOnThumbnailHover: false,
  disableThumbnailScroll: false,
  disableArrowKeys: false,
  disableSwipe: false,
  useTranslate3D: true,
  useBrowserFullscreen: true,
  preventDefaultTouchmoveEvent: false,
  flickThreshold: 0.4,
  stopPropagation: false,
  indexSeparator: ' / ',
  thumbnailPosition: 'bottom',
  startIndex: 0,
  slideDuration: 450,
  swipingTransitionDuration: 0,
  slideInterval: 3000,
  swipeThreshold: 30,
  renderLeftNav: function renderLeftNav(onClick, disabled) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-left-nav',
      disabled: disabled,
      onClick: onClick,
      'aria-label': 'Previous Slide'
    });
  },
  renderRightNav: function renderRightNav(onClick, disabled) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-right-nav',
      disabled: disabled,
      onClick: onClick,
      'aria-label': 'Next Slide'
    });
  },
  renderPlayPauseButton: function renderPlayPauseButton(onClick, isPlaying) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-play-button' + (isPlaying ? ' active' : ''),
      onClick: onClick,
      'aria-label': 'Play or Pause Slideshow'
    });
  },
  renderFullscreenButton: function renderFullscreenButton(onClick, isFullscreen) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-fullscreen-button' + (isFullscreen ? ' active' : ''),
      onClick: onClick,
      'aria-label': 'Open Fullscreen'
    });
  }
};
exports.default = ImageGallery;

/***/ }),

/***/ "xQgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"map":"map__1IWfb","mapContainer":"mapContainer__zAfSw","disclaimer":"disclaimer__A8ibr","wrapper":"wrapper__1vshp","filterTextWrapper":"filterTextWrapper__2GDLH","filterHighlight":"filterHighlight__1zca5","filterText":"filterText__WUvNS","subtitleWrapper":"subtitleWrapper__1V4FX","titleWrapper":"titleWrapper__B_g1r","list":"list__3dWIz","value":"value__a334h","label":"label__2-_ol","loaderWrapper":"loaderWrapper__3OP09"};

/***/ }),

/***/ "y4nW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1PCS1","imageWrapper":"imageWrapper__3WJDP","sdg_image":"sdg_image__19Nib","list":"list__nb2Y1","value":"value__3AFyS","label":"label__3qlEn","mapContainer":"mapContainer__34fex","disclaimer":"disclaimer__1qZW0","chartWrapper":"chartWrapper__3nh-Z","recipient_themes_wrapper":"recipient_themes_wrapper__C2or0","budget_percent":"budget_percent__2q5yB","top_budget_sources_wrapper":"top_budget_sources_wrapper__dI3k_","targetChartWrapper":"targetChartWrapper__7pZ6J","chartHead":"chartHead__2b61b","infoWrapper":"infoWrapper__3kAoi","tableWrapper":"tableWrapper__14DLL","titleWrapper":"titleWrapper__1nsRh"};

/***/ }),

/***/ "ygBH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__32Z8H","rowLegend":"rowLegend__C5ms_","innerLegend":"innerLegend__1Igj1","row":"row__2z0YC","rowWrapper":"rowWrapper__3pAJu","rowWrapperItem":"rowWrapperItem__3lHd4","rowText":"rowText__3WB_V","country_percentage":"country_percentage__19Tmk","countryWrapper":"countryWrapper__P6LGH","allDonorWrapper":"allDonorWrapper__34mCZ","labelText":"labelText__385Vj","barValue":"barValue__10UpB","text":"text__2WqNp","barType":"barType__Tducy","imageWrapper":"imageWrapper__1GaFI","sdg_image":"sdg_image__uHBJJ"};

/***/ }),

/***/ "ykHf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"legend":"legend__16Bxb","textLabel":"textLabel__1joTL","exportLegend":"exportLegend__Ubl1L","legendWrapper":"legendWrapper__Vw742","legendColor":"legendColor__3Vlb7","legendDescription":"legendDescription__2fl0B","legendPercentage":"legendPercentage__1XV7M","perc":"perc__2AJLF","textField":"textField__3idj6","contributionText":"contributionText__2WWI2","dollor":"dollor__2DjDI","donut":"donut__1hbgJ","imageWrapper":"imageWrapper__wG9x0","sdg_image":"sdg_image__3iyCd","svgIe":"svgIe__2AJSS"};

/***/ }),

/***/ "zKRB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"percentageFill":"percentageFill__24M0Q","progressOuterWrapper":"progressOuterWrapper__1TJ6M","progressWrapper":"progressWrapper__1Zccm","progressPercent":"progressPercent__2X7Fm","progressPercentage":"progressPercentage__bEl3a"};

/***/ }),

/***/ "zgDO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"budgetComponentWrapper":"budgetComponentWrapper__3Bh97","budgetWrapper":"budgetWrapper__1EAas","budgetHeading":"budgetHeading__27Bp9","projectWrapper":"projectWrapper__22DLY","projectPrice":"projectPrice__2I1m1","project":"project__2XXUp"};

/***/ })

});


// WEBPACK FOOTER //
// route-index.chunk.26919.js